import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Hex: any;
  Json: any;
  Long: any;
  RGBAHue: any;
  RGBATransparency: any;
  RichTextAST: any;
};

export enum AdPartnerBannerType {
  CAROUSEL = 'carousel',
  LARGE = 'large',
  SKINNY = 'skinny',
  STANDARD = 'standard'
}

/** Admins of the app and allowed permissions in app */
export type Admin = Entity & Node & {
  __typename?: 'Admin';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Admin>;
  /** List of Admin versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Does this admin have access to the test menu */
  testMenu: Scalars['Boolean'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** User's ID for admin permissions */
  userId: Scalars['String'];
  /** The name of the user associated to this ID */
  userName: Scalars['String'];
  /**
   * Allows the selected user to bypass the 'is not enabled' screen for Valorant.
   * Note: This does not bypass the isSupported guard
   */
  valorantEnabledFlagBypass: Scalars['Boolean'];
};


/** Admins of the app and allowed permissions in app */
export type AdminCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Admins of the app and allowed permissions in app */
export type AdminDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Admins of the app and allowed permissions in app */
export type AdminHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Admins of the app and allowed permissions in app */
export type AdminPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Admins of the app and allowed permissions in app */
export type AdminScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Admins of the app and allowed permissions in app */
export type AdminUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AdminConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AdminWhereUniqueInput;
};

/** A connection to a list of items. */
export type AdminConnection = {
  __typename?: 'AdminConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AdminEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AdminCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  testMenu: Scalars['Boolean'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userName: Scalars['String'];
  valorantEnabledFlagBypass: Scalars['Boolean'];
};

export type AdminCreateManyInlineInput = {
  /** Connect multiple existing Admin documents */
  connect?: InputMaybe<Array<AdminWhereUniqueInput>>;
  /** Create and connect multiple existing Admin documents */
  create?: InputMaybe<Array<AdminCreateInput>>;
};

export type AdminCreateOneInlineInput = {
  /** Connect one existing Admin document */
  connect?: InputMaybe<AdminWhereUniqueInput>;
  /** Create and connect one Admin document */
  create?: InputMaybe<AdminCreateInput>;
};

/** An edge in a connection. */
export type AdminEdge = {
  __typename?: 'AdminEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Admin;
};

/** Identifies documents */
export type AdminManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AdminWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AdminWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AdminWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AdminWhereStageInput>;
  documentInStages_none?: InputMaybe<AdminWhereStageInput>;
  documentInStages_some?: InputMaybe<AdminWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  testMenu?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  testMenu_not?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  userId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  userId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  userId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  userId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  userId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  userId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  userId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  userId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  userId_starts_with?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  userName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  userName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  userName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  userName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  userName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  userName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  userName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  userName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  userName_starts_with?: InputMaybe<Scalars['String']>;
  valorantEnabledFlagBypass?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  valorantEnabledFlagBypass_not?: InputMaybe<Scalars['Boolean']>;
};

export enum AdminOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  TESTMENU_ASC = 'testMenu_ASC',
  TESTMENU_DESC = 'testMenu_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  USERID_ASC = 'userId_ASC',
  USERID_DESC = 'userId_DESC',
  USERNAME_ASC = 'userName_ASC',
  USERNAME_DESC = 'userName_DESC',
  VALORANTENABLEDFLAGBYPASS_ASC = 'valorantEnabledFlagBypass_ASC',
  VALORANTENABLEDFLAGBYPASS_DESC = 'valorantEnabledFlagBypass_DESC'
}

export type AdminUpdateInput = {
  testMenu?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  valorantEnabledFlagBypass?: InputMaybe<Scalars['Boolean']>;
};

export type AdminUpdateManyInlineInput = {
  /** Connect multiple existing Admin documents */
  connect?: InputMaybe<Array<AdminConnectInput>>;
  /** Create and connect multiple Admin documents */
  create?: InputMaybe<Array<AdminCreateInput>>;
  /** Delete multiple Admin documents */
  delete?: InputMaybe<Array<AdminWhereUniqueInput>>;
  /** Disconnect multiple Admin documents */
  disconnect?: InputMaybe<Array<AdminWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Admin documents */
  set?: InputMaybe<Array<AdminWhereUniqueInput>>;
  /** Update multiple Admin documents */
  update?: InputMaybe<Array<AdminUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Admin documents */
  upsert?: InputMaybe<Array<AdminUpsertWithNestedWhereUniqueInput>>;
};

export type AdminUpdateManyInput = {
  testMenu?: InputMaybe<Scalars['Boolean']>;
  valorantEnabledFlagBypass?: InputMaybe<Scalars['Boolean']>;
};

export type AdminUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AdminUpdateManyInput;
  /** Document search */
  where: AdminWhereInput;
};

export type AdminUpdateOneInlineInput = {
  /** Connect existing Admin document */
  connect?: InputMaybe<AdminWhereUniqueInput>;
  /** Create and connect one Admin document */
  create?: InputMaybe<AdminCreateInput>;
  /** Delete currently connected Admin document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Admin document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Admin document */
  update?: InputMaybe<AdminUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Admin document */
  upsert?: InputMaybe<AdminUpsertWithNestedWhereUniqueInput>;
};

export type AdminUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AdminUpdateInput;
  /** Unique document search */
  where: AdminWhereUniqueInput;
};

export type AdminUpsertInput = {
  /** Create document if it didn't exist */
  create: AdminCreateInput;
  /** Update document if it exists */
  update: AdminUpdateInput;
};

export type AdminUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AdminUpsertInput;
  /** Unique document search */
  where: AdminWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AdminWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type AdminWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AdminWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AdminWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AdminWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AdminWhereStageInput>;
  documentInStages_none?: InputMaybe<AdminWhereStageInput>;
  documentInStages_some?: InputMaybe<AdminWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  testMenu?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  testMenu_not?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  userId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  userId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  userId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  userId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  userId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  userId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  userId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  userId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  userId_starts_with?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  userName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  userName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  userName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  userName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  userName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  userName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  userName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  userName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  userName_starts_with?: InputMaybe<Scalars['String']>;
  valorantEnabledFlagBypass?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  valorantEnabledFlagBypass_not?: InputMaybe<Scalars['Boolean']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AdminWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AdminWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AdminWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AdminWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AdminWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Admin record uniquely */
export type AdminWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int'];
};

/** Content for known issues in characters within the apex game */
export type ApexCharacterIssue = Entity & Node & {
  __typename?: 'ApexCharacterIssue';
  /** The body to describe the known character issue */
  body?: Maybe<Phrase>;
  /** The Character name for the Issue */
  character: Scalars['String'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ApexCharacterIssue>;
  /** The header to show describing the character issue */
  header?: Maybe<Phrase>;
  /** List of ApexCharacterIssue versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Content for known issues in characters within the apex game */
export type ApexCharacterIssueBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content for known issues in characters within the apex game */
export type ApexCharacterIssueCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content for known issues in characters within the apex game */
export type ApexCharacterIssueDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Content for known issues in characters within the apex game */
export type ApexCharacterIssueHeaderArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content for known issues in characters within the apex game */
export type ApexCharacterIssueHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Content for known issues in characters within the apex game */
export type ApexCharacterIssuePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content for known issues in characters within the apex game */
export type ApexCharacterIssueScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Content for known issues in characters within the apex game */
export type ApexCharacterIssueUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ApexCharacterIssueConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ApexCharacterIssueWhereUniqueInput;
};

/** A connection to a list of items. */
export type ApexCharacterIssueConnection = {
  __typename?: 'ApexCharacterIssueConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ApexCharacterIssueEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ApexCharacterIssueCreateInput = {
  body?: InputMaybe<PhraseCreateOneInlineInput>;
  character: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  header?: InputMaybe<PhraseCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ApexCharacterIssueCreateManyInlineInput = {
  /** Connect multiple existing ApexCharacterIssue documents */
  connect?: InputMaybe<Array<ApexCharacterIssueWhereUniqueInput>>;
  /** Create and connect multiple existing ApexCharacterIssue documents */
  create?: InputMaybe<Array<ApexCharacterIssueCreateInput>>;
};

export type ApexCharacterIssueCreateOneInlineInput = {
  /** Connect one existing ApexCharacterIssue document */
  connect?: InputMaybe<ApexCharacterIssueWhereUniqueInput>;
  /** Create and connect one ApexCharacterIssue document */
  create?: InputMaybe<ApexCharacterIssueCreateInput>;
};

/** An edge in a connection. */
export type ApexCharacterIssueEdge = {
  __typename?: 'ApexCharacterIssueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApexCharacterIssue;
};

/** Identifies documents */
export type ApexCharacterIssueManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ApexCharacterIssueWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ApexCharacterIssueWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ApexCharacterIssueWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<PhraseWhereInput>;
  character?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  character_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  character_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  character_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  character_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  character_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  character_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  character_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  character_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  character_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ApexCharacterIssueWhereStageInput>;
  documentInStages_none?: InputMaybe<ApexCharacterIssueWhereStageInput>;
  documentInStages_some?: InputMaybe<ApexCharacterIssueWhereStageInput>;
  header?: InputMaybe<PhraseWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ApexCharacterIssueOrderByInput {
  CHARACTER_ASC = 'character_ASC',
  CHARACTER_DESC = 'character_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type ApexCharacterIssueUpdateInput = {
  body?: InputMaybe<PhraseUpdateOneInlineInput>;
  character?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<PhraseUpdateOneInlineInput>;
};

export type ApexCharacterIssueUpdateManyInlineInput = {
  /** Connect multiple existing ApexCharacterIssue documents */
  connect?: InputMaybe<Array<ApexCharacterIssueConnectInput>>;
  /** Create and connect multiple ApexCharacterIssue documents */
  create?: InputMaybe<Array<ApexCharacterIssueCreateInput>>;
  /** Delete multiple ApexCharacterIssue documents */
  delete?: InputMaybe<Array<ApexCharacterIssueWhereUniqueInput>>;
  /** Disconnect multiple ApexCharacterIssue documents */
  disconnect?: InputMaybe<Array<ApexCharacterIssueWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ApexCharacterIssue documents */
  set?: InputMaybe<Array<ApexCharacterIssueWhereUniqueInput>>;
  /** Update multiple ApexCharacterIssue documents */
  update?: InputMaybe<Array<ApexCharacterIssueUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ApexCharacterIssue documents */
  upsert?: InputMaybe<Array<ApexCharacterIssueUpsertWithNestedWhereUniqueInput>>;
};

export type ApexCharacterIssueUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']>;
};

export type ApexCharacterIssueUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ApexCharacterIssueUpdateManyInput;
  /** Document search */
  where: ApexCharacterIssueWhereInput;
};

export type ApexCharacterIssueUpdateOneInlineInput = {
  /** Connect existing ApexCharacterIssue document */
  connect?: InputMaybe<ApexCharacterIssueWhereUniqueInput>;
  /** Create and connect one ApexCharacterIssue document */
  create?: InputMaybe<ApexCharacterIssueCreateInput>;
  /** Delete currently connected ApexCharacterIssue document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected ApexCharacterIssue document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single ApexCharacterIssue document */
  update?: InputMaybe<ApexCharacterIssueUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ApexCharacterIssue document */
  upsert?: InputMaybe<ApexCharacterIssueUpsertWithNestedWhereUniqueInput>;
};

export type ApexCharacterIssueUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ApexCharacterIssueUpdateInput;
  /** Unique document search */
  where: ApexCharacterIssueWhereUniqueInput;
};

export type ApexCharacterIssueUpsertInput = {
  /** Create document if it didn't exist */
  create: ApexCharacterIssueCreateInput;
  /** Update document if it exists */
  update: ApexCharacterIssueUpdateInput;
};

export type ApexCharacterIssueUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ApexCharacterIssueUpsertInput;
  /** Unique document search */
  where: ApexCharacterIssueWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ApexCharacterIssueWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type ApexCharacterIssueWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ApexCharacterIssueWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ApexCharacterIssueWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ApexCharacterIssueWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<PhraseWhereInput>;
  character?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  character_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  character_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  character_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  character_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  character_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  character_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  character_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  character_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  character_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ApexCharacterIssueWhereStageInput>;
  documentInStages_none?: InputMaybe<ApexCharacterIssueWhereStageInput>;
  documentInStages_some?: InputMaybe<ApexCharacterIssueWhereStageInput>;
  header?: InputMaybe<PhraseWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ApexCharacterIssueWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ApexCharacterIssueWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ApexCharacterIssueWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ApexCharacterIssueWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ApexCharacterIssueWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ApexCharacterIssue record uniquely */
export type ApexCharacterIssueWhereUniqueInput = {
  character?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

/** Asset system model */
export type Asset = Entity & Node & {
  __typename?: 'Asset';
  bannerImagePlayBanner: Array<PlayBanner>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  /** The file name */
  fileName: Scalars['String'];
  /** The file handle */
  handle: Scalars['String'];
  /** The height of the file */
  height?: Maybe<Scalars['Float']>;
  /** List of Asset versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Name of image for reference inside the app */
  imageName?: Maybe<Scalars['String']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']>;
  modalImagePlayBanner: Array<PlayBanner>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** The file size */
  size?: Maybe<Scalars['Float']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
  upload?: Maybe<AssetUpload>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String'];
  /** The file width */
  width?: Maybe<Scalars['Float']>;
};


/** Asset system model */
export type AssetBannerImagePlayBannerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PlayBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlayBannerWhereInput>;
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


/** Asset system model */
export type AssetModalImagePlayBannerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PlayBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlayBannerWhereInput>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  bannerImagePlayBanner?: InputMaybe<PlayBannerCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileName?: InputMaybe<Scalars['String']>;
  imageName?: InputMaybe<Scalars['String']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  modalImagePlayBanner?: InputMaybe<PlayBannerCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type AssetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  bannerImagePlayBanner_every?: InputMaybe<PlayBannerWhereInput>;
  bannerImagePlayBanner_none?: InputMaybe<PlayBannerWhereInput>;
  bannerImagePlayBanner_some?: InputMaybe<PlayBannerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  imageName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  imageName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  imageName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  imageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  imageName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  imageName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  imageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  imageName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  imageName_starts_with?: InputMaybe<Scalars['String']>;
  modalImagePlayBanner_every?: InputMaybe<PlayBannerWhereInput>;
  modalImagePlayBanner_none?: InputMaybe<PlayBannerWhereInput>;
  modalImagePlayBanner_some?: InputMaybe<PlayBannerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

export enum AssetOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  FILENAME_ASC = 'fileName_ASC',
  FILENAME_DESC = 'fileName_DESC',
  HANDLE_ASC = 'handle_ASC',
  HANDLE_DESC = 'handle_DESC',
  HEIGHT_ASC = 'height_ASC',
  HEIGHT_DESC = 'height_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  IMAGENAME_ASC = 'imageName_ASC',
  IMAGENAME_DESC = 'imageName_DESC',
  MIMETYPE_ASC = 'mimeType_ASC',
  MIMETYPE_DESC = 'mimeType_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  SIZE_ASC = 'size_ASC',
  SIZE_DESC = 'size_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  WIDTH_ASC = 'width_ASC',
  WIDTH_DESC = 'width_DESC'
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']>;
};

export type AssetUpdateInput = {
  bannerImagePlayBanner?: InputMaybe<PlayBannerUpdateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']>;
  imageName?: InputMaybe<Scalars['String']>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  modalImagePlayBanner?: InputMaybe<PlayBannerUpdateManyInlineInput>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type AssetUpdateLocalizationDataInput = {
  fileName?: InputMaybe<Scalars['String']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>;
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput;
  /** Document search */
  where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String'];
  message: Scalars['String'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  ASSET_CREATE_PENDING = 'ASSET_CREATE_PENDING',
  ASSET_ERROR_UPLOAD = 'ASSET_ERROR_UPLOAD',
  ASSET_UPDATE_PENDING = 'ASSET_UPDATE_PENDING',
  ASSET_UPLOAD_COMPLETE = 'ASSET_UPLOAD_COMPLETE'
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** Identifies documents */
export type AssetUploadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  bannerImagePlayBanner_every?: InputMaybe<PlayBannerWhereInput>;
  bannerImagePlayBanner_none?: InputMaybe<PlayBannerWhereInput>;
  bannerImagePlayBanner_some?: InputMaybe<PlayBannerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  fileName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  imageName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  imageName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  imageName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  imageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  imageName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  imageName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  imageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  imageName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  imageName_starts_with?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']>;
  modalImagePlayBanner_every?: InputMaybe<PlayBannerWhereInput>;
  modalImagePlayBanner_none?: InputMaybe<PlayBannerWhereInput>;
  modalImagePlayBanner_some?: InputMaybe<PlayBannerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  width?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  imageName?: InputMaybe<Scalars['String']>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long'];
};

/** Bet Categories prioritization list */
export type BetCategory = Entity & Node & {
  __typename?: 'BetCategory';
  /** The value of the bet category */
  category: Scalars['String'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Display name of the bet category */
  displayName?: Maybe<Phrase>;
  displayNewLabelOnBetLinePanel?: Maybe<Scalars['Boolean']>;
  /** Get the document in other stages */
  documentInStages: Array<BetCategory>;
  /** Is bet category enabled? */
  enabled: Scalars['Boolean'];
  /** Toggles wether or not the explainer modal display icon shows */
  explainerModalEnabled: Scalars['Boolean'];
  /** List of BetCategory versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /**
   * Ordering priority
   * The higher the number, the higher it appears in the list
   * The lower the number, the lower it appears in the list
   */
  priority: Scalars['Int'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Is bet category visible? */
  visible: Scalars['Boolean'];
};


/** Bet Categories prioritization list */
export type BetCategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Bet Categories prioritization list */
export type BetCategoryDisplayNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Bet Categories prioritization list */
export type BetCategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Bet Categories prioritization list */
export type BetCategoryHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Bet Categories prioritization list */
export type BetCategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Bet Categories prioritization list */
export type BetCategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Bet Categories prioritization list */
export type BetCategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BetCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BetCategoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type BetCategoryConnection = {
  __typename?: 'BetCategoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BetCategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BetCategoryCreateInput = {
  category: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  displayName?: InputMaybe<PhraseCreateOneInlineInput>;
  displayNewLabelOnBetLinePanel?: InputMaybe<Scalars['Boolean']>;
  enabled: Scalars['Boolean'];
  explainerModalEnabled: Scalars['Boolean'];
  priority: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
};

export type BetCategoryCreateManyInlineInput = {
  /** Connect multiple existing BetCategory documents */
  connect?: InputMaybe<Array<BetCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing BetCategory documents */
  create?: InputMaybe<Array<BetCategoryCreateInput>>;
};

export type BetCategoryCreateOneInlineInput = {
  /** Connect one existing BetCategory document */
  connect?: InputMaybe<BetCategoryWhereUniqueInput>;
  /** Create and connect one BetCategory document */
  create?: InputMaybe<BetCategoryCreateInput>;
};

/** An edge in a connection. */
export type BetCategoryEdge = {
  __typename?: 'BetCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BetCategory;
};

/** Identifies documents */
export type BetCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<PhraseWhereInput>;
  displayNewLabelOnBetLinePanel?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  displayNewLabelOnBetLinePanel_not?: InputMaybe<Scalars['Boolean']>;
  documentInStages_every?: InputMaybe<BetCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<BetCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<BetCategoryWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  explainerModalEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  explainerModalEnabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

export enum BetCategoryOrderByInput {
  CATEGORY_ASC = 'category_ASC',
  CATEGORY_DESC = 'category_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DISPLAYNEWLABELONBETLINEPANEL_ASC = 'displayNewLabelOnBetLinePanel_ASC',
  DISPLAYNEWLABELONBETLINEPANEL_DESC = 'displayNewLabelOnBetLinePanel_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  EXPLAINERMODALENABLED_ASC = 'explainerModalEnabled_ASC',
  EXPLAINERMODALENABLED_DESC = 'explainerModalEnabled_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PRIORITY_ASC = 'priority_ASC',
  PRIORITY_DESC = 'priority_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  VISIBLE_ASC = 'visible_ASC',
  VISIBLE_DESC = 'visible_DESC'
}

export type BetCategoryUpdateInput = {
  category?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<PhraseUpdateOneInlineInput>;
  displayNewLabelOnBetLinePanel?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  explainerModalEnabled?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type BetCategoryUpdateManyInlineInput = {
  /** Connect multiple existing BetCategory documents */
  connect?: InputMaybe<Array<BetCategoryConnectInput>>;
  /** Create and connect multiple BetCategory documents */
  create?: InputMaybe<Array<BetCategoryCreateInput>>;
  /** Delete multiple BetCategory documents */
  delete?: InputMaybe<Array<BetCategoryWhereUniqueInput>>;
  /** Disconnect multiple BetCategory documents */
  disconnect?: InputMaybe<Array<BetCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BetCategory documents */
  set?: InputMaybe<Array<BetCategoryWhereUniqueInput>>;
  /** Update multiple BetCategory documents */
  update?: InputMaybe<Array<BetCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BetCategory documents */
  upsert?: InputMaybe<Array<BetCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type BetCategoryUpdateManyInput = {
  category?: InputMaybe<Scalars['String']>;
  displayNewLabelOnBetLinePanel?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  explainerModalEnabled?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type BetCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BetCategoryUpdateManyInput;
  /** Document search */
  where: BetCategoryWhereInput;
};

export type BetCategoryUpdateOneInlineInput = {
  /** Connect existing BetCategory document */
  connect?: InputMaybe<BetCategoryWhereUniqueInput>;
  /** Create and connect one BetCategory document */
  create?: InputMaybe<BetCategoryCreateInput>;
  /** Delete currently connected BetCategory document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected BetCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single BetCategory document */
  update?: InputMaybe<BetCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BetCategory document */
  upsert?: InputMaybe<BetCategoryUpsertWithNestedWhereUniqueInput>;
};

export type BetCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BetCategoryUpdateInput;
  /** Unique document search */
  where: BetCategoryWhereUniqueInput;
};

export type BetCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: BetCategoryCreateInput;
  /** Update document if it exists */
  update: BetCategoryUpdateInput;
};

export type BetCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BetCategoryUpsertInput;
  /** Unique document search */
  where: BetCategoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BetCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type BetCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<PhraseWhereInput>;
  displayNewLabelOnBetLinePanel?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  displayNewLabelOnBetLinePanel_not?: InputMaybe<Scalars['Boolean']>;
  documentInStages_every?: InputMaybe<BetCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<BetCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<BetCategoryWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  explainerModalEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  explainerModalEnabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BetCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetCategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetCategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetCategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BetCategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BetCategory record uniquely */
export type BetCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type BetDenominationRestriction = Entity & Node & {
  __typename?: 'BetDenominationRestriction';
  /** The bet denomination that is being unlocked. */
  betValue?: Maybe<BetValue>;
  /** The denomination that the user has to play in order to unlock the defined value. Always the lower bet amount. (E.g. if you have to play $3 bets to unlock $5, this value is $3.) */
  betValueNeededToUnlock?: Maybe<BetValue>;
  betsCompletedToUnlock: Scalars['Int'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<BetDenominationRestriction>;
  /** List of BetDenominationRestriction versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** For internal use, to make these unlocks easier to read at a glance */
  restrictionTitle: Scalars['String'];
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type BetDenominationRestrictionBetValueArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetDenominationRestrictionBetValueNeededToUnlockArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetDenominationRestrictionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetDenominationRestrictionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type BetDenominationRestrictionHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type BetDenominationRestrictionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetDenominationRestrictionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type BetDenominationRestrictionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BetDenominationRestrictionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BetDenominationRestrictionWhereUniqueInput;
};

/** A connection to a list of items. */
export type BetDenominationRestrictionConnection = {
  __typename?: 'BetDenominationRestrictionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BetDenominationRestrictionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BetDenominationRestrictionCreateInput = {
  betValue?: InputMaybe<BetValueCreateOneInlineInput>;
  betValueNeededToUnlock?: InputMaybe<BetValueCreateOneInlineInput>;
  betsCompletedToUnlock: Scalars['Int'];
  cm6igo4k703ni07io94sj3xbs?: InputMaybe<GameModeCreateManyInlineInput>;
  cm6jjar49018k07iwh290exvv?: InputMaybe<BetValueCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  restrictionTitle: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BetDenominationRestrictionCreateManyInlineInput = {
  /** Connect multiple existing BetDenominationRestriction documents */
  connect?: InputMaybe<Array<BetDenominationRestrictionWhereUniqueInput>>;
  /** Create and connect multiple existing BetDenominationRestriction documents */
  create?: InputMaybe<Array<BetDenominationRestrictionCreateInput>>;
};

export type BetDenominationRestrictionCreateOneInlineInput = {
  /** Connect one existing BetDenominationRestriction document */
  connect?: InputMaybe<BetDenominationRestrictionWhereUniqueInput>;
  /** Create and connect one BetDenominationRestriction document */
  create?: InputMaybe<BetDenominationRestrictionCreateInput>;
};

/** An edge in a connection. */
export type BetDenominationRestrictionEdge = {
  __typename?: 'BetDenominationRestrictionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BetDenominationRestriction;
};

/** Identifies documents */
export type BetDenominationRestrictionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetDenominationRestrictionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetDenominationRestrictionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetDenominationRestrictionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  betValue?: InputMaybe<BetValueWhereInput>;
  betValueNeededToUnlock?: InputMaybe<BetValueWhereInput>;
  betsCompletedToUnlock?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  betsCompletedToUnlock_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  betsCompletedToUnlock_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  betsCompletedToUnlock_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  betsCompletedToUnlock_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  betsCompletedToUnlock_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  betsCompletedToUnlock_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  betsCompletedToUnlock_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BetDenominationRestrictionWhereStageInput>;
  documentInStages_none?: InputMaybe<BetDenominationRestrictionWhereStageInput>;
  documentInStages_some?: InputMaybe<BetDenominationRestrictionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  restrictionTitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  restrictionTitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  restrictionTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  restrictionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  restrictionTitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  restrictionTitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  restrictionTitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  restrictionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  restrictionTitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  restrictionTitle_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum BetDenominationRestrictionOrderByInput {
  BETSCOMPLETEDTOUNLOCK_ASC = 'betsCompletedToUnlock_ASC',
  BETSCOMPLETEDTOUNLOCK_DESC = 'betsCompletedToUnlock_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  RESTRICTIONTITLE_ASC = 'restrictionTitle_ASC',
  RESTRICTIONTITLE_DESC = 'restrictionTitle_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type BetDenominationRestrictionUpdateInput = {
  betValue?: InputMaybe<BetValueUpdateOneInlineInput>;
  betValueNeededToUnlock?: InputMaybe<BetValueUpdateOneInlineInput>;
  betsCompletedToUnlock?: InputMaybe<Scalars['Int']>;
  cm6igo4k703ni07io94sj3xbs?: InputMaybe<GameModeUpdateManyInlineInput>;
  cm6jjar49018k07iwh290exvv?: InputMaybe<BetValueUpdateManyInlineInput>;
  restrictionTitle?: InputMaybe<Scalars['String']>;
};

export type BetDenominationRestrictionUpdateManyInlineInput = {
  /** Connect multiple existing BetDenominationRestriction documents */
  connect?: InputMaybe<Array<BetDenominationRestrictionConnectInput>>;
  /** Create and connect multiple BetDenominationRestriction documents */
  create?: InputMaybe<Array<BetDenominationRestrictionCreateInput>>;
  /** Delete multiple BetDenominationRestriction documents */
  delete?: InputMaybe<Array<BetDenominationRestrictionWhereUniqueInput>>;
  /** Disconnect multiple BetDenominationRestriction documents */
  disconnect?: InputMaybe<Array<BetDenominationRestrictionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BetDenominationRestriction documents */
  set?: InputMaybe<Array<BetDenominationRestrictionWhereUniqueInput>>;
  /** Update multiple BetDenominationRestriction documents */
  update?: InputMaybe<Array<BetDenominationRestrictionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BetDenominationRestriction documents */
  upsert?: InputMaybe<Array<BetDenominationRestrictionUpsertWithNestedWhereUniqueInput>>;
};

export type BetDenominationRestrictionUpdateManyInput = {
  betsCompletedToUnlock?: InputMaybe<Scalars['Int']>;
  restrictionTitle?: InputMaybe<Scalars['String']>;
};

export type BetDenominationRestrictionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BetDenominationRestrictionUpdateManyInput;
  /** Document search */
  where: BetDenominationRestrictionWhereInput;
};

export type BetDenominationRestrictionUpdateOneInlineInput = {
  /** Connect existing BetDenominationRestriction document */
  connect?: InputMaybe<BetDenominationRestrictionWhereUniqueInput>;
  /** Create and connect one BetDenominationRestriction document */
  create?: InputMaybe<BetDenominationRestrictionCreateInput>;
  /** Delete currently connected BetDenominationRestriction document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected BetDenominationRestriction document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single BetDenominationRestriction document */
  update?: InputMaybe<BetDenominationRestrictionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BetDenominationRestriction document */
  upsert?: InputMaybe<BetDenominationRestrictionUpsertWithNestedWhereUniqueInput>;
};

export type BetDenominationRestrictionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BetDenominationRestrictionUpdateInput;
  /** Unique document search */
  where: BetDenominationRestrictionWhereUniqueInput;
};

export type BetDenominationRestrictionUpsertInput = {
  /** Create document if it didn't exist */
  create: BetDenominationRestrictionCreateInput;
  /** Update document if it exists */
  update: BetDenominationRestrictionUpdateInput;
};

export type BetDenominationRestrictionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BetDenominationRestrictionUpsertInput;
  /** Unique document search */
  where: BetDenominationRestrictionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BetDenominationRestrictionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type BetDenominationRestrictionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetDenominationRestrictionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetDenominationRestrictionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetDenominationRestrictionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  betValue?: InputMaybe<BetValueWhereInput>;
  betValueNeededToUnlock?: InputMaybe<BetValueWhereInput>;
  betsCompletedToUnlock?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  betsCompletedToUnlock_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  betsCompletedToUnlock_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  betsCompletedToUnlock_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  betsCompletedToUnlock_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  betsCompletedToUnlock_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  betsCompletedToUnlock_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  betsCompletedToUnlock_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BetDenominationRestrictionWhereStageInput>;
  documentInStages_none?: InputMaybe<BetDenominationRestrictionWhereStageInput>;
  documentInStages_some?: InputMaybe<BetDenominationRestrictionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  restrictionTitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  restrictionTitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  restrictionTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  restrictionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  restrictionTitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  restrictionTitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  restrictionTitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  restrictionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  restrictionTitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  restrictionTitle_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BetDenominationRestrictionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetDenominationRestrictionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetDenominationRestrictionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetDenominationRestrictionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BetDenominationRestrictionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BetDenominationRestriction record uniquely */
export type BetDenominationRestrictionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Handles all the bet line information */
export type BetLine = Entity & Node & {
  __typename?: 'BetLine';
  betLineName: Scalars['String'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<BetLine>;
  gameMode?: Maybe<GameMode>;
  /** List of BetLine versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  maximumMultibetsAllowed?: Maybe<Scalars['Int']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Handles all the bet line information */
export type BetLineCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Handles all the bet line information */
export type BetLineDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Handles all the bet line information */
export type BetLineGameModeArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Handles all the bet line information */
export type BetLineHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Handles all the bet line information */
export type BetLinePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Handles all the bet line information */
export type BetLineScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Handles all the bet line information */
export type BetLineUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BetLineConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BetLineWhereUniqueInput;
};

/** A connection to a list of items. */
export type BetLineConnection = {
  __typename?: 'BetLineConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BetLineEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BetLineCreateInput = {
  betLineName: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  gameMode?: InputMaybe<GameModeCreateOneInlineInput>;
  maximumMultibetsAllowed?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BetLineCreateManyInlineInput = {
  /** Connect multiple existing BetLine documents */
  connect?: InputMaybe<Array<BetLineWhereUniqueInput>>;
  /** Create and connect multiple existing BetLine documents */
  create?: InputMaybe<Array<BetLineCreateInput>>;
};

export type BetLineCreateOneInlineInput = {
  /** Connect one existing BetLine document */
  connect?: InputMaybe<BetLineWhereUniqueInput>;
  /** Create and connect one BetLine document */
  create?: InputMaybe<BetLineCreateInput>;
};

/** An edge in a connection. */
export type BetLineEdge = {
  __typename?: 'BetLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BetLine;
};

/** Identifies documents */
export type BetLineManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetLineWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetLineWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetLineWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  betLineName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  betLineName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  betLineName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  betLineName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  betLineName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  betLineName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  betLineName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  betLineName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  betLineName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  betLineName_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BetLineWhereStageInput>;
  documentInStages_none?: InputMaybe<BetLineWhereStageInput>;
  documentInStages_some?: InputMaybe<BetLineWhereStageInput>;
  gameMode?: InputMaybe<GameModeWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  maximumMultibetsAllowed?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  maximumMultibetsAllowed_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  maximumMultibetsAllowed_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  maximumMultibetsAllowed_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  maximumMultibetsAllowed_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  maximumMultibetsAllowed_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  maximumMultibetsAllowed_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  maximumMultibetsAllowed_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum BetLineOrderByInput {
  BETLINENAME_ASC = 'betLineName_ASC',
  BETLINENAME_DESC = 'betLineName_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  MAXIMUMMULTIBETSALLOWED_ASC = 'maximumMultibetsAllowed_ASC',
  MAXIMUMMULTIBETSALLOWED_DESC = 'maximumMultibetsAllowed_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type BetLineRule = Entity & Node & {
  __typename?: 'BetLineRule';
  betLineTypes: Array<BetLineType>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<BetLineRule>;
  gameModes: Array<GameMode>;
  /** List of BetLineRule versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  ruleDisplay: Array<BetLineRuleDisplay>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  systemId?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type BetLineRuleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetLineRuleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type BetLineRuleGameModesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GameModeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameModeWhereInput>;
};


export type BetLineRuleHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type BetLineRulePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetLineRuleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type BetLineRuleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BetLineRuleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BetLineRuleWhereUniqueInput;
};

/** A connection to a list of items. */
export type BetLineRuleConnection = {
  __typename?: 'BetLineRuleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BetLineRuleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BetLineRuleCreateInput = {
  betLineTypes?: InputMaybe<Array<BetLineType>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  gameModes?: InputMaybe<GameModeCreateManyInlineInput>;
  ruleDisplay?: InputMaybe<Array<BetLineRuleDisplay>>;
  systemId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BetLineRuleCreateManyInlineInput = {
  /** Connect multiple existing BetLineRule documents */
  connect?: InputMaybe<Array<BetLineRuleWhereUniqueInput>>;
  /** Create and connect multiple existing BetLineRule documents */
  create?: InputMaybe<Array<BetLineRuleCreateInput>>;
};

export type BetLineRuleCreateOneInlineInput = {
  /** Connect one existing BetLineRule document */
  connect?: InputMaybe<BetLineRuleWhereUniqueInput>;
  /** Create and connect one BetLineRule document */
  create?: InputMaybe<BetLineRuleCreateInput>;
};

export enum BetLineRuleDisplay {
  PLACEMENT = 'PLACEMENT',
  POST_PLACEMENT = 'POST_PLACEMENT'
}

/** An edge in a connection. */
export type BetLineRuleEdge = {
  __typename?: 'BetLineRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BetLineRule;
};

/** Identifies documents */
export type BetLineRuleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetLineRuleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetLineRuleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetLineRuleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  betLineTypes?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array contains *all* items provided to the filter */
  betLineTypes_contains_all?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  betLineTypes_contains_none?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array contains at least one item provided to the filter */
  betLineTypes_contains_some?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  betLineTypes_not?: InputMaybe<Array<BetLineType>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BetLineRuleWhereStageInput>;
  documentInStages_none?: InputMaybe<BetLineRuleWhereStageInput>;
  documentInStages_some?: InputMaybe<BetLineRuleWhereStageInput>;
  gameModes_every?: InputMaybe<GameModeWhereInput>;
  gameModes_none?: InputMaybe<GameModeWhereInput>;
  gameModes_some?: InputMaybe<GameModeWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  ruleDisplay?: InputMaybe<Array<BetLineRuleDisplay>>;
  /** Matches if the field array contains *all* items provided to the filter */
  ruleDisplay_contains_all?: InputMaybe<Array<BetLineRuleDisplay>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  ruleDisplay_contains_none?: InputMaybe<Array<BetLineRuleDisplay>>;
  /** Matches if the field array contains at least one item provided to the filter */
  ruleDisplay_contains_some?: InputMaybe<Array<BetLineRuleDisplay>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  ruleDisplay_not?: InputMaybe<Array<BetLineRuleDisplay>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum BetLineRuleOrderByInput {
  BETLINETYPES_ASC = 'betLineTypes_ASC',
  BETLINETYPES_DESC = 'betLineTypes_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  RULEDISPLAY_ASC = 'ruleDisplay_ASC',
  RULEDISPLAY_DESC = 'ruleDisplay_DESC',
  SYSTEMID_ASC = 'systemId_ASC',
  SYSTEMID_DESC = 'systemId_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type BetLineRuleUpdateInput = {
  betLineTypes?: InputMaybe<Array<BetLineType>>;
  gameModes?: InputMaybe<GameModeUpdateManyInlineInput>;
  ruleDisplay?: InputMaybe<Array<BetLineRuleDisplay>>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type BetLineRuleUpdateManyInlineInput = {
  /** Connect multiple existing BetLineRule documents */
  connect?: InputMaybe<Array<BetLineRuleConnectInput>>;
  /** Create and connect multiple BetLineRule documents */
  create?: InputMaybe<Array<BetLineRuleCreateInput>>;
  /** Delete multiple BetLineRule documents */
  delete?: InputMaybe<Array<BetLineRuleWhereUniqueInput>>;
  /** Disconnect multiple BetLineRule documents */
  disconnect?: InputMaybe<Array<BetLineRuleWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BetLineRule documents */
  set?: InputMaybe<Array<BetLineRuleWhereUniqueInput>>;
  /** Update multiple BetLineRule documents */
  update?: InputMaybe<Array<BetLineRuleUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BetLineRule documents */
  upsert?: InputMaybe<Array<BetLineRuleUpsertWithNestedWhereUniqueInput>>;
};

export type BetLineRuleUpdateManyInput = {
  betLineTypes?: InputMaybe<Array<BetLineType>>;
  ruleDisplay?: InputMaybe<Array<BetLineRuleDisplay>>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type BetLineRuleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BetLineRuleUpdateManyInput;
  /** Document search */
  where: BetLineRuleWhereInput;
};

export type BetLineRuleUpdateOneInlineInput = {
  /** Connect existing BetLineRule document */
  connect?: InputMaybe<BetLineRuleWhereUniqueInput>;
  /** Create and connect one BetLineRule document */
  create?: InputMaybe<BetLineRuleCreateInput>;
  /** Delete currently connected BetLineRule document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected BetLineRule document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single BetLineRule document */
  update?: InputMaybe<BetLineRuleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BetLineRule document */
  upsert?: InputMaybe<BetLineRuleUpsertWithNestedWhereUniqueInput>;
};

export type BetLineRuleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BetLineRuleUpdateInput;
  /** Unique document search */
  where: BetLineRuleWhereUniqueInput;
};

export type BetLineRuleUpsertInput = {
  /** Create document if it didn't exist */
  create: BetLineRuleCreateInput;
  /** Update document if it exists */
  update: BetLineRuleUpdateInput;
};

export type BetLineRuleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BetLineRuleUpsertInput;
  /** Unique document search */
  where: BetLineRuleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BetLineRuleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type BetLineRuleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetLineRuleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetLineRuleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetLineRuleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  betLineTypes?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array contains *all* items provided to the filter */
  betLineTypes_contains_all?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  betLineTypes_contains_none?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array contains at least one item provided to the filter */
  betLineTypes_contains_some?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  betLineTypes_not?: InputMaybe<Array<BetLineType>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BetLineRuleWhereStageInput>;
  documentInStages_none?: InputMaybe<BetLineRuleWhereStageInput>;
  documentInStages_some?: InputMaybe<BetLineRuleWhereStageInput>;
  gameModes_every?: InputMaybe<GameModeWhereInput>;
  gameModes_none?: InputMaybe<GameModeWhereInput>;
  gameModes_some?: InputMaybe<GameModeWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  ruleDisplay?: InputMaybe<Array<BetLineRuleDisplay>>;
  /** Matches if the field array contains *all* items provided to the filter */
  ruleDisplay_contains_all?: InputMaybe<Array<BetLineRuleDisplay>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  ruleDisplay_contains_none?: InputMaybe<Array<BetLineRuleDisplay>>;
  /** Matches if the field array contains at least one item provided to the filter */
  ruleDisplay_contains_some?: InputMaybe<Array<BetLineRuleDisplay>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  ruleDisplay_not?: InputMaybe<Array<BetLineRuleDisplay>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BetLineRuleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetLineRuleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetLineRuleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetLineRuleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BetLineRuleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BetLineRule record uniquely */
export type BetLineRuleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export enum BetLineType {
  ASSISTS = 'ASSISTS',
  AVERAGE_KILLS_PER_ROUND = 'AVERAGE_KILLS_PER_ROUND',
  BEST_ON_TEAM = 'BEST_ON_TEAM',
  CLASH_FLAWLESS_VICTORY = 'CLASH_FLAWLESS_VICTORY',
  CLASH_MATCH_THREE_CROWNS = 'CLASH_MATCH_THREE_CROWNS',
  CLASH_TOTAL_VICTORY = 'CLASH_TOTAL_VICTORY',
  COMPLETED_CONTRACTS = 'COMPLETED_CONTRACTS',
  DAMAGE = 'DAMAGE',
  DEATH = 'DEATH',
  FIVE_KILLS_PER_ROUND = 'FIVE_KILLS_PER_ROUND',
  FLAWLESS_VICTORY = 'FLAWLESS_VICTORY',
  FOUR_KILLS_PER_ROUND = 'FOUR_KILLS_PER_ROUND',
  GOALS = 'GOALS',
  GULAG_WIN = 'GULAG_WIN',
  KILLS = 'KILLS',
  LAST_KILL = 'LAST_KILL',
  MAIN = 'MAIN',
  MATCH = 'MATCH',
  MATCH_WIN = 'MATCH_WIN',
  MULTI_PARLAY = 'MULTI_PARLAY',
  MVP = 'MVP',
  OPPONENT_SCORE = 'OPPONENT_SCORE',
  PARLAY = 'PARLAY',
  PLACEMENT = 'PLACEMENT',
  PLAYER_GRADE = 'PLAYER_GRADE',
  PLAY_OF_THE_GAME = 'PLAY_OF_THE_GAME',
  PODIUM_PLACEMENT = 'PODIUM_PLACEMENT',
  REBOUNDS = 'REBOUNDS',
  SPREAD = 'SPREAD',
  THREE_KILLS_PER_ROUND = 'THREE_KILLS_PER_ROUND',
  TOP_TEN = 'TOP_TEN',
  TOP_THREE = 'TOP_THREE',
  TOP_TWENTY_FIVE = 'TOP_TWENTY_FIVE',
  TWO_KILLS_PER_ROUND = 'TWO_KILLS_PER_ROUND'
}

export type BetLineUpdateInput = {
  betLineName?: InputMaybe<Scalars['String']>;
  gameMode?: InputMaybe<GameModeUpdateOneInlineInput>;
  maximumMultibetsAllowed?: InputMaybe<Scalars['Int']>;
};

export type BetLineUpdateManyInlineInput = {
  /** Connect multiple existing BetLine documents */
  connect?: InputMaybe<Array<BetLineConnectInput>>;
  /** Create and connect multiple BetLine documents */
  create?: InputMaybe<Array<BetLineCreateInput>>;
  /** Delete multiple BetLine documents */
  delete?: InputMaybe<Array<BetLineWhereUniqueInput>>;
  /** Disconnect multiple BetLine documents */
  disconnect?: InputMaybe<Array<BetLineWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BetLine documents */
  set?: InputMaybe<Array<BetLineWhereUniqueInput>>;
  /** Update multiple BetLine documents */
  update?: InputMaybe<Array<BetLineUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BetLine documents */
  upsert?: InputMaybe<Array<BetLineUpsertWithNestedWhereUniqueInput>>;
};

export type BetLineUpdateManyInput = {
  betLineName?: InputMaybe<Scalars['String']>;
  maximumMultibetsAllowed?: InputMaybe<Scalars['Int']>;
};

export type BetLineUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BetLineUpdateManyInput;
  /** Document search */
  where: BetLineWhereInput;
};

export type BetLineUpdateOneInlineInput = {
  /** Connect existing BetLine document */
  connect?: InputMaybe<BetLineWhereUniqueInput>;
  /** Create and connect one BetLine document */
  create?: InputMaybe<BetLineCreateInput>;
  /** Delete currently connected BetLine document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected BetLine document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single BetLine document */
  update?: InputMaybe<BetLineUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BetLine document */
  upsert?: InputMaybe<BetLineUpsertWithNestedWhereUniqueInput>;
};

export type BetLineUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BetLineUpdateInput;
  /** Unique document search */
  where: BetLineWhereUniqueInput;
};

export type BetLineUpsertInput = {
  /** Create document if it didn't exist */
  create: BetLineCreateInput;
  /** Update document if it exists */
  update: BetLineUpdateInput;
};

export type BetLineUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BetLineUpsertInput;
  /** Unique document search */
  where: BetLineWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BetLineWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type BetLineWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetLineWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetLineWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetLineWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  betLineName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  betLineName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  betLineName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  betLineName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  betLineName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  betLineName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  betLineName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  betLineName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  betLineName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  betLineName_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BetLineWhereStageInput>;
  documentInStages_none?: InputMaybe<BetLineWhereStageInput>;
  documentInStages_some?: InputMaybe<BetLineWhereStageInput>;
  gameMode?: InputMaybe<GameModeWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  maximumMultibetsAllowed?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  maximumMultibetsAllowed_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  maximumMultibetsAllowed_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  maximumMultibetsAllowed_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  maximumMultibetsAllowed_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  maximumMultibetsAllowed_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  maximumMultibetsAllowed_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  maximumMultibetsAllowed_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BetLineWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetLineWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetLineWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetLineWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BetLineWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BetLine record uniquely */
export type BetLineWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type BetRestriction = Entity & Node & {
  __typename?: 'BetRestriction';
  /** What is the unlocked value from this i.e if the appliedTo value is "max_wager_value" this would be a numeric value of 2500 ($25) */
  appliedToValue?: Maybe<Scalars['String']>;
  /** What type of restriction does this apply to. i.e min_matches */
  appliesTo?: Maybe<Scalars['String']>;
  /** Conditions required for this restriction to be met, if no conditions assume the restriction is met */
  conditions: Array<Restriction>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<BetRestriction>;
  /** Is this restriction enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** List of BetRestriction versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Are the conditions of this required to ensure the user can play a specific gamemode */
  required?: Maybe<Scalars['Boolean']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type BetRestrictionConditionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RestrictionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RestrictionWhereInput>;
};


export type BetRestrictionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetRestrictionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type BetRestrictionHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type BetRestrictionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetRestrictionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type BetRestrictionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BetRestrictionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BetRestrictionWhereUniqueInput;
};

/** A connection to a list of items. */
export type BetRestrictionConnection = {
  __typename?: 'BetRestrictionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BetRestrictionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BetRestrictionCreateInput = {
  appliedToValue?: InputMaybe<Scalars['String']>;
  appliesTo?: InputMaybe<Scalars['String']>;
  clbfl6xff0vp401t62eyo2ih2?: InputMaybe<GameModeCreateManyInlineInput>;
  conditions?: InputMaybe<RestrictionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BetRestrictionCreateManyInlineInput = {
  /** Connect multiple existing BetRestriction documents */
  connect?: InputMaybe<Array<BetRestrictionWhereUniqueInput>>;
  /** Create and connect multiple existing BetRestriction documents */
  create?: InputMaybe<Array<BetRestrictionCreateInput>>;
};

export type BetRestrictionCreateOneInlineInput = {
  /** Connect one existing BetRestriction document */
  connect?: InputMaybe<BetRestrictionWhereUniqueInput>;
  /** Create and connect one BetRestriction document */
  create?: InputMaybe<BetRestrictionCreateInput>;
};

/** An edge in a connection. */
export type BetRestrictionEdge = {
  __typename?: 'BetRestrictionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BetRestriction;
};

/** Identifies documents */
export type BetRestrictionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetRestrictionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetRestrictionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetRestrictionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  appliedToValue?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  appliedToValue_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  appliedToValue_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  appliedToValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  appliedToValue_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  appliedToValue_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  appliedToValue_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  appliedToValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  appliedToValue_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  appliedToValue_starts_with?: InputMaybe<Scalars['String']>;
  appliesTo?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  appliesTo_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  appliesTo_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  appliesTo_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  appliesTo_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  appliesTo_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  appliesTo_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  appliesTo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  appliesTo_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  appliesTo_starts_with?: InputMaybe<Scalars['String']>;
  conditions_every?: InputMaybe<RestrictionWhereInput>;
  conditions_none?: InputMaybe<RestrictionWhereInput>;
  conditions_some?: InputMaybe<RestrictionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BetRestrictionWhereStageInput>;
  documentInStages_none?: InputMaybe<BetRestrictionWhereStageInput>;
  documentInStages_some?: InputMaybe<BetRestrictionWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum BetRestrictionOrderByInput {
  APPLIEDTOVALUE_ASC = 'appliedToValue_ASC',
  APPLIEDTOVALUE_DESC = 'appliedToValue_DESC',
  APPLIESTO_ASC = 'appliesTo_ASC',
  APPLIESTO_DESC = 'appliesTo_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  REQUIRED_ASC = 'required_ASC',
  REQUIRED_DESC = 'required_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type BetRestrictionUpdateInput = {
  appliedToValue?: InputMaybe<Scalars['String']>;
  appliesTo?: InputMaybe<Scalars['String']>;
  clbfl6xff0vp401t62eyo2ih2?: InputMaybe<GameModeUpdateManyInlineInput>;
  conditions?: InputMaybe<RestrictionUpdateManyInlineInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
};

export type BetRestrictionUpdateManyInlineInput = {
  /** Connect multiple existing BetRestriction documents */
  connect?: InputMaybe<Array<BetRestrictionConnectInput>>;
  /** Create and connect multiple BetRestriction documents */
  create?: InputMaybe<Array<BetRestrictionCreateInput>>;
  /** Delete multiple BetRestriction documents */
  delete?: InputMaybe<Array<BetRestrictionWhereUniqueInput>>;
  /** Disconnect multiple BetRestriction documents */
  disconnect?: InputMaybe<Array<BetRestrictionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BetRestriction documents */
  set?: InputMaybe<Array<BetRestrictionWhereUniqueInput>>;
  /** Update multiple BetRestriction documents */
  update?: InputMaybe<Array<BetRestrictionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BetRestriction documents */
  upsert?: InputMaybe<Array<BetRestrictionUpsertWithNestedWhereUniqueInput>>;
};

export type BetRestrictionUpdateManyInput = {
  appliedToValue?: InputMaybe<Scalars['String']>;
  appliesTo?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
};

export type BetRestrictionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BetRestrictionUpdateManyInput;
  /** Document search */
  where: BetRestrictionWhereInput;
};

export type BetRestrictionUpdateOneInlineInput = {
  /** Connect existing BetRestriction document */
  connect?: InputMaybe<BetRestrictionWhereUniqueInput>;
  /** Create and connect one BetRestriction document */
  create?: InputMaybe<BetRestrictionCreateInput>;
  /** Delete currently connected BetRestriction document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected BetRestriction document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single BetRestriction document */
  update?: InputMaybe<BetRestrictionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BetRestriction document */
  upsert?: InputMaybe<BetRestrictionUpsertWithNestedWhereUniqueInput>;
};

export type BetRestrictionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BetRestrictionUpdateInput;
  /** Unique document search */
  where: BetRestrictionWhereUniqueInput;
};

export type BetRestrictionUpsertInput = {
  /** Create document if it didn't exist */
  create: BetRestrictionCreateInput;
  /** Update document if it exists */
  update: BetRestrictionUpdateInput;
};

export type BetRestrictionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BetRestrictionUpsertInput;
  /** Unique document search */
  where: BetRestrictionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BetRestrictionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type BetRestrictionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetRestrictionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetRestrictionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetRestrictionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  appliedToValue?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  appliedToValue_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  appliedToValue_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  appliedToValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  appliedToValue_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  appliedToValue_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  appliedToValue_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  appliedToValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  appliedToValue_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  appliedToValue_starts_with?: InputMaybe<Scalars['String']>;
  appliesTo?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  appliesTo_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  appliesTo_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  appliesTo_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  appliesTo_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  appliesTo_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  appliesTo_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  appliesTo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  appliesTo_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  appliesTo_starts_with?: InputMaybe<Scalars['String']>;
  conditions_every?: InputMaybe<RestrictionWhereInput>;
  conditions_none?: InputMaybe<RestrictionWhereInput>;
  conditions_some?: InputMaybe<RestrictionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BetRestrictionWhereStageInput>;
  documentInStages_none?: InputMaybe<BetRestrictionWhereStageInput>;
  documentInStages_some?: InputMaybe<BetRestrictionWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BetRestrictionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetRestrictionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetRestrictionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetRestrictionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BetRestrictionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BetRestriction record uniquely */
export type BetRestrictionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type BetValue = Entity & Node & {
  __typename?: 'BetValue';
  addon: Scalars['Float'];
  /** Bet Value restrictions on a per gamemode basis. */
  betValueRestrictions: Array<BetValueRestriction>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<BetValue>;
  enabled: Scalars['Boolean'];
  /** List of BetValue versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  main: Scalars['Int'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  restriction?: Maybe<BetDenominationRestriction>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  systemId: Scalars['String'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  visible: Scalars['Boolean'];
};


export type BetValueBetValueRestrictionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BetValueRestrictionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetValueRestrictionWhereInput>;
};


export type BetValueCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetValueDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type BetValueHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type BetValuePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetValueRestrictionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetValueScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type BetValueUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BetValueConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BetValueWhereUniqueInput;
};

/** A connection to a list of items. */
export type BetValueConnection = {
  __typename?: 'BetValueConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BetValueEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BetValueCreateInput = {
  addon: Scalars['Float'];
  betValueRestrictions?: InputMaybe<BetValueRestrictionCreateManyInlineInput>;
  cle5w6wpu1zih01uj0piggapq?: InputMaybe<GameModeCreateManyInlineInput>;
  clehpybv72c4101up8x6e8m32?: InputMaybe<GameModeCreateManyInlineInput>;
  cljwv4yjn077w01ug0juo4psh?: InputMaybe<BetValueRestrictionCreateManyInlineInput>;
  cm6jm6web025407iwf4o336fm?: InputMaybe<BetDenominationRestrictionCreateManyInlineInput>;
  cm6jm62hn024p07iw6t08h730?: InputMaybe<BetDenominationRestrictionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  main: Scalars['Int'];
  restriction?: InputMaybe<BetDenominationRestrictionCreateOneInlineInput>;
  systemId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
};

export type BetValueCreateManyInlineInput = {
  /** Connect multiple existing BetValue documents */
  connect?: InputMaybe<Array<BetValueWhereUniqueInput>>;
  /** Create and connect multiple existing BetValue documents */
  create?: InputMaybe<Array<BetValueCreateInput>>;
};

export type BetValueCreateOneInlineInput = {
  /** Connect one existing BetValue document */
  connect?: InputMaybe<BetValueWhereUniqueInput>;
  /** Create and connect one BetValue document */
  create?: InputMaybe<BetValueCreateInput>;
};

/** An edge in a connection. */
export type BetValueEdge = {
  __typename?: 'BetValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BetValue;
};

/** Identifies documents */
export type BetValueManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetValueWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetValueWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetValueWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  addon?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  addon_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  addon_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  addon_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  addon_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  addon_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  addon_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  addon_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  betValueRestrictions_every?: InputMaybe<BetValueRestrictionWhereInput>;
  betValueRestrictions_none?: InputMaybe<BetValueRestrictionWhereInput>;
  betValueRestrictions_some?: InputMaybe<BetValueRestrictionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BetValueWhereStageInput>;
  documentInStages_none?: InputMaybe<BetValueWhereStageInput>;
  documentInStages_some?: InputMaybe<BetValueWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  main?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  main_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  main_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  main_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  main_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  main_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  main_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  main_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  restriction?: InputMaybe<BetDenominationRestrictionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

export enum BetValueOrderByInput {
  ADDON_ASC = 'addon_ASC',
  ADDON_DESC = 'addon_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  MAIN_ASC = 'main_ASC',
  MAIN_DESC = 'main_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  SYSTEMID_ASC = 'systemId_ASC',
  SYSTEMID_DESC = 'systemId_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  VISIBLE_ASC = 'visible_ASC',
  VISIBLE_DESC = 'visible_DESC'
}

export type BetValueRestriction = Entity & {
  __typename?: 'BetValueRestriction';
  betValue?: Maybe<BetValue>;
  gameMode?: Maybe<GameMode>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** If a users match history is below this number, the bet value should be disabled. */
  minimumMatches: Scalars['Int'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type BetValueRestrictionBetValueArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BetValueRestrictionGameModeArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BetValueRestrictionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BetValueRestrictionWhereUniqueInput;
};

/** A connection to a list of items. */
export type BetValueRestrictionConnection = {
  __typename?: 'BetValueRestrictionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BetValueRestrictionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BetValueRestrictionCreateInput = {
  betValue?: InputMaybe<BetValueCreateOneInlineInput>;
  gameMode?: InputMaybe<GameModeCreateOneInlineInput>;
  minimumMatches: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BetValueRestrictionCreateManyInlineInput = {
  /** Create and connect multiple existing BetValueRestriction documents */
  create?: InputMaybe<Array<BetValueRestrictionCreateInput>>;
};

export type BetValueRestrictionCreateOneInlineInput = {
  /** Create and connect one BetValueRestriction document */
  create?: InputMaybe<BetValueRestrictionCreateInput>;
};

export type BetValueRestrictionCreateWithPositionInput = {
  /** Document to create */
  data: BetValueRestrictionCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type BetValueRestrictionEdge = {
  __typename?: 'BetValueRestrictionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BetValueRestriction;
};

/** Identifies documents */
export type BetValueRestrictionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetValueRestrictionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetValueRestrictionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetValueRestrictionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  betValue?: InputMaybe<BetValueWhereInput>;
  gameMode?: InputMaybe<GameModeWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  minimumMatches?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  minimumMatches_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  minimumMatches_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  minimumMatches_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  minimumMatches_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  minimumMatches_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  minimumMatches_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  minimumMatches_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export enum BetValueRestrictionOrderByInput {
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  MINIMUMMATCHES_ASC = 'minimumMatches_ASC',
  MINIMUMMATCHES_DESC = 'minimumMatches_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type BetValueRestrictionParent = BetValue;

export type BetValueRestrictionParentConnectInput = {
  BetValue?: InputMaybe<BetValueConnectInput>;
};

export type BetValueRestrictionParentCreateInput = {
  BetValue?: InputMaybe<BetValueCreateInput>;
};

export type BetValueRestrictionParentCreateManyInlineInput = {
  /** Connect multiple existing BetValueRestrictionParent documents */
  connect?: InputMaybe<Array<BetValueRestrictionParentWhereUniqueInput>>;
  /** Create and connect multiple existing BetValueRestrictionParent documents */
  create?: InputMaybe<Array<BetValueRestrictionParentCreateInput>>;
};

export type BetValueRestrictionParentCreateOneInlineInput = {
  /** Connect one existing BetValueRestrictionParent document */
  connect?: InputMaybe<BetValueRestrictionParentWhereUniqueInput>;
  /** Create and connect one BetValueRestrictionParent document */
  create?: InputMaybe<BetValueRestrictionParentCreateInput>;
};

export type BetValueRestrictionParentUpdateInput = {
  BetValue?: InputMaybe<BetValueUpdateInput>;
};

export type BetValueRestrictionParentUpdateManyInlineInput = {
  /** Connect multiple existing BetValueRestrictionParent documents */
  connect?: InputMaybe<Array<BetValueRestrictionParentConnectInput>>;
  /** Create and connect multiple BetValueRestrictionParent documents */
  create?: InputMaybe<Array<BetValueRestrictionParentCreateInput>>;
  /** Delete multiple BetValueRestrictionParent documents */
  delete?: InputMaybe<Array<BetValueRestrictionParentWhereUniqueInput>>;
  /** Disconnect multiple BetValueRestrictionParent documents */
  disconnect?: InputMaybe<Array<BetValueRestrictionParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BetValueRestrictionParent documents */
  set?: InputMaybe<Array<BetValueRestrictionParentWhereUniqueInput>>;
  /** Update multiple BetValueRestrictionParent documents */
  update?: InputMaybe<Array<BetValueRestrictionParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BetValueRestrictionParent documents */
  upsert?: InputMaybe<Array<BetValueRestrictionParentUpsertWithNestedWhereUniqueInput>>;
};

export type BetValueRestrictionParentUpdateManyWithNestedWhereInput = {
  BetValue?: InputMaybe<BetValueUpdateManyWithNestedWhereInput>;
};

export type BetValueRestrictionParentUpdateOneInlineInput = {
  /** Connect existing BetValueRestrictionParent document */
  connect?: InputMaybe<BetValueRestrictionParentWhereUniqueInput>;
  /** Create and connect one BetValueRestrictionParent document */
  create?: InputMaybe<BetValueRestrictionParentCreateInput>;
  /** Delete currently connected BetValueRestrictionParent document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected BetValueRestrictionParent document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single BetValueRestrictionParent document */
  update?: InputMaybe<BetValueRestrictionParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BetValueRestrictionParent document */
  upsert?: InputMaybe<BetValueRestrictionParentUpsertWithNestedWhereUniqueInput>;
};

export type BetValueRestrictionParentUpdateWithNestedWhereUniqueInput = {
  BetValue?: InputMaybe<BetValueUpdateWithNestedWhereUniqueInput>;
};

export type BetValueRestrictionParentUpsertWithNestedWhereUniqueInput = {
  BetValue?: InputMaybe<BetValueUpsertWithNestedWhereUniqueInput>;
};

export type BetValueRestrictionParentWhereInput = {
  BetValue?: InputMaybe<BetValueWhereInput>;
};

export type BetValueRestrictionParentWhereUniqueInput = {
  BetValue?: InputMaybe<BetValueWhereUniqueInput>;
};

export type BetValueRestrictionUpdateInput = {
  betValue?: InputMaybe<BetValueUpdateOneInlineInput>;
  gameMode?: InputMaybe<GameModeUpdateOneInlineInput>;
  minimumMatches?: InputMaybe<Scalars['Int']>;
};

export type BetValueRestrictionUpdateManyInlineInput = {
  /** Create and connect multiple BetValueRestriction component instances */
  create?: InputMaybe<Array<BetValueRestrictionCreateWithPositionInput>>;
  /** Delete multiple BetValueRestriction documents */
  delete?: InputMaybe<Array<BetValueRestrictionWhereUniqueInput>>;
  /** Update multiple BetValueRestriction component instances */
  update?: InputMaybe<Array<BetValueRestrictionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple BetValueRestriction component instances */
  upsert?: InputMaybe<Array<BetValueRestrictionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type BetValueRestrictionUpdateManyInput = {
  minimumMatches?: InputMaybe<Scalars['Int']>;
};

export type BetValueRestrictionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BetValueRestrictionUpdateManyInput;
  /** Document search */
  where: BetValueRestrictionWhereInput;
};

export type BetValueRestrictionUpdateOneInlineInput = {
  /** Create and connect one BetValueRestriction document */
  create?: InputMaybe<BetValueRestrictionCreateInput>;
  /** Delete currently connected BetValueRestriction document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Update single BetValueRestriction document */
  update?: InputMaybe<BetValueRestrictionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BetValueRestriction document */
  upsert?: InputMaybe<BetValueRestrictionUpsertWithNestedWhereUniqueInput>;
};

export type BetValueRestrictionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<BetValueRestrictionUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: BetValueRestrictionWhereUniqueInput;
};

export type BetValueRestrictionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BetValueRestrictionUpdateInput;
  /** Unique document search */
  where: BetValueRestrictionWhereUniqueInput;
};

export type BetValueRestrictionUpsertInput = {
  /** Create document if it didn't exist */
  create: BetValueRestrictionCreateInput;
  /** Update document if it exists */
  update: BetValueRestrictionUpdateInput;
};

export type BetValueRestrictionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<BetValueRestrictionUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: BetValueRestrictionWhereUniqueInput;
};

export type BetValueRestrictionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BetValueRestrictionUpsertInput;
  /** Unique document search */
  where: BetValueRestrictionWhereUniqueInput;
};

/** Identifies documents */
export type BetValueRestrictionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetValueRestrictionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetValueRestrictionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetValueRestrictionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  betValue?: InputMaybe<BetValueWhereInput>;
  gameMode?: InputMaybe<GameModeWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  minimumMatches?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  minimumMatches_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  minimumMatches_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  minimumMatches_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  minimumMatches_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  minimumMatches_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  minimumMatches_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  minimumMatches_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

/** References BetValueRestriction record uniquely */
export type BetValueRestrictionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type BetValueUpdateInput = {
  addon?: InputMaybe<Scalars['Float']>;
  betValueRestrictions?: InputMaybe<BetValueRestrictionUpdateManyInlineInput>;
  cle5w6wpu1zih01uj0piggapq?: InputMaybe<GameModeUpdateManyInlineInput>;
  clehpybv72c4101up8x6e8m32?: InputMaybe<GameModeUpdateManyInlineInput>;
  cljwv4yjn077w01ug0juo4psh?: InputMaybe<BetValueRestrictionUpdateManyInlineInput>;
  cm6jm6web025407iwf4o336fm?: InputMaybe<BetDenominationRestrictionUpdateManyInlineInput>;
  cm6jm62hn024p07iw6t08h730?: InputMaybe<BetDenominationRestrictionUpdateManyInlineInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  main?: InputMaybe<Scalars['Int']>;
  restriction?: InputMaybe<BetDenominationRestrictionUpdateOneInlineInput>;
  systemId?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type BetValueUpdateManyInlineInput = {
  /** Connect multiple existing BetValue documents */
  connect?: InputMaybe<Array<BetValueConnectInput>>;
  /** Create and connect multiple BetValue documents */
  create?: InputMaybe<Array<BetValueCreateInput>>;
  /** Delete multiple BetValue documents */
  delete?: InputMaybe<Array<BetValueWhereUniqueInput>>;
  /** Disconnect multiple BetValue documents */
  disconnect?: InputMaybe<Array<BetValueWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BetValue documents */
  set?: InputMaybe<Array<BetValueWhereUniqueInput>>;
  /** Update multiple BetValue documents */
  update?: InputMaybe<Array<BetValueUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BetValue documents */
  upsert?: InputMaybe<Array<BetValueUpsertWithNestedWhereUniqueInput>>;
};

export type BetValueUpdateManyInput = {
  addon?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  main?: InputMaybe<Scalars['Int']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type BetValueUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BetValueUpdateManyInput;
  /** Document search */
  where: BetValueWhereInput;
};

export type BetValueUpdateOneInlineInput = {
  /** Connect existing BetValue document */
  connect?: InputMaybe<BetValueWhereUniqueInput>;
  /** Create and connect one BetValue document */
  create?: InputMaybe<BetValueCreateInput>;
  /** Delete currently connected BetValue document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected BetValue document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single BetValue document */
  update?: InputMaybe<BetValueUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BetValue document */
  upsert?: InputMaybe<BetValueUpsertWithNestedWhereUniqueInput>;
};

export type BetValueUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BetValueUpdateInput;
  /** Unique document search */
  where: BetValueWhereUniqueInput;
};

export type BetValueUpsertInput = {
  /** Create document if it didn't exist */
  create: BetValueCreateInput;
  /** Update document if it exists */
  update: BetValueUpdateInput;
};

export type BetValueUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BetValueUpsertInput;
  /** Unique document search */
  where: BetValueWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BetValueWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type BetValueWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetValueWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetValueWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetValueWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  addon?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  addon_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  addon_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  addon_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  addon_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  addon_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  addon_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  addon_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  betValueRestrictions_every?: InputMaybe<BetValueRestrictionWhereInput>;
  betValueRestrictions_none?: InputMaybe<BetValueRestrictionWhereInput>;
  betValueRestrictions_some?: InputMaybe<BetValueRestrictionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BetValueWhereStageInput>;
  documentInStages_none?: InputMaybe<BetValueWhereStageInput>;
  documentInStages_some?: InputMaybe<BetValueWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  main?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  main_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  main_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  main_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  main_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  main_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  main_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  main_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  restriction?: InputMaybe<BetDenominationRestrictionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BetValueWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BetValueWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BetValueWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BetValueWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BetValueWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BetValue record uniquely */
export type BetValueWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  systemId?: InputMaybe<Scalars['String']>;
};

export enum ButtonTypes {
  ERROR = 'error',
  INFORMATION = 'information',
  SUCCESS = 'success',
  WARNING = 'warning'
}

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  css: Scalars['String'];
  hex: Scalars['Hex'];
  rgba: Rgba;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']>;
  rgba?: InputMaybe<RgbaInput>;
};

/** Content that might be shared across applications, etc. */
export type CommonContent = Entity & Node & {
  __typename?: 'CommonContent';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CommonContent>;
  /** List of CommonContent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Content name */
  reference: Scalars['String'];
  /** List of restricted states */
  restrictedStates: Array<UsStates>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Content */
  stringContent: Array<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Content that might be shared across applications, etc. */
export type CommonContentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content that might be shared across applications, etc. */
export type CommonContentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Content that might be shared across applications, etc. */
export type CommonContentHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Content that might be shared across applications, etc. */
export type CommonContentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content that might be shared across applications, etc. */
export type CommonContentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Content that might be shared across applications, etc. */
export type CommonContentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CommonContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CommonContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type CommonContentConnection = {
  __typename?: 'CommonContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CommonContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CommonContentCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  reference: Scalars['String'];
  restrictedStates?: InputMaybe<Array<UsStates>>;
  stringContent?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommonContentCreateManyInlineInput = {
  /** Connect multiple existing CommonContent documents */
  connect?: InputMaybe<Array<CommonContentWhereUniqueInput>>;
  /** Create and connect multiple existing CommonContent documents */
  create?: InputMaybe<Array<CommonContentCreateInput>>;
};

export type CommonContentCreateOneInlineInput = {
  /** Connect one existing CommonContent document */
  connect?: InputMaybe<CommonContentWhereUniqueInput>;
  /** Create and connect one CommonContent document */
  create?: InputMaybe<CommonContentCreateInput>;
};

/** An edge in a connection. */
export type CommonContentEdge = {
  __typename?: 'CommonContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CommonContent;
};

/** Identifies documents */
export type CommonContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CommonContentWhereStageInput>;
  documentInStages_none?: InputMaybe<CommonContentWhereStageInput>;
  documentInStages_some?: InputMaybe<CommonContentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  reference?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  reference_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  reference_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  reference_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  reference_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  reference_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  reference_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  reference_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  reference_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  reference_starts_with?: InputMaybe<Scalars['String']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  restrictedStates?: InputMaybe<Array<UsStates>>;
  /** Matches if the field array contains *all* items provided to the filter */
  restrictedStates_contains_all?: InputMaybe<Array<UsStates>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  restrictedStates_contains_none?: InputMaybe<Array<UsStates>>;
  /** Matches if the field array contains at least one item provided to the filter */
  restrictedStates_contains_some?: InputMaybe<Array<UsStates>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  restrictedStates_not?: InputMaybe<Array<UsStates>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  stringContent?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  stringContent_contains_all?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  stringContent_contains_none?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  stringContent_contains_some?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  stringContent_not?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CommonContentOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  REFERENCE_ASC = 'reference_ASC',
  REFERENCE_DESC = 'reference_DESC',
  RESTRICTEDSTATES_ASC = 'restrictedStates_ASC',
  RESTRICTEDSTATES_DESC = 'restrictedStates_DESC',
  STRINGCONTENT_ASC = 'stringContent_ASC',
  STRINGCONTENT_DESC = 'stringContent_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type CommonContentUpdateInput = {
  reference?: InputMaybe<Scalars['String']>;
  restrictedStates?: InputMaybe<Array<UsStates>>;
  stringContent?: InputMaybe<Array<Scalars['String']>>;
};

export type CommonContentUpdateManyInlineInput = {
  /** Connect multiple existing CommonContent documents */
  connect?: InputMaybe<Array<CommonContentConnectInput>>;
  /** Create and connect multiple CommonContent documents */
  create?: InputMaybe<Array<CommonContentCreateInput>>;
  /** Delete multiple CommonContent documents */
  delete?: InputMaybe<Array<CommonContentWhereUniqueInput>>;
  /** Disconnect multiple CommonContent documents */
  disconnect?: InputMaybe<Array<CommonContentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CommonContent documents */
  set?: InputMaybe<Array<CommonContentWhereUniqueInput>>;
  /** Update multiple CommonContent documents */
  update?: InputMaybe<Array<CommonContentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CommonContent documents */
  upsert?: InputMaybe<Array<CommonContentUpsertWithNestedWhereUniqueInput>>;
};

export type CommonContentUpdateManyInput = {
  restrictedStates?: InputMaybe<Array<UsStates>>;
  stringContent?: InputMaybe<Array<Scalars['String']>>;
};

export type CommonContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CommonContentUpdateManyInput;
  /** Document search */
  where: CommonContentWhereInput;
};

export type CommonContentUpdateOneInlineInput = {
  /** Connect existing CommonContent document */
  connect?: InputMaybe<CommonContentWhereUniqueInput>;
  /** Create and connect one CommonContent document */
  create?: InputMaybe<CommonContentCreateInput>;
  /** Delete currently connected CommonContent document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected CommonContent document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single CommonContent document */
  update?: InputMaybe<CommonContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CommonContent document */
  upsert?: InputMaybe<CommonContentUpsertWithNestedWhereUniqueInput>;
};

export type CommonContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CommonContentUpdateInput;
  /** Unique document search */
  where: CommonContentWhereUniqueInput;
};

export type CommonContentUpsertInput = {
  /** Create document if it didn't exist */
  create: CommonContentCreateInput;
  /** Update document if it exists */
  update: CommonContentUpdateInput;
};

export type CommonContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CommonContentUpsertInput;
  /** Unique document search */
  where: CommonContentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CommonContentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type CommonContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CommonContentWhereStageInput>;
  documentInStages_none?: InputMaybe<CommonContentWhereStageInput>;
  documentInStages_some?: InputMaybe<CommonContentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  reference?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  reference_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  reference_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  reference_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  reference_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  reference_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  reference_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  reference_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  reference_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  reference_starts_with?: InputMaybe<Scalars['String']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  restrictedStates?: InputMaybe<Array<UsStates>>;
  /** Matches if the field array contains *all* items provided to the filter */
  restrictedStates_contains_all?: InputMaybe<Array<UsStates>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  restrictedStates_contains_none?: InputMaybe<Array<UsStates>>;
  /** Matches if the field array contains at least one item provided to the filter */
  restrictedStates_contains_some?: InputMaybe<Array<UsStates>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  restrictedStates_not?: InputMaybe<Array<UsStates>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  stringContent?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  stringContent_contains_all?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  stringContent_contains_none?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  stringContent_contains_some?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  stringContent_not?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CommonContentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonContentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonContentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonContentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CommonContentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CommonContent record uniquely */
export type CommonContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  reference?: InputMaybe<Scalars['String']>;
};

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']>;
};

export enum CtaButtonClickType {
  DEEPLINK = 'deeplink',
  INTERCOM = 'intercom',
  WEBVIEW = 'webview'
}

export type DefaultGameState = Entity & Node & {
  __typename?: 'DefaultGameState';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<DefaultGameState>;
  game?: Maybe<Game>;
  gameMode?: Maybe<GameMode>;
  gameSeries?: Maybe<GameSeries>;
  /** List of DefaultGameState versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type DefaultGameStateCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DefaultGameStateDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type DefaultGameStateGameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DefaultGameStateGameModeArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DefaultGameStateGameSeriesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DefaultGameStateHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type DefaultGameStatePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DefaultGameStateScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type DefaultGameStateUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DefaultGameStateConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DefaultGameStateWhereUniqueInput;
};

/** A connection to a list of items. */
export type DefaultGameStateConnection = {
  __typename?: 'DefaultGameStateConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DefaultGameStateEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DefaultGameStateCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  game?: InputMaybe<GameCreateOneInlineInput>;
  gameMode?: InputMaybe<GameModeCreateOneInlineInput>;
  gameSeries?: InputMaybe<GameSeriesCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefaultGameStateCreateManyInlineInput = {
  /** Connect multiple existing DefaultGameState documents */
  connect?: InputMaybe<Array<DefaultGameStateWhereUniqueInput>>;
  /** Create and connect multiple existing DefaultGameState documents */
  create?: InputMaybe<Array<DefaultGameStateCreateInput>>;
};

export type DefaultGameStateCreateOneInlineInput = {
  /** Connect one existing DefaultGameState document */
  connect?: InputMaybe<DefaultGameStateWhereUniqueInput>;
  /** Create and connect one DefaultGameState document */
  create?: InputMaybe<DefaultGameStateCreateInput>;
};

/** An edge in a connection. */
export type DefaultGameStateEdge = {
  __typename?: 'DefaultGameStateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DefaultGameState;
};

/** Identifies documents */
export type DefaultGameStateManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DefaultGameStateWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DefaultGameStateWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DefaultGameStateWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DefaultGameStateWhereStageInput>;
  documentInStages_none?: InputMaybe<DefaultGameStateWhereStageInput>;
  documentInStages_some?: InputMaybe<DefaultGameStateWhereStageInput>;
  game?: InputMaybe<GameWhereInput>;
  gameMode?: InputMaybe<GameModeWhereInput>;
  gameSeries?: InputMaybe<GameSeriesWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DefaultGameStateOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type DefaultGameStateUpdateInput = {
  game?: InputMaybe<GameUpdateOneInlineInput>;
  gameMode?: InputMaybe<GameModeUpdateOneInlineInput>;
  gameSeries?: InputMaybe<GameSeriesUpdateOneInlineInput>;
};

export type DefaultGameStateUpdateManyInlineInput = {
  /** Connect multiple existing DefaultGameState documents */
  connect?: InputMaybe<Array<DefaultGameStateConnectInput>>;
  /** Create and connect multiple DefaultGameState documents */
  create?: InputMaybe<Array<DefaultGameStateCreateInput>>;
  /** Delete multiple DefaultGameState documents */
  delete?: InputMaybe<Array<DefaultGameStateWhereUniqueInput>>;
  /** Disconnect multiple DefaultGameState documents */
  disconnect?: InputMaybe<Array<DefaultGameStateWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DefaultGameState documents */
  set?: InputMaybe<Array<DefaultGameStateWhereUniqueInput>>;
  /** Update multiple DefaultGameState documents */
  update?: InputMaybe<Array<DefaultGameStateUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DefaultGameState documents */
  upsert?: InputMaybe<Array<DefaultGameStateUpsertWithNestedWhereUniqueInput>>;
};

export type DefaultGameStateUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']>;
};

export type DefaultGameStateUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DefaultGameStateUpdateManyInput;
  /** Document search */
  where: DefaultGameStateWhereInput;
};

export type DefaultGameStateUpdateOneInlineInput = {
  /** Connect existing DefaultGameState document */
  connect?: InputMaybe<DefaultGameStateWhereUniqueInput>;
  /** Create and connect one DefaultGameState document */
  create?: InputMaybe<DefaultGameStateCreateInput>;
  /** Delete currently connected DefaultGameState document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected DefaultGameState document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single DefaultGameState document */
  update?: InputMaybe<DefaultGameStateUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DefaultGameState document */
  upsert?: InputMaybe<DefaultGameStateUpsertWithNestedWhereUniqueInput>;
};

export type DefaultGameStateUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DefaultGameStateUpdateInput;
  /** Unique document search */
  where: DefaultGameStateWhereUniqueInput;
};

export type DefaultGameStateUpsertInput = {
  /** Create document if it didn't exist */
  create: DefaultGameStateCreateInput;
  /** Update document if it exists */
  update: DefaultGameStateUpdateInput;
};

export type DefaultGameStateUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DefaultGameStateUpsertInput;
  /** Unique document search */
  where: DefaultGameStateWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DefaultGameStateWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type DefaultGameStateWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DefaultGameStateWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DefaultGameStateWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DefaultGameStateWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DefaultGameStateWhereStageInput>;
  documentInStages_none?: InputMaybe<DefaultGameStateWhereStageInput>;
  documentInStages_some?: InputMaybe<DefaultGameStateWhereStageInput>;
  game?: InputMaybe<GameWhereInput>;
  gameMode?: InputMaybe<GameModeWhereInput>;
  gameSeries?: InputMaybe<GameSeriesWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DefaultGameStateWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DefaultGameStateWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DefaultGameStateWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DefaultGameStateWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DefaultGameStateWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DefaultGameState record uniquely */
export type DefaultGameStateWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type DefaultPayoutBand = Entity & Node & {
  __typename?: 'DefaultPayoutBand';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<DefaultPayoutBand>;
  /** List of DefaultPayoutBand versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  payoutBand: PayoutBands;
  /**
   * The payout band minimum is a value that greater than or
   * equal to the value you select.
   *
   * e.g. 500 mean any value >=500 will be in this band. Higher numbers take prescidence
   */
  payoutBandMinimum: Scalars['Int'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type DefaultPayoutBandCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DefaultPayoutBandDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type DefaultPayoutBandHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type DefaultPayoutBandPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DefaultPayoutBandScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type DefaultPayoutBandUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DefaultPayoutBandConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DefaultPayoutBandWhereUniqueInput;
};

/** A connection to a list of items. */
export type DefaultPayoutBandConnection = {
  __typename?: 'DefaultPayoutBandConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DefaultPayoutBandEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DefaultPayoutBandCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  payoutBand: PayoutBands;
  payoutBandMinimum: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefaultPayoutBandCreateManyInlineInput = {
  /** Connect multiple existing DefaultPayoutBand documents */
  connect?: InputMaybe<Array<DefaultPayoutBandWhereUniqueInput>>;
  /** Create and connect multiple existing DefaultPayoutBand documents */
  create?: InputMaybe<Array<DefaultPayoutBandCreateInput>>;
};

export type DefaultPayoutBandCreateOneInlineInput = {
  /** Connect one existing DefaultPayoutBand document */
  connect?: InputMaybe<DefaultPayoutBandWhereUniqueInput>;
  /** Create and connect one DefaultPayoutBand document */
  create?: InputMaybe<DefaultPayoutBandCreateInput>;
};

/** An edge in a connection. */
export type DefaultPayoutBandEdge = {
  __typename?: 'DefaultPayoutBandEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DefaultPayoutBand;
};

/** Identifies documents */
export type DefaultPayoutBandManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DefaultPayoutBandWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DefaultPayoutBandWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DefaultPayoutBandWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DefaultPayoutBandWhereStageInput>;
  documentInStages_none?: InputMaybe<DefaultPayoutBandWhereStageInput>;
  documentInStages_some?: InputMaybe<DefaultPayoutBandWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  payoutBand?: InputMaybe<PayoutBands>;
  payoutBandMinimum?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  payoutBandMinimum_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  payoutBandMinimum_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  payoutBandMinimum_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  payoutBandMinimum_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  payoutBandMinimum_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  payoutBandMinimum_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  payoutBandMinimum_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values that are contained in given list. */
  payoutBand_in?: InputMaybe<Array<InputMaybe<PayoutBands>>>;
  /** Any other value that exists and is not equal to the given value. */
  payoutBand_not?: InputMaybe<PayoutBands>;
  /** All values that are not contained in given list. */
  payoutBand_not_in?: InputMaybe<Array<InputMaybe<PayoutBands>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DefaultPayoutBandOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PAYOUTBANDMINIMUM_ASC = 'payoutBandMinimum_ASC',
  PAYOUTBANDMINIMUM_DESC = 'payoutBandMinimum_DESC',
  PAYOUTBAND_ASC = 'payoutBand_ASC',
  PAYOUTBAND_DESC = 'payoutBand_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type DefaultPayoutBandUpdateInput = {
  payoutBand?: InputMaybe<PayoutBands>;
  payoutBandMinimum?: InputMaybe<Scalars['Int']>;
};

export type DefaultPayoutBandUpdateManyInlineInput = {
  /** Connect multiple existing DefaultPayoutBand documents */
  connect?: InputMaybe<Array<DefaultPayoutBandConnectInput>>;
  /** Create and connect multiple DefaultPayoutBand documents */
  create?: InputMaybe<Array<DefaultPayoutBandCreateInput>>;
  /** Delete multiple DefaultPayoutBand documents */
  delete?: InputMaybe<Array<DefaultPayoutBandWhereUniqueInput>>;
  /** Disconnect multiple DefaultPayoutBand documents */
  disconnect?: InputMaybe<Array<DefaultPayoutBandWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DefaultPayoutBand documents */
  set?: InputMaybe<Array<DefaultPayoutBandWhereUniqueInput>>;
  /** Update multiple DefaultPayoutBand documents */
  update?: InputMaybe<Array<DefaultPayoutBandUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DefaultPayoutBand documents */
  upsert?: InputMaybe<Array<DefaultPayoutBandUpsertWithNestedWhereUniqueInput>>;
};

export type DefaultPayoutBandUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']>;
};

export type DefaultPayoutBandUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DefaultPayoutBandUpdateManyInput;
  /** Document search */
  where: DefaultPayoutBandWhereInput;
};

export type DefaultPayoutBandUpdateOneInlineInput = {
  /** Connect existing DefaultPayoutBand document */
  connect?: InputMaybe<DefaultPayoutBandWhereUniqueInput>;
  /** Create and connect one DefaultPayoutBand document */
  create?: InputMaybe<DefaultPayoutBandCreateInput>;
  /** Delete currently connected DefaultPayoutBand document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected DefaultPayoutBand document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single DefaultPayoutBand document */
  update?: InputMaybe<DefaultPayoutBandUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DefaultPayoutBand document */
  upsert?: InputMaybe<DefaultPayoutBandUpsertWithNestedWhereUniqueInput>;
};

export type DefaultPayoutBandUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DefaultPayoutBandUpdateInput;
  /** Unique document search */
  where: DefaultPayoutBandWhereUniqueInput;
};

export type DefaultPayoutBandUpsertInput = {
  /** Create document if it didn't exist */
  create: DefaultPayoutBandCreateInput;
  /** Update document if it exists */
  update: DefaultPayoutBandUpdateInput;
};

export type DefaultPayoutBandUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DefaultPayoutBandUpsertInput;
  /** Unique document search */
  where: DefaultPayoutBandWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DefaultPayoutBandWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type DefaultPayoutBandWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DefaultPayoutBandWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DefaultPayoutBandWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DefaultPayoutBandWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DefaultPayoutBandWhereStageInput>;
  documentInStages_none?: InputMaybe<DefaultPayoutBandWhereStageInput>;
  documentInStages_some?: InputMaybe<DefaultPayoutBandWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  payoutBand?: InputMaybe<PayoutBands>;
  payoutBandMinimum?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  payoutBandMinimum_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  payoutBandMinimum_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  payoutBandMinimum_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  payoutBandMinimum_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  payoutBandMinimum_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  payoutBandMinimum_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  payoutBandMinimum_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values that are contained in given list. */
  payoutBand_in?: InputMaybe<Array<InputMaybe<PayoutBands>>>;
  /** Any other value that exists and is not equal to the given value. */
  payoutBand_not?: InputMaybe<PayoutBands>;
  /** All values that are not contained in given list. */
  payoutBand_not_in?: InputMaybe<Array<InputMaybe<PayoutBands>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DefaultPayoutBandWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DefaultPayoutBandWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DefaultPayoutBandWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DefaultPayoutBandWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DefaultPayoutBandWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DefaultPayoutBand record uniquely */
export type DefaultPayoutBandWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  payoutBand?: InputMaybe<PayoutBands>;
  payoutBandMinimum?: InputMaybe<Scalars['Int']>;
};

/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModel = Entity & Node & {
  __typename?: 'DemoModel';
  content: DemoModelContentRichText;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<DemoModel>;
  /** List of DemoModel versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String'];
  /** System stage field */
  stage: Stage;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DemoModelConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DemoModelWhereUniqueInput;
};

/** A connection to a list of items. */
export type DemoModelConnection = {
  __typename?: 'DemoModelConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DemoModelEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DemoModelContentRichText = {
  __typename?: 'DemoModelContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  json: Scalars['RichTextAST'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST'];
  references: Array<DemoModelContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};


export type DemoModelContentRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type DemoModelContentRichTextEmbeddedTypes = Asset;

export type DemoModelCreateInput = {
  content: Scalars['RichTextAST'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DemoModelCreateManyInlineInput = {
  /** Connect multiple existing DemoModel documents */
  connect?: InputMaybe<Array<DemoModelWhereUniqueInput>>;
  /** Create and connect multiple existing DemoModel documents */
  create?: InputMaybe<Array<DemoModelCreateInput>>;
};

export type DemoModelCreateOneInlineInput = {
  /** Connect one existing DemoModel document */
  connect?: InputMaybe<DemoModelWhereUniqueInput>;
  /** Create and connect one DemoModel document */
  create?: InputMaybe<DemoModelCreateInput>;
};

/** An edge in a connection. */
export type DemoModelEdge = {
  __typename?: 'DemoModelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DemoModel;
};

/** Identifies documents */
export type DemoModelManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DemoModelWhereStageInput>;
  documentInStages_none?: InputMaybe<DemoModelWhereStageInput>;
  documentInStages_some?: InputMaybe<DemoModelWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DemoModelOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  SLUG_ASC = 'slug_ASC',
  SLUG_DESC = 'slug_DESC',
  SUBTITLE_ASC = 'subtitle_ASC',
  SUBTITLE_DESC = 'subtitle_DESC',
  TITLE_ASC = 'title_ASC',
  TITLE_DESC = 'title_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type DemoModelUpdateInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
  slug?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type DemoModelUpdateManyInlineInput = {
  /** Connect multiple existing DemoModel documents */
  connect?: InputMaybe<Array<DemoModelConnectInput>>;
  /** Create and connect multiple DemoModel documents */
  create?: InputMaybe<Array<DemoModelCreateInput>>;
  /** Delete multiple DemoModel documents */
  delete?: InputMaybe<Array<DemoModelWhereUniqueInput>>;
  /** Disconnect multiple DemoModel documents */
  disconnect?: InputMaybe<Array<DemoModelWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DemoModel documents */
  set?: InputMaybe<Array<DemoModelWhereUniqueInput>>;
  /** Update multiple DemoModel documents */
  update?: InputMaybe<Array<DemoModelUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DemoModel documents */
  upsert?: InputMaybe<Array<DemoModelUpsertWithNestedWhereUniqueInput>>;
};

export type DemoModelUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type DemoModelUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DemoModelUpdateManyInput;
  /** Document search */
  where: DemoModelWhereInput;
};

export type DemoModelUpdateOneInlineInput = {
  /** Connect existing DemoModel document */
  connect?: InputMaybe<DemoModelWhereUniqueInput>;
  /** Create and connect one DemoModel document */
  create?: InputMaybe<DemoModelCreateInput>;
  /** Delete currently connected DemoModel document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected DemoModel document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single DemoModel document */
  update?: InputMaybe<DemoModelUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DemoModel document */
  upsert?: InputMaybe<DemoModelUpsertWithNestedWhereUniqueInput>;
};

export type DemoModelUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DemoModelUpdateInput;
  /** Unique document search */
  where: DemoModelWhereUniqueInput;
};

export type DemoModelUpsertInput = {
  /** Create document if it didn't exist */
  create: DemoModelCreateInput;
  /** Update document if it exists */
  update: DemoModelUpdateInput;
};

export type DemoModelUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DemoModelUpsertInput;
  /** Unique document search */
  where: DemoModelWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DemoModelWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type DemoModelWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DemoModelWhereStageInput>;
  documentInStages_none?: InputMaybe<DemoModelWhereStageInput>;
  documentInStages_some?: InputMaybe<DemoModelWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DemoModelWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DemoModelWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DemoModelWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DemoModelWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DemoModelWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DemoModel record uniquely */
export type DemoModelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  AUTOIMAGE = 'autoImage',
  AVIF = 'avif',
  BMP = 'bmp',
  GIF = 'gif',
  HEIC = 'heic',
  JPG = 'jpg',
  PNG = 'png',
  SVG = 'svg',
  TIFF = 'tiff',
  WEBP = 'webp'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  /** Admins of the app and allowed permissions in app */
  ADMIN = 'Admin',
  /** Content for known issues in characters within the apex game */
  APEXCHARACTERISSUE = 'ApexCharacterIssue',
  /** Asset system model */
  ASSET = 'Asset',
  /** Bet Categories prioritization list */
  BETCATEGORY = 'BetCategory',
  BETDENOMINATIONRESTRICTION = 'BetDenominationRestriction',
  /** Handles all the bet line information */
  BETLINE = 'BetLine',
  BETLINERULE = 'BetLineRule',
  BETRESTRICTION = 'BetRestriction',
  BETVALUE = 'BetValue',
  BETVALUERESTRICTION = 'BetValueRestriction',
  /** Content that might be shared across applications, etc. */
  COMMONCONTENT = 'CommonContent',
  DEFAULTGAMESTATE = 'DefaultGameState',
  DEFAULTPAYOUTBAND = 'DefaultPayoutBand',
  /** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
  DEMOMODEL = 'DemoModel',
  FAQ = 'FAQ',
  /** Controls display names of FAQ categories. */
  FAQCATEGORYMODEL = 'FaqCategoryModel',
  FEATUREFLAG = 'FeatureFlag',
  GAME = 'Game',
  GAMEMODE = 'GameMode',
  /** Extra information that gets displayed on the game mode selection modal */
  GAMEMODECALLOUT = 'GameModeCallout',
  GAMESERIES = 'GameSeries',
  /** List of common problems that a user would contact support for help */
  MATCHISSUE = 'MatchIssue',
  /** Question and answers to be displayed during the onboarding flow for a particular game */
  ONBOARDINGQUESTION = 'OnboardingQuestion',
  PARTNERAD = 'PartnerAd',
  PAYOUTBAND = 'PayoutBand',
  /** Phrases used in the application copy  */
  PHRASE = 'Phrase',
  PLATFORM = 'Platform',
  PLAYBANNER = 'PlayBanner',
  REGEXPATTERN = 'RegexPattern',
  RESTRICTION = 'Restriction',
  /** Scheduled Operation system model */
  SCHEDULEDOPERATION = 'ScheduledOperation',
  /** Scheduled Release system model */
  SCHEDULEDRELEASE = 'ScheduledRelease',
  TEAMSIZE = 'TeamSize',
  /** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
  TERMSANDPRIVACY = 'TermsandPrivacy',
  /** How to stream to twitch explainer */
  TWITCHEXPLAINER = 'TwitchExplainer',
  /** User system model */
  USER = 'User'
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export type Faq = Entity & Node & {
  __typename?: 'FAQ';
  answer?: Maybe<Scalars['String']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Faq>;
  /** What category does this FAQ question belong to? A value is required. */
  faq_category: FaqCategory;
  /** Indicates whether this question relates to Head to Head or Connect (pick both for it to display on both FAQ pages) */
  faq_product: Array<Product>;
  /** List of FAQ versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Priority number used to order the FAQs */
  priority: Scalars['Int'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  question?: Maybe<Scalars['String']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FaqCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type FaqHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type FaqPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FaqUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqConnection = {
  __typename?: 'FAQConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqCreateInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  faq_category: FaqCategory;
  faq_product?: InputMaybe<Array<Product>>;
  priority: Scalars['Int'];
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FaqCreateManyInlineInput = {
  /** Connect multiple existing FAQ documents */
  connect?: InputMaybe<Array<FaqWhereUniqueInput>>;
  /** Create and connect multiple existing FAQ documents */
  create?: InputMaybe<Array<FaqCreateInput>>;
};

export type FaqCreateOneInlineInput = {
  /** Connect one existing FAQ document */
  connect?: InputMaybe<FaqWhereUniqueInput>;
  /** Create and connect one FAQ document */
  create?: InputMaybe<FaqCreateInput>;
};

/** An edge in a connection. */
export type FaqEdge = {
  __typename?: 'FAQEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Faq;
};

/** Identifies documents */
export type FaqManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  answer?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  answer_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  answer_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  answer_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  answer_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  answer_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  answer_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  answer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  answer_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  answer_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FaqWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqWhereStageInput>;
  faq_category?: InputMaybe<FaqCategory>;
  /** All values that are contained in given list. */
  faq_category_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  /** Any other value that exists and is not equal to the given value. */
  faq_category_not?: InputMaybe<FaqCategory>;
  /** All values that are not contained in given list. */
  faq_category_not_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  faq_product?: InputMaybe<Array<Product>>;
  /** Matches if the field array contains *all* items provided to the filter */
  faq_product_contains_all?: InputMaybe<Array<Product>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  faq_product_contains_none?: InputMaybe<Array<Product>>;
  /** Matches if the field array contains at least one item provided to the filter */
  faq_product_contains_some?: InputMaybe<Array<Product>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  faq_product_not?: InputMaybe<Array<Product>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  question?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FaqOrderByInput {
  ANSWER_ASC = 'answer_ASC',
  ANSWER_DESC = 'answer_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  FAQ_CATEGORY_ASC = 'faq_category_ASC',
  FAQ_CATEGORY_DESC = 'faq_category_DESC',
  FAQ_PRODUCT_ASC = 'faq_product_ASC',
  FAQ_PRODUCT_DESC = 'faq_product_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PRIORITY_ASC = 'priority_ASC',
  PRIORITY_DESC = 'priority_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  QUESTION_ASC = 'question_ASC',
  QUESTION_DESC = 'question_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type FaqUpdateInput = {
  answer?: InputMaybe<Scalars['String']>;
  faq_category?: InputMaybe<FaqCategory>;
  faq_product?: InputMaybe<Array<Product>>;
  priority?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
};

export type FaqUpdateManyInlineInput = {
  /** Connect multiple existing FAQ documents */
  connect?: InputMaybe<Array<FaqConnectInput>>;
  /** Create and connect multiple FAQ documents */
  create?: InputMaybe<Array<FaqCreateInput>>;
  /** Delete multiple FAQ documents */
  delete?: InputMaybe<Array<FaqWhereUniqueInput>>;
  /** Disconnect multiple FAQ documents */
  disconnect?: InputMaybe<Array<FaqWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FAQ documents */
  set?: InputMaybe<Array<FaqWhereUniqueInput>>;
  /** Update multiple FAQ documents */
  update?: InputMaybe<Array<FaqUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FAQ documents */
  upsert?: InputMaybe<Array<FaqUpsertWithNestedWhereUniqueInput>>;
};

export type FaqUpdateManyInput = {
  answer?: InputMaybe<Scalars['String']>;
  faq_category?: InputMaybe<FaqCategory>;
  faq_product?: InputMaybe<Array<Product>>;
  question?: InputMaybe<Scalars['String']>;
};

export type FaqUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqUpdateManyInput;
  /** Document search */
  where: FaqWhereInput;
};

export type FaqUpdateOneInlineInput = {
  /** Connect existing FAQ document */
  connect?: InputMaybe<FaqWhereUniqueInput>;
  /** Create and connect one FAQ document */
  create?: InputMaybe<FaqCreateInput>;
  /** Delete currently connected FAQ document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected FAQ document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single FAQ document */
  update?: InputMaybe<FaqUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FAQ document */
  upsert?: InputMaybe<FaqUpsertWithNestedWhereUniqueInput>;
};

export type FaqUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqUpdateInput;
  /** Unique document search */
  where: FaqWhereUniqueInput;
};

export type FaqUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqCreateInput;
  /** Update document if it exists */
  update: FaqUpdateInput;
};

export type FaqUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqUpsertInput;
  /** Unique document search */
  where: FaqWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FaqWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type FaqWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  answer?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  answer_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  answer_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  answer_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  answer_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  answer_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  answer_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  answer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  answer_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  answer_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FaqWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqWhereStageInput>;
  faq_category?: InputMaybe<FaqCategory>;
  /** All values that are contained in given list. */
  faq_category_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  /** Any other value that exists and is not equal to the given value. */
  faq_category_not?: InputMaybe<FaqCategory>;
  /** All values that are not contained in given list. */
  faq_category_not_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  faq_product?: InputMaybe<Array<Product>>;
  /** Matches if the field array contains *all* items provided to the filter */
  faq_product_contains_all?: InputMaybe<Array<Product>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  faq_product_contains_none?: InputMaybe<Array<Product>>;
  /** Matches if the field array contains at least one item provided to the filter */
  faq_product_contains_some?: InputMaybe<Array<Product>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  faq_product_not?: InputMaybe<Array<Product>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  question?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FaqWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FaqWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FAQ record uniquely */
export type FaqWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
};

/** Category that the question falls under on an FAQ page. */
export enum FaqCategory {
  ACCOUNT = 'account',
  APEX = 'apex',
  BONUS_BETS = 'bonus_bets',
  COD = 'cod',
  FAIRNESS = 'fairness',
  GENERAL = 'general',
  MATCHES = 'matches',
  PLUS = 'plus',
  SPORTS_GAMES = 'sports_games',
  SUPPORT = 'support',
  UPCOMING_GAMES = 'upcoming_games',
  WITHDRAWALS = 'withdrawals'
}

/** Controls display names of FAQ categories. */
export type FaqCategoryModel = Entity & Node & {
  __typename?: 'FaqCategoryModel';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Display name for an FAQ category */
  displayName: Scalars['String'];
  /** Get the document in other stages */
  documentInStages: Array<FaqCategoryModel>;
  /** Category enum. Non-pretty display. */
  faqCategory: FaqCategory;
  /** List of FaqCategoryModel versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Priority order of the FAQ list */
  priority: Scalars['Int'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Controls display names of FAQ categories. */
export type FaqCategoryModelCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Controls display names of FAQ categories. */
export type FaqCategoryModelDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Controls display names of FAQ categories. */
export type FaqCategoryModelHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Controls display names of FAQ categories. */
export type FaqCategoryModelPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Controls display names of FAQ categories. */
export type FaqCategoryModelScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Controls display names of FAQ categories. */
export type FaqCategoryModelUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqCategoryModelConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqCategoryModelWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqCategoryModelConnection = {
  __typename?: 'FaqCategoryModelConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqCategoryModelEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqCategoryModelCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  faqCategory: FaqCategory;
  priority: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FaqCategoryModelCreateManyInlineInput = {
  /** Connect multiple existing FaqCategoryModel documents */
  connect?: InputMaybe<Array<FaqCategoryModelWhereUniqueInput>>;
  /** Create and connect multiple existing FaqCategoryModel documents */
  create?: InputMaybe<Array<FaqCategoryModelCreateInput>>;
};

export type FaqCategoryModelCreateOneInlineInput = {
  /** Connect one existing FaqCategoryModel document */
  connect?: InputMaybe<FaqCategoryModelWhereUniqueInput>;
  /** Create and connect one FaqCategoryModel document */
  create?: InputMaybe<FaqCategoryModelCreateInput>;
};

/** An edge in a connection. */
export type FaqCategoryModelEdge = {
  __typename?: 'FaqCategoryModelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FaqCategoryModel;
};

/** Identifies documents */
export type FaqCategoryModelManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqCategoryModelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqCategoryModelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqCategoryModelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<FaqCategoryModelWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqCategoryModelWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqCategoryModelWhereStageInput>;
  faqCategory?: InputMaybe<FaqCategory>;
  /** All values that are contained in given list. */
  faqCategory_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  /** Any other value that exists and is not equal to the given value. */
  faqCategory_not?: InputMaybe<FaqCategory>;
  /** All values that are not contained in given list. */
  faqCategory_not_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FaqCategoryModelOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DISPLAYNAME_ASC = 'displayName_ASC',
  DISPLAYNAME_DESC = 'displayName_DESC',
  FAQCATEGORY_ASC = 'faqCategory_ASC',
  FAQCATEGORY_DESC = 'faqCategory_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PRIORITY_ASC = 'priority_ASC',
  PRIORITY_DESC = 'priority_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type FaqCategoryModelUpdateInput = {
  displayName?: InputMaybe<Scalars['String']>;
  faqCategory?: InputMaybe<FaqCategory>;
  priority?: InputMaybe<Scalars['Int']>;
};

export type FaqCategoryModelUpdateManyInlineInput = {
  /** Connect multiple existing FaqCategoryModel documents */
  connect?: InputMaybe<Array<FaqCategoryModelConnectInput>>;
  /** Create and connect multiple FaqCategoryModel documents */
  create?: InputMaybe<Array<FaqCategoryModelCreateInput>>;
  /** Delete multiple FaqCategoryModel documents */
  delete?: InputMaybe<Array<FaqCategoryModelWhereUniqueInput>>;
  /** Disconnect multiple FaqCategoryModel documents */
  disconnect?: InputMaybe<Array<FaqCategoryModelWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FaqCategoryModel documents */
  set?: InputMaybe<Array<FaqCategoryModelWhereUniqueInput>>;
  /** Update multiple FaqCategoryModel documents */
  update?: InputMaybe<Array<FaqCategoryModelUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FaqCategoryModel documents */
  upsert?: InputMaybe<Array<FaqCategoryModelUpsertWithNestedWhereUniqueInput>>;
};

export type FaqCategoryModelUpdateManyInput = {
  displayName?: InputMaybe<Scalars['String']>;
};

export type FaqCategoryModelUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqCategoryModelUpdateManyInput;
  /** Document search */
  where: FaqCategoryModelWhereInput;
};

export type FaqCategoryModelUpdateOneInlineInput = {
  /** Connect existing FaqCategoryModel document */
  connect?: InputMaybe<FaqCategoryModelWhereUniqueInput>;
  /** Create and connect one FaqCategoryModel document */
  create?: InputMaybe<FaqCategoryModelCreateInput>;
  /** Delete currently connected FaqCategoryModel document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected FaqCategoryModel document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single FaqCategoryModel document */
  update?: InputMaybe<FaqCategoryModelUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqCategoryModel document */
  upsert?: InputMaybe<FaqCategoryModelUpsertWithNestedWhereUniqueInput>;
};

export type FaqCategoryModelUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqCategoryModelUpdateInput;
  /** Unique document search */
  where: FaqCategoryModelWhereUniqueInput;
};

export type FaqCategoryModelUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqCategoryModelCreateInput;
  /** Update document if it exists */
  update: FaqCategoryModelUpdateInput;
};

export type FaqCategoryModelUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqCategoryModelUpsertInput;
  /** Unique document search */
  where: FaqCategoryModelWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FaqCategoryModelWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type FaqCategoryModelWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqCategoryModelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqCategoryModelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqCategoryModelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<FaqCategoryModelWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqCategoryModelWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqCategoryModelWhereStageInput>;
  faqCategory?: InputMaybe<FaqCategory>;
  /** All values that are contained in given list. */
  faqCategory_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  /** Any other value that exists and is not equal to the given value. */
  faqCategory_not?: InputMaybe<FaqCategory>;
  /** All values that are not contained in given list. */
  faqCategory_not_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FaqCategoryModelWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqCategoryModelWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqCategoryModelWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqCategoryModelWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FaqCategoryModelWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FaqCategoryModel record uniquely */
export type FaqCategoryModelWhereUniqueInput = {
  faqCategory?: InputMaybe<FaqCategory>;
  id?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
};

export type FeatureFlag = Entity & Node & {
  __typename?: 'FeatureFlag';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** A description to help admins in the future understand the purpose of the flag, this NEVER gets shown to a user */
  decription?: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<FeatureFlag>;
  enabled: Scalars['Boolean'];
  featureFlag: Scalars['String'];
  /** The heading to show on a banner if applicable */
  heading?: Maybe<Phrase>;
  /** List of FeatureFlag versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The text to show on a banner if applicable */
  text?: Maybe<Phrase>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  userCreatedAfter?: Maybe<Scalars['Date']>;
  userCreatedBefore?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['String']>;
};


export type FeatureFlagCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeatureFlagDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type FeatureFlagHeadingArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeatureFlagHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type FeatureFlagPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeatureFlagScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FeatureFlagTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeatureFlagUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FeatureFlagConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FeatureFlagWhereUniqueInput;
};

/** A connection to a list of items. */
export type FeatureFlagConnection = {
  __typename?: 'FeatureFlagConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FeatureFlagEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FeatureFlagCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  decription?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  featureFlag: Scalars['String'];
  heading?: InputMaybe<PhraseCreateOneInlineInput>;
  text?: InputMaybe<PhraseCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userCreatedAfter?: InputMaybe<Scalars['Date']>;
  userCreatedBefore?: InputMaybe<Scalars['Date']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FeatureFlagCreateManyInlineInput = {
  /** Connect multiple existing FeatureFlag documents */
  connect?: InputMaybe<Array<FeatureFlagWhereUniqueInput>>;
  /** Create and connect multiple existing FeatureFlag documents */
  create?: InputMaybe<Array<FeatureFlagCreateInput>>;
};

export type FeatureFlagCreateOneInlineInput = {
  /** Connect one existing FeatureFlag document */
  connect?: InputMaybe<FeatureFlagWhereUniqueInput>;
  /** Create and connect one FeatureFlag document */
  create?: InputMaybe<FeatureFlagCreateInput>;
};

/** An edge in a connection. */
export type FeatureFlagEdge = {
  __typename?: 'FeatureFlagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FeatureFlag;
};

/** Identifies documents */
export type FeatureFlagManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeatureFlagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeatureFlagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeatureFlagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  decription?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  decription_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  decription_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  decription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  decription_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  decription_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  decription_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  decription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  decription_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  decription_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<FeatureFlagWhereStageInput>;
  documentInStages_none?: InputMaybe<FeatureFlagWhereStageInput>;
  documentInStages_some?: InputMaybe<FeatureFlagWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  featureFlag?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  featureFlag_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  featureFlag_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  featureFlag_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  featureFlag_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  featureFlag_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  featureFlag_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  featureFlag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  featureFlag_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  featureFlag_starts_with?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<PhraseWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  text?: InputMaybe<PhraseWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  userCreatedAfter?: InputMaybe<Scalars['Date']>;
  /** All values greater than the given value. */
  userCreatedAfter_gt?: InputMaybe<Scalars['Date']>;
  /** All values greater than or equal the given value. */
  userCreatedAfter_gte?: InputMaybe<Scalars['Date']>;
  /** All values that are contained in given list. */
  userCreatedAfter_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  /** All values less than the given value. */
  userCreatedAfter_lt?: InputMaybe<Scalars['Date']>;
  /** All values less than or equal the given value. */
  userCreatedAfter_lte?: InputMaybe<Scalars['Date']>;
  /** Any other value that exists and is not equal to the given value. */
  userCreatedAfter_not?: InputMaybe<Scalars['Date']>;
  /** All values that are not contained in given list. */
  userCreatedAfter_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  userCreatedBefore?: InputMaybe<Scalars['Date']>;
  /** All values greater than the given value. */
  userCreatedBefore_gt?: InputMaybe<Scalars['Date']>;
  /** All values greater than or equal the given value. */
  userCreatedBefore_gte?: InputMaybe<Scalars['Date']>;
  /** All values that are contained in given list. */
  userCreatedBefore_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  /** All values less than the given value. */
  userCreatedBefore_lt?: InputMaybe<Scalars['Date']>;
  /** All values less than or equal the given value. */
  userCreatedBefore_lte?: InputMaybe<Scalars['Date']>;
  /** Any other value that exists and is not equal to the given value. */
  userCreatedBefore_not?: InputMaybe<Scalars['Date']>;
  /** All values that are not contained in given list. */
  userCreatedBefore_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  value?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']>;
};

export enum FeatureFlagOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DECRIPTION_ASC = 'decription_ASC',
  DECRIPTION_DESC = 'decription_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  FEATUREFLAG_ASC = 'featureFlag_ASC',
  FEATUREFLAG_DESC = 'featureFlag_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  USERCREATEDAFTER_ASC = 'userCreatedAfter_ASC',
  USERCREATEDAFTER_DESC = 'userCreatedAfter_DESC',
  USERCREATEDBEFORE_ASC = 'userCreatedBefore_ASC',
  USERCREATEDBEFORE_DESC = 'userCreatedBefore_DESC',
  VALUE_ASC = 'value_ASC',
  VALUE_DESC = 'value_DESC'
}

export type FeatureFlagUpdateInput = {
  decription?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  featureFlag?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<PhraseUpdateOneInlineInput>;
  text?: InputMaybe<PhraseUpdateOneInlineInput>;
  userCreatedAfter?: InputMaybe<Scalars['Date']>;
  userCreatedBefore?: InputMaybe<Scalars['Date']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FeatureFlagUpdateManyInlineInput = {
  /** Connect multiple existing FeatureFlag documents */
  connect?: InputMaybe<Array<FeatureFlagConnectInput>>;
  /** Create and connect multiple FeatureFlag documents */
  create?: InputMaybe<Array<FeatureFlagCreateInput>>;
  /** Delete multiple FeatureFlag documents */
  delete?: InputMaybe<Array<FeatureFlagWhereUniqueInput>>;
  /** Disconnect multiple FeatureFlag documents */
  disconnect?: InputMaybe<Array<FeatureFlagWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FeatureFlag documents */
  set?: InputMaybe<Array<FeatureFlagWhereUniqueInput>>;
  /** Update multiple FeatureFlag documents */
  update?: InputMaybe<Array<FeatureFlagUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FeatureFlag documents */
  upsert?: InputMaybe<Array<FeatureFlagUpsertWithNestedWhereUniqueInput>>;
};

export type FeatureFlagUpdateManyInput = {
  decription?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  userCreatedAfter?: InputMaybe<Scalars['Date']>;
  userCreatedBefore?: InputMaybe<Scalars['Date']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FeatureFlagUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FeatureFlagUpdateManyInput;
  /** Document search */
  where: FeatureFlagWhereInput;
};

export type FeatureFlagUpdateOneInlineInput = {
  /** Connect existing FeatureFlag document */
  connect?: InputMaybe<FeatureFlagWhereUniqueInput>;
  /** Create and connect one FeatureFlag document */
  create?: InputMaybe<FeatureFlagCreateInput>;
  /** Delete currently connected FeatureFlag document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected FeatureFlag document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single FeatureFlag document */
  update?: InputMaybe<FeatureFlagUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FeatureFlag document */
  upsert?: InputMaybe<FeatureFlagUpsertWithNestedWhereUniqueInput>;
};

export type FeatureFlagUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FeatureFlagUpdateInput;
  /** Unique document search */
  where: FeatureFlagWhereUniqueInput;
};

export type FeatureFlagUpsertInput = {
  /** Create document if it didn't exist */
  create: FeatureFlagCreateInput;
  /** Update document if it exists */
  update: FeatureFlagUpdateInput;
};

export type FeatureFlagUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FeatureFlagUpsertInput;
  /** Unique document search */
  where: FeatureFlagWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FeatureFlagWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type FeatureFlagWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeatureFlagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeatureFlagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeatureFlagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  decription?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  decription_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  decription_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  decription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  decription_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  decription_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  decription_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  decription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  decription_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  decription_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<FeatureFlagWhereStageInput>;
  documentInStages_none?: InputMaybe<FeatureFlagWhereStageInput>;
  documentInStages_some?: InputMaybe<FeatureFlagWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  featureFlag?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  featureFlag_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  featureFlag_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  featureFlag_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  featureFlag_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  featureFlag_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  featureFlag_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  featureFlag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  featureFlag_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  featureFlag_starts_with?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<PhraseWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  text?: InputMaybe<PhraseWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  userCreatedAfter?: InputMaybe<Scalars['Date']>;
  /** All values greater than the given value. */
  userCreatedAfter_gt?: InputMaybe<Scalars['Date']>;
  /** All values greater than or equal the given value. */
  userCreatedAfter_gte?: InputMaybe<Scalars['Date']>;
  /** All values that are contained in given list. */
  userCreatedAfter_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  /** All values less than the given value. */
  userCreatedAfter_lt?: InputMaybe<Scalars['Date']>;
  /** All values less than or equal the given value. */
  userCreatedAfter_lte?: InputMaybe<Scalars['Date']>;
  /** Any other value that exists and is not equal to the given value. */
  userCreatedAfter_not?: InputMaybe<Scalars['Date']>;
  /** All values that are not contained in given list. */
  userCreatedAfter_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  userCreatedBefore?: InputMaybe<Scalars['Date']>;
  /** All values greater than the given value. */
  userCreatedBefore_gt?: InputMaybe<Scalars['Date']>;
  /** All values greater than or equal the given value. */
  userCreatedBefore_gte?: InputMaybe<Scalars['Date']>;
  /** All values that are contained in given list. */
  userCreatedBefore_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  /** All values less than the given value. */
  userCreatedBefore_lt?: InputMaybe<Scalars['Date']>;
  /** All values less than or equal the given value. */
  userCreatedBefore_lte?: InputMaybe<Scalars['Date']>;
  /** Any other value that exists and is not equal to the given value. */
  userCreatedBefore_not?: InputMaybe<Scalars['Date']>;
  /** All values that are not contained in given list. */
  userCreatedBefore_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  value?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FeatureFlagWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeatureFlagWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeatureFlagWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeatureFlagWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FeatureFlagWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FeatureFlag record uniquely */
export type FeatureFlagWhereUniqueInput = {
  featureFlag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type Game = Entity & Node & {
  __typename?: 'Game';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** If the game is disabled, this is the text body displayed to the user */
  disabledBody?: Maybe<Phrase>;
  /** If the game is disabled, this header is shown to users */
  disabledHeader?: Maybe<Phrase>;
  displayComingSoonIndicator?: Maybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  /** Get the document in other stages */
  documentInStages: Array<Game>;
  /** Are we currently taking bets on this game? (Users can still link accounts for disabled games.) */
  enabled: Scalars['Boolean'];
  fairPlayAgreementBody?: Maybe<Phrase>;
  /** Extra information that gets displayed on the game mode selection modal */
  gameModeCallout?: Maybe<GameModeCallout>;
  gameSeries?: Maybe<GameSeries>;
  gamemodes: Array<GameMode>;
  /** List of Game versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  isBetaGame?: Maybe<Scalars['Boolean']>;
  isDisplayedOnActivityScreenFilter?: Maybe<Scalars['Boolean']>;
  /** Does PL currently support the game? Users will be able to see but not interact with unsupported games. */
  isSupported: Scalars['Boolean'];
  /** Phrase body to show when the isSupported flag is false */
  isSupportedDisabledBody?: Maybe<Phrase>;
  /** Phrase header to show when the isSupported flag is false */
  isSupportedDisabledHeader?: Maybe<Phrase>;
  isTwitchRequired?: Maybe<Scalars['Boolean']>;
  longName?: Maybe<Phrase>;
  /** The minimum number of matches before betting is allowed on the game */
  minimumMatchesBeforeBetting: Scalars['Int'];
  /** Shows the notify me button if not enabled or not supported */
  notifyMe: Scalars['Boolean'];
  onboardingBody?: Maybe<Phrase>;
  onboardingHeader?: Maybe<Phrase>;
  onboardingQuestions: Array<OnboardingQuestion>;
  /** The number of games needed to play before we hide $1 bets to user */
  oneDollarCalibrationGamesPlayedAmount: Scalars['Int'];
  platforms: Array<Platform>;
  /** The higher the number, the closer to the front of the picker the game displays */
  priority: Scalars['Int'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  scoreNoun?: Maybe<ScoreNoun>;
  shortName?: Maybe<Phrase>;
  /** System stage field */
  stage: Stage;
  systemId: Scalars['String'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Is the game viewable in the app? */
  visible: Scalars['Boolean'];
  year?: Maybe<Scalars['Int']>;
};


export type GameCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameDisabledBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameDisabledHeaderArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type GameFairPlayAgreementBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameGameModeCalloutArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameGameSeriesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameGamemodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameModeWhereInput>;
};


export type GameHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type GameIsSupportedDisabledBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameIsSupportedDisabledHeaderArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameLongNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameOnboardingBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameOnboardingHeaderArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameOnboardingQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<OnboardingQuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OnboardingQuestionWhereInput>;
};


export type GamePlatformsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PlatformOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlatformWhereInput>;
};


export type GamePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GameShortNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GameConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GameWhereUniqueInput;
};

/** A connection to a list of items. */
export type GameConnection = {
  __typename?: 'GameConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GameEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GameCreateInput = {
  cl7g1wpr8793f01t23l8ff9b2?: InputMaybe<DefaultGameStateCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  disabledBody?: InputMaybe<PhraseCreateOneInlineInput>;
  disabledHeader?: InputMaybe<PhraseCreateOneInlineInput>;
  displayComingSoonIndicator?: InputMaybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  enabled: Scalars['Boolean'];
  fairPlayAgreementBody?: InputMaybe<PhraseCreateOneInlineInput>;
  gameModeCallout?: InputMaybe<GameModeCalloutCreateOneInlineInput>;
  gameSeries?: InputMaybe<GameSeriesCreateOneInlineInput>;
  gamemodes?: InputMaybe<GameModeCreateManyInlineInput>;
  isBetaGame?: InputMaybe<Scalars['Boolean']>;
  isDisplayedOnActivityScreenFilter?: InputMaybe<Scalars['Boolean']>;
  isSupported: Scalars['Boolean'];
  isSupportedDisabledBody?: InputMaybe<PhraseCreateOneInlineInput>;
  isSupportedDisabledHeader?: InputMaybe<PhraseCreateOneInlineInput>;
  isTwitchRequired?: InputMaybe<Scalars['Boolean']>;
  longName?: InputMaybe<PhraseCreateOneInlineInput>;
  minimumMatchesBeforeBetting: Scalars['Int'];
  notifyMe: Scalars['Boolean'];
  onboardingBody?: InputMaybe<PhraseCreateOneInlineInput>;
  onboardingHeader?: InputMaybe<PhraseCreateOneInlineInput>;
  onboardingQuestions?: InputMaybe<OnboardingQuestionCreateManyInlineInput>;
  oneDollarCalibrationGamesPlayedAmount: Scalars['Int'];
  platforms?: InputMaybe<PlatformCreateManyInlineInput>;
  priority: Scalars['Int'];
  scoreNoun?: InputMaybe<ScoreNoun>;
  shortName?: InputMaybe<PhraseCreateOneInlineInput>;
  systemId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
  year?: InputMaybe<Scalars['Int']>;
};

export type GameCreateManyInlineInput = {
  /** Connect multiple existing Game documents */
  connect?: InputMaybe<Array<GameWhereUniqueInput>>;
  /** Create and connect multiple existing Game documents */
  create?: InputMaybe<Array<GameCreateInput>>;
};

export type GameCreateOneInlineInput = {
  /** Connect one existing Game document */
  connect?: InputMaybe<GameWhereUniqueInput>;
  /** Create and connect one Game document */
  create?: InputMaybe<GameCreateInput>;
};

/** An edge in a connection. */
export type GameEdge = {
  __typename?: 'GameEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Game;
};

/** Identifies documents */
export type GameManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  disabledBody?: InputMaybe<PhraseWhereInput>;
  disabledHeader?: InputMaybe<PhraseWhereInput>;
  displayComingSoonIndicator?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  displayComingSoonIndicator_not?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<GameWhereStageInput>;
  documentInStages_none?: InputMaybe<GameWhereStageInput>;
  documentInStages_some?: InputMaybe<GameWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  fairPlayAgreementBody?: InputMaybe<PhraseWhereInput>;
  gameModeCallout?: InputMaybe<GameModeCalloutWhereInput>;
  gameSeries?: InputMaybe<GameSeriesWhereInput>;
  gamemodes_every?: InputMaybe<GameModeWhereInput>;
  gamemodes_none?: InputMaybe<GameModeWhereInput>;
  gamemodes_some?: InputMaybe<GameModeWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isBetaGame?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isBetaGame_not?: InputMaybe<Scalars['Boolean']>;
  isDisplayedOnActivityScreenFilter?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isDisplayedOnActivityScreenFilter_not?: InputMaybe<Scalars['Boolean']>;
  isSupported?: InputMaybe<Scalars['Boolean']>;
  isSupportedDisabledBody?: InputMaybe<PhraseWhereInput>;
  isSupportedDisabledHeader?: InputMaybe<PhraseWhereInput>;
  /** Any other value that exists and is not equal to the given value. */
  isSupported_not?: InputMaybe<Scalars['Boolean']>;
  isTwitchRequired?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isTwitchRequired_not?: InputMaybe<Scalars['Boolean']>;
  longName?: InputMaybe<PhraseWhereInput>;
  minimumMatchesBeforeBetting?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  minimumMatchesBeforeBetting_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  minimumMatchesBeforeBetting_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  minimumMatchesBeforeBetting_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  minimumMatchesBeforeBetting_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  minimumMatchesBeforeBetting_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  minimumMatchesBeforeBetting_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  minimumMatchesBeforeBetting_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notifyMe?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  notifyMe_not?: InputMaybe<Scalars['Boolean']>;
  onboardingBody?: InputMaybe<PhraseWhereInput>;
  onboardingHeader?: InputMaybe<PhraseWhereInput>;
  onboardingQuestions_every?: InputMaybe<OnboardingQuestionWhereInput>;
  onboardingQuestions_none?: InputMaybe<OnboardingQuestionWhereInput>;
  onboardingQuestions_some?: InputMaybe<OnboardingQuestionWhereInput>;
  oneDollarCalibrationGamesPlayedAmount?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  oneDollarCalibrationGamesPlayedAmount_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  oneDollarCalibrationGamesPlayedAmount_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  oneDollarCalibrationGamesPlayedAmount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  oneDollarCalibrationGamesPlayedAmount_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  oneDollarCalibrationGamesPlayedAmount_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  oneDollarCalibrationGamesPlayedAmount_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  oneDollarCalibrationGamesPlayedAmount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  platforms_every?: InputMaybe<PlatformWhereInput>;
  platforms_none?: InputMaybe<PlatformWhereInput>;
  platforms_some?: InputMaybe<PlatformWhereInput>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  scoreNoun?: InputMaybe<ScoreNoun>;
  /** All values that are contained in given list. */
  scoreNoun_in?: InputMaybe<Array<InputMaybe<ScoreNoun>>>;
  /** Any other value that exists and is not equal to the given value. */
  scoreNoun_not?: InputMaybe<ScoreNoun>;
  /** All values that are not contained in given list. */
  scoreNoun_not_in?: InputMaybe<Array<InputMaybe<ScoreNoun>>>;
  shortName?: InputMaybe<PhraseWhereInput>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  year_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  year_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  year_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  year_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  year_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  year_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  year_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type GameMode = Entity & Node & {
  __typename?: 'GameMode';
  betDenominationRestrictionOverrides: Array<BetDenominationRestriction>;
  betLineDisplayOrder: Array<BetLineType>;
  betRestrictions: Array<BetRestriction>;
  /** Bet Values that are allowed on this game mode */
  betValues: Array<BetValue>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  defaultBetValue?: Maybe<BetValue>;
  /** If game mode is disabled, optionally display a lock icon. Tapping the locked game mode displays a toast with locked reason phrases. */
  displayLockedReason?: Maybe<Scalars['Boolean']>;
  /** This is not the name, but the key that is referenced in the phrases file for the name & translations of the name. (E.g. "rbrth" could be the key, and in Phrases that key is turned into "Rebirth Island".) */
  displayName: Scalars['String'];
  /** Get the document in other stages */
  documentInStages: Array<GameMode>;
  enabled: Scalars['Boolean'];
  explainer?: Maybe<Phrase>;
  /** What game is this game mode used in? */
  game?: Maybe<GamemodeSupportedGame>;
  gameSeries?: Maybe<GameSeries>;
  /** List of GameMode versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  lockedReasonBody?: Maybe<Phrase>;
  lockedReasonHead?: Maybe<Phrase>;
  /**
   * Specific Payout Bands for this game mode that overwrite the global Default Payout Bands. You will need to specify ALL bands for this game mode if you want to overwrite a single value.
   *
   * PLEASE DON'T JUST OVERWRITE A SINGLE FIELD!
   */
  payoutBands: Array<PayoutBand>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Game modes that can be taken into consideration for restrictions */
  relatedGamemodes: Array<Scalars['String']>;
  /** Minimum expected time to resolution in seconds i.e 1800/30 mins */
  resolutionTime?: Maybe<Scalars['Int']>;
  scheduledIn: Array<ScheduledOperation>;
  /** Like the Display Name field, this is not the actual display name, but rather the key used in the phrases CMS to reference the short display name. */
  shortDisplayName?: Maybe<Scalars['String']>;
  /** Used to show the icon in game mode selection views */
  showIconIfAvailable: Scalars['Boolean'];
  /** System stage field */
  stage: Stage;
  systemId: Scalars['String'];
  teamsize: Array<TeamSize>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  visible: Scalars['Boolean'];
};


export type GameModeBetDenominationRestrictionOverridesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BetDenominationRestrictionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetDenominationRestrictionWhereInput>;
};


export type GameModeBetRestrictionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BetRestrictionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetRestrictionWhereInput>;
};


export type GameModeBetValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BetValueOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetValueWhereInput>;
};


export type GameModeCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameModeDefaultBetValueArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameModeDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type GameModeExplainerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameModeGameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameModeGameSeriesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameModeHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type GameModeLockedReasonBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameModeLockedReasonHeadArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameModePayoutBandsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PayoutBandOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PayoutBandWhereInput>;
};


export type GameModePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameModeScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GameModeTeamsizeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeamSizeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TeamSizeWhereInput>;
};


export type GameModeUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCallout = Entity & Node & {
  __typename?: 'GameModeCallout';
  actionText?: Maybe<Phrase>;
  body?: Maybe<Phrase>;
  /** Internal title for this callout */
  calloutTitle?: Maybe<Scalars['String']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GameModeCallout>;
  /** List of GameModeCallout versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  isVisible?: Maybe<Scalars['Boolean']>;
  modalBody?: Maybe<Phrase>;
  modalBodyHeadline?: Maybe<Phrase>;
  modalHeader?: Maybe<Phrase>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutActionTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutModalBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutModalBodyHeadlineArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutModalHeaderArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Extra information that gets displayed on the game mode selection modal */
export type GameModeCalloutUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GameModeCalloutConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GameModeCalloutWhereUniqueInput;
};

/** A connection to a list of items. */
export type GameModeCalloutConnection = {
  __typename?: 'GameModeCalloutConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GameModeCalloutEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GameModeCalloutCreateInput = {
  actionText?: InputMaybe<PhraseCreateOneInlineInput>;
  body?: InputMaybe<PhraseCreateOneInlineInput>;
  calloutTitle?: InputMaybe<Scalars['String']>;
  cm3g6dw7y01ej07iu4izq9vto?: InputMaybe<GameCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  modalBody?: InputMaybe<PhraseCreateOneInlineInput>;
  modalBodyHeadline?: InputMaybe<PhraseCreateOneInlineInput>;
  modalHeader?: InputMaybe<PhraseCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type GameModeCalloutCreateManyInlineInput = {
  /** Connect multiple existing GameModeCallout documents */
  connect?: InputMaybe<Array<GameModeCalloutWhereUniqueInput>>;
  /** Create and connect multiple existing GameModeCallout documents */
  create?: InputMaybe<Array<GameModeCalloutCreateInput>>;
};

export type GameModeCalloutCreateOneInlineInput = {
  /** Connect one existing GameModeCallout document */
  connect?: InputMaybe<GameModeCalloutWhereUniqueInput>;
  /** Create and connect one GameModeCallout document */
  create?: InputMaybe<GameModeCalloutCreateInput>;
};

/** An edge in a connection. */
export type GameModeCalloutEdge = {
  __typename?: 'GameModeCalloutEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GameModeCallout;
};

/** Identifies documents */
export type GameModeCalloutManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameModeCalloutWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameModeCalloutWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameModeCalloutWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  actionText?: InputMaybe<PhraseWhereInput>;
  body?: InputMaybe<PhraseWhereInput>;
  calloutTitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  calloutTitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  calloutTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  calloutTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  calloutTitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  calloutTitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  calloutTitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  calloutTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  calloutTitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  calloutTitle_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GameModeCalloutWhereStageInput>;
  documentInStages_none?: InputMaybe<GameModeCalloutWhereStageInput>;
  documentInStages_some?: InputMaybe<GameModeCalloutWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isVisible_not?: InputMaybe<Scalars['Boolean']>;
  modalBody?: InputMaybe<PhraseWhereInput>;
  modalBodyHeadline?: InputMaybe<PhraseWhereInput>;
  modalHeader?: InputMaybe<PhraseWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GameModeCalloutOrderByInput {
  CALLOUTTITLE_ASC = 'calloutTitle_ASC',
  CALLOUTTITLE_DESC = 'calloutTitle_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  ISVISIBLE_ASC = 'isVisible_ASC',
  ISVISIBLE_DESC = 'isVisible_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type GameModeCalloutUpdateInput = {
  actionText?: InputMaybe<PhraseUpdateOneInlineInput>;
  body?: InputMaybe<PhraseUpdateOneInlineInput>;
  calloutTitle?: InputMaybe<Scalars['String']>;
  cm3g6dw7y01ej07iu4izq9vto?: InputMaybe<GameUpdateManyInlineInput>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  modalBody?: InputMaybe<PhraseUpdateOneInlineInput>;
  modalBodyHeadline?: InputMaybe<PhraseUpdateOneInlineInput>;
  modalHeader?: InputMaybe<PhraseUpdateOneInlineInput>;
};

export type GameModeCalloutUpdateManyInlineInput = {
  /** Connect multiple existing GameModeCallout documents */
  connect?: InputMaybe<Array<GameModeCalloutConnectInput>>;
  /** Create and connect multiple GameModeCallout documents */
  create?: InputMaybe<Array<GameModeCalloutCreateInput>>;
  /** Delete multiple GameModeCallout documents */
  delete?: InputMaybe<Array<GameModeCalloutWhereUniqueInput>>;
  /** Disconnect multiple GameModeCallout documents */
  disconnect?: InputMaybe<Array<GameModeCalloutWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GameModeCallout documents */
  set?: InputMaybe<Array<GameModeCalloutWhereUniqueInput>>;
  /** Update multiple GameModeCallout documents */
  update?: InputMaybe<Array<GameModeCalloutUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GameModeCallout documents */
  upsert?: InputMaybe<Array<GameModeCalloutUpsertWithNestedWhereUniqueInput>>;
};

export type GameModeCalloutUpdateManyInput = {
  calloutTitle?: InputMaybe<Scalars['String']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
};

export type GameModeCalloutUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GameModeCalloutUpdateManyInput;
  /** Document search */
  where: GameModeCalloutWhereInput;
};

export type GameModeCalloutUpdateOneInlineInput = {
  /** Connect existing GameModeCallout document */
  connect?: InputMaybe<GameModeCalloutWhereUniqueInput>;
  /** Create and connect one GameModeCallout document */
  create?: InputMaybe<GameModeCalloutCreateInput>;
  /** Delete currently connected GameModeCallout document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected GameModeCallout document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single GameModeCallout document */
  update?: InputMaybe<GameModeCalloutUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GameModeCallout document */
  upsert?: InputMaybe<GameModeCalloutUpsertWithNestedWhereUniqueInput>;
};

export type GameModeCalloutUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GameModeCalloutUpdateInput;
  /** Unique document search */
  where: GameModeCalloutWhereUniqueInput;
};

export type GameModeCalloutUpsertInput = {
  /** Create document if it didn't exist */
  create: GameModeCalloutCreateInput;
  /** Update document if it exists */
  update: GameModeCalloutUpdateInput;
};

export type GameModeCalloutUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GameModeCalloutUpsertInput;
  /** Unique document search */
  where: GameModeCalloutWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GameModeCalloutWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type GameModeCalloutWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameModeCalloutWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameModeCalloutWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameModeCalloutWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  actionText?: InputMaybe<PhraseWhereInput>;
  body?: InputMaybe<PhraseWhereInput>;
  calloutTitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  calloutTitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  calloutTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  calloutTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  calloutTitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  calloutTitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  calloutTitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  calloutTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  calloutTitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  calloutTitle_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GameModeCalloutWhereStageInput>;
  documentInStages_none?: InputMaybe<GameModeCalloutWhereStageInput>;
  documentInStages_some?: InputMaybe<GameModeCalloutWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isVisible_not?: InputMaybe<Scalars['Boolean']>;
  modalBody?: InputMaybe<PhraseWhereInput>;
  modalBodyHeadline?: InputMaybe<PhraseWhereInput>;
  modalHeader?: InputMaybe<PhraseWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GameModeCalloutWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameModeCalloutWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameModeCalloutWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameModeCalloutWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GameModeCalloutWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GameModeCallout record uniquely */
export type GameModeCalloutWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type GameModeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GameModeWhereUniqueInput;
};

/** A connection to a list of items. */
export type GameModeConnection = {
  __typename?: 'GameModeConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GameModeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GameModeCreateInput = {
  betDenominationRestrictionOverrides?: InputMaybe<BetDenominationRestrictionCreateManyInlineInput>;
  betLineDisplayOrder?: InputMaybe<Array<BetLineType>>;
  betRestrictions?: InputMaybe<BetRestrictionCreateManyInlineInput>;
  betValues?: InputMaybe<BetValueCreateManyInlineInput>;
  cl7g21gxr7hjn01ul947vadd7?: InputMaybe<DefaultGameStateCreateManyInlineInput>;
  clggnxdbg1d9q01t53sjuf01i?: InputMaybe<BetValueRestrictionCreateManyInlineInput>;
  clkh5ovas70t101t5bdcc6bor?: InputMaybe<BetLineCreateManyInlineInput>;
  cmbtiy15f00gs07k25iyg7gub?: InputMaybe<BetLineRuleCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBetValue?: InputMaybe<BetValueCreateOneInlineInput>;
  displayLockedReason?: InputMaybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  enabled: Scalars['Boolean'];
  explainer?: InputMaybe<PhraseCreateOneInlineInput>;
  game?: InputMaybe<GamemodeSupportedGameCreateOneInlineInput>;
  gameSeries?: InputMaybe<GameSeriesCreateOneInlineInput>;
  lockedReasonBody?: InputMaybe<PhraseCreateOneInlineInput>;
  lockedReasonHead?: InputMaybe<PhraseCreateOneInlineInput>;
  payoutBands?: InputMaybe<PayoutBandCreateManyInlineInput>;
  relatedGamemodes?: InputMaybe<Array<Scalars['String']>>;
  resolutionTime?: InputMaybe<Scalars['Int']>;
  shortDisplayName?: InputMaybe<Scalars['String']>;
  showIconIfAvailable: Scalars['Boolean'];
  systemId: Scalars['String'];
  teamsize?: InputMaybe<TeamSizeCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
};

export type GameModeCreateManyInlineInput = {
  /** Connect multiple existing GameMode documents */
  connect?: InputMaybe<Array<GameModeWhereUniqueInput>>;
  /** Create and connect multiple existing GameMode documents */
  create?: InputMaybe<Array<GameModeCreateInput>>;
};

export type GameModeCreateOneInlineInput = {
  /** Connect one existing GameMode document */
  connect?: InputMaybe<GameModeWhereUniqueInput>;
  /** Create and connect one GameMode document */
  create?: InputMaybe<GameModeCreateInput>;
};

/** An edge in a connection. */
export type GameModeEdge = {
  __typename?: 'GameModeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GameMode;
};

/** Identifies documents */
export type GameModeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameModeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameModeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameModeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  betDenominationRestrictionOverrides_every?: InputMaybe<BetDenominationRestrictionWhereInput>;
  betDenominationRestrictionOverrides_none?: InputMaybe<BetDenominationRestrictionWhereInput>;
  betDenominationRestrictionOverrides_some?: InputMaybe<BetDenominationRestrictionWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  betLineDisplayOrder?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array contains *all* items provided to the filter */
  betLineDisplayOrder_contains_all?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  betLineDisplayOrder_contains_none?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array contains at least one item provided to the filter */
  betLineDisplayOrder_contains_some?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  betLineDisplayOrder_not?: InputMaybe<Array<BetLineType>>;
  betRestrictions_every?: InputMaybe<BetRestrictionWhereInput>;
  betRestrictions_none?: InputMaybe<BetRestrictionWhereInput>;
  betRestrictions_some?: InputMaybe<BetRestrictionWhereInput>;
  betValues_every?: InputMaybe<BetValueWhereInput>;
  betValues_none?: InputMaybe<BetValueWhereInput>;
  betValues_some?: InputMaybe<BetValueWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  defaultBetValue?: InputMaybe<BetValueWhereInput>;
  displayLockedReason?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  displayLockedReason_not?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<GameModeWhereStageInput>;
  documentInStages_none?: InputMaybe<GameModeWhereStageInput>;
  documentInStages_some?: InputMaybe<GameModeWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  explainer?: InputMaybe<PhraseWhereInput>;
  /** All values in which the union is connected to the given models */
  game?: InputMaybe<GamemodeSupportedGameWhereInput>;
  gameSeries?: InputMaybe<GameSeriesWhereInput>;
  /** All values in which the union is empty */
  game_empty?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  lockedReasonBody?: InputMaybe<PhraseWhereInput>;
  lockedReasonHead?: InputMaybe<PhraseWhereInput>;
  payoutBands_every?: InputMaybe<PayoutBandWhereInput>;
  payoutBands_none?: InputMaybe<PayoutBandWhereInput>;
  payoutBands_some?: InputMaybe<PayoutBandWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  relatedGamemodes?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  relatedGamemodes_contains_all?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  relatedGamemodes_contains_none?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  relatedGamemodes_contains_some?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  relatedGamemodes_not?: InputMaybe<Array<Scalars['String']>>;
  resolutionTime?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  resolutionTime_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  resolutionTime_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  resolutionTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  resolutionTime_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  resolutionTime_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  resolutionTime_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  resolutionTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDisplayName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  shortDisplayName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  shortDisplayName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  shortDisplayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDisplayName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  shortDisplayName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  shortDisplayName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  shortDisplayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  shortDisplayName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  shortDisplayName_starts_with?: InputMaybe<Scalars['String']>;
  showIconIfAvailable?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  showIconIfAvailable_not?: InputMaybe<Scalars['Boolean']>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  teamsize_every?: InputMaybe<TeamSizeWhereInput>;
  teamsize_none?: InputMaybe<TeamSizeWhereInput>;
  teamsize_some?: InputMaybe<TeamSizeWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

export enum GameModeOrderByInput {
  BETLINEDISPLAYORDER_ASC = 'betLineDisplayOrder_ASC',
  BETLINEDISPLAYORDER_DESC = 'betLineDisplayOrder_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DISPLAYLOCKEDREASON_ASC = 'displayLockedReason_ASC',
  DISPLAYLOCKEDREASON_DESC = 'displayLockedReason_DESC',
  DISPLAYNAME_ASC = 'displayName_ASC',
  DISPLAYNAME_DESC = 'displayName_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  RELATEDGAMEMODES_ASC = 'relatedGamemodes_ASC',
  RELATEDGAMEMODES_DESC = 'relatedGamemodes_DESC',
  RESOLUTIONTIME_ASC = 'resolutionTime_ASC',
  RESOLUTIONTIME_DESC = 'resolutionTime_DESC',
  SHORTDISPLAYNAME_ASC = 'shortDisplayName_ASC',
  SHORTDISPLAYNAME_DESC = 'shortDisplayName_DESC',
  SHOWICONIFAVAILABLE_ASC = 'showIconIfAvailable_ASC',
  SHOWICONIFAVAILABLE_DESC = 'showIconIfAvailable_DESC',
  SYSTEMID_ASC = 'systemId_ASC',
  SYSTEMID_DESC = 'systemId_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  VISIBLE_ASC = 'visible_ASC',
  VISIBLE_DESC = 'visible_DESC'
}

export type GameModeUpdateInput = {
  betDenominationRestrictionOverrides?: InputMaybe<BetDenominationRestrictionUpdateManyInlineInput>;
  betLineDisplayOrder?: InputMaybe<Array<BetLineType>>;
  betRestrictions?: InputMaybe<BetRestrictionUpdateManyInlineInput>;
  betValues?: InputMaybe<BetValueUpdateManyInlineInput>;
  cl7g21gxr7hjn01ul947vadd7?: InputMaybe<DefaultGameStateUpdateManyInlineInput>;
  clggnxdbg1d9q01t53sjuf01i?: InputMaybe<BetValueRestrictionUpdateManyInlineInput>;
  clkh5ovas70t101t5bdcc6bor?: InputMaybe<BetLineUpdateManyInlineInput>;
  cmbtiy15f00gs07k25iyg7gub?: InputMaybe<BetLineRuleUpdateManyInlineInput>;
  defaultBetValue?: InputMaybe<BetValueUpdateOneInlineInput>;
  displayLockedReason?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  explainer?: InputMaybe<PhraseUpdateOneInlineInput>;
  game?: InputMaybe<GamemodeSupportedGameUpdateOneInlineInput>;
  gameSeries?: InputMaybe<GameSeriesUpdateOneInlineInput>;
  lockedReasonBody?: InputMaybe<PhraseUpdateOneInlineInput>;
  lockedReasonHead?: InputMaybe<PhraseUpdateOneInlineInput>;
  payoutBands?: InputMaybe<PayoutBandUpdateManyInlineInput>;
  relatedGamemodes?: InputMaybe<Array<Scalars['String']>>;
  resolutionTime?: InputMaybe<Scalars['Int']>;
  shortDisplayName?: InputMaybe<Scalars['String']>;
  showIconIfAvailable?: InputMaybe<Scalars['Boolean']>;
  systemId?: InputMaybe<Scalars['String']>;
  teamsize?: InputMaybe<TeamSizeUpdateManyInlineInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type GameModeUpdateManyInlineInput = {
  /** Connect multiple existing GameMode documents */
  connect?: InputMaybe<Array<GameModeConnectInput>>;
  /** Create and connect multiple GameMode documents */
  create?: InputMaybe<Array<GameModeCreateInput>>;
  /** Delete multiple GameMode documents */
  delete?: InputMaybe<Array<GameModeWhereUniqueInput>>;
  /** Disconnect multiple GameMode documents */
  disconnect?: InputMaybe<Array<GameModeWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GameMode documents */
  set?: InputMaybe<Array<GameModeWhereUniqueInput>>;
  /** Update multiple GameMode documents */
  update?: InputMaybe<Array<GameModeUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GameMode documents */
  upsert?: InputMaybe<Array<GameModeUpsertWithNestedWhereUniqueInput>>;
};

export type GameModeUpdateManyInput = {
  betLineDisplayOrder?: InputMaybe<Array<BetLineType>>;
  displayLockedReason?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  relatedGamemodes?: InputMaybe<Array<Scalars['String']>>;
  resolutionTime?: InputMaybe<Scalars['Int']>;
  shortDisplayName?: InputMaybe<Scalars['String']>;
  showIconIfAvailable?: InputMaybe<Scalars['Boolean']>;
  systemId?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type GameModeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GameModeUpdateManyInput;
  /** Document search */
  where: GameModeWhereInput;
};

export type GameModeUpdateOneInlineInput = {
  /** Connect existing GameMode document */
  connect?: InputMaybe<GameModeWhereUniqueInput>;
  /** Create and connect one GameMode document */
  create?: InputMaybe<GameModeCreateInput>;
  /** Delete currently connected GameMode document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected GameMode document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single GameMode document */
  update?: InputMaybe<GameModeUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GameMode document */
  upsert?: InputMaybe<GameModeUpsertWithNestedWhereUniqueInput>;
};

export type GameModeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GameModeUpdateInput;
  /** Unique document search */
  where: GameModeWhereUniqueInput;
};

export type GameModeUpsertInput = {
  /** Create document if it didn't exist */
  create: GameModeCreateInput;
  /** Update document if it exists */
  update: GameModeUpdateInput;
};

export type GameModeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GameModeUpsertInput;
  /** Unique document search */
  where: GameModeWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GameModeWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type GameModeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameModeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameModeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameModeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  betDenominationRestrictionOverrides_every?: InputMaybe<BetDenominationRestrictionWhereInput>;
  betDenominationRestrictionOverrides_none?: InputMaybe<BetDenominationRestrictionWhereInput>;
  betDenominationRestrictionOverrides_some?: InputMaybe<BetDenominationRestrictionWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  betLineDisplayOrder?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array contains *all* items provided to the filter */
  betLineDisplayOrder_contains_all?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  betLineDisplayOrder_contains_none?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array contains at least one item provided to the filter */
  betLineDisplayOrder_contains_some?: InputMaybe<Array<BetLineType>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  betLineDisplayOrder_not?: InputMaybe<Array<BetLineType>>;
  betRestrictions_every?: InputMaybe<BetRestrictionWhereInput>;
  betRestrictions_none?: InputMaybe<BetRestrictionWhereInput>;
  betRestrictions_some?: InputMaybe<BetRestrictionWhereInput>;
  betValues_every?: InputMaybe<BetValueWhereInput>;
  betValues_none?: InputMaybe<BetValueWhereInput>;
  betValues_some?: InputMaybe<BetValueWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  defaultBetValue?: InputMaybe<BetValueWhereInput>;
  displayLockedReason?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  displayLockedReason_not?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<GameModeWhereStageInput>;
  documentInStages_none?: InputMaybe<GameModeWhereStageInput>;
  documentInStages_some?: InputMaybe<GameModeWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  explainer?: InputMaybe<PhraseWhereInput>;
  /** All values in which the union is connected to the given models */
  game?: InputMaybe<GamemodeSupportedGameWhereInput>;
  gameSeries?: InputMaybe<GameSeriesWhereInput>;
  /** All values in which the union is empty */
  game_empty?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  lockedReasonBody?: InputMaybe<PhraseWhereInput>;
  lockedReasonHead?: InputMaybe<PhraseWhereInput>;
  payoutBands_every?: InputMaybe<PayoutBandWhereInput>;
  payoutBands_none?: InputMaybe<PayoutBandWhereInput>;
  payoutBands_some?: InputMaybe<PayoutBandWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  relatedGamemodes?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  relatedGamemodes_contains_all?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  relatedGamemodes_contains_none?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  relatedGamemodes_contains_some?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  relatedGamemodes_not?: InputMaybe<Array<Scalars['String']>>;
  resolutionTime?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  resolutionTime_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  resolutionTime_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  resolutionTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  resolutionTime_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  resolutionTime_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  resolutionTime_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  resolutionTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDisplayName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  shortDisplayName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  shortDisplayName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  shortDisplayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDisplayName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  shortDisplayName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  shortDisplayName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  shortDisplayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  shortDisplayName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  shortDisplayName_starts_with?: InputMaybe<Scalars['String']>;
  showIconIfAvailable?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  showIconIfAvailable_not?: InputMaybe<Scalars['Boolean']>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  teamsize_every?: InputMaybe<TeamSizeWhereInput>;
  teamsize_none?: InputMaybe<TeamSizeWhereInput>;
  teamsize_some?: InputMaybe<TeamSizeWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GameModeWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameModeWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameModeWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameModeWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GameModeWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GameMode record uniquely */
export type GameModeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export enum GameOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DISPLAYCOMINGSOONINDICATOR_ASC = 'displayComingSoonIndicator_ASC',
  DISPLAYCOMINGSOONINDICATOR_DESC = 'displayComingSoonIndicator_DESC',
  DISPLAYNAME_ASC = 'displayName_ASC',
  DISPLAYNAME_DESC = 'displayName_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  ISBETAGAME_ASC = 'isBetaGame_ASC',
  ISBETAGAME_DESC = 'isBetaGame_DESC',
  ISDISPLAYEDONACTIVITYSCREENFILTER_ASC = 'isDisplayedOnActivityScreenFilter_ASC',
  ISDISPLAYEDONACTIVITYSCREENFILTER_DESC = 'isDisplayedOnActivityScreenFilter_DESC',
  ISSUPPORTED_ASC = 'isSupported_ASC',
  ISSUPPORTED_DESC = 'isSupported_DESC',
  ISTWITCHREQUIRED_ASC = 'isTwitchRequired_ASC',
  ISTWITCHREQUIRED_DESC = 'isTwitchRequired_DESC',
  MINIMUMMATCHESBEFOREBETTING_ASC = 'minimumMatchesBeforeBetting_ASC',
  MINIMUMMATCHESBEFOREBETTING_DESC = 'minimumMatchesBeforeBetting_DESC',
  NOTIFYME_ASC = 'notifyMe_ASC',
  NOTIFYME_DESC = 'notifyMe_DESC',
  ONEDOLLARCALIBRATIONGAMESPLAYEDAMOUNT_ASC = 'oneDollarCalibrationGamesPlayedAmount_ASC',
  ONEDOLLARCALIBRATIONGAMESPLAYEDAMOUNT_DESC = 'oneDollarCalibrationGamesPlayedAmount_DESC',
  PRIORITY_ASC = 'priority_ASC',
  PRIORITY_DESC = 'priority_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  SCORENOUN_ASC = 'scoreNoun_ASC',
  SCORENOUN_DESC = 'scoreNoun_DESC',
  SYSTEMID_ASC = 'systemId_ASC',
  SYSTEMID_DESC = 'systemId_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  VISIBLE_ASC = 'visible_ASC',
  VISIBLE_DESC = 'visible_DESC',
  YEAR_ASC = 'year_ASC',
  YEAR_DESC = 'year_DESC'
}

export type GameSeries = Entity & Node & {
  __typename?: 'GameSeries';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  displayName?: Maybe<Phrase>;
  /** Get the document in other stages */
  documentInStages: Array<GameSeries>;
  enabled: Scalars['Boolean'];
  gamemodes: Array<GameMode>;
  games: Array<Game>;
  /** List of GameSeries versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  isSeparatedByGameYear: Scalars['Boolean'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  systemId: Scalars['String'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  visible: Scalars['Boolean'];
};


export type GameSeriesCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameSeriesDisplayNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameSeriesDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type GameSeriesGamemodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GameModeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameModeWhereInput>;
};


export type GameSeriesGamesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GameOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameWhereInput>;
};


export type GameSeriesHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type GameSeriesPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GameSeriesScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GameSeriesUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GameSeriesConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GameSeriesWhereUniqueInput;
};

/** A connection to a list of items. */
export type GameSeriesConnection = {
  __typename?: 'GameSeriesConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GameSeriesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GameSeriesCreateInput = {
  cl7g21t537fzb01uh8jj63ian?: InputMaybe<DefaultGameStateCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  displayName?: InputMaybe<PhraseCreateOneInlineInput>;
  enabled: Scalars['Boolean'];
  gamemodes?: InputMaybe<GameModeCreateManyInlineInput>;
  games?: InputMaybe<GameCreateManyInlineInput>;
  isSeparatedByGameYear: Scalars['Boolean'];
  systemId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
};

export type GameSeriesCreateManyInlineInput = {
  /** Connect multiple existing GameSeries documents */
  connect?: InputMaybe<Array<GameSeriesWhereUniqueInput>>;
  /** Create and connect multiple existing GameSeries documents */
  create?: InputMaybe<Array<GameSeriesCreateInput>>;
};

export type GameSeriesCreateOneInlineInput = {
  /** Connect one existing GameSeries document */
  connect?: InputMaybe<GameSeriesWhereUniqueInput>;
  /** Create and connect one GameSeries document */
  create?: InputMaybe<GameSeriesCreateInput>;
};

/** An edge in a connection. */
export type GameSeriesEdge = {
  __typename?: 'GameSeriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GameSeries;
};

/** Identifies documents */
export type GameSeriesManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameSeriesWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameSeriesWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameSeriesWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<PhraseWhereInput>;
  documentInStages_every?: InputMaybe<GameSeriesWhereStageInput>;
  documentInStages_none?: InputMaybe<GameSeriesWhereStageInput>;
  documentInStages_some?: InputMaybe<GameSeriesWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  gamemodes_every?: InputMaybe<GameModeWhereInput>;
  gamemodes_none?: InputMaybe<GameModeWhereInput>;
  gamemodes_some?: InputMaybe<GameModeWhereInput>;
  games_every?: InputMaybe<GameWhereInput>;
  games_none?: InputMaybe<GameWhereInput>;
  games_some?: InputMaybe<GameWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isSeparatedByGameYear?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isSeparatedByGameYear_not?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

export enum GameSeriesOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  ISSEPARATEDBYGAMEYEAR_ASC = 'isSeparatedByGameYear_ASC',
  ISSEPARATEDBYGAMEYEAR_DESC = 'isSeparatedByGameYear_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  SYSTEMID_ASC = 'systemId_ASC',
  SYSTEMID_DESC = 'systemId_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  VISIBLE_ASC = 'visible_ASC',
  VISIBLE_DESC = 'visible_DESC'
}

export type GameSeriesUpdateInput = {
  cl7g21t537fzb01uh8jj63ian?: InputMaybe<DefaultGameStateUpdateManyInlineInput>;
  displayName?: InputMaybe<PhraseUpdateOneInlineInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  gamemodes?: InputMaybe<GameModeUpdateManyInlineInput>;
  games?: InputMaybe<GameUpdateManyInlineInput>;
  isSeparatedByGameYear?: InputMaybe<Scalars['Boolean']>;
  systemId?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type GameSeriesUpdateManyInlineInput = {
  /** Connect multiple existing GameSeries documents */
  connect?: InputMaybe<Array<GameSeriesConnectInput>>;
  /** Create and connect multiple GameSeries documents */
  create?: InputMaybe<Array<GameSeriesCreateInput>>;
  /** Delete multiple GameSeries documents */
  delete?: InputMaybe<Array<GameSeriesWhereUniqueInput>>;
  /** Disconnect multiple GameSeries documents */
  disconnect?: InputMaybe<Array<GameSeriesWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GameSeries documents */
  set?: InputMaybe<Array<GameSeriesWhereUniqueInput>>;
  /** Update multiple GameSeries documents */
  update?: InputMaybe<Array<GameSeriesUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GameSeries documents */
  upsert?: InputMaybe<Array<GameSeriesUpsertWithNestedWhereUniqueInput>>;
};

export type GameSeriesUpdateManyInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  isSeparatedByGameYear?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type GameSeriesUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GameSeriesUpdateManyInput;
  /** Document search */
  where: GameSeriesWhereInput;
};

export type GameSeriesUpdateOneInlineInput = {
  /** Connect existing GameSeries document */
  connect?: InputMaybe<GameSeriesWhereUniqueInput>;
  /** Create and connect one GameSeries document */
  create?: InputMaybe<GameSeriesCreateInput>;
  /** Delete currently connected GameSeries document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected GameSeries document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single GameSeries document */
  update?: InputMaybe<GameSeriesUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GameSeries document */
  upsert?: InputMaybe<GameSeriesUpsertWithNestedWhereUniqueInput>;
};

export type GameSeriesUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GameSeriesUpdateInput;
  /** Unique document search */
  where: GameSeriesWhereUniqueInput;
};

export type GameSeriesUpsertInput = {
  /** Create document if it didn't exist */
  create: GameSeriesCreateInput;
  /** Update document if it exists */
  update: GameSeriesUpdateInput;
};

export type GameSeriesUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GameSeriesUpsertInput;
  /** Unique document search */
  where: GameSeriesWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GameSeriesWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type GameSeriesWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameSeriesWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameSeriesWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameSeriesWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<PhraseWhereInput>;
  documentInStages_every?: InputMaybe<GameSeriesWhereStageInput>;
  documentInStages_none?: InputMaybe<GameSeriesWhereStageInput>;
  documentInStages_some?: InputMaybe<GameSeriesWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  gamemodes_every?: InputMaybe<GameModeWhereInput>;
  gamemodes_none?: InputMaybe<GameModeWhereInput>;
  gamemodes_some?: InputMaybe<GameModeWhereInput>;
  games_every?: InputMaybe<GameWhereInput>;
  games_none?: InputMaybe<GameWhereInput>;
  games_some?: InputMaybe<GameWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isSeparatedByGameYear?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isSeparatedByGameYear_not?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GameSeriesWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameSeriesWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameSeriesWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameSeriesWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GameSeriesWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GameSeries record uniquely */
export type GameSeriesWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type GameUpdateInput = {
  cl7g1wpr8793f01t23l8ff9b2?: InputMaybe<DefaultGameStateUpdateManyInlineInput>;
  disabledBody?: InputMaybe<PhraseUpdateOneInlineInput>;
  disabledHeader?: InputMaybe<PhraseUpdateOneInlineInput>;
  displayComingSoonIndicator?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  fairPlayAgreementBody?: InputMaybe<PhraseUpdateOneInlineInput>;
  gameModeCallout?: InputMaybe<GameModeCalloutUpdateOneInlineInput>;
  gameSeries?: InputMaybe<GameSeriesUpdateOneInlineInput>;
  gamemodes?: InputMaybe<GameModeUpdateManyInlineInput>;
  isBetaGame?: InputMaybe<Scalars['Boolean']>;
  isDisplayedOnActivityScreenFilter?: InputMaybe<Scalars['Boolean']>;
  isSupported?: InputMaybe<Scalars['Boolean']>;
  isSupportedDisabledBody?: InputMaybe<PhraseUpdateOneInlineInput>;
  isSupportedDisabledHeader?: InputMaybe<PhraseUpdateOneInlineInput>;
  isTwitchRequired?: InputMaybe<Scalars['Boolean']>;
  longName?: InputMaybe<PhraseUpdateOneInlineInput>;
  minimumMatchesBeforeBetting?: InputMaybe<Scalars['Int']>;
  notifyMe?: InputMaybe<Scalars['Boolean']>;
  onboardingBody?: InputMaybe<PhraseUpdateOneInlineInput>;
  onboardingHeader?: InputMaybe<PhraseUpdateOneInlineInput>;
  onboardingQuestions?: InputMaybe<OnboardingQuestionUpdateManyInlineInput>;
  oneDollarCalibrationGamesPlayedAmount?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<PlatformUpdateManyInlineInput>;
  priority?: InputMaybe<Scalars['Int']>;
  scoreNoun?: InputMaybe<ScoreNoun>;
  shortName?: InputMaybe<PhraseUpdateOneInlineInput>;
  systemId?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type GameUpdateManyInlineInput = {
  /** Connect multiple existing Game documents */
  connect?: InputMaybe<Array<GameConnectInput>>;
  /** Create and connect multiple Game documents */
  create?: InputMaybe<Array<GameCreateInput>>;
  /** Delete multiple Game documents */
  delete?: InputMaybe<Array<GameWhereUniqueInput>>;
  /** Disconnect multiple Game documents */
  disconnect?: InputMaybe<Array<GameWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Game documents */
  set?: InputMaybe<Array<GameWhereUniqueInput>>;
  /** Update multiple Game documents */
  update?: InputMaybe<Array<GameUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Game documents */
  upsert?: InputMaybe<Array<GameUpsertWithNestedWhereUniqueInput>>;
};

export type GameUpdateManyInput = {
  displayComingSoonIndicator?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  isBetaGame?: InputMaybe<Scalars['Boolean']>;
  isDisplayedOnActivityScreenFilter?: InputMaybe<Scalars['Boolean']>;
  isSupported?: InputMaybe<Scalars['Boolean']>;
  isTwitchRequired?: InputMaybe<Scalars['Boolean']>;
  minimumMatchesBeforeBetting?: InputMaybe<Scalars['Int']>;
  notifyMe?: InputMaybe<Scalars['Boolean']>;
  oneDollarCalibrationGamesPlayedAmount?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
  scoreNoun?: InputMaybe<ScoreNoun>;
  visible?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type GameUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GameUpdateManyInput;
  /** Document search */
  where: GameWhereInput;
};

export type GameUpdateOneInlineInput = {
  /** Connect existing Game document */
  connect?: InputMaybe<GameWhereUniqueInput>;
  /** Create and connect one Game document */
  create?: InputMaybe<GameCreateInput>;
  /** Delete currently connected Game document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Game document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Game document */
  update?: InputMaybe<GameUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Game document */
  upsert?: InputMaybe<GameUpsertWithNestedWhereUniqueInput>;
};

export type GameUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GameUpdateInput;
  /** Unique document search */
  where: GameWhereUniqueInput;
};

export type GameUpsertInput = {
  /** Create document if it didn't exist */
  create: GameCreateInput;
  /** Update document if it exists */
  update: GameUpdateInput;
};

export type GameUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GameUpsertInput;
  /** Unique document search */
  where: GameWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GameWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type GameWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  disabledBody?: InputMaybe<PhraseWhereInput>;
  disabledHeader?: InputMaybe<PhraseWhereInput>;
  displayComingSoonIndicator?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  displayComingSoonIndicator_not?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<GameWhereStageInput>;
  documentInStages_none?: InputMaybe<GameWhereStageInput>;
  documentInStages_some?: InputMaybe<GameWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  fairPlayAgreementBody?: InputMaybe<PhraseWhereInput>;
  gameModeCallout?: InputMaybe<GameModeCalloutWhereInput>;
  gameSeries?: InputMaybe<GameSeriesWhereInput>;
  gamemodes_every?: InputMaybe<GameModeWhereInput>;
  gamemodes_none?: InputMaybe<GameModeWhereInput>;
  gamemodes_some?: InputMaybe<GameModeWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isBetaGame?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isBetaGame_not?: InputMaybe<Scalars['Boolean']>;
  isDisplayedOnActivityScreenFilter?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isDisplayedOnActivityScreenFilter_not?: InputMaybe<Scalars['Boolean']>;
  isSupported?: InputMaybe<Scalars['Boolean']>;
  isSupportedDisabledBody?: InputMaybe<PhraseWhereInput>;
  isSupportedDisabledHeader?: InputMaybe<PhraseWhereInput>;
  /** Any other value that exists and is not equal to the given value. */
  isSupported_not?: InputMaybe<Scalars['Boolean']>;
  isTwitchRequired?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isTwitchRequired_not?: InputMaybe<Scalars['Boolean']>;
  longName?: InputMaybe<PhraseWhereInput>;
  minimumMatchesBeforeBetting?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  minimumMatchesBeforeBetting_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  minimumMatchesBeforeBetting_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  minimumMatchesBeforeBetting_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  minimumMatchesBeforeBetting_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  minimumMatchesBeforeBetting_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  minimumMatchesBeforeBetting_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  minimumMatchesBeforeBetting_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notifyMe?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  notifyMe_not?: InputMaybe<Scalars['Boolean']>;
  onboardingBody?: InputMaybe<PhraseWhereInput>;
  onboardingHeader?: InputMaybe<PhraseWhereInput>;
  onboardingQuestions_every?: InputMaybe<OnboardingQuestionWhereInput>;
  onboardingQuestions_none?: InputMaybe<OnboardingQuestionWhereInput>;
  onboardingQuestions_some?: InputMaybe<OnboardingQuestionWhereInput>;
  oneDollarCalibrationGamesPlayedAmount?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  oneDollarCalibrationGamesPlayedAmount_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  oneDollarCalibrationGamesPlayedAmount_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  oneDollarCalibrationGamesPlayedAmount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  oneDollarCalibrationGamesPlayedAmount_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  oneDollarCalibrationGamesPlayedAmount_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  oneDollarCalibrationGamesPlayedAmount_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  oneDollarCalibrationGamesPlayedAmount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  platforms_every?: InputMaybe<PlatformWhereInput>;
  platforms_none?: InputMaybe<PlatformWhereInput>;
  platforms_some?: InputMaybe<PlatformWhereInput>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  scoreNoun?: InputMaybe<ScoreNoun>;
  /** All values that are contained in given list. */
  scoreNoun_in?: InputMaybe<Array<InputMaybe<ScoreNoun>>>;
  /** Any other value that exists and is not equal to the given value. */
  scoreNoun_not?: InputMaybe<ScoreNoun>;
  /** All values that are not contained in given list. */
  scoreNoun_not_in?: InputMaybe<Array<InputMaybe<ScoreNoun>>>;
  shortName?: InputMaybe<PhraseWhereInput>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  year_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  year_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  year_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  year_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  year_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  year_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  year_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GameWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GameWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GameWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GameWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GameWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Game record uniquely */
export type GameWhereUniqueInput = {
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type GamemodeSupportedGame = Game;

export type GamemodeSupportedGameConnectInput = {
  Game?: InputMaybe<GameConnectInput>;
};

export type GamemodeSupportedGameCreateInput = {
  Game?: InputMaybe<GameCreateInput>;
};

export type GamemodeSupportedGameCreateManyInlineInput = {
  /** Connect multiple existing GamemodeSupportedGame documents */
  connect?: InputMaybe<Array<GamemodeSupportedGameWhereUniqueInput>>;
  /** Create and connect multiple existing GamemodeSupportedGame documents */
  create?: InputMaybe<Array<GamemodeSupportedGameCreateInput>>;
};

export type GamemodeSupportedGameCreateOneInlineInput = {
  /** Connect one existing GamemodeSupportedGame document */
  connect?: InputMaybe<GamemodeSupportedGameWhereUniqueInput>;
  /** Create and connect one GamemodeSupportedGame document */
  create?: InputMaybe<GamemodeSupportedGameCreateInput>;
};

export type GamemodeSupportedGameUpdateInput = {
  Game?: InputMaybe<GameUpdateInput>;
};

export type GamemodeSupportedGameUpdateManyInlineInput = {
  /** Connect multiple existing GamemodeSupportedGame documents */
  connect?: InputMaybe<Array<GamemodeSupportedGameConnectInput>>;
  /** Create and connect multiple GamemodeSupportedGame documents */
  create?: InputMaybe<Array<GamemodeSupportedGameCreateInput>>;
  /** Delete multiple GamemodeSupportedGame documents */
  delete?: InputMaybe<Array<GamemodeSupportedGameWhereUniqueInput>>;
  /** Disconnect multiple GamemodeSupportedGame documents */
  disconnect?: InputMaybe<Array<GamemodeSupportedGameWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GamemodeSupportedGame documents */
  set?: InputMaybe<Array<GamemodeSupportedGameWhereUniqueInput>>;
  /** Update multiple GamemodeSupportedGame documents */
  update?: InputMaybe<Array<GamemodeSupportedGameUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GamemodeSupportedGame documents */
  upsert?: InputMaybe<Array<GamemodeSupportedGameUpsertWithNestedWhereUniqueInput>>;
};

export type GamemodeSupportedGameUpdateManyWithNestedWhereInput = {
  Game?: InputMaybe<GameUpdateManyWithNestedWhereInput>;
};

export type GamemodeSupportedGameUpdateOneInlineInput = {
  /** Connect existing GamemodeSupportedGame document */
  connect?: InputMaybe<GamemodeSupportedGameWhereUniqueInput>;
  /** Create and connect one GamemodeSupportedGame document */
  create?: InputMaybe<GamemodeSupportedGameCreateInput>;
  /** Delete currently connected GamemodeSupportedGame document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected GamemodeSupportedGame document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single GamemodeSupportedGame document */
  update?: InputMaybe<GamemodeSupportedGameUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GamemodeSupportedGame document */
  upsert?: InputMaybe<GamemodeSupportedGameUpsertWithNestedWhereUniqueInput>;
};

export type GamemodeSupportedGameUpdateWithNestedWhereUniqueInput = {
  Game?: InputMaybe<GameUpdateWithNestedWhereUniqueInput>;
};

export type GamemodeSupportedGameUpsertWithNestedWhereUniqueInput = {
  Game?: InputMaybe<GameUpsertWithNestedWhereUniqueInput>;
};

export type GamemodeSupportedGameWhereInput = {
  Game?: InputMaybe<GameWhereInput>;
};

export type GamemodeSupportedGameWhereUniqueInput = {
  Game?: InputMaybe<GameWhereUniqueInput>;
};

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean'];
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int'];
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  CLIP = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  CROP = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  MAX = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  SCALE = 'scale'
}

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int'];
};

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

/** Locale system enumeration */
export enum Locale {
  /** System locale */
  EN = 'en',
  EN_ANDROID = 'en_android',
  ES_CO = 'es_CO'
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location';
  distance: Scalars['Float'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};


/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

/** List of common problems that a user would contact support for help */
export type MatchIssue = Entity & Node & {
  __typename?: 'MatchIssue';
  /** The issue type to display in analytic event data */
  analyticKey: Scalars['String'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<MatchIssue>;
  /** List of MatchIssue versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Phrase to pre-load into the intercom chat box */
  intercomText?: Maybe<Phrase>;
  /** Title of problem to display on problems list */
  phrase?: Maybe<Phrase>;
  /** Priority to order issues */
  priority: Scalars['Int'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** Set if this field should be shown on pending bet resolution */
  showOnPending: Scalars['Boolean'];
  /** Display match issue if bet resolution is refunded */
  showOnRefunded: Scalars['Boolean'];
  /** Display match issue if bet resolution is settled */
  showOnSettled: Scalars['Boolean'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Set match issue as visible */
  visible: Scalars['Boolean'];
};


/** List of common problems that a user would contact support for help */
export type MatchIssueCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** List of common problems that a user would contact support for help */
export type MatchIssueDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** List of common problems that a user would contact support for help */
export type MatchIssueHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** List of common problems that a user would contact support for help */
export type MatchIssueIntercomTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** List of common problems that a user would contact support for help */
export type MatchIssuePhraseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** List of common problems that a user would contact support for help */
export type MatchIssuePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** List of common problems that a user would contact support for help */
export type MatchIssueScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** List of common problems that a user would contact support for help */
export type MatchIssueUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MatchIssueConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MatchIssueWhereUniqueInput;
};

/** A connection to a list of items. */
export type MatchIssueConnection = {
  __typename?: 'MatchIssueConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MatchIssueEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MatchIssueCreateInput = {
  analyticKey: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  intercomText?: InputMaybe<PhraseCreateOneInlineInput>;
  phrase?: InputMaybe<PhraseCreateOneInlineInput>;
  priority: Scalars['Int'];
  showOnPending: Scalars['Boolean'];
  showOnRefunded: Scalars['Boolean'];
  showOnSettled: Scalars['Boolean'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
};

export type MatchIssueCreateManyInlineInput = {
  /** Connect multiple existing MatchIssue documents */
  connect?: InputMaybe<Array<MatchIssueWhereUniqueInput>>;
  /** Create and connect multiple existing MatchIssue documents */
  create?: InputMaybe<Array<MatchIssueCreateInput>>;
};

export type MatchIssueCreateOneInlineInput = {
  /** Connect one existing MatchIssue document */
  connect?: InputMaybe<MatchIssueWhereUniqueInput>;
  /** Create and connect one MatchIssue document */
  create?: InputMaybe<MatchIssueCreateInput>;
};

/** An edge in a connection. */
export type MatchIssueEdge = {
  __typename?: 'MatchIssueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MatchIssue;
};

/** Identifies documents */
export type MatchIssueManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MatchIssueWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MatchIssueWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MatchIssueWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  analyticKey?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  analyticKey_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  analyticKey_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  analyticKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  analyticKey_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  analyticKey_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  analyticKey_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  analyticKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  analyticKey_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  analyticKey_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MatchIssueWhereStageInput>;
  documentInStages_none?: InputMaybe<MatchIssueWhereStageInput>;
  documentInStages_some?: InputMaybe<MatchIssueWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  intercomText?: InputMaybe<PhraseWhereInput>;
  phrase?: InputMaybe<PhraseWhereInput>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showOnPending?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  showOnPending_not?: InputMaybe<Scalars['Boolean']>;
  showOnRefunded?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  showOnRefunded_not?: InputMaybe<Scalars['Boolean']>;
  showOnSettled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  showOnSettled_not?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

export enum MatchIssueOrderByInput {
  ANALYTICKEY_ASC = 'analyticKey_ASC',
  ANALYTICKEY_DESC = 'analyticKey_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PRIORITY_ASC = 'priority_ASC',
  PRIORITY_DESC = 'priority_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  SHOWONPENDING_ASC = 'showOnPending_ASC',
  SHOWONPENDING_DESC = 'showOnPending_DESC',
  SHOWONREFUNDED_ASC = 'showOnRefunded_ASC',
  SHOWONREFUNDED_DESC = 'showOnRefunded_DESC',
  SHOWONSETTLED_ASC = 'showOnSettled_ASC',
  SHOWONSETTLED_DESC = 'showOnSettled_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  VISIBLE_ASC = 'visible_ASC',
  VISIBLE_DESC = 'visible_DESC'
}

export type MatchIssueUpdateInput = {
  analyticKey?: InputMaybe<Scalars['String']>;
  intercomText?: InputMaybe<PhraseUpdateOneInlineInput>;
  phrase?: InputMaybe<PhraseUpdateOneInlineInput>;
  priority?: InputMaybe<Scalars['Int']>;
  showOnPending?: InputMaybe<Scalars['Boolean']>;
  showOnRefunded?: InputMaybe<Scalars['Boolean']>;
  showOnSettled?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type MatchIssueUpdateManyInlineInput = {
  /** Connect multiple existing MatchIssue documents */
  connect?: InputMaybe<Array<MatchIssueConnectInput>>;
  /** Create and connect multiple MatchIssue documents */
  create?: InputMaybe<Array<MatchIssueCreateInput>>;
  /** Delete multiple MatchIssue documents */
  delete?: InputMaybe<Array<MatchIssueWhereUniqueInput>>;
  /** Disconnect multiple MatchIssue documents */
  disconnect?: InputMaybe<Array<MatchIssueWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MatchIssue documents */
  set?: InputMaybe<Array<MatchIssueWhereUniqueInput>>;
  /** Update multiple MatchIssue documents */
  update?: InputMaybe<Array<MatchIssueUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MatchIssue documents */
  upsert?: InputMaybe<Array<MatchIssueUpsertWithNestedWhereUniqueInput>>;
};

export type MatchIssueUpdateManyInput = {
  analyticKey?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  showOnPending?: InputMaybe<Scalars['Boolean']>;
  showOnRefunded?: InputMaybe<Scalars['Boolean']>;
  showOnSettled?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type MatchIssueUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MatchIssueUpdateManyInput;
  /** Document search */
  where: MatchIssueWhereInput;
};

export type MatchIssueUpdateOneInlineInput = {
  /** Connect existing MatchIssue document */
  connect?: InputMaybe<MatchIssueWhereUniqueInput>;
  /** Create and connect one MatchIssue document */
  create?: InputMaybe<MatchIssueCreateInput>;
  /** Delete currently connected MatchIssue document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected MatchIssue document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single MatchIssue document */
  update?: InputMaybe<MatchIssueUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MatchIssue document */
  upsert?: InputMaybe<MatchIssueUpsertWithNestedWhereUniqueInput>;
};

export type MatchIssueUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MatchIssueUpdateInput;
  /** Unique document search */
  where: MatchIssueWhereUniqueInput;
};

export type MatchIssueUpsertInput = {
  /** Create document if it didn't exist */
  create: MatchIssueCreateInput;
  /** Update document if it exists */
  update: MatchIssueUpdateInput;
};

export type MatchIssueUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MatchIssueUpsertInput;
  /** Unique document search */
  where: MatchIssueWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MatchIssueWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type MatchIssueWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MatchIssueWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MatchIssueWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MatchIssueWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  analyticKey?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  analyticKey_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  analyticKey_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  analyticKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  analyticKey_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  analyticKey_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  analyticKey_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  analyticKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  analyticKey_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  analyticKey_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MatchIssueWhereStageInput>;
  documentInStages_none?: InputMaybe<MatchIssueWhereStageInput>;
  documentInStages_some?: InputMaybe<MatchIssueWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  intercomText?: InputMaybe<PhraseWhereInput>;
  phrase?: InputMaybe<PhraseWhereInput>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showOnPending?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  showOnPending_not?: InputMaybe<Scalars['Boolean']>;
  showOnRefunded?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  showOnRefunded_not?: InputMaybe<Scalars['Boolean']>;
  showOnSettled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  showOnSettled_not?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MatchIssueWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MatchIssueWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MatchIssueWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MatchIssueWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MatchIssueWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References MatchIssue record uniquely */
export type MatchIssueWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create one admin */
  createAdmin?: Maybe<Admin>;
  /** Create one apexCharacterIssue */
  createApexCharacterIssue?: Maybe<ApexCharacterIssue>;
  /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
  createAsset?: Maybe<Asset>;
  /** Create one betCategory */
  createBetCategory?: Maybe<BetCategory>;
  /** Create one betDenominationRestriction */
  createBetDenominationRestriction?: Maybe<BetDenominationRestriction>;
  /** Create one betLine */
  createBetLine?: Maybe<BetLine>;
  /** Create one betLineRule */
  createBetLineRule?: Maybe<BetLineRule>;
  /** Create one betRestriction */
  createBetRestriction?: Maybe<BetRestriction>;
  /** Create one betValue */
  createBetValue?: Maybe<BetValue>;
  /** Create one commonContent */
  createCommonContent?: Maybe<CommonContent>;
  /** Create one defaultGameState */
  createDefaultGameState?: Maybe<DefaultGameState>;
  /** Create one defaultPayoutBand */
  createDefaultPayoutBand?: Maybe<DefaultPayoutBand>;
  /** Create one demoModel */
  createDemoModel?: Maybe<DemoModel>;
  /** Create one fAQ */
  createFAQ?: Maybe<Faq>;
  /** Create one faqCategoryModel */
  createFaqCategoryModel?: Maybe<FaqCategoryModel>;
  /** Create one featureFlag */
  createFeatureFlag?: Maybe<FeatureFlag>;
  /** Create one game */
  createGame?: Maybe<Game>;
  /** Create one gameMode */
  createGameMode?: Maybe<GameMode>;
  /** Create one gameModeCallout */
  createGameModeCallout?: Maybe<GameModeCallout>;
  /** Create one gameSeries */
  createGameSeries?: Maybe<GameSeries>;
  /** Create one matchIssue */
  createMatchIssue?: Maybe<MatchIssue>;
  /** Create one onboardingQuestion */
  createOnboardingQuestion?: Maybe<OnboardingQuestion>;
  /** Create one partnerAd */
  createPartnerAd?: Maybe<PartnerAd>;
  /** Create one phrase */
  createPhrase?: Maybe<Phrase>;
  /** Create one platform */
  createPlatform?: Maybe<Platform>;
  /** Create one playBanner */
  createPlayBanner?: Maybe<PlayBanner>;
  /** Create one regexPattern */
  createRegexPattern?: Maybe<RegexPattern>;
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>;
  /** Create one termsandPrivacy */
  createTermsandPrivacy?: Maybe<TermsandPrivacy>;
  /** Create one twitchExplainer */
  createTwitchExplainer?: Maybe<TwitchExplainer>;
  /** Delete one admin from _all_ existing stages. Returns deleted document. */
  deleteAdmin?: Maybe<Admin>;
  /** Delete one apexCharacterIssue from _all_ existing stages. Returns deleted document. */
  deleteApexCharacterIssue?: Maybe<ApexCharacterIssue>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Delete one betCategory from _all_ existing stages. Returns deleted document. */
  deleteBetCategory?: Maybe<BetCategory>;
  /** Delete one betDenominationRestriction from _all_ existing stages. Returns deleted document. */
  deleteBetDenominationRestriction?: Maybe<BetDenominationRestriction>;
  /** Delete one betLine from _all_ existing stages. Returns deleted document. */
  deleteBetLine?: Maybe<BetLine>;
  /** Delete one betLineRule from _all_ existing stages. Returns deleted document. */
  deleteBetLineRule?: Maybe<BetLineRule>;
  /** Delete one betRestriction from _all_ existing stages. Returns deleted document. */
  deleteBetRestriction?: Maybe<BetRestriction>;
  /** Delete one betValue from _all_ existing stages. Returns deleted document. */
  deleteBetValue?: Maybe<BetValue>;
  /** Delete one commonContent from _all_ existing stages. Returns deleted document. */
  deleteCommonContent?: Maybe<CommonContent>;
  /** Delete one defaultGameState from _all_ existing stages. Returns deleted document. */
  deleteDefaultGameState?: Maybe<DefaultGameState>;
  /** Delete one defaultPayoutBand from _all_ existing stages. Returns deleted document. */
  deleteDefaultPayoutBand?: Maybe<DefaultPayoutBand>;
  /** Delete one demoModel from _all_ existing stages. Returns deleted document. */
  deleteDemoModel?: Maybe<DemoModel>;
  /** Delete one fAQ from _all_ existing stages. Returns deleted document. */
  deleteFAQ?: Maybe<Faq>;
  /** Delete one faqCategoryModel from _all_ existing stages. Returns deleted document. */
  deleteFaqCategoryModel?: Maybe<FaqCategoryModel>;
  /** Delete one featureFlag from _all_ existing stages. Returns deleted document. */
  deleteFeatureFlag?: Maybe<FeatureFlag>;
  /** Delete one game from _all_ existing stages. Returns deleted document. */
  deleteGame?: Maybe<Game>;
  /** Delete one gameMode from _all_ existing stages. Returns deleted document. */
  deleteGameMode?: Maybe<GameMode>;
  /** Delete one gameModeCallout from _all_ existing stages. Returns deleted document. */
  deleteGameModeCallout?: Maybe<GameModeCallout>;
  /** Delete one gameSeries from _all_ existing stages. Returns deleted document. */
  deleteGameSeries?: Maybe<GameSeries>;
  /**
   * Delete many Admin documents
   * @deprecated Please use the new paginated many mutation (deleteManyAdminsConnection)
   */
  deleteManyAdmins: BatchPayload;
  /** Delete many Admin documents, return deleted documents */
  deleteManyAdminsConnection: AdminConnection;
  /**
   * Delete many ApexCharacterIssue documents
   * @deprecated Please use the new paginated many mutation (deleteManyApexCharacterIssuesConnection)
   */
  deleteManyApexCharacterIssues: BatchPayload;
  /** Delete many ApexCharacterIssue documents, return deleted documents */
  deleteManyApexCharacterIssuesConnection: ApexCharacterIssueConnection;
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /**
   * Delete many BetCategory documents
   * @deprecated Please use the new paginated many mutation (deleteManyBetCategoriesConnection)
   */
  deleteManyBetCategories: BatchPayload;
  /** Delete many BetCategory documents, return deleted documents */
  deleteManyBetCategoriesConnection: BetCategoryConnection;
  /**
   * Delete many BetDenominationRestriction documents
   * @deprecated Please use the new paginated many mutation (deleteManyBetDenominationRestrictionsConnection)
   */
  deleteManyBetDenominationRestrictions: BatchPayload;
  /** Delete many BetDenominationRestriction documents, return deleted documents */
  deleteManyBetDenominationRestrictionsConnection: BetDenominationRestrictionConnection;
  /**
   * Delete many BetLineRule documents
   * @deprecated Please use the new paginated many mutation (deleteManyBetLineRulesConnection)
   */
  deleteManyBetLineRules: BatchPayload;
  /** Delete many BetLineRule documents, return deleted documents */
  deleteManyBetLineRulesConnection: BetLineRuleConnection;
  /**
   * Delete many BetLine documents
   * @deprecated Please use the new paginated many mutation (deleteManyBetLinesConnection)
   */
  deleteManyBetLines: BatchPayload;
  /** Delete many BetLine documents, return deleted documents */
  deleteManyBetLinesConnection: BetLineConnection;
  /**
   * Delete many BetRestriction documents
   * @deprecated Please use the new paginated many mutation (deleteManyBetRestrictionsConnection)
   */
  deleteManyBetRestrictions: BatchPayload;
  /** Delete many BetRestriction documents, return deleted documents */
  deleteManyBetRestrictionsConnection: BetRestrictionConnection;
  /**
   * Delete many BetValue documents
   * @deprecated Please use the new paginated many mutation (deleteManyBetValuesConnection)
   */
  deleteManyBetValues: BatchPayload;
  /** Delete many BetValue documents, return deleted documents */
  deleteManyBetValuesConnection: BetValueConnection;
  /**
   * Delete many CommonContent documents
   * @deprecated Please use the new paginated many mutation (deleteManyCommonContentsConnection)
   */
  deleteManyCommonContents: BatchPayload;
  /** Delete many CommonContent documents, return deleted documents */
  deleteManyCommonContentsConnection: CommonContentConnection;
  /**
   * Delete many DefaultGameState documents
   * @deprecated Please use the new paginated many mutation (deleteManyDefaultGameStatesConnection)
   */
  deleteManyDefaultGameStates: BatchPayload;
  /** Delete many DefaultGameState documents, return deleted documents */
  deleteManyDefaultGameStatesConnection: DefaultGameStateConnection;
  /**
   * Delete many DefaultPayoutBand documents
   * @deprecated Please use the new paginated many mutation (deleteManyDefaultPayoutBandsConnection)
   */
  deleteManyDefaultPayoutBands: BatchPayload;
  /** Delete many DefaultPayoutBand documents, return deleted documents */
  deleteManyDefaultPayoutBandsConnection: DefaultPayoutBandConnection;
  /**
   * Delete many DemoModel documents
   * @deprecated Please use the new paginated many mutation (deleteManyDemoModelsConnection)
   */
  deleteManyDemoModels: BatchPayload;
  /** Delete many DemoModel documents, return deleted documents */
  deleteManyDemoModelsConnection: DemoModelConnection;
  /**
   * Delete many FAQ documents
   * @deprecated Please use the new paginated many mutation (deleteManyFAQsConnection)
   */
  deleteManyFAQs: BatchPayload;
  /** Delete many FAQ documents, return deleted documents */
  deleteManyFAQsConnection: FaqConnection;
  /**
   * Delete many FaqCategoryModel documents
   * @deprecated Please use the new paginated many mutation (deleteManyFaqCategoriesConnection)
   */
  deleteManyFaqCategories: BatchPayload;
  /** Delete many FaqCategoryModel documents, return deleted documents */
  deleteManyFaqCategoriesConnection: FaqCategoryModelConnection;
  /**
   * Delete many FeatureFlag documents
   * @deprecated Please use the new paginated many mutation (deleteManyFeatureFlagsConnection)
   */
  deleteManyFeatureFlags: BatchPayload;
  /** Delete many FeatureFlag documents, return deleted documents */
  deleteManyFeatureFlagsConnection: FeatureFlagConnection;
  /**
   * Delete many GameModeCallout documents
   * @deprecated Please use the new paginated many mutation (deleteManyGameModeCalloutsConnection)
   */
  deleteManyGameModeCallouts: BatchPayload;
  /** Delete many GameModeCallout documents, return deleted documents */
  deleteManyGameModeCalloutsConnection: GameModeCalloutConnection;
  /**
   * Delete many GameMode documents
   * @deprecated Please use the new paginated many mutation (deleteManyGameModesConnection)
   */
  deleteManyGameModes: BatchPayload;
  /** Delete many GameMode documents, return deleted documents */
  deleteManyGameModesConnection: GameModeConnection;
  /**
   * Delete many GameSeries documents
   * @deprecated Please use the new paginated many mutation (deleteManyGameSeriesesConnection)
   */
  deleteManyGameSerieses: BatchPayload;
  /** Delete many GameSeries documents, return deleted documents */
  deleteManyGameSeriesesConnection: GameSeriesConnection;
  /**
   * Delete many Game documents
   * @deprecated Please use the new paginated many mutation (deleteManyGamesConnection)
   */
  deleteManyGames: BatchPayload;
  /** Delete many Game documents, return deleted documents */
  deleteManyGamesConnection: GameConnection;
  /**
   * Delete many MatchIssue documents
   * @deprecated Please use the new paginated many mutation (deleteManyMatchIssuesConnection)
   */
  deleteManyMatchIssues: BatchPayload;
  /** Delete many MatchIssue documents, return deleted documents */
  deleteManyMatchIssuesConnection: MatchIssueConnection;
  /**
   * Delete many OnboardingQuestion documents
   * @deprecated Please use the new paginated many mutation (deleteManyOnboardingQuestionsConnection)
   */
  deleteManyOnboardingQuestions: BatchPayload;
  /** Delete many OnboardingQuestion documents, return deleted documents */
  deleteManyOnboardingQuestionsConnection: OnboardingQuestionConnection;
  /**
   * Delete many PartnerAd documents
   * @deprecated Please use the new paginated many mutation (deleteManyPartnerAdsConnection)
   */
  deleteManyPartnerAds: BatchPayload;
  /** Delete many PartnerAd documents, return deleted documents */
  deleteManyPartnerAdsConnection: PartnerAdConnection;
  /**
   * Delete many Phrase documents
   * @deprecated Please use the new paginated many mutation (deleteManyPhrasesConnection)
   */
  deleteManyPhrases: BatchPayload;
  /** Delete many Phrase documents, return deleted documents */
  deleteManyPhrasesConnection: PhraseConnection;
  /**
   * Delete many Platform documents
   * @deprecated Please use the new paginated many mutation (deleteManyPlatformsConnection)
   */
  deleteManyPlatforms: BatchPayload;
  /** Delete many Platform documents, return deleted documents */
  deleteManyPlatformsConnection: PlatformConnection;
  /**
   * Delete many PlayBanner documents
   * @deprecated Please use the new paginated many mutation (deleteManyPlayBannersConnection)
   */
  deleteManyPlayBanners: BatchPayload;
  /** Delete many PlayBanner documents, return deleted documents */
  deleteManyPlayBannersConnection: PlayBannerConnection;
  /**
   * Delete many RegexPattern documents
   * @deprecated Please use the new paginated many mutation (deleteManyRegexPatternsConnection)
   */
  deleteManyRegexPatterns: BatchPayload;
  /** Delete many RegexPattern documents, return deleted documents */
  deleteManyRegexPatternsConnection: RegexPatternConnection;
  /**
   * Delete many TermsandPrivacy documents
   * @deprecated Please use the new paginated many mutation (deleteManyTermsandPrivacysConnection)
   */
  deleteManyTermsandPrivacys: BatchPayload;
  /** Delete many TermsandPrivacy documents, return deleted documents */
  deleteManyTermsandPrivacysConnection: TermsandPrivacyConnection;
  /**
   * Delete many TwitchExplainer documents
   * @deprecated Please use the new paginated many mutation (deleteManyTwitchExplainersConnection)
   */
  deleteManyTwitchExplainers: BatchPayload;
  /** Delete many TwitchExplainer documents, return deleted documents */
  deleteManyTwitchExplainersConnection: TwitchExplainerConnection;
  /** Delete one matchIssue from _all_ existing stages. Returns deleted document. */
  deleteMatchIssue?: Maybe<MatchIssue>;
  /** Delete one onboardingQuestion from _all_ existing stages. Returns deleted document. */
  deleteOnboardingQuestion?: Maybe<OnboardingQuestion>;
  /** Delete one partnerAd from _all_ existing stages. Returns deleted document. */
  deletePartnerAd?: Maybe<PartnerAd>;
  /** Delete one phrase from _all_ existing stages. Returns deleted document. */
  deletePhrase?: Maybe<Phrase>;
  /** Delete one platform from _all_ existing stages. Returns deleted document. */
  deletePlatform?: Maybe<Platform>;
  /** Delete one playBanner from _all_ existing stages. Returns deleted document. */
  deletePlayBanner?: Maybe<PlayBanner>;
  /** Delete one regexPattern from _all_ existing stages. Returns deleted document. */
  deleteRegexPattern?: Maybe<RegexPattern>;
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>;
  /** Delete one termsandPrivacy from _all_ existing stages. Returns deleted document. */
  deleteTermsandPrivacy?: Maybe<TermsandPrivacy>;
  /** Delete one twitchExplainer from _all_ existing stages. Returns deleted document. */
  deleteTwitchExplainer?: Maybe<TwitchExplainer>;
  /** Publish one admin */
  publishAdmin?: Maybe<Admin>;
  /** Publish one apexCharacterIssue */
  publishApexCharacterIssue?: Maybe<ApexCharacterIssue>;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /** Publish one betCategory */
  publishBetCategory?: Maybe<BetCategory>;
  /** Publish one betDenominationRestriction */
  publishBetDenominationRestriction?: Maybe<BetDenominationRestriction>;
  /** Publish one betLine */
  publishBetLine?: Maybe<BetLine>;
  /** Publish one betLineRule */
  publishBetLineRule?: Maybe<BetLineRule>;
  /** Publish one betRestriction */
  publishBetRestriction?: Maybe<BetRestriction>;
  /** Publish one betValue */
  publishBetValue?: Maybe<BetValue>;
  /** Publish one commonContent */
  publishCommonContent?: Maybe<CommonContent>;
  /** Publish one defaultGameState */
  publishDefaultGameState?: Maybe<DefaultGameState>;
  /** Publish one defaultPayoutBand */
  publishDefaultPayoutBand?: Maybe<DefaultPayoutBand>;
  /** Publish one demoModel */
  publishDemoModel?: Maybe<DemoModel>;
  /** Publish one fAQ */
  publishFAQ?: Maybe<Faq>;
  /** Publish one faqCategoryModel */
  publishFaqCategoryModel?: Maybe<FaqCategoryModel>;
  /** Publish one featureFlag */
  publishFeatureFlag?: Maybe<FeatureFlag>;
  /** Publish one game */
  publishGame?: Maybe<Game>;
  /** Publish one gameMode */
  publishGameMode?: Maybe<GameMode>;
  /** Publish one gameModeCallout */
  publishGameModeCallout?: Maybe<GameModeCallout>;
  /** Publish one gameSeries */
  publishGameSeries?: Maybe<GameSeries>;
  /**
   * Publish many Admin documents
   * @deprecated Please use the new paginated many mutation (publishManyAdminsConnection)
   */
  publishManyAdmins: BatchPayload;
  /** Publish many Admin documents */
  publishManyAdminsConnection: AdminConnection;
  /**
   * Publish many ApexCharacterIssue documents
   * @deprecated Please use the new paginated many mutation (publishManyApexCharacterIssuesConnection)
   */
  publishManyApexCharacterIssues: BatchPayload;
  /** Publish many ApexCharacterIssue documents */
  publishManyApexCharacterIssuesConnection: ApexCharacterIssueConnection;
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /**
   * Publish many BetCategory documents
   * @deprecated Please use the new paginated many mutation (publishManyBetCategoriesConnection)
   */
  publishManyBetCategories: BatchPayload;
  /** Publish many BetCategory documents */
  publishManyBetCategoriesConnection: BetCategoryConnection;
  /**
   * Publish many BetDenominationRestriction documents
   * @deprecated Please use the new paginated many mutation (publishManyBetDenominationRestrictionsConnection)
   */
  publishManyBetDenominationRestrictions: BatchPayload;
  /** Publish many BetDenominationRestriction documents */
  publishManyBetDenominationRestrictionsConnection: BetDenominationRestrictionConnection;
  /**
   * Publish many BetLineRule documents
   * @deprecated Please use the new paginated many mutation (publishManyBetLineRulesConnection)
   */
  publishManyBetLineRules: BatchPayload;
  /** Publish many BetLineRule documents */
  publishManyBetLineRulesConnection: BetLineRuleConnection;
  /**
   * Publish many BetLine documents
   * @deprecated Please use the new paginated many mutation (publishManyBetLinesConnection)
   */
  publishManyBetLines: BatchPayload;
  /** Publish many BetLine documents */
  publishManyBetLinesConnection: BetLineConnection;
  /**
   * Publish many BetRestriction documents
   * @deprecated Please use the new paginated many mutation (publishManyBetRestrictionsConnection)
   */
  publishManyBetRestrictions: BatchPayload;
  /** Publish many BetRestriction documents */
  publishManyBetRestrictionsConnection: BetRestrictionConnection;
  /**
   * Publish many BetValue documents
   * @deprecated Please use the new paginated many mutation (publishManyBetValuesConnection)
   */
  publishManyBetValues: BatchPayload;
  /** Publish many BetValue documents */
  publishManyBetValuesConnection: BetValueConnection;
  /**
   * Publish many CommonContent documents
   * @deprecated Please use the new paginated many mutation (publishManyCommonContentsConnection)
   */
  publishManyCommonContents: BatchPayload;
  /** Publish many CommonContent documents */
  publishManyCommonContentsConnection: CommonContentConnection;
  /**
   * Publish many DefaultGameState documents
   * @deprecated Please use the new paginated many mutation (publishManyDefaultGameStatesConnection)
   */
  publishManyDefaultGameStates: BatchPayload;
  /** Publish many DefaultGameState documents */
  publishManyDefaultGameStatesConnection: DefaultGameStateConnection;
  /**
   * Publish many DefaultPayoutBand documents
   * @deprecated Please use the new paginated many mutation (publishManyDefaultPayoutBandsConnection)
   */
  publishManyDefaultPayoutBands: BatchPayload;
  /** Publish many DefaultPayoutBand documents */
  publishManyDefaultPayoutBandsConnection: DefaultPayoutBandConnection;
  /**
   * Publish many DemoModel documents
   * @deprecated Please use the new paginated many mutation (publishManyDemoModelsConnection)
   */
  publishManyDemoModels: BatchPayload;
  /** Publish many DemoModel documents */
  publishManyDemoModelsConnection: DemoModelConnection;
  /**
   * Publish many FAQ documents
   * @deprecated Please use the new paginated many mutation (publishManyFAQsConnection)
   */
  publishManyFAQs: BatchPayload;
  /** Publish many FAQ documents */
  publishManyFAQsConnection: FaqConnection;
  /**
   * Publish many FaqCategoryModel documents
   * @deprecated Please use the new paginated many mutation (publishManyFaqCategoriesConnection)
   */
  publishManyFaqCategories: BatchPayload;
  /** Publish many FaqCategoryModel documents */
  publishManyFaqCategoriesConnection: FaqCategoryModelConnection;
  /**
   * Publish many FeatureFlag documents
   * @deprecated Please use the new paginated many mutation (publishManyFeatureFlagsConnection)
   */
  publishManyFeatureFlags: BatchPayload;
  /** Publish many FeatureFlag documents */
  publishManyFeatureFlagsConnection: FeatureFlagConnection;
  /**
   * Publish many GameModeCallout documents
   * @deprecated Please use the new paginated many mutation (publishManyGameModeCalloutsConnection)
   */
  publishManyGameModeCallouts: BatchPayload;
  /** Publish many GameModeCallout documents */
  publishManyGameModeCalloutsConnection: GameModeCalloutConnection;
  /**
   * Publish many GameMode documents
   * @deprecated Please use the new paginated many mutation (publishManyGameModesConnection)
   */
  publishManyGameModes: BatchPayload;
  /** Publish many GameMode documents */
  publishManyGameModesConnection: GameModeConnection;
  /**
   * Publish many GameSeries documents
   * @deprecated Please use the new paginated many mutation (publishManyGameSeriesesConnection)
   */
  publishManyGameSerieses: BatchPayload;
  /** Publish many GameSeries documents */
  publishManyGameSeriesesConnection: GameSeriesConnection;
  /**
   * Publish many Game documents
   * @deprecated Please use the new paginated many mutation (publishManyGamesConnection)
   */
  publishManyGames: BatchPayload;
  /** Publish many Game documents */
  publishManyGamesConnection: GameConnection;
  /**
   * Publish many MatchIssue documents
   * @deprecated Please use the new paginated many mutation (publishManyMatchIssuesConnection)
   */
  publishManyMatchIssues: BatchPayload;
  /** Publish many MatchIssue documents */
  publishManyMatchIssuesConnection: MatchIssueConnection;
  /**
   * Publish many OnboardingQuestion documents
   * @deprecated Please use the new paginated many mutation (publishManyOnboardingQuestionsConnection)
   */
  publishManyOnboardingQuestions: BatchPayload;
  /** Publish many OnboardingQuestion documents */
  publishManyOnboardingQuestionsConnection: OnboardingQuestionConnection;
  /**
   * Publish many PartnerAd documents
   * @deprecated Please use the new paginated many mutation (publishManyPartnerAdsConnection)
   */
  publishManyPartnerAds: BatchPayload;
  /** Publish many PartnerAd documents */
  publishManyPartnerAdsConnection: PartnerAdConnection;
  /**
   * Publish many Phrase documents
   * @deprecated Please use the new paginated many mutation (publishManyPhrasesConnection)
   */
  publishManyPhrases: BatchPayload;
  /** Publish many Phrase documents */
  publishManyPhrasesConnection: PhraseConnection;
  /**
   * Publish many Platform documents
   * @deprecated Please use the new paginated many mutation (publishManyPlatformsConnection)
   */
  publishManyPlatforms: BatchPayload;
  /** Publish many Platform documents */
  publishManyPlatformsConnection: PlatformConnection;
  /**
   * Publish many PlayBanner documents
   * @deprecated Please use the new paginated many mutation (publishManyPlayBannersConnection)
   */
  publishManyPlayBanners: BatchPayload;
  /** Publish many PlayBanner documents */
  publishManyPlayBannersConnection: PlayBannerConnection;
  /**
   * Publish many RegexPattern documents
   * @deprecated Please use the new paginated many mutation (publishManyRegexPatternsConnection)
   */
  publishManyRegexPatterns: BatchPayload;
  /** Publish many RegexPattern documents */
  publishManyRegexPatternsConnection: RegexPatternConnection;
  /**
   * Publish many TermsandPrivacy documents
   * @deprecated Please use the new paginated many mutation (publishManyTermsandPrivacysConnection)
   */
  publishManyTermsandPrivacys: BatchPayload;
  /** Publish many TermsandPrivacy documents */
  publishManyTermsandPrivacysConnection: TermsandPrivacyConnection;
  /**
   * Publish many TwitchExplainer documents
   * @deprecated Please use the new paginated many mutation (publishManyTwitchExplainersConnection)
   */
  publishManyTwitchExplainers: BatchPayload;
  /** Publish many TwitchExplainer documents */
  publishManyTwitchExplainersConnection: TwitchExplainerConnection;
  /** Publish one matchIssue */
  publishMatchIssue?: Maybe<MatchIssue>;
  /** Publish one onboardingQuestion */
  publishOnboardingQuestion?: Maybe<OnboardingQuestion>;
  /** Publish one partnerAd */
  publishPartnerAd?: Maybe<PartnerAd>;
  /** Publish one phrase */
  publishPhrase?: Maybe<Phrase>;
  /** Publish one platform */
  publishPlatform?: Maybe<Platform>;
  /** Publish one playBanner */
  publishPlayBanner?: Maybe<PlayBanner>;
  /** Publish one regexPattern */
  publishRegexPattern?: Maybe<RegexPattern>;
  /** Publish one termsandPrivacy */
  publishTermsandPrivacy?: Maybe<TermsandPrivacy>;
  /** Publish one twitchExplainer */
  publishTwitchExplainer?: Maybe<TwitchExplainer>;
  /** Schedule to publish one admin */
  schedulePublishAdmin?: Maybe<Admin>;
  /** Schedule to publish one apexCharacterIssue */
  schedulePublishApexCharacterIssue?: Maybe<ApexCharacterIssue>;
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>;
  /** Schedule to publish one betCategory */
  schedulePublishBetCategory?: Maybe<BetCategory>;
  /** Schedule to publish one betDenominationRestriction */
  schedulePublishBetDenominationRestriction?: Maybe<BetDenominationRestriction>;
  /** Schedule to publish one betLine */
  schedulePublishBetLine?: Maybe<BetLine>;
  /** Schedule to publish one betLineRule */
  schedulePublishBetLineRule?: Maybe<BetLineRule>;
  /** Schedule to publish one betRestriction */
  schedulePublishBetRestriction?: Maybe<BetRestriction>;
  /** Schedule to publish one betValue */
  schedulePublishBetValue?: Maybe<BetValue>;
  /** Schedule to publish one commonContent */
  schedulePublishCommonContent?: Maybe<CommonContent>;
  /** Schedule to publish one defaultGameState */
  schedulePublishDefaultGameState?: Maybe<DefaultGameState>;
  /** Schedule to publish one defaultPayoutBand */
  schedulePublishDefaultPayoutBand?: Maybe<DefaultPayoutBand>;
  /** Schedule to publish one demoModel */
  schedulePublishDemoModel?: Maybe<DemoModel>;
  /** Schedule to publish one fAQ */
  schedulePublishFAQ?: Maybe<Faq>;
  /** Schedule to publish one faqCategoryModel */
  schedulePublishFaqCategoryModel?: Maybe<FaqCategoryModel>;
  /** Schedule to publish one featureFlag */
  schedulePublishFeatureFlag?: Maybe<FeatureFlag>;
  /** Schedule to publish one game */
  schedulePublishGame?: Maybe<Game>;
  /** Schedule to publish one gameMode */
  schedulePublishGameMode?: Maybe<GameMode>;
  /** Schedule to publish one gameModeCallout */
  schedulePublishGameModeCallout?: Maybe<GameModeCallout>;
  /** Schedule to publish one gameSeries */
  schedulePublishGameSeries?: Maybe<GameSeries>;
  /** Schedule to publish one matchIssue */
  schedulePublishMatchIssue?: Maybe<MatchIssue>;
  /** Schedule to publish one onboardingQuestion */
  schedulePublishOnboardingQuestion?: Maybe<OnboardingQuestion>;
  /** Schedule to publish one partnerAd */
  schedulePublishPartnerAd?: Maybe<PartnerAd>;
  /** Schedule to publish one phrase */
  schedulePublishPhrase?: Maybe<Phrase>;
  /** Schedule to publish one platform */
  schedulePublishPlatform?: Maybe<Platform>;
  /** Schedule to publish one playBanner */
  schedulePublishPlayBanner?: Maybe<PlayBanner>;
  /** Schedule to publish one regexPattern */
  schedulePublishRegexPattern?: Maybe<RegexPattern>;
  /** Schedule to publish one termsandPrivacy */
  schedulePublishTermsandPrivacy?: Maybe<TermsandPrivacy>;
  /** Schedule to publish one twitchExplainer */
  schedulePublishTwitchExplainer?: Maybe<TwitchExplainer>;
  /** Unpublish one admin from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAdmin?: Maybe<Admin>;
  /** Unpublish one apexCharacterIssue from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishApexCharacterIssue?: Maybe<ApexCharacterIssue>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset?: Maybe<Asset>;
  /** Unpublish one betCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBetCategory?: Maybe<BetCategory>;
  /** Unpublish one betDenominationRestriction from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBetDenominationRestriction?: Maybe<BetDenominationRestriction>;
  /** Unpublish one betLine from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBetLine?: Maybe<BetLine>;
  /** Unpublish one betLineRule from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBetLineRule?: Maybe<BetLineRule>;
  /** Unpublish one betRestriction from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBetRestriction?: Maybe<BetRestriction>;
  /** Unpublish one betValue from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBetValue?: Maybe<BetValue>;
  /** Unpublish one commonContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCommonContent?: Maybe<CommonContent>;
  /** Unpublish one defaultGameState from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDefaultGameState?: Maybe<DefaultGameState>;
  /** Unpublish one defaultPayoutBand from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDefaultPayoutBand?: Maybe<DefaultPayoutBand>;
  /** Unpublish one demoModel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDemoModel?: Maybe<DemoModel>;
  /** Unpublish one fAQ from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFAQ?: Maybe<Faq>;
  /** Unpublish one faqCategoryModel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFaqCategoryModel?: Maybe<FaqCategoryModel>;
  /** Unpublish one featureFlag from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFeatureFlag?: Maybe<FeatureFlag>;
  /** Unpublish one game from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGame?: Maybe<Game>;
  /** Unpublish one gameMode from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGameMode?: Maybe<GameMode>;
  /** Unpublish one gameModeCallout from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGameModeCallout?: Maybe<GameModeCallout>;
  /** Unpublish one gameSeries from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGameSeries?: Maybe<GameSeries>;
  /** Unpublish one matchIssue from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMatchIssue?: Maybe<MatchIssue>;
  /** Unpublish one onboardingQuestion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishOnboardingQuestion?: Maybe<OnboardingQuestion>;
  /** Unpublish one partnerAd from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPartnerAd?: Maybe<PartnerAd>;
  /** Unpublish one phrase from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPhrase?: Maybe<Phrase>;
  /** Unpublish one platform from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPlatform?: Maybe<Platform>;
  /** Unpublish one playBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPlayBanner?: Maybe<PlayBanner>;
  /** Unpublish one regexPattern from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRegexPattern?: Maybe<RegexPattern>;
  /** Unpublish one termsandPrivacy from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTermsandPrivacy?: Maybe<TermsandPrivacy>;
  /** Unpublish one twitchExplainer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTwitchExplainer?: Maybe<TwitchExplainer>;
  /** Unpublish one admin from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAdmin?: Maybe<Admin>;
  /** Unpublish one apexCharacterIssue from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishApexCharacterIssue?: Maybe<ApexCharacterIssue>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset?: Maybe<Asset>;
  /** Unpublish one betCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBetCategory?: Maybe<BetCategory>;
  /** Unpublish one betDenominationRestriction from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBetDenominationRestriction?: Maybe<BetDenominationRestriction>;
  /** Unpublish one betLine from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBetLine?: Maybe<BetLine>;
  /** Unpublish one betLineRule from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBetLineRule?: Maybe<BetLineRule>;
  /** Unpublish one betRestriction from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBetRestriction?: Maybe<BetRestriction>;
  /** Unpublish one betValue from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBetValue?: Maybe<BetValue>;
  /** Unpublish one commonContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCommonContent?: Maybe<CommonContent>;
  /** Unpublish one defaultGameState from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDefaultGameState?: Maybe<DefaultGameState>;
  /** Unpublish one defaultPayoutBand from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDefaultPayoutBand?: Maybe<DefaultPayoutBand>;
  /** Unpublish one demoModel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDemoModel?: Maybe<DemoModel>;
  /** Unpublish one fAQ from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFAQ?: Maybe<Faq>;
  /** Unpublish one faqCategoryModel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFaqCategoryModel?: Maybe<FaqCategoryModel>;
  /** Unpublish one featureFlag from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFeatureFlag?: Maybe<FeatureFlag>;
  /** Unpublish one game from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGame?: Maybe<Game>;
  /** Unpublish one gameMode from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGameMode?: Maybe<GameMode>;
  /** Unpublish one gameModeCallout from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGameModeCallout?: Maybe<GameModeCallout>;
  /** Unpublish one gameSeries from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGameSeries?: Maybe<GameSeries>;
  /**
   * Unpublish many Admin documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAdminsConnection)
   */
  unpublishManyAdmins: BatchPayload;
  /** Find many Admin documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAdminsConnection: AdminConnection;
  /**
   * Unpublish many ApexCharacterIssue documents
   * @deprecated Please use the new paginated many mutation (unpublishManyApexCharacterIssuesConnection)
   */
  unpublishManyApexCharacterIssues: BatchPayload;
  /** Find many ApexCharacterIssue documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyApexCharacterIssuesConnection: ApexCharacterIssueConnection;
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /**
   * Unpublish many BetCategory documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBetCategoriesConnection)
   */
  unpublishManyBetCategories: BatchPayload;
  /** Find many BetCategory documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBetCategoriesConnection: BetCategoryConnection;
  /**
   * Unpublish many BetDenominationRestriction documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBetDenominationRestrictionsConnection)
   */
  unpublishManyBetDenominationRestrictions: BatchPayload;
  /** Find many BetDenominationRestriction documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBetDenominationRestrictionsConnection: BetDenominationRestrictionConnection;
  /**
   * Unpublish many BetLineRule documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBetLineRulesConnection)
   */
  unpublishManyBetLineRules: BatchPayload;
  /** Find many BetLineRule documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBetLineRulesConnection: BetLineRuleConnection;
  /**
   * Unpublish many BetLine documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBetLinesConnection)
   */
  unpublishManyBetLines: BatchPayload;
  /** Find many BetLine documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBetLinesConnection: BetLineConnection;
  /**
   * Unpublish many BetRestriction documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBetRestrictionsConnection)
   */
  unpublishManyBetRestrictions: BatchPayload;
  /** Find many BetRestriction documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBetRestrictionsConnection: BetRestrictionConnection;
  /**
   * Unpublish many BetValue documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBetValuesConnection)
   */
  unpublishManyBetValues: BatchPayload;
  /** Find many BetValue documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBetValuesConnection: BetValueConnection;
  /**
   * Unpublish many CommonContent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCommonContentsConnection)
   */
  unpublishManyCommonContents: BatchPayload;
  /** Find many CommonContent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCommonContentsConnection: CommonContentConnection;
  /**
   * Unpublish many DefaultGameState documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDefaultGameStatesConnection)
   */
  unpublishManyDefaultGameStates: BatchPayload;
  /** Find many DefaultGameState documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDefaultGameStatesConnection: DefaultGameStateConnection;
  /**
   * Unpublish many DefaultPayoutBand documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDefaultPayoutBandsConnection)
   */
  unpublishManyDefaultPayoutBands: BatchPayload;
  /** Find many DefaultPayoutBand documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDefaultPayoutBandsConnection: DefaultPayoutBandConnection;
  /**
   * Unpublish many DemoModel documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDemoModelsConnection)
   */
  unpublishManyDemoModels: BatchPayload;
  /** Find many DemoModel documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDemoModelsConnection: DemoModelConnection;
  /**
   * Unpublish many FAQ documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFAQsConnection)
   */
  unpublishManyFAQs: BatchPayload;
  /** Find many FAQ documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFAQsConnection: FaqConnection;
  /**
   * Unpublish many FaqCategoryModel documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFaqCategoriesConnection)
   */
  unpublishManyFaqCategories: BatchPayload;
  /** Find many FaqCategoryModel documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFaqCategoriesConnection: FaqCategoryModelConnection;
  /**
   * Unpublish many FeatureFlag documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFeatureFlagsConnection)
   */
  unpublishManyFeatureFlags: BatchPayload;
  /** Find many FeatureFlag documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFeatureFlagsConnection: FeatureFlagConnection;
  /**
   * Unpublish many GameModeCallout documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGameModeCalloutsConnection)
   */
  unpublishManyGameModeCallouts: BatchPayload;
  /** Find many GameModeCallout documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGameModeCalloutsConnection: GameModeCalloutConnection;
  /**
   * Unpublish many GameMode documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGameModesConnection)
   */
  unpublishManyGameModes: BatchPayload;
  /** Find many GameMode documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGameModesConnection: GameModeConnection;
  /**
   * Unpublish many GameSeries documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGameSeriesesConnection)
   */
  unpublishManyGameSerieses: BatchPayload;
  /** Find many GameSeries documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGameSeriesesConnection: GameSeriesConnection;
  /**
   * Unpublish many Game documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGamesConnection)
   */
  unpublishManyGames: BatchPayload;
  /** Find many Game documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGamesConnection: GameConnection;
  /**
   * Unpublish many MatchIssue documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMatchIssuesConnection)
   */
  unpublishManyMatchIssues: BatchPayload;
  /** Find many MatchIssue documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMatchIssuesConnection: MatchIssueConnection;
  /**
   * Unpublish many OnboardingQuestion documents
   * @deprecated Please use the new paginated many mutation (unpublishManyOnboardingQuestionsConnection)
   */
  unpublishManyOnboardingQuestions: BatchPayload;
  /** Find many OnboardingQuestion documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyOnboardingQuestionsConnection: OnboardingQuestionConnection;
  /**
   * Unpublish many PartnerAd documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPartnerAdsConnection)
   */
  unpublishManyPartnerAds: BatchPayload;
  /** Find many PartnerAd documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPartnerAdsConnection: PartnerAdConnection;
  /**
   * Unpublish many Phrase documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPhrasesConnection)
   */
  unpublishManyPhrases: BatchPayload;
  /** Find many Phrase documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPhrasesConnection: PhraseConnection;
  /**
   * Unpublish many Platform documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPlatformsConnection)
   */
  unpublishManyPlatforms: BatchPayload;
  /** Find many Platform documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPlatformsConnection: PlatformConnection;
  /**
   * Unpublish many PlayBanner documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPlayBannersConnection)
   */
  unpublishManyPlayBanners: BatchPayload;
  /** Find many PlayBanner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPlayBannersConnection: PlayBannerConnection;
  /**
   * Unpublish many RegexPattern documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRegexPatternsConnection)
   */
  unpublishManyRegexPatterns: BatchPayload;
  /** Find many RegexPattern documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRegexPatternsConnection: RegexPatternConnection;
  /**
   * Unpublish many TermsandPrivacy documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTermsandPrivacysConnection)
   */
  unpublishManyTermsandPrivacys: BatchPayload;
  /** Find many TermsandPrivacy documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTermsandPrivacysConnection: TermsandPrivacyConnection;
  /**
   * Unpublish many TwitchExplainer documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTwitchExplainersConnection)
   */
  unpublishManyTwitchExplainers: BatchPayload;
  /** Find many TwitchExplainer documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTwitchExplainersConnection: TwitchExplainerConnection;
  /** Unpublish one matchIssue from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMatchIssue?: Maybe<MatchIssue>;
  /** Unpublish one onboardingQuestion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishOnboardingQuestion?: Maybe<OnboardingQuestion>;
  /** Unpublish one partnerAd from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPartnerAd?: Maybe<PartnerAd>;
  /** Unpublish one phrase from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPhrase?: Maybe<Phrase>;
  /** Unpublish one platform from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPlatform?: Maybe<Platform>;
  /** Unpublish one playBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPlayBanner?: Maybe<PlayBanner>;
  /** Unpublish one regexPattern from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRegexPattern?: Maybe<RegexPattern>;
  /** Unpublish one termsandPrivacy from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTermsandPrivacy?: Maybe<TermsandPrivacy>;
  /** Unpublish one twitchExplainer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTwitchExplainer?: Maybe<TwitchExplainer>;
  /** Update one admin */
  updateAdmin?: Maybe<Admin>;
  /** Update one apexCharacterIssue */
  updateApexCharacterIssue?: Maybe<ApexCharacterIssue>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  /** Update one betCategory */
  updateBetCategory?: Maybe<BetCategory>;
  /** Update one betDenominationRestriction */
  updateBetDenominationRestriction?: Maybe<BetDenominationRestriction>;
  /** Update one betLine */
  updateBetLine?: Maybe<BetLine>;
  /** Update one betLineRule */
  updateBetLineRule?: Maybe<BetLineRule>;
  /** Update one betRestriction */
  updateBetRestriction?: Maybe<BetRestriction>;
  /** Update one betValue */
  updateBetValue?: Maybe<BetValue>;
  /** Update one commonContent */
  updateCommonContent?: Maybe<CommonContent>;
  /** Update one defaultGameState */
  updateDefaultGameState?: Maybe<DefaultGameState>;
  /** Update one defaultPayoutBand */
  updateDefaultPayoutBand?: Maybe<DefaultPayoutBand>;
  /** Update one demoModel */
  updateDemoModel?: Maybe<DemoModel>;
  /** Update one fAQ */
  updateFAQ?: Maybe<Faq>;
  /** Update one faqCategoryModel */
  updateFaqCategoryModel?: Maybe<FaqCategoryModel>;
  /** Update one featureFlag */
  updateFeatureFlag?: Maybe<FeatureFlag>;
  /** Update one game */
  updateGame?: Maybe<Game>;
  /** Update one gameMode */
  updateGameMode?: Maybe<GameMode>;
  /** Update one gameModeCallout */
  updateGameModeCallout?: Maybe<GameModeCallout>;
  /** Update one gameSeries */
  updateGameSeries?: Maybe<GameSeries>;
  /**
   * Update many admins
   * @deprecated Please use the new paginated many mutation (updateManyAdminsConnection)
   */
  updateManyAdmins: BatchPayload;
  /** Update many Admin documents */
  updateManyAdminsConnection: AdminConnection;
  /**
   * Update many apexCharacterIssues
   * @deprecated Please use the new paginated many mutation (updateManyApexCharacterIssuesConnection)
   */
  updateManyApexCharacterIssues: BatchPayload;
  /** Update many ApexCharacterIssue documents */
  updateManyApexCharacterIssuesConnection: ApexCharacterIssueConnection;
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /**
   * Update many betCategories
   * @deprecated Please use the new paginated many mutation (updateManyBetCategoriesConnection)
   */
  updateManyBetCategories: BatchPayload;
  /** Update many BetCategory documents */
  updateManyBetCategoriesConnection: BetCategoryConnection;
  /**
   * Update many betDenominationRestrictions
   * @deprecated Please use the new paginated many mutation (updateManyBetDenominationRestrictionsConnection)
   */
  updateManyBetDenominationRestrictions: BatchPayload;
  /** Update many BetDenominationRestriction documents */
  updateManyBetDenominationRestrictionsConnection: BetDenominationRestrictionConnection;
  /**
   * Update many betLineRules
   * @deprecated Please use the new paginated many mutation (updateManyBetLineRulesConnection)
   */
  updateManyBetLineRules: BatchPayload;
  /** Update many BetLineRule documents */
  updateManyBetLineRulesConnection: BetLineRuleConnection;
  /**
   * Update many betLines
   * @deprecated Please use the new paginated many mutation (updateManyBetLinesConnection)
   */
  updateManyBetLines: BatchPayload;
  /** Update many BetLine documents */
  updateManyBetLinesConnection: BetLineConnection;
  /**
   * Update many betRestrictions
   * @deprecated Please use the new paginated many mutation (updateManyBetRestrictionsConnection)
   */
  updateManyBetRestrictions: BatchPayload;
  /** Update many BetRestriction documents */
  updateManyBetRestrictionsConnection: BetRestrictionConnection;
  /**
   * Update many betValues
   * @deprecated Please use the new paginated many mutation (updateManyBetValuesConnection)
   */
  updateManyBetValues: BatchPayload;
  /** Update many BetValue documents */
  updateManyBetValuesConnection: BetValueConnection;
  /**
   * Update many commonContents
   * @deprecated Please use the new paginated many mutation (updateManyCommonContentsConnection)
   */
  updateManyCommonContents: BatchPayload;
  /** Update many CommonContent documents */
  updateManyCommonContentsConnection: CommonContentConnection;
  /**
   * Update many defaultGameStates
   * @deprecated Please use the new paginated many mutation (updateManyDefaultGameStatesConnection)
   */
  updateManyDefaultGameStates: BatchPayload;
  /** Update many DefaultGameState documents */
  updateManyDefaultGameStatesConnection: DefaultGameStateConnection;
  /**
   * Update many defaultPayoutBands
   * @deprecated Please use the new paginated many mutation (updateManyDefaultPayoutBandsConnection)
   */
  updateManyDefaultPayoutBands: BatchPayload;
  /** Update many DefaultPayoutBand documents */
  updateManyDefaultPayoutBandsConnection: DefaultPayoutBandConnection;
  /**
   * Update many demoModels
   * @deprecated Please use the new paginated many mutation (updateManyDemoModelsConnection)
   */
  updateManyDemoModels: BatchPayload;
  /** Update many DemoModel documents */
  updateManyDemoModelsConnection: DemoModelConnection;
  /**
   * Update many fAQs
   * @deprecated Please use the new paginated many mutation (updateManyFAQsConnection)
   */
  updateManyFAQs: BatchPayload;
  /** Update many FAQ documents */
  updateManyFAQsConnection: FaqConnection;
  /**
   * Update many faqCategories
   * @deprecated Please use the new paginated many mutation (updateManyFaqCategoriesConnection)
   */
  updateManyFaqCategories: BatchPayload;
  /** Update many FaqCategoryModel documents */
  updateManyFaqCategoriesConnection: FaqCategoryModelConnection;
  /**
   * Update many featureFlags
   * @deprecated Please use the new paginated many mutation (updateManyFeatureFlagsConnection)
   */
  updateManyFeatureFlags: BatchPayload;
  /** Update many FeatureFlag documents */
  updateManyFeatureFlagsConnection: FeatureFlagConnection;
  /**
   * Update many gameModeCallouts
   * @deprecated Please use the new paginated many mutation (updateManyGameModeCalloutsConnection)
   */
  updateManyGameModeCallouts: BatchPayload;
  /** Update many GameModeCallout documents */
  updateManyGameModeCalloutsConnection: GameModeCalloutConnection;
  /**
   * Update many gameModes
   * @deprecated Please use the new paginated many mutation (updateManyGameModesConnection)
   */
  updateManyGameModes: BatchPayload;
  /** Update many GameMode documents */
  updateManyGameModesConnection: GameModeConnection;
  /**
   * Update many gameSerieses
   * @deprecated Please use the new paginated many mutation (updateManyGameSeriesesConnection)
   */
  updateManyGameSerieses: BatchPayload;
  /** Update many GameSeries documents */
  updateManyGameSeriesesConnection: GameSeriesConnection;
  /**
   * Update many games
   * @deprecated Please use the new paginated many mutation (updateManyGamesConnection)
   */
  updateManyGames: BatchPayload;
  /** Update many Game documents */
  updateManyGamesConnection: GameConnection;
  /**
   * Update many matchIssues
   * @deprecated Please use the new paginated many mutation (updateManyMatchIssuesConnection)
   */
  updateManyMatchIssues: BatchPayload;
  /** Update many MatchIssue documents */
  updateManyMatchIssuesConnection: MatchIssueConnection;
  /**
   * Update many onboardingQuestions
   * @deprecated Please use the new paginated many mutation (updateManyOnboardingQuestionsConnection)
   */
  updateManyOnboardingQuestions: BatchPayload;
  /** Update many OnboardingQuestion documents */
  updateManyOnboardingQuestionsConnection: OnboardingQuestionConnection;
  /**
   * Update many partnerAds
   * @deprecated Please use the new paginated many mutation (updateManyPartnerAdsConnection)
   */
  updateManyPartnerAds: BatchPayload;
  /** Update many PartnerAd documents */
  updateManyPartnerAdsConnection: PartnerAdConnection;
  /**
   * Update many phrases
   * @deprecated Please use the new paginated many mutation (updateManyPhrasesConnection)
   */
  updateManyPhrases: BatchPayload;
  /** Update many Phrase documents */
  updateManyPhrasesConnection: PhraseConnection;
  /**
   * Update many platforms
   * @deprecated Please use the new paginated many mutation (updateManyPlatformsConnection)
   */
  updateManyPlatforms: BatchPayload;
  /** Update many Platform documents */
  updateManyPlatformsConnection: PlatformConnection;
  /**
   * Update many playBanners
   * @deprecated Please use the new paginated many mutation (updateManyPlayBannersConnection)
   */
  updateManyPlayBanners: BatchPayload;
  /** Update many PlayBanner documents */
  updateManyPlayBannersConnection: PlayBannerConnection;
  /**
   * Update many regexPatterns
   * @deprecated Please use the new paginated many mutation (updateManyRegexPatternsConnection)
   */
  updateManyRegexPatterns: BatchPayload;
  /** Update many RegexPattern documents */
  updateManyRegexPatternsConnection: RegexPatternConnection;
  /**
   * Update many termsandPrivacys
   * @deprecated Please use the new paginated many mutation (updateManyTermsandPrivacysConnection)
   */
  updateManyTermsandPrivacys: BatchPayload;
  /** Update many TermsandPrivacy documents */
  updateManyTermsandPrivacysConnection: TermsandPrivacyConnection;
  /**
   * Update many twitchExplainers
   * @deprecated Please use the new paginated many mutation (updateManyTwitchExplainersConnection)
   */
  updateManyTwitchExplainers: BatchPayload;
  /** Update many TwitchExplainer documents */
  updateManyTwitchExplainersConnection: TwitchExplainerConnection;
  /** Update one matchIssue */
  updateMatchIssue?: Maybe<MatchIssue>;
  /** Update one onboardingQuestion */
  updateOnboardingQuestion?: Maybe<OnboardingQuestion>;
  /** Update one partnerAd */
  updatePartnerAd?: Maybe<PartnerAd>;
  /** Update one phrase */
  updatePhrase?: Maybe<Phrase>;
  /** Update one platform */
  updatePlatform?: Maybe<Platform>;
  /** Update one playBanner */
  updatePlayBanner?: Maybe<PlayBanner>;
  /** Update one regexPattern */
  updateRegexPattern?: Maybe<RegexPattern>;
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>;
  /** Update one termsandPrivacy */
  updateTermsandPrivacy?: Maybe<TermsandPrivacy>;
  /** Update one twitchExplainer */
  updateTwitchExplainer?: Maybe<TwitchExplainer>;
  /** Upsert one admin */
  upsertAdmin?: Maybe<Admin>;
  /** Upsert one apexCharacterIssue */
  upsertApexCharacterIssue?: Maybe<ApexCharacterIssue>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  /** Upsert one betCategory */
  upsertBetCategory?: Maybe<BetCategory>;
  /** Upsert one betDenominationRestriction */
  upsertBetDenominationRestriction?: Maybe<BetDenominationRestriction>;
  /** Upsert one betLine */
  upsertBetLine?: Maybe<BetLine>;
  /** Upsert one betLineRule */
  upsertBetLineRule?: Maybe<BetLineRule>;
  /** Upsert one betRestriction */
  upsertBetRestriction?: Maybe<BetRestriction>;
  /** Upsert one betValue */
  upsertBetValue?: Maybe<BetValue>;
  /** Upsert one commonContent */
  upsertCommonContent?: Maybe<CommonContent>;
  /** Upsert one defaultGameState */
  upsertDefaultGameState?: Maybe<DefaultGameState>;
  /** Upsert one defaultPayoutBand */
  upsertDefaultPayoutBand?: Maybe<DefaultPayoutBand>;
  /** Upsert one demoModel */
  upsertDemoModel?: Maybe<DemoModel>;
  /** Upsert one fAQ */
  upsertFAQ?: Maybe<Faq>;
  /** Upsert one faqCategoryModel */
  upsertFaqCategoryModel?: Maybe<FaqCategoryModel>;
  /** Upsert one featureFlag */
  upsertFeatureFlag?: Maybe<FeatureFlag>;
  /** Upsert one game */
  upsertGame?: Maybe<Game>;
  /** Upsert one gameMode */
  upsertGameMode?: Maybe<GameMode>;
  /** Upsert one gameModeCallout */
  upsertGameModeCallout?: Maybe<GameModeCallout>;
  /** Upsert one gameSeries */
  upsertGameSeries?: Maybe<GameSeries>;
  /** Upsert one matchIssue */
  upsertMatchIssue?: Maybe<MatchIssue>;
  /** Upsert one onboardingQuestion */
  upsertOnboardingQuestion?: Maybe<OnboardingQuestion>;
  /** Upsert one partnerAd */
  upsertPartnerAd?: Maybe<PartnerAd>;
  /** Upsert one phrase */
  upsertPhrase?: Maybe<Phrase>;
  /** Upsert one platform */
  upsertPlatform?: Maybe<Platform>;
  /** Upsert one playBanner */
  upsertPlayBanner?: Maybe<PlayBanner>;
  /** Upsert one regexPattern */
  upsertRegexPattern?: Maybe<RegexPattern>;
  /** Upsert one termsandPrivacy */
  upsertTermsandPrivacy?: Maybe<TermsandPrivacy>;
  /** Upsert one twitchExplainer */
  upsertTwitchExplainer?: Maybe<TwitchExplainer>;
};


export type MutationCreateAdminArgs = {
  data: AdminCreateInput;
};


export type MutationCreateApexCharacterIssueArgs = {
  data: ApexCharacterIssueCreateInput;
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationCreateBetCategoryArgs = {
  data: BetCategoryCreateInput;
};


export type MutationCreateBetDenominationRestrictionArgs = {
  data: BetDenominationRestrictionCreateInput;
};


export type MutationCreateBetLineArgs = {
  data: BetLineCreateInput;
};


export type MutationCreateBetLineRuleArgs = {
  data: BetLineRuleCreateInput;
};


export type MutationCreateBetRestrictionArgs = {
  data: BetRestrictionCreateInput;
};


export type MutationCreateBetValueArgs = {
  data: BetValueCreateInput;
};


export type MutationCreateCommonContentArgs = {
  data: CommonContentCreateInput;
};


export type MutationCreateDefaultGameStateArgs = {
  data: DefaultGameStateCreateInput;
};


export type MutationCreateDefaultPayoutBandArgs = {
  data: DefaultPayoutBandCreateInput;
};


export type MutationCreateDemoModelArgs = {
  data: DemoModelCreateInput;
};


export type MutationCreateFaqArgs = {
  data: FaqCreateInput;
};


export type MutationCreateFaqCategoryModelArgs = {
  data: FaqCategoryModelCreateInput;
};


export type MutationCreateFeatureFlagArgs = {
  data: FeatureFlagCreateInput;
};


export type MutationCreateGameArgs = {
  data: GameCreateInput;
};


export type MutationCreateGameModeArgs = {
  data: GameModeCreateInput;
};


export type MutationCreateGameModeCalloutArgs = {
  data: GameModeCalloutCreateInput;
};


export type MutationCreateGameSeriesArgs = {
  data: GameSeriesCreateInput;
};


export type MutationCreateMatchIssueArgs = {
  data: MatchIssueCreateInput;
};


export type MutationCreateOnboardingQuestionArgs = {
  data: OnboardingQuestionCreateInput;
};


export type MutationCreatePartnerAdArgs = {
  data: PartnerAdCreateInput;
};


export type MutationCreatePhraseArgs = {
  data: PhraseCreateInput;
};


export type MutationCreatePlatformArgs = {
  data: PlatformCreateInput;
};


export type MutationCreatePlayBannerArgs = {
  data: PlayBannerCreateInput;
};


export type MutationCreateRegexPatternArgs = {
  data: RegexPatternCreateInput;
};


export type MutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};


export type MutationCreateTermsandPrivacyArgs = {
  data: TermsandPrivacyCreateInput;
};


export type MutationCreateTwitchExplainerArgs = {
  data: TwitchExplainerCreateInput;
};


export type MutationDeleteAdminArgs = {
  where: AdminWhereUniqueInput;
};


export type MutationDeleteApexCharacterIssueArgs = {
  where: ApexCharacterIssueWhereUniqueInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationDeleteBetCategoryArgs = {
  where: BetCategoryWhereUniqueInput;
};


export type MutationDeleteBetDenominationRestrictionArgs = {
  where: BetDenominationRestrictionWhereUniqueInput;
};


export type MutationDeleteBetLineArgs = {
  where: BetLineWhereUniqueInput;
};


export type MutationDeleteBetLineRuleArgs = {
  where: BetLineRuleWhereUniqueInput;
};


export type MutationDeleteBetRestrictionArgs = {
  where: BetRestrictionWhereUniqueInput;
};


export type MutationDeleteBetValueArgs = {
  where: BetValueWhereUniqueInput;
};


export type MutationDeleteCommonContentArgs = {
  where: CommonContentWhereUniqueInput;
};


export type MutationDeleteDefaultGameStateArgs = {
  where: DefaultGameStateWhereUniqueInput;
};


export type MutationDeleteDefaultPayoutBandArgs = {
  where: DefaultPayoutBandWhereUniqueInput;
};


export type MutationDeleteDemoModelArgs = {
  where: DemoModelWhereUniqueInput;
};


export type MutationDeleteFaqArgs = {
  where: FaqWhereUniqueInput;
};


export type MutationDeleteFaqCategoryModelArgs = {
  where: FaqCategoryModelWhereUniqueInput;
};


export type MutationDeleteFeatureFlagArgs = {
  where: FeatureFlagWhereUniqueInput;
};


export type MutationDeleteGameArgs = {
  where: GameWhereUniqueInput;
};


export type MutationDeleteGameModeArgs = {
  where: GameModeWhereUniqueInput;
};


export type MutationDeleteGameModeCalloutArgs = {
  where: GameModeCalloutWhereUniqueInput;
};


export type MutationDeleteGameSeriesArgs = {
  where: GameSeriesWhereUniqueInput;
};


export type MutationDeleteManyAdminsArgs = {
  where?: InputMaybe<AdminManyWhereInput>;
};


export type MutationDeleteManyAdminsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminManyWhereInput>;
};


export type MutationDeleteManyApexCharacterIssuesArgs = {
  where?: InputMaybe<ApexCharacterIssueManyWhereInput>;
};


export type MutationDeleteManyApexCharacterIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApexCharacterIssueManyWhereInput>;
};


export type MutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyBetCategoriesArgs = {
  where?: InputMaybe<BetCategoryManyWhereInput>;
};


export type MutationDeleteManyBetCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetCategoryManyWhereInput>;
};


export type MutationDeleteManyBetDenominationRestrictionsArgs = {
  where?: InputMaybe<BetDenominationRestrictionManyWhereInput>;
};


export type MutationDeleteManyBetDenominationRestrictionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetDenominationRestrictionManyWhereInput>;
};


export type MutationDeleteManyBetLineRulesArgs = {
  where?: InputMaybe<BetLineRuleManyWhereInput>;
};


export type MutationDeleteManyBetLineRulesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetLineRuleManyWhereInput>;
};


export type MutationDeleteManyBetLinesArgs = {
  where?: InputMaybe<BetLineManyWhereInput>;
};


export type MutationDeleteManyBetLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetLineManyWhereInput>;
};


export type MutationDeleteManyBetRestrictionsArgs = {
  where?: InputMaybe<BetRestrictionManyWhereInput>;
};


export type MutationDeleteManyBetRestrictionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetRestrictionManyWhereInput>;
};


export type MutationDeleteManyBetValuesArgs = {
  where?: InputMaybe<BetValueManyWhereInput>;
};


export type MutationDeleteManyBetValuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetValueManyWhereInput>;
};


export type MutationDeleteManyCommonContentsArgs = {
  where?: InputMaybe<CommonContentManyWhereInput>;
};


export type MutationDeleteManyCommonContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommonContentManyWhereInput>;
};


export type MutationDeleteManyDefaultGameStatesArgs = {
  where?: InputMaybe<DefaultGameStateManyWhereInput>;
};


export type MutationDeleteManyDefaultGameStatesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefaultGameStateManyWhereInput>;
};


export type MutationDeleteManyDefaultPayoutBandsArgs = {
  where?: InputMaybe<DefaultPayoutBandManyWhereInput>;
};


export type MutationDeleteManyDefaultPayoutBandsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefaultPayoutBandManyWhereInput>;
};


export type MutationDeleteManyDemoModelsArgs = {
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationDeleteManyDemoModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationDeleteManyFaQsArgs = {
  where?: InputMaybe<FaqManyWhereInput>;
};


export type MutationDeleteManyFaQsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FaqManyWhereInput>;
};


export type MutationDeleteManyFaqCategoriesArgs = {
  where?: InputMaybe<FaqCategoryModelManyWhereInput>;
};


export type MutationDeleteManyFaqCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FaqCategoryModelManyWhereInput>;
};


export type MutationDeleteManyFeatureFlagsArgs = {
  where?: InputMaybe<FeatureFlagManyWhereInput>;
};


export type MutationDeleteManyFeatureFlagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeatureFlagManyWhereInput>;
};


export type MutationDeleteManyGameModeCalloutsArgs = {
  where?: InputMaybe<GameModeCalloutManyWhereInput>;
};


export type MutationDeleteManyGameModeCalloutsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameModeCalloutManyWhereInput>;
};


export type MutationDeleteManyGameModesArgs = {
  where?: InputMaybe<GameModeManyWhereInput>;
};


export type MutationDeleteManyGameModesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameModeManyWhereInput>;
};


export type MutationDeleteManyGameSeriesesArgs = {
  where?: InputMaybe<GameSeriesManyWhereInput>;
};


export type MutationDeleteManyGameSeriesesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameSeriesManyWhereInput>;
};


export type MutationDeleteManyGamesArgs = {
  where?: InputMaybe<GameManyWhereInput>;
};


export type MutationDeleteManyGamesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameManyWhereInput>;
};


export type MutationDeleteManyMatchIssuesArgs = {
  where?: InputMaybe<MatchIssueManyWhereInput>;
};


export type MutationDeleteManyMatchIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MatchIssueManyWhereInput>;
};


export type MutationDeleteManyOnboardingQuestionsArgs = {
  where?: InputMaybe<OnboardingQuestionManyWhereInput>;
};


export type MutationDeleteManyOnboardingQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OnboardingQuestionManyWhereInput>;
};


export type MutationDeleteManyPartnerAdsArgs = {
  where?: InputMaybe<PartnerAdManyWhereInput>;
};


export type MutationDeleteManyPartnerAdsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PartnerAdManyWhereInput>;
};


export type MutationDeleteManyPhrasesArgs = {
  where?: InputMaybe<PhraseManyWhereInput>;
};


export type MutationDeleteManyPhrasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PhraseManyWhereInput>;
};


export type MutationDeleteManyPlatformsArgs = {
  where?: InputMaybe<PlatformManyWhereInput>;
};


export type MutationDeleteManyPlatformsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlatformManyWhereInput>;
};


export type MutationDeleteManyPlayBannersArgs = {
  where?: InputMaybe<PlayBannerManyWhereInput>;
};


export type MutationDeleteManyPlayBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlayBannerManyWhereInput>;
};


export type MutationDeleteManyRegexPatternsArgs = {
  where?: InputMaybe<RegexPatternManyWhereInput>;
};


export type MutationDeleteManyRegexPatternsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RegexPatternManyWhereInput>;
};


export type MutationDeleteManyTermsandPrivacysArgs = {
  where?: InputMaybe<TermsandPrivacyManyWhereInput>;
};


export type MutationDeleteManyTermsandPrivacysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TermsandPrivacyManyWhereInput>;
};


export type MutationDeleteManyTwitchExplainersArgs = {
  where?: InputMaybe<TwitchExplainerManyWhereInput>;
};


export type MutationDeleteManyTwitchExplainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TwitchExplainerManyWhereInput>;
};


export type MutationDeleteMatchIssueArgs = {
  where: MatchIssueWhereUniqueInput;
};


export type MutationDeleteOnboardingQuestionArgs = {
  where: OnboardingQuestionWhereUniqueInput;
};


export type MutationDeletePartnerAdArgs = {
  where: PartnerAdWhereUniqueInput;
};


export type MutationDeletePhraseArgs = {
  where: PhraseWhereUniqueInput;
};


export type MutationDeletePlatformArgs = {
  where: PlatformWhereUniqueInput;
};


export type MutationDeletePlayBannerArgs = {
  where: PlayBannerWhereUniqueInput;
};


export type MutationDeleteRegexPatternArgs = {
  where: RegexPatternWhereUniqueInput;
};


export type MutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};


export type MutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationDeleteTermsandPrivacyArgs = {
  where: TermsandPrivacyWhereUniqueInput;
};


export type MutationDeleteTwitchExplainerArgs = {
  where: TwitchExplainerWhereUniqueInput;
};


export type MutationPublishAdminArgs = {
  to?: Array<Stage>;
  where: AdminWhereUniqueInput;
};


export type MutationPublishApexCharacterIssueArgs = {
  to?: Array<Stage>;
  where: ApexCharacterIssueWhereUniqueInput;
};


export type MutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishBetCategoryArgs = {
  to?: Array<Stage>;
  where: BetCategoryWhereUniqueInput;
};


export type MutationPublishBetDenominationRestrictionArgs = {
  to?: Array<Stage>;
  where: BetDenominationRestrictionWhereUniqueInput;
};


export type MutationPublishBetLineArgs = {
  to?: Array<Stage>;
  where: BetLineWhereUniqueInput;
};


export type MutationPublishBetLineRuleArgs = {
  to?: Array<Stage>;
  where: BetLineRuleWhereUniqueInput;
};


export type MutationPublishBetRestrictionArgs = {
  to?: Array<Stage>;
  where: BetRestrictionWhereUniqueInput;
};


export type MutationPublishBetValueArgs = {
  to?: Array<Stage>;
  where: BetValueWhereUniqueInput;
};


export type MutationPublishCommonContentArgs = {
  to?: Array<Stage>;
  where: CommonContentWhereUniqueInput;
};


export type MutationPublishDefaultGameStateArgs = {
  to?: Array<Stage>;
  where: DefaultGameStateWhereUniqueInput;
};


export type MutationPublishDefaultPayoutBandArgs = {
  to?: Array<Stage>;
  where: DefaultPayoutBandWhereUniqueInput;
};


export type MutationPublishDemoModelArgs = {
  to?: Array<Stage>;
  where: DemoModelWhereUniqueInput;
};


export type MutationPublishFaqArgs = {
  to?: Array<Stage>;
  where: FaqWhereUniqueInput;
};


export type MutationPublishFaqCategoryModelArgs = {
  to?: Array<Stage>;
  where: FaqCategoryModelWhereUniqueInput;
};


export type MutationPublishFeatureFlagArgs = {
  to?: Array<Stage>;
  where: FeatureFlagWhereUniqueInput;
};


export type MutationPublishGameArgs = {
  to?: Array<Stage>;
  where: GameWhereUniqueInput;
};


export type MutationPublishGameModeArgs = {
  to?: Array<Stage>;
  where: GameModeWhereUniqueInput;
};


export type MutationPublishGameModeCalloutArgs = {
  to?: Array<Stage>;
  where: GameModeCalloutWhereUniqueInput;
};


export type MutationPublishGameSeriesArgs = {
  to?: Array<Stage>;
  where: GameSeriesWhereUniqueInput;
};


export type MutationPublishManyAdminsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AdminManyWhereInput>;
};


export type MutationPublishManyAdminsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<AdminManyWhereInput>;
};


export type MutationPublishManyApexCharacterIssuesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ApexCharacterIssueManyWhereInput>;
};


export type MutationPublishManyApexCharacterIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<ApexCharacterIssueManyWhereInput>;
};


export type MutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyBetCategoriesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BetCategoryManyWhereInput>;
};


export type MutationPublishManyBetCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<BetCategoryManyWhereInput>;
};


export type MutationPublishManyBetDenominationRestrictionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BetDenominationRestrictionManyWhereInput>;
};


export type MutationPublishManyBetDenominationRestrictionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<BetDenominationRestrictionManyWhereInput>;
};


export type MutationPublishManyBetLineRulesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BetLineRuleManyWhereInput>;
};


export type MutationPublishManyBetLineRulesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<BetLineRuleManyWhereInput>;
};


export type MutationPublishManyBetLinesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BetLineManyWhereInput>;
};


export type MutationPublishManyBetLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<BetLineManyWhereInput>;
};


export type MutationPublishManyBetRestrictionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BetRestrictionManyWhereInput>;
};


export type MutationPublishManyBetRestrictionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<BetRestrictionManyWhereInput>;
};


export type MutationPublishManyBetValuesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BetValueManyWhereInput>;
};


export type MutationPublishManyBetValuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<BetValueManyWhereInput>;
};


export type MutationPublishManyCommonContentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CommonContentManyWhereInput>;
};


export type MutationPublishManyCommonContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<CommonContentManyWhereInput>;
};


export type MutationPublishManyDefaultGameStatesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<DefaultGameStateManyWhereInput>;
};


export type MutationPublishManyDefaultGameStatesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<DefaultGameStateManyWhereInput>;
};


export type MutationPublishManyDefaultPayoutBandsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<DefaultPayoutBandManyWhereInput>;
};


export type MutationPublishManyDefaultPayoutBandsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<DefaultPayoutBandManyWhereInput>;
};


export type MutationPublishManyDemoModelsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationPublishManyDemoModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationPublishManyFaQsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FaqManyWhereInput>;
};


export type MutationPublishManyFaQsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<FaqManyWhereInput>;
};


export type MutationPublishManyFaqCategoriesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FaqCategoryModelManyWhereInput>;
};


export type MutationPublishManyFaqCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<FaqCategoryModelManyWhereInput>;
};


export type MutationPublishManyFeatureFlagsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FeatureFlagManyWhereInput>;
};


export type MutationPublishManyFeatureFlagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<FeatureFlagManyWhereInput>;
};


export type MutationPublishManyGameModeCalloutsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GameModeCalloutManyWhereInput>;
};


export type MutationPublishManyGameModeCalloutsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<GameModeCalloutManyWhereInput>;
};


export type MutationPublishManyGameModesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GameModeManyWhereInput>;
};


export type MutationPublishManyGameModesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<GameModeManyWhereInput>;
};


export type MutationPublishManyGameSeriesesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GameSeriesManyWhereInput>;
};


export type MutationPublishManyGameSeriesesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<GameSeriesManyWhereInput>;
};


export type MutationPublishManyGamesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GameManyWhereInput>;
};


export type MutationPublishManyGamesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<GameManyWhereInput>;
};


export type MutationPublishManyMatchIssuesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<MatchIssueManyWhereInput>;
};


export type MutationPublishManyMatchIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<MatchIssueManyWhereInput>;
};


export type MutationPublishManyOnboardingQuestionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<OnboardingQuestionManyWhereInput>;
};


export type MutationPublishManyOnboardingQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<OnboardingQuestionManyWhereInput>;
};


export type MutationPublishManyPartnerAdsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PartnerAdManyWhereInput>;
};


export type MutationPublishManyPartnerAdsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<PartnerAdManyWhereInput>;
};


export type MutationPublishManyPhrasesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<PhraseManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyPhrasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<PhraseManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyPlatformsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PlatformManyWhereInput>;
};


export type MutationPublishManyPlatformsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<PlatformManyWhereInput>;
};


export type MutationPublishManyPlayBannersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PlayBannerManyWhereInput>;
};


export type MutationPublishManyPlayBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<PlayBannerManyWhereInput>;
};


export type MutationPublishManyRegexPatternsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RegexPatternManyWhereInput>;
};


export type MutationPublishManyRegexPatternsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<RegexPatternManyWhereInput>;
};


export type MutationPublishManyTermsandPrivacysArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<TermsandPrivacyManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyTermsandPrivacysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<TermsandPrivacyManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishManyTwitchExplainersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TwitchExplainerManyWhereInput>;
};


export type MutationPublishManyTwitchExplainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<TwitchExplainerManyWhereInput>;
};


export type MutationPublishMatchIssueArgs = {
  to?: Array<Stage>;
  where: MatchIssueWhereUniqueInput;
};


export type MutationPublishOnboardingQuestionArgs = {
  to?: Array<Stage>;
  where: OnboardingQuestionWhereUniqueInput;
};


export type MutationPublishPartnerAdArgs = {
  to?: Array<Stage>;
  where: PartnerAdWhereUniqueInput;
};


export type MutationPublishPhraseArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: PhraseWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishPlatformArgs = {
  to?: Array<Stage>;
  where: PlatformWhereUniqueInput;
};


export type MutationPublishPlayBannerArgs = {
  to?: Array<Stage>;
  where: PlayBannerWhereUniqueInput;
};


export type MutationPublishRegexPatternArgs = {
  to?: Array<Stage>;
  where: RegexPatternWhereUniqueInput;
};


export type MutationPublishTermsandPrivacyArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: TermsandPrivacyWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPublishTwitchExplainerArgs = {
  to?: Array<Stage>;
  where: TwitchExplainerWhereUniqueInput;
};


export type MutationSchedulePublishAdminArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: AdminWhereUniqueInput;
};


export type MutationSchedulePublishApexCharacterIssueArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: ApexCharacterIssueWhereUniqueInput;
};


export type MutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishBetCategoryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: BetCategoryWhereUniqueInput;
};


export type MutationSchedulePublishBetDenominationRestrictionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: BetDenominationRestrictionWhereUniqueInput;
};


export type MutationSchedulePublishBetLineArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: BetLineWhereUniqueInput;
};


export type MutationSchedulePublishBetLineRuleArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: BetLineRuleWhereUniqueInput;
};


export type MutationSchedulePublishBetRestrictionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: BetRestrictionWhereUniqueInput;
};


export type MutationSchedulePublishBetValueArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: BetValueWhereUniqueInput;
};


export type MutationSchedulePublishCommonContentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: CommonContentWhereUniqueInput;
};


export type MutationSchedulePublishDefaultGameStateArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: DefaultGameStateWhereUniqueInput;
};


export type MutationSchedulePublishDefaultPayoutBandArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: DefaultPayoutBandWhereUniqueInput;
};


export type MutationSchedulePublishDemoModelArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: DemoModelWhereUniqueInput;
};


export type MutationSchedulePublishFaqArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: FaqWhereUniqueInput;
};


export type MutationSchedulePublishFaqCategoryModelArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: FaqCategoryModelWhereUniqueInput;
};


export type MutationSchedulePublishFeatureFlagArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: FeatureFlagWhereUniqueInput;
};


export type MutationSchedulePublishGameArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: GameWhereUniqueInput;
};


export type MutationSchedulePublishGameModeArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: GameModeWhereUniqueInput;
};


export type MutationSchedulePublishGameModeCalloutArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: GameModeCalloutWhereUniqueInput;
};


export type MutationSchedulePublishGameSeriesArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: GameSeriesWhereUniqueInput;
};


export type MutationSchedulePublishMatchIssueArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: MatchIssueWhereUniqueInput;
};


export type MutationSchedulePublishOnboardingQuestionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: OnboardingQuestionWhereUniqueInput;
};


export type MutationSchedulePublishPartnerAdArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: PartnerAdWhereUniqueInput;
};


export type MutationSchedulePublishPhraseArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: PhraseWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishPlatformArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: PlatformWhereUniqueInput;
};


export type MutationSchedulePublishPlayBannerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: PlayBannerWhereUniqueInput;
};


export type MutationSchedulePublishRegexPatternArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: RegexPatternWhereUniqueInput;
};


export type MutationSchedulePublishTermsandPrivacyArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: TermsandPrivacyWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSchedulePublishTwitchExplainerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: TwitchExplainerWhereUniqueInput;
};


export type MutationScheduleUnpublishAdminArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: AdminWhereUniqueInput;
};


export type MutationScheduleUnpublishApexCharacterIssueArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: ApexCharacterIssueWhereUniqueInput;
};


export type MutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: AssetWhereUniqueInput;
};


export type MutationScheduleUnpublishBetCategoryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: BetCategoryWhereUniqueInput;
};


export type MutationScheduleUnpublishBetDenominationRestrictionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: BetDenominationRestrictionWhereUniqueInput;
};


export type MutationScheduleUnpublishBetLineArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: BetLineWhereUniqueInput;
};


export type MutationScheduleUnpublishBetLineRuleArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: BetLineRuleWhereUniqueInput;
};


export type MutationScheduleUnpublishBetRestrictionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: BetRestrictionWhereUniqueInput;
};


export type MutationScheduleUnpublishBetValueArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: BetValueWhereUniqueInput;
};


export type MutationScheduleUnpublishCommonContentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: CommonContentWhereUniqueInput;
};


export type MutationScheduleUnpublishDefaultGameStateArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: DefaultGameStateWhereUniqueInput;
};


export type MutationScheduleUnpublishDefaultPayoutBandArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: DefaultPayoutBandWhereUniqueInput;
};


export type MutationScheduleUnpublishDemoModelArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: DemoModelWhereUniqueInput;
};


export type MutationScheduleUnpublishFaqArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: FaqWhereUniqueInput;
};


export type MutationScheduleUnpublishFaqCategoryModelArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: FaqCategoryModelWhereUniqueInput;
};


export type MutationScheduleUnpublishFeatureFlagArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: FeatureFlagWhereUniqueInput;
};


export type MutationScheduleUnpublishGameArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: GameWhereUniqueInput;
};


export type MutationScheduleUnpublishGameModeArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: GameModeWhereUniqueInput;
};


export type MutationScheduleUnpublishGameModeCalloutArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: GameModeCalloutWhereUniqueInput;
};


export type MutationScheduleUnpublishGameSeriesArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: GameSeriesWhereUniqueInput;
};


export type MutationScheduleUnpublishMatchIssueArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: MatchIssueWhereUniqueInput;
};


export type MutationScheduleUnpublishOnboardingQuestionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: OnboardingQuestionWhereUniqueInput;
};


export type MutationScheduleUnpublishPartnerAdArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: PartnerAdWhereUniqueInput;
};


export type MutationScheduleUnpublishPhraseArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: PhraseWhereUniqueInput;
};


export type MutationScheduleUnpublishPlatformArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: PlatformWhereUniqueInput;
};


export type MutationScheduleUnpublishPlayBannerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: PlayBannerWhereUniqueInput;
};


export type MutationScheduleUnpublishRegexPatternArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: RegexPatternWhereUniqueInput;
};


export type MutationScheduleUnpublishTermsandPrivacyArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: TermsandPrivacyWhereUniqueInput;
};


export type MutationScheduleUnpublishTwitchExplainerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: TwitchExplainerWhereUniqueInput;
};


export type MutationUnpublishAdminArgs = {
  from?: Array<Stage>;
  where: AdminWhereUniqueInput;
};


export type MutationUnpublishApexCharacterIssueArgs = {
  from?: Array<Stage>;
  where: ApexCharacterIssueWhereUniqueInput;
};


export type MutationUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: AssetWhereUniqueInput;
};


export type MutationUnpublishBetCategoryArgs = {
  from?: Array<Stage>;
  where: BetCategoryWhereUniqueInput;
};


export type MutationUnpublishBetDenominationRestrictionArgs = {
  from?: Array<Stage>;
  where: BetDenominationRestrictionWhereUniqueInput;
};


export type MutationUnpublishBetLineArgs = {
  from?: Array<Stage>;
  where: BetLineWhereUniqueInput;
};


export type MutationUnpublishBetLineRuleArgs = {
  from?: Array<Stage>;
  where: BetLineRuleWhereUniqueInput;
};


export type MutationUnpublishBetRestrictionArgs = {
  from?: Array<Stage>;
  where: BetRestrictionWhereUniqueInput;
};


export type MutationUnpublishBetValueArgs = {
  from?: Array<Stage>;
  where: BetValueWhereUniqueInput;
};


export type MutationUnpublishCommonContentArgs = {
  from?: Array<Stage>;
  where: CommonContentWhereUniqueInput;
};


export type MutationUnpublishDefaultGameStateArgs = {
  from?: Array<Stage>;
  where: DefaultGameStateWhereUniqueInput;
};


export type MutationUnpublishDefaultPayoutBandArgs = {
  from?: Array<Stage>;
  where: DefaultPayoutBandWhereUniqueInput;
};


export type MutationUnpublishDemoModelArgs = {
  from?: Array<Stage>;
  where: DemoModelWhereUniqueInput;
};


export type MutationUnpublishFaqArgs = {
  from?: Array<Stage>;
  where: FaqWhereUniqueInput;
};


export type MutationUnpublishFaqCategoryModelArgs = {
  from?: Array<Stage>;
  where: FaqCategoryModelWhereUniqueInput;
};


export type MutationUnpublishFeatureFlagArgs = {
  from?: Array<Stage>;
  where: FeatureFlagWhereUniqueInput;
};


export type MutationUnpublishGameArgs = {
  from?: Array<Stage>;
  where: GameWhereUniqueInput;
};


export type MutationUnpublishGameModeArgs = {
  from?: Array<Stage>;
  where: GameModeWhereUniqueInput;
};


export type MutationUnpublishGameModeCalloutArgs = {
  from?: Array<Stage>;
  where: GameModeCalloutWhereUniqueInput;
};


export type MutationUnpublishGameSeriesArgs = {
  from?: Array<Stage>;
  where: GameSeriesWhereUniqueInput;
};


export type MutationUnpublishManyAdminsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AdminManyWhereInput>;
};


export type MutationUnpublishManyAdminsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AdminManyWhereInput>;
};


export type MutationUnpublishManyApexCharacterIssuesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ApexCharacterIssueManyWhereInput>;
};


export type MutationUnpublishManyApexCharacterIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ApexCharacterIssueManyWhereInput>;
};


export type MutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyBetCategoriesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BetCategoryManyWhereInput>;
};


export type MutationUnpublishManyBetCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BetCategoryManyWhereInput>;
};


export type MutationUnpublishManyBetDenominationRestrictionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BetDenominationRestrictionManyWhereInput>;
};


export type MutationUnpublishManyBetDenominationRestrictionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BetDenominationRestrictionManyWhereInput>;
};


export type MutationUnpublishManyBetLineRulesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BetLineRuleManyWhereInput>;
};


export type MutationUnpublishManyBetLineRulesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BetLineRuleManyWhereInput>;
};


export type MutationUnpublishManyBetLinesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BetLineManyWhereInput>;
};


export type MutationUnpublishManyBetLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BetLineManyWhereInput>;
};


export type MutationUnpublishManyBetRestrictionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BetRestrictionManyWhereInput>;
};


export type MutationUnpublishManyBetRestrictionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BetRestrictionManyWhereInput>;
};


export type MutationUnpublishManyBetValuesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BetValueManyWhereInput>;
};


export type MutationUnpublishManyBetValuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BetValueManyWhereInput>;
};


export type MutationUnpublishManyCommonContentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CommonContentManyWhereInput>;
};


export type MutationUnpublishManyCommonContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CommonContentManyWhereInput>;
};


export type MutationUnpublishManyDefaultGameStatesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<DefaultGameStateManyWhereInput>;
};


export type MutationUnpublishManyDefaultGameStatesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<DefaultGameStateManyWhereInput>;
};


export type MutationUnpublishManyDefaultPayoutBandsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<DefaultPayoutBandManyWhereInput>;
};


export type MutationUnpublishManyDefaultPayoutBandsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<DefaultPayoutBandManyWhereInput>;
};


export type MutationUnpublishManyDemoModelsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationUnpublishManyDemoModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationUnpublishManyFaQsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FaqManyWhereInput>;
};


export type MutationUnpublishManyFaQsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FaqManyWhereInput>;
};


export type MutationUnpublishManyFaqCategoriesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FaqCategoryModelManyWhereInput>;
};


export type MutationUnpublishManyFaqCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FaqCategoryModelManyWhereInput>;
};


export type MutationUnpublishManyFeatureFlagsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FeatureFlagManyWhereInput>;
};


export type MutationUnpublishManyFeatureFlagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FeatureFlagManyWhereInput>;
};


export type MutationUnpublishManyGameModeCalloutsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GameModeCalloutManyWhereInput>;
};


export type MutationUnpublishManyGameModeCalloutsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GameModeCalloutManyWhereInput>;
};


export type MutationUnpublishManyGameModesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GameModeManyWhereInput>;
};


export type MutationUnpublishManyGameModesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GameModeManyWhereInput>;
};


export type MutationUnpublishManyGameSeriesesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GameSeriesManyWhereInput>;
};


export type MutationUnpublishManyGameSeriesesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GameSeriesManyWhereInput>;
};


export type MutationUnpublishManyGamesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GameManyWhereInput>;
};


export type MutationUnpublishManyGamesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GameManyWhereInput>;
};


export type MutationUnpublishManyMatchIssuesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<MatchIssueManyWhereInput>;
};


export type MutationUnpublishManyMatchIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<MatchIssueManyWhereInput>;
};


export type MutationUnpublishManyOnboardingQuestionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<OnboardingQuestionManyWhereInput>;
};


export type MutationUnpublishManyOnboardingQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<OnboardingQuestionManyWhereInput>;
};


export type MutationUnpublishManyPartnerAdsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PartnerAdManyWhereInput>;
};


export type MutationUnpublishManyPartnerAdsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PartnerAdManyWhereInput>;
};


export type MutationUnpublishManyPhrasesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PhraseManyWhereInput>;
};


export type MutationUnpublishManyPhrasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PhraseManyWhereInput>;
};


export type MutationUnpublishManyPlatformsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PlatformManyWhereInput>;
};


export type MutationUnpublishManyPlatformsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PlatformManyWhereInput>;
};


export type MutationUnpublishManyPlayBannersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PlayBannerManyWhereInput>;
};


export type MutationUnpublishManyPlayBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PlayBannerManyWhereInput>;
};


export type MutationUnpublishManyRegexPatternsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RegexPatternManyWhereInput>;
};


export type MutationUnpublishManyRegexPatternsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RegexPatternManyWhereInput>;
};


export type MutationUnpublishManyTermsandPrivacysArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TermsandPrivacyManyWhereInput>;
};


export type MutationUnpublishManyTermsandPrivacysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TermsandPrivacyManyWhereInput>;
};


export type MutationUnpublishManyTwitchExplainersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TwitchExplainerManyWhereInput>;
};


export type MutationUnpublishManyTwitchExplainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TwitchExplainerManyWhereInput>;
};


export type MutationUnpublishMatchIssueArgs = {
  from?: Array<Stage>;
  where: MatchIssueWhereUniqueInput;
};


export type MutationUnpublishOnboardingQuestionArgs = {
  from?: Array<Stage>;
  where: OnboardingQuestionWhereUniqueInput;
};


export type MutationUnpublishPartnerAdArgs = {
  from?: Array<Stage>;
  where: PartnerAdWhereUniqueInput;
};


export type MutationUnpublishPhraseArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: PhraseWhereUniqueInput;
};


export type MutationUnpublishPlatformArgs = {
  from?: Array<Stage>;
  where: PlatformWhereUniqueInput;
};


export type MutationUnpublishPlayBannerArgs = {
  from?: Array<Stage>;
  where: PlayBannerWhereUniqueInput;
};


export type MutationUnpublishRegexPatternArgs = {
  from?: Array<Stage>;
  where: RegexPatternWhereUniqueInput;
};


export type MutationUnpublishTermsandPrivacyArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: TermsandPrivacyWhereUniqueInput;
};


export type MutationUnpublishTwitchExplainerArgs = {
  from?: Array<Stage>;
  where: TwitchExplainerWhereUniqueInput;
};


export type MutationUpdateAdminArgs = {
  data: AdminUpdateInput;
  where: AdminWhereUniqueInput;
};


export type MutationUpdateApexCharacterIssueArgs = {
  data: ApexCharacterIssueUpdateInput;
  where: ApexCharacterIssueWhereUniqueInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpdateBetCategoryArgs = {
  data: BetCategoryUpdateInput;
  where: BetCategoryWhereUniqueInput;
};


export type MutationUpdateBetDenominationRestrictionArgs = {
  data: BetDenominationRestrictionUpdateInput;
  where: BetDenominationRestrictionWhereUniqueInput;
};


export type MutationUpdateBetLineArgs = {
  data: BetLineUpdateInput;
  where: BetLineWhereUniqueInput;
};


export type MutationUpdateBetLineRuleArgs = {
  data: BetLineRuleUpdateInput;
  where: BetLineRuleWhereUniqueInput;
};


export type MutationUpdateBetRestrictionArgs = {
  data: BetRestrictionUpdateInput;
  where: BetRestrictionWhereUniqueInput;
};


export type MutationUpdateBetValueArgs = {
  data: BetValueUpdateInput;
  where: BetValueWhereUniqueInput;
};


export type MutationUpdateCommonContentArgs = {
  data: CommonContentUpdateInput;
  where: CommonContentWhereUniqueInput;
};


export type MutationUpdateDefaultGameStateArgs = {
  data: DefaultGameStateUpdateInput;
  where: DefaultGameStateWhereUniqueInput;
};


export type MutationUpdateDefaultPayoutBandArgs = {
  data: DefaultPayoutBandUpdateInput;
  where: DefaultPayoutBandWhereUniqueInput;
};


export type MutationUpdateDemoModelArgs = {
  data: DemoModelUpdateInput;
  where: DemoModelWhereUniqueInput;
};


export type MutationUpdateFaqArgs = {
  data: FaqUpdateInput;
  where: FaqWhereUniqueInput;
};


export type MutationUpdateFaqCategoryModelArgs = {
  data: FaqCategoryModelUpdateInput;
  where: FaqCategoryModelWhereUniqueInput;
};


export type MutationUpdateFeatureFlagArgs = {
  data: FeatureFlagUpdateInput;
  where: FeatureFlagWhereUniqueInput;
};


export type MutationUpdateGameArgs = {
  data: GameUpdateInput;
  where: GameWhereUniqueInput;
};


export type MutationUpdateGameModeArgs = {
  data: GameModeUpdateInput;
  where: GameModeWhereUniqueInput;
};


export type MutationUpdateGameModeCalloutArgs = {
  data: GameModeCalloutUpdateInput;
  where: GameModeCalloutWhereUniqueInput;
};


export type MutationUpdateGameSeriesArgs = {
  data: GameSeriesUpdateInput;
  where: GameSeriesWhereUniqueInput;
};


export type MutationUpdateManyAdminsArgs = {
  data: AdminUpdateManyInput;
  where?: InputMaybe<AdminManyWhereInput>;
};


export type MutationUpdateManyAdminsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: AdminUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminManyWhereInput>;
};


export type MutationUpdateManyApexCharacterIssuesArgs = {
  data: ApexCharacterIssueUpdateManyInput;
  where?: InputMaybe<ApexCharacterIssueManyWhereInput>;
};


export type MutationUpdateManyApexCharacterIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: ApexCharacterIssueUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApexCharacterIssueManyWhereInput>;
};


export type MutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyBetCategoriesArgs = {
  data: BetCategoryUpdateManyInput;
  where?: InputMaybe<BetCategoryManyWhereInput>;
};


export type MutationUpdateManyBetCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: BetCategoryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetCategoryManyWhereInput>;
};


export type MutationUpdateManyBetDenominationRestrictionsArgs = {
  data: BetDenominationRestrictionUpdateManyInput;
  where?: InputMaybe<BetDenominationRestrictionManyWhereInput>;
};


export type MutationUpdateManyBetDenominationRestrictionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: BetDenominationRestrictionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetDenominationRestrictionManyWhereInput>;
};


export type MutationUpdateManyBetLineRulesArgs = {
  data: BetLineRuleUpdateManyInput;
  where?: InputMaybe<BetLineRuleManyWhereInput>;
};


export type MutationUpdateManyBetLineRulesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: BetLineRuleUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetLineRuleManyWhereInput>;
};


export type MutationUpdateManyBetLinesArgs = {
  data: BetLineUpdateManyInput;
  where?: InputMaybe<BetLineManyWhereInput>;
};


export type MutationUpdateManyBetLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: BetLineUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetLineManyWhereInput>;
};


export type MutationUpdateManyBetRestrictionsArgs = {
  data: BetRestrictionUpdateManyInput;
  where?: InputMaybe<BetRestrictionManyWhereInput>;
};


export type MutationUpdateManyBetRestrictionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: BetRestrictionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetRestrictionManyWhereInput>;
};


export type MutationUpdateManyBetValuesArgs = {
  data: BetValueUpdateManyInput;
  where?: InputMaybe<BetValueManyWhereInput>;
};


export type MutationUpdateManyBetValuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: BetValueUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BetValueManyWhereInput>;
};


export type MutationUpdateManyCommonContentsArgs = {
  data: CommonContentUpdateManyInput;
  where?: InputMaybe<CommonContentManyWhereInput>;
};


export type MutationUpdateManyCommonContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: CommonContentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommonContentManyWhereInput>;
};


export type MutationUpdateManyDefaultGameStatesArgs = {
  data: DefaultGameStateUpdateManyInput;
  where?: InputMaybe<DefaultGameStateManyWhereInput>;
};


export type MutationUpdateManyDefaultGameStatesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: DefaultGameStateUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefaultGameStateManyWhereInput>;
};


export type MutationUpdateManyDefaultPayoutBandsArgs = {
  data: DefaultPayoutBandUpdateManyInput;
  where?: InputMaybe<DefaultPayoutBandManyWhereInput>;
};


export type MutationUpdateManyDefaultPayoutBandsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: DefaultPayoutBandUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefaultPayoutBandManyWhereInput>;
};


export type MutationUpdateManyDemoModelsArgs = {
  data: DemoModelUpdateManyInput;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationUpdateManyDemoModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: DemoModelUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationUpdateManyFaQsArgs = {
  data: FaqUpdateManyInput;
  where?: InputMaybe<FaqManyWhereInput>;
};


export type MutationUpdateManyFaQsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: FaqUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FaqManyWhereInput>;
};


export type MutationUpdateManyFaqCategoriesArgs = {
  data: FaqCategoryModelUpdateManyInput;
  where?: InputMaybe<FaqCategoryModelManyWhereInput>;
};


export type MutationUpdateManyFaqCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: FaqCategoryModelUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FaqCategoryModelManyWhereInput>;
};


export type MutationUpdateManyFeatureFlagsArgs = {
  data: FeatureFlagUpdateManyInput;
  where?: InputMaybe<FeatureFlagManyWhereInput>;
};


export type MutationUpdateManyFeatureFlagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: FeatureFlagUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeatureFlagManyWhereInput>;
};


export type MutationUpdateManyGameModeCalloutsArgs = {
  data: GameModeCalloutUpdateManyInput;
  where?: InputMaybe<GameModeCalloutManyWhereInput>;
};


export type MutationUpdateManyGameModeCalloutsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: GameModeCalloutUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameModeCalloutManyWhereInput>;
};


export type MutationUpdateManyGameModesArgs = {
  data: GameModeUpdateManyInput;
  where?: InputMaybe<GameModeManyWhereInput>;
};


export type MutationUpdateManyGameModesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: GameModeUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameModeManyWhereInput>;
};


export type MutationUpdateManyGameSeriesesArgs = {
  data: GameSeriesUpdateManyInput;
  where?: InputMaybe<GameSeriesManyWhereInput>;
};


export type MutationUpdateManyGameSeriesesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: GameSeriesUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameSeriesManyWhereInput>;
};


export type MutationUpdateManyGamesArgs = {
  data: GameUpdateManyInput;
  where?: InputMaybe<GameManyWhereInput>;
};


export type MutationUpdateManyGamesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: GameUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameManyWhereInput>;
};


export type MutationUpdateManyMatchIssuesArgs = {
  data: MatchIssueUpdateManyInput;
  where?: InputMaybe<MatchIssueManyWhereInput>;
};


export type MutationUpdateManyMatchIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: MatchIssueUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MatchIssueManyWhereInput>;
};


export type MutationUpdateManyOnboardingQuestionsArgs = {
  data: OnboardingQuestionUpdateManyInput;
  where?: InputMaybe<OnboardingQuestionManyWhereInput>;
};


export type MutationUpdateManyOnboardingQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: OnboardingQuestionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OnboardingQuestionManyWhereInput>;
};


export type MutationUpdateManyPartnerAdsArgs = {
  data: PartnerAdUpdateManyInput;
  where?: InputMaybe<PartnerAdManyWhereInput>;
};


export type MutationUpdateManyPartnerAdsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: PartnerAdUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PartnerAdManyWhereInput>;
};


export type MutationUpdateManyPhrasesArgs = {
  data: PhraseUpdateManyInput;
  where?: InputMaybe<PhraseManyWhereInput>;
};


export type MutationUpdateManyPhrasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: PhraseUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PhraseManyWhereInput>;
};


export type MutationUpdateManyPlatformsArgs = {
  data: PlatformUpdateManyInput;
  where?: InputMaybe<PlatformManyWhereInput>;
};


export type MutationUpdateManyPlatformsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: PlatformUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlatformManyWhereInput>;
};


export type MutationUpdateManyPlayBannersArgs = {
  data: PlayBannerUpdateManyInput;
  where?: InputMaybe<PlayBannerManyWhereInput>;
};


export type MutationUpdateManyPlayBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: PlayBannerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlayBannerManyWhereInput>;
};


export type MutationUpdateManyRegexPatternsArgs = {
  data: RegexPatternUpdateManyInput;
  where?: InputMaybe<RegexPatternManyWhereInput>;
};


export type MutationUpdateManyRegexPatternsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: RegexPatternUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RegexPatternManyWhereInput>;
};


export type MutationUpdateManyTermsandPrivacysArgs = {
  data: TermsandPrivacyUpdateManyInput;
  where?: InputMaybe<TermsandPrivacyManyWhereInput>;
};


export type MutationUpdateManyTermsandPrivacysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: TermsandPrivacyUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TermsandPrivacyManyWhereInput>;
};


export type MutationUpdateManyTwitchExplainersArgs = {
  data: TwitchExplainerUpdateManyInput;
  where?: InputMaybe<TwitchExplainerManyWhereInput>;
};


export type MutationUpdateManyTwitchExplainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: TwitchExplainerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TwitchExplainerManyWhereInput>;
};


export type MutationUpdateMatchIssueArgs = {
  data: MatchIssueUpdateInput;
  where: MatchIssueWhereUniqueInput;
};


export type MutationUpdateOnboardingQuestionArgs = {
  data: OnboardingQuestionUpdateInput;
  where: OnboardingQuestionWhereUniqueInput;
};


export type MutationUpdatePartnerAdArgs = {
  data: PartnerAdUpdateInput;
  where: PartnerAdWhereUniqueInput;
};


export type MutationUpdatePhraseArgs = {
  data: PhraseUpdateInput;
  where: PhraseWhereUniqueInput;
};


export type MutationUpdatePlatformArgs = {
  data: PlatformUpdateInput;
  where: PlatformWhereUniqueInput;
};


export type MutationUpdatePlayBannerArgs = {
  data: PlayBannerUpdateInput;
  where: PlayBannerWhereUniqueInput;
};


export type MutationUpdateRegexPatternArgs = {
  data: RegexPatternUpdateInput;
  where: RegexPatternWhereUniqueInput;
};


export type MutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationUpdateTermsandPrivacyArgs = {
  data: TermsandPrivacyUpdateInput;
  where: TermsandPrivacyWhereUniqueInput;
};


export type MutationUpdateTwitchExplainerArgs = {
  data: TwitchExplainerUpdateInput;
  where: TwitchExplainerWhereUniqueInput;
};


export type MutationUpsertAdminArgs = {
  upsert: AdminUpsertInput;
  where: AdminWhereUniqueInput;
};


export type MutationUpsertApexCharacterIssueArgs = {
  upsert: ApexCharacterIssueUpsertInput;
  where: ApexCharacterIssueWhereUniqueInput;
};


export type MutationUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpsertBetCategoryArgs = {
  upsert: BetCategoryUpsertInput;
  where: BetCategoryWhereUniqueInput;
};


export type MutationUpsertBetDenominationRestrictionArgs = {
  upsert: BetDenominationRestrictionUpsertInput;
  where: BetDenominationRestrictionWhereUniqueInput;
};


export type MutationUpsertBetLineArgs = {
  upsert: BetLineUpsertInput;
  where: BetLineWhereUniqueInput;
};


export type MutationUpsertBetLineRuleArgs = {
  upsert: BetLineRuleUpsertInput;
  where: BetLineRuleWhereUniqueInput;
};


export type MutationUpsertBetRestrictionArgs = {
  upsert: BetRestrictionUpsertInput;
  where: BetRestrictionWhereUniqueInput;
};


export type MutationUpsertBetValueArgs = {
  upsert: BetValueUpsertInput;
  where: BetValueWhereUniqueInput;
};


export type MutationUpsertCommonContentArgs = {
  upsert: CommonContentUpsertInput;
  where: CommonContentWhereUniqueInput;
};


export type MutationUpsertDefaultGameStateArgs = {
  upsert: DefaultGameStateUpsertInput;
  where: DefaultGameStateWhereUniqueInput;
};


export type MutationUpsertDefaultPayoutBandArgs = {
  upsert: DefaultPayoutBandUpsertInput;
  where: DefaultPayoutBandWhereUniqueInput;
};


export type MutationUpsertDemoModelArgs = {
  upsert: DemoModelUpsertInput;
  where: DemoModelWhereUniqueInput;
};


export type MutationUpsertFaqArgs = {
  upsert: FaqUpsertInput;
  where: FaqWhereUniqueInput;
};


export type MutationUpsertFaqCategoryModelArgs = {
  upsert: FaqCategoryModelUpsertInput;
  where: FaqCategoryModelWhereUniqueInput;
};


export type MutationUpsertFeatureFlagArgs = {
  upsert: FeatureFlagUpsertInput;
  where: FeatureFlagWhereUniqueInput;
};


export type MutationUpsertGameArgs = {
  upsert: GameUpsertInput;
  where: GameWhereUniqueInput;
};


export type MutationUpsertGameModeArgs = {
  upsert: GameModeUpsertInput;
  where: GameModeWhereUniqueInput;
};


export type MutationUpsertGameModeCalloutArgs = {
  upsert: GameModeCalloutUpsertInput;
  where: GameModeCalloutWhereUniqueInput;
};


export type MutationUpsertGameSeriesArgs = {
  upsert: GameSeriesUpsertInput;
  where: GameSeriesWhereUniqueInput;
};


export type MutationUpsertMatchIssueArgs = {
  upsert: MatchIssueUpsertInput;
  where: MatchIssueWhereUniqueInput;
};


export type MutationUpsertOnboardingQuestionArgs = {
  upsert: OnboardingQuestionUpsertInput;
  where: OnboardingQuestionWhereUniqueInput;
};


export type MutationUpsertPartnerAdArgs = {
  upsert: PartnerAdUpsertInput;
  where: PartnerAdWhereUniqueInput;
};


export type MutationUpsertPhraseArgs = {
  upsert: PhraseUpsertInput;
  where: PhraseWhereUniqueInput;
};


export type MutationUpsertPlatformArgs = {
  upsert: PlatformUpsertInput;
  where: PlatformWhereUniqueInput;
};


export type MutationUpsertPlayBannerArgs = {
  upsert: PlayBannerUpsertInput;
  where: PlayBannerWhereUniqueInput;
};


export type MutationUpsertRegexPatternArgs = {
  upsert: RegexPatternUpsertInput;
  where: RegexPatternWhereUniqueInput;
};


export type MutationUpsertTermsandPrivacyArgs = {
  upsert: TermsandPrivacyUpsertInput;
  where: TermsandPrivacyWhereUniqueInput;
};


export type MutationUpsertTwitchExplainerArgs = {
  upsert: TwitchExplainerUpsertInput;
  where: TwitchExplainerWhereUniqueInput;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID'];
  /** The Stage of an object */
  stage: Stage;
};

/** Question and answers to be displayed during the onboarding flow for a particular game */
export type OnboardingQuestion = Entity & Node & {
  __typename?: 'OnboardingQuestion';
  answer?: Maybe<Phrase>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<OnboardingQuestion>;
  /** List of OnboardingQuestion versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  question?: Maybe<Phrase>;
  /** Internal question title/description. What is this FAQ? */
  questionTitle: Scalars['String'];
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Question and answers to be displayed during the onboarding flow for a particular game */
export type OnboardingQuestionAnswerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Question and answers to be displayed during the onboarding flow for a particular game */
export type OnboardingQuestionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Question and answers to be displayed during the onboarding flow for a particular game */
export type OnboardingQuestionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Question and answers to be displayed during the onboarding flow for a particular game */
export type OnboardingQuestionHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Question and answers to be displayed during the onboarding flow for a particular game */
export type OnboardingQuestionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Question and answers to be displayed during the onboarding flow for a particular game */
export type OnboardingQuestionQuestionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Question and answers to be displayed during the onboarding flow for a particular game */
export type OnboardingQuestionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Question and answers to be displayed during the onboarding flow for a particular game */
export type OnboardingQuestionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type OnboardingQuestionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: OnboardingQuestionWhereUniqueInput;
};

/** A connection to a list of items. */
export type OnboardingQuestionConnection = {
  __typename?: 'OnboardingQuestionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<OnboardingQuestionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type OnboardingQuestionCreateInput = {
  answer?: InputMaybe<PhraseCreateOneInlineInput>;
  clp76hx9e1clc01umgslt0j8r?: InputMaybe<GameCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  question?: InputMaybe<PhraseCreateOneInlineInput>;
  questionTitle: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OnboardingQuestionCreateManyInlineInput = {
  /** Connect multiple existing OnboardingQuestion documents */
  connect?: InputMaybe<Array<OnboardingQuestionWhereUniqueInput>>;
  /** Create and connect multiple existing OnboardingQuestion documents */
  create?: InputMaybe<Array<OnboardingQuestionCreateInput>>;
};

export type OnboardingQuestionCreateOneInlineInput = {
  /** Connect one existing OnboardingQuestion document */
  connect?: InputMaybe<OnboardingQuestionWhereUniqueInput>;
  /** Create and connect one OnboardingQuestion document */
  create?: InputMaybe<OnboardingQuestionCreateInput>;
};

/** An edge in a connection. */
export type OnboardingQuestionEdge = {
  __typename?: 'OnboardingQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OnboardingQuestion;
};

/** Identifies documents */
export type OnboardingQuestionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<OnboardingQuestionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<OnboardingQuestionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<OnboardingQuestionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  answer?: InputMaybe<PhraseWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<OnboardingQuestionWhereStageInput>;
  documentInStages_none?: InputMaybe<OnboardingQuestionWhereStageInput>;
  documentInStages_some?: InputMaybe<OnboardingQuestionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  question?: InputMaybe<PhraseWhereInput>;
  questionTitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  questionTitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  questionTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  questionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  questionTitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  questionTitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  questionTitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  questionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  questionTitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  questionTitle_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum OnboardingQuestionOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  QUESTIONTITLE_ASC = 'questionTitle_ASC',
  QUESTIONTITLE_DESC = 'questionTitle_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type OnboardingQuestionUpdateInput = {
  answer?: InputMaybe<PhraseUpdateOneInlineInput>;
  clp76hx9e1clc01umgslt0j8r?: InputMaybe<GameUpdateManyInlineInput>;
  question?: InputMaybe<PhraseUpdateOneInlineInput>;
  questionTitle?: InputMaybe<Scalars['String']>;
};

export type OnboardingQuestionUpdateManyInlineInput = {
  /** Connect multiple existing OnboardingQuestion documents */
  connect?: InputMaybe<Array<OnboardingQuestionConnectInput>>;
  /** Create and connect multiple OnboardingQuestion documents */
  create?: InputMaybe<Array<OnboardingQuestionCreateInput>>;
  /** Delete multiple OnboardingQuestion documents */
  delete?: InputMaybe<Array<OnboardingQuestionWhereUniqueInput>>;
  /** Disconnect multiple OnboardingQuestion documents */
  disconnect?: InputMaybe<Array<OnboardingQuestionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing OnboardingQuestion documents */
  set?: InputMaybe<Array<OnboardingQuestionWhereUniqueInput>>;
  /** Update multiple OnboardingQuestion documents */
  update?: InputMaybe<Array<OnboardingQuestionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple OnboardingQuestion documents */
  upsert?: InputMaybe<Array<OnboardingQuestionUpsertWithNestedWhereUniqueInput>>;
};

export type OnboardingQuestionUpdateManyInput = {
  questionTitle?: InputMaybe<Scalars['String']>;
};

export type OnboardingQuestionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: OnboardingQuestionUpdateManyInput;
  /** Document search */
  where: OnboardingQuestionWhereInput;
};

export type OnboardingQuestionUpdateOneInlineInput = {
  /** Connect existing OnboardingQuestion document */
  connect?: InputMaybe<OnboardingQuestionWhereUniqueInput>;
  /** Create and connect one OnboardingQuestion document */
  create?: InputMaybe<OnboardingQuestionCreateInput>;
  /** Delete currently connected OnboardingQuestion document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected OnboardingQuestion document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single OnboardingQuestion document */
  update?: InputMaybe<OnboardingQuestionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single OnboardingQuestion document */
  upsert?: InputMaybe<OnboardingQuestionUpsertWithNestedWhereUniqueInput>;
};

export type OnboardingQuestionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: OnboardingQuestionUpdateInput;
  /** Unique document search */
  where: OnboardingQuestionWhereUniqueInput;
};

export type OnboardingQuestionUpsertInput = {
  /** Create document if it didn't exist */
  create: OnboardingQuestionCreateInput;
  /** Update document if it exists */
  update: OnboardingQuestionUpdateInput;
};

export type OnboardingQuestionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: OnboardingQuestionUpsertInput;
  /** Unique document search */
  where: OnboardingQuestionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type OnboardingQuestionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type OnboardingQuestionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<OnboardingQuestionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<OnboardingQuestionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<OnboardingQuestionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  answer?: InputMaybe<PhraseWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<OnboardingQuestionWhereStageInput>;
  documentInStages_none?: InputMaybe<OnboardingQuestionWhereStageInput>;
  documentInStages_some?: InputMaybe<OnboardingQuestionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  question?: InputMaybe<PhraseWhereInput>;
  questionTitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  questionTitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  questionTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  questionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  questionTitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  questionTitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  questionTitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  questionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  questionTitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  questionTitle_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type OnboardingQuestionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<OnboardingQuestionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<OnboardingQuestionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<OnboardingQuestionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<OnboardingQuestionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References OnboardingQuestion record uniquely */
export type OnboardingQuestionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PartnerAd = Entity & Node & {
  __typename?: 'PartnerAd';
  bannerImageUrl: Scalars['String'];
  bannerLink: Scalars['String'];
  bannerName: Scalars['String'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<PartnerAd>;
  enabled: Scalars['Boolean'];
  /** List of PartnerAd versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  partnerName: Scalars['String'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: AdPartnerBannerType;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PartnerAdCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PartnerAdDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type PartnerAdHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type PartnerAdPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PartnerAdScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PartnerAdUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PartnerAdConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PartnerAdWhereUniqueInput;
};

/** A connection to a list of items. */
export type PartnerAdConnection = {
  __typename?: 'PartnerAdConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PartnerAdEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PartnerAdCreateInput = {
  bannerImageUrl: Scalars['String'];
  bannerLink: Scalars['String'];
  bannerName: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  partnerName: Scalars['String'];
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type: AdPartnerBannerType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PartnerAdCreateManyInlineInput = {
  /** Connect multiple existing PartnerAd documents */
  connect?: InputMaybe<Array<PartnerAdWhereUniqueInput>>;
  /** Create and connect multiple existing PartnerAd documents */
  create?: InputMaybe<Array<PartnerAdCreateInput>>;
};

export type PartnerAdCreateOneInlineInput = {
  /** Connect one existing PartnerAd document */
  connect?: InputMaybe<PartnerAdWhereUniqueInput>;
  /** Create and connect one PartnerAd document */
  create?: InputMaybe<PartnerAdCreateInput>;
};

/** An edge in a connection. */
export type PartnerAdEdge = {
  __typename?: 'PartnerAdEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PartnerAd;
};

/** Identifies documents */
export type PartnerAdManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PartnerAdWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PartnerAdWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PartnerAdWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  bannerImageUrl?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  bannerImageUrl_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  bannerImageUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  bannerImageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerImageUrl_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  bannerImageUrl_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  bannerImageUrl_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  bannerImageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  bannerImageUrl_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  bannerImageUrl_starts_with?: InputMaybe<Scalars['String']>;
  bannerLink?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  bannerLink_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  bannerLink_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  bannerLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerLink_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  bannerLink_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  bannerLink_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  bannerLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  bannerLink_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  bannerLink_starts_with?: InputMaybe<Scalars['String']>;
  bannerName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  bannerName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  bannerName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  bannerName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  bannerName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  bannerName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  bannerName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  bannerName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  bannerName_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PartnerAdWhereStageInput>;
  documentInStages_none?: InputMaybe<PartnerAdWhereStageInput>;
  documentInStages_some?: InputMaybe<PartnerAdWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  partnerName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  partnerName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  partnerName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  partnerName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  partnerName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  partnerName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  partnerName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  partnerName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  partnerName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  partnerName_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subtitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AdPartnerBannerType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<AdPartnerBannerType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<AdPartnerBannerType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<AdPartnerBannerType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PartnerAdOrderByInput {
  BANNERIMAGEURL_ASC = 'bannerImageUrl_ASC',
  BANNERIMAGEURL_DESC = 'bannerImageUrl_DESC',
  BANNERLINK_ASC = 'bannerLink_ASC',
  BANNERLINK_DESC = 'bannerLink_DESC',
  BANNERNAME_ASC = 'bannerName_ASC',
  BANNERNAME_DESC = 'bannerName_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PARTNERNAME_ASC = 'partnerName_ASC',
  PARTNERNAME_DESC = 'partnerName_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  SUBTITLE_ASC = 'subtitle_ASC',
  SUBTITLE_DESC = 'subtitle_DESC',
  TITLE_ASC = 'title_ASC',
  TITLE_DESC = 'title_DESC',
  TYPE_ASC = 'type_ASC',
  TYPE_DESC = 'type_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type PartnerAdUpdateInput = {
  bannerImageUrl?: InputMaybe<Scalars['String']>;
  bannerLink?: InputMaybe<Scalars['String']>;
  bannerName?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  partnerName?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AdPartnerBannerType>;
};

export type PartnerAdUpdateManyInlineInput = {
  /** Connect multiple existing PartnerAd documents */
  connect?: InputMaybe<Array<PartnerAdConnectInput>>;
  /** Create and connect multiple PartnerAd documents */
  create?: InputMaybe<Array<PartnerAdCreateInput>>;
  /** Delete multiple PartnerAd documents */
  delete?: InputMaybe<Array<PartnerAdWhereUniqueInput>>;
  /** Disconnect multiple PartnerAd documents */
  disconnect?: InputMaybe<Array<PartnerAdWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PartnerAd documents */
  set?: InputMaybe<Array<PartnerAdWhereUniqueInput>>;
  /** Update multiple PartnerAd documents */
  update?: InputMaybe<Array<PartnerAdUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PartnerAd documents */
  upsert?: InputMaybe<Array<PartnerAdUpsertWithNestedWhereUniqueInput>>;
};

export type PartnerAdUpdateManyInput = {
  bannerImageUrl?: InputMaybe<Scalars['String']>;
  bannerLink?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  partnerName?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AdPartnerBannerType>;
};

export type PartnerAdUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PartnerAdUpdateManyInput;
  /** Document search */
  where: PartnerAdWhereInput;
};

export type PartnerAdUpdateOneInlineInput = {
  /** Connect existing PartnerAd document */
  connect?: InputMaybe<PartnerAdWhereUniqueInput>;
  /** Create and connect one PartnerAd document */
  create?: InputMaybe<PartnerAdCreateInput>;
  /** Delete currently connected PartnerAd document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected PartnerAd document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single PartnerAd document */
  update?: InputMaybe<PartnerAdUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PartnerAd document */
  upsert?: InputMaybe<PartnerAdUpsertWithNestedWhereUniqueInput>;
};

export type PartnerAdUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PartnerAdUpdateInput;
  /** Unique document search */
  where: PartnerAdWhereUniqueInput;
};

export type PartnerAdUpsertInput = {
  /** Create document if it didn't exist */
  create: PartnerAdCreateInput;
  /** Update document if it exists */
  update: PartnerAdUpdateInput;
};

export type PartnerAdUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PartnerAdUpsertInput;
  /** Unique document search */
  where: PartnerAdWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PartnerAdWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type PartnerAdWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PartnerAdWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PartnerAdWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PartnerAdWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  bannerImageUrl?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  bannerImageUrl_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  bannerImageUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  bannerImageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerImageUrl_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  bannerImageUrl_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  bannerImageUrl_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  bannerImageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  bannerImageUrl_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  bannerImageUrl_starts_with?: InputMaybe<Scalars['String']>;
  bannerLink?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  bannerLink_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  bannerLink_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  bannerLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerLink_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  bannerLink_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  bannerLink_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  bannerLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  bannerLink_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  bannerLink_starts_with?: InputMaybe<Scalars['String']>;
  bannerName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  bannerName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  bannerName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  bannerName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  bannerName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  bannerName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  bannerName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  bannerName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  bannerName_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PartnerAdWhereStageInput>;
  documentInStages_none?: InputMaybe<PartnerAdWhereStageInput>;
  documentInStages_some?: InputMaybe<PartnerAdWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  partnerName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  partnerName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  partnerName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  partnerName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  partnerName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  partnerName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  partnerName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  partnerName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  partnerName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  partnerName_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subtitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AdPartnerBannerType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<AdPartnerBannerType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<AdPartnerBannerType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<AdPartnerBannerType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PartnerAdWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PartnerAdWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PartnerAdWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PartnerAdWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PartnerAdWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PartnerAd record uniquely */
export type PartnerAdWhereUniqueInput = {
  bannerName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type PayoutBand = Entity & {
  __typename?: 'PayoutBand';
  /** The unique identifier */
  id: Scalars['ID'];
  payoutBand: PayoutBands;
  /**
   * The payout band minimum is a value that greater than or
   * equal to the value you select.
   *
   * e.g. 500 mean any value >=500 will be in this band. Higher numbers take prescidence
   */
  payoutBandMinimum: Scalars['Int'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutBandConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PayoutBandWhereUniqueInput;
};

/** A connection to a list of items. */
export type PayoutBandConnection = {
  __typename?: 'PayoutBandConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PayoutBandEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PayoutBandCreateInput = {
  payoutBand: PayoutBands;
  payoutBandMinimum: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PayoutBandCreateManyInlineInput = {
  /** Create and connect multiple existing PayoutBand documents */
  create?: InputMaybe<Array<PayoutBandCreateInput>>;
};

export type PayoutBandCreateOneInlineInput = {
  /** Create and connect one PayoutBand document */
  create?: InputMaybe<PayoutBandCreateInput>;
};

export type PayoutBandCreateWithPositionInput = {
  /** Document to create */
  data: PayoutBandCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type PayoutBandEdge = {
  __typename?: 'PayoutBandEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayoutBand;
};

/** Identifies documents */
export type PayoutBandManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PayoutBandWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PayoutBandWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PayoutBandWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  payoutBand?: InputMaybe<PayoutBands>;
  payoutBandMinimum?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  payoutBandMinimum_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  payoutBandMinimum_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  payoutBandMinimum_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  payoutBandMinimum_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  payoutBandMinimum_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  payoutBandMinimum_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  payoutBandMinimum_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values that are contained in given list. */
  payoutBand_in?: InputMaybe<Array<InputMaybe<PayoutBands>>>;
  /** Any other value that exists and is not equal to the given value. */
  payoutBand_not?: InputMaybe<PayoutBands>;
  /** All values that are not contained in given list. */
  payoutBand_not_in?: InputMaybe<Array<InputMaybe<PayoutBands>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export enum PayoutBandOrderByInput {
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PAYOUTBANDMINIMUM_ASC = 'payoutBandMinimum_ASC',
  PAYOUTBANDMINIMUM_DESC = 'payoutBandMinimum_DESC',
  PAYOUTBAND_ASC = 'payoutBand_ASC',
  PAYOUTBAND_DESC = 'payoutBand_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type PayoutBandParent = GameMode;

export type PayoutBandParentConnectInput = {
  GameMode?: InputMaybe<GameModeConnectInput>;
};

export type PayoutBandParentCreateInput = {
  GameMode?: InputMaybe<GameModeCreateInput>;
};

export type PayoutBandParentCreateManyInlineInput = {
  /** Connect multiple existing PayoutBandParent documents */
  connect?: InputMaybe<Array<PayoutBandParentWhereUniqueInput>>;
  /** Create and connect multiple existing PayoutBandParent documents */
  create?: InputMaybe<Array<PayoutBandParentCreateInput>>;
};

export type PayoutBandParentCreateOneInlineInput = {
  /** Connect one existing PayoutBandParent document */
  connect?: InputMaybe<PayoutBandParentWhereUniqueInput>;
  /** Create and connect one PayoutBandParent document */
  create?: InputMaybe<PayoutBandParentCreateInput>;
};

export type PayoutBandParentUpdateInput = {
  GameMode?: InputMaybe<GameModeUpdateInput>;
};

export type PayoutBandParentUpdateManyInlineInput = {
  /** Connect multiple existing PayoutBandParent documents */
  connect?: InputMaybe<Array<PayoutBandParentConnectInput>>;
  /** Create and connect multiple PayoutBandParent documents */
  create?: InputMaybe<Array<PayoutBandParentCreateInput>>;
  /** Delete multiple PayoutBandParent documents */
  delete?: InputMaybe<Array<PayoutBandParentWhereUniqueInput>>;
  /** Disconnect multiple PayoutBandParent documents */
  disconnect?: InputMaybe<Array<PayoutBandParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PayoutBandParent documents */
  set?: InputMaybe<Array<PayoutBandParentWhereUniqueInput>>;
  /** Update multiple PayoutBandParent documents */
  update?: InputMaybe<Array<PayoutBandParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PayoutBandParent documents */
  upsert?: InputMaybe<Array<PayoutBandParentUpsertWithNestedWhereUniqueInput>>;
};

export type PayoutBandParentUpdateManyWithNestedWhereInput = {
  GameMode?: InputMaybe<GameModeUpdateManyWithNestedWhereInput>;
};

export type PayoutBandParentUpdateOneInlineInput = {
  /** Connect existing PayoutBandParent document */
  connect?: InputMaybe<PayoutBandParentWhereUniqueInput>;
  /** Create and connect one PayoutBandParent document */
  create?: InputMaybe<PayoutBandParentCreateInput>;
  /** Delete currently connected PayoutBandParent document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected PayoutBandParent document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single PayoutBandParent document */
  update?: InputMaybe<PayoutBandParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PayoutBandParent document */
  upsert?: InputMaybe<PayoutBandParentUpsertWithNestedWhereUniqueInput>;
};

export type PayoutBandParentUpdateWithNestedWhereUniqueInput = {
  GameMode?: InputMaybe<GameModeUpdateWithNestedWhereUniqueInput>;
};

export type PayoutBandParentUpsertWithNestedWhereUniqueInput = {
  GameMode?: InputMaybe<GameModeUpsertWithNestedWhereUniqueInput>;
};

export type PayoutBandParentWhereInput = {
  GameMode?: InputMaybe<GameModeWhereInput>;
};

export type PayoutBandParentWhereUniqueInput = {
  GameMode?: InputMaybe<GameModeWhereUniqueInput>;
};

export type PayoutBandUpdateInput = {
  payoutBand?: InputMaybe<PayoutBands>;
  payoutBandMinimum?: InputMaybe<Scalars['Int']>;
};

export type PayoutBandUpdateManyInlineInput = {
  /** Create and connect multiple PayoutBand component instances */
  create?: InputMaybe<Array<PayoutBandCreateWithPositionInput>>;
  /** Delete multiple PayoutBand documents */
  delete?: InputMaybe<Array<PayoutBandWhereUniqueInput>>;
  /** Update multiple PayoutBand component instances */
  update?: InputMaybe<Array<PayoutBandUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple PayoutBand component instances */
  upsert?: InputMaybe<Array<PayoutBandUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type PayoutBandUpdateManyInput = {
  payoutBand?: InputMaybe<PayoutBands>;
};

export type PayoutBandUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PayoutBandUpdateManyInput;
  /** Document search */
  where: PayoutBandWhereInput;
};

export type PayoutBandUpdateOneInlineInput = {
  /** Create and connect one PayoutBand document */
  create?: InputMaybe<PayoutBandCreateInput>;
  /** Delete currently connected PayoutBand document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Update single PayoutBand document */
  update?: InputMaybe<PayoutBandUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PayoutBand document */
  upsert?: InputMaybe<PayoutBandUpsertWithNestedWhereUniqueInput>;
};

export type PayoutBandUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<PayoutBandUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: PayoutBandWhereUniqueInput;
};

export type PayoutBandUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PayoutBandUpdateInput;
  /** Unique document search */
  where: PayoutBandWhereUniqueInput;
};

export type PayoutBandUpsertInput = {
  /** Create document if it didn't exist */
  create: PayoutBandCreateInput;
  /** Update document if it exists */
  update: PayoutBandUpdateInput;
};

export type PayoutBandUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<PayoutBandUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: PayoutBandWhereUniqueInput;
};

export type PayoutBandUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PayoutBandUpsertInput;
  /** Unique document search */
  where: PayoutBandWhereUniqueInput;
};

/** Identifies documents */
export type PayoutBandWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PayoutBandWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PayoutBandWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PayoutBandWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  payoutBand?: InputMaybe<PayoutBands>;
  payoutBandMinimum?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  payoutBandMinimum_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  payoutBandMinimum_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  payoutBandMinimum_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  payoutBandMinimum_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  payoutBandMinimum_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  payoutBandMinimum_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  payoutBandMinimum_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values that are contained in given list. */
  payoutBand_in?: InputMaybe<Array<InputMaybe<PayoutBands>>>;
  /** Any other value that exists and is not equal to the given value. */
  payoutBand_not?: InputMaybe<PayoutBands>;
  /** All values that are not contained in given list. */
  payoutBand_not_in?: InputMaybe<Array<InputMaybe<PayoutBands>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

/** References PayoutBand record uniquely */
export type PayoutBandWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  payoutBandMinimum?: InputMaybe<Scalars['Int']>;
};

export enum PayoutBands {
  BLUE = 'Blue',
  GOLD = 'Gold',
  GREEN = 'Green',
  PURPLE = 'Purple'
}

/** Phrases used in the application copy  */
export type Phrase = Entity & Node & {
  __typename?: 'Phrase';
  content: Scalars['String'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Phrase>;
  /** List of Phrase versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Phrase>;
  /** Admin notes for what this key allude's to. */
  notes?: Maybe<Scalars['String']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** A unique reference to the phrase. Must match the format: screen_name-phrase_descriptor  */
  reference: Scalars['String'];
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Phrases used in the application copy  */
export type PhraseCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Phrases used in the application copy  */
export type PhraseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Phrases used in the application copy  */
export type PhraseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Phrases used in the application copy  */
export type PhraseHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Phrases used in the application copy  */
export type PhraseLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


/** Phrases used in the application copy  */
export type PhrasePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Phrases used in the application copy  */
export type PhrasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Phrases used in the application copy  */
export type PhraseScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Phrases used in the application copy  */
export type PhraseUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Phrases used in the application copy  */
export type PhraseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PhraseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PhraseWhereUniqueInput;
};

/** A connection to a list of items. */
export type PhraseConnection = {
  __typename?: 'PhraseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PhraseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PhraseCreateInput = {
  cl7a710z72muy01ujczqt26ew?: InputMaybe<FeatureFlagCreateManyInlineInput>;
  cl7a729zu2mx201ujep2z62ga?: InputMaybe<FeatureFlagCreateManyInlineInput>;
  cl8end1p62zd601ulfiki6k8b?: InputMaybe<GameCreateManyInlineInput>;
  cl8endmat300101ueevj60foc?: InputMaybe<GameCreateManyInlineInput>;
  cl8iopid7014g01ul7tpdghx3?: InputMaybe<GameCreateManyInlineInput>;
  cl8ioqcfy015z01ul1j8q1k49?: InputMaybe<GameCreateManyInlineInput>;
  cl8iqdh2p00so01tcc102bqkv?: InputMaybe<PlatformCreateManyInlineInput>;
  clasc34jh05kn01ur2vjvg4tl?: InputMaybe<PlatformCreateManyInlineInput>;
  cld91svf10crj01t92w0m95wh?: InputMaybe<GameCreateManyInlineInput>;
  cld91txgw0cm201uh217sfzys?: InputMaybe<GameCreateManyInlineInput>;
  cldydm0m615n001ui2y9o72nz?: InputMaybe<ApexCharacterIssueCreateManyInlineInput>;
  cldydmrv7163g01t2grzc2lfi?: InputMaybe<ApexCharacterIssueCreateManyInlineInput>;
  clf9rgt2o1alx01up3ghlc0sx?: InputMaybe<BetCategoryCreateManyInlineInput>;
  clfjogn7p021s01td0092gf4h?: InputMaybe<PlayBannerCreateManyInlineInput>;
  clfjohs5p01su01ul6o1a9a5d?: InputMaybe<PlayBannerCreateManyInlineInput>;
  clfjoje8c01um01ur0l42gu5a?: InputMaybe<PlayBannerCreateManyInlineInput>;
  clfjojzr0021r01ug9vghd7cx?: InputMaybe<PlayBannerCreateManyInlineInput>;
  clgxkwxkv0xlk01um6rfe5eus?: InputMaybe<PlatformCreateManyInlineInput>;
  clh7y7sjg864701ta9zaoen93?: InputMaybe<MatchIssueCreateManyInlineInput>;
  clh7y69dz887m01umg46v3puq?: InputMaybe<MatchIssueCreateManyInlineInput>;
  clj5xejky0m4n01un9lab7rie?: InputMaybe<TwitchExplainerCreateManyInlineInput>;
  clj5xft0h0mvq01ui3wc3cnad?: InputMaybe<TwitchExplainerCreateManyInlineInput>;
  clp1mnij50yd301unfy9e9bts?: InputMaybe<GameCreateManyInlineInput>;
  clp1mo0f40y0g01uk7de9cucj?: InputMaybe<GameCreateManyInlineInput>;
  clp76gvyb1cz101ul2se6h0zo?: InputMaybe<OnboardingQuestionCreateManyInlineInput>;
  clp76h9u01dk601t72sqg8n2g?: InputMaybe<OnboardingQuestionCreateManyInlineInput>;
  clsa8ohnn154m01irggtbbeoa?: InputMaybe<GameModeCreateManyInlineInput>;
  clw7xs7ol03io07k7ct591dvk?: InputMaybe<PlayBannerCreateManyInlineInput>;
  clxngbiok00xw07iv6tav1acq?: InputMaybe<RegexPatternCreateManyInlineInput>;
  cly61szba027007it1atu3se5?: InputMaybe<TeamSizeCreateManyInlineInput>;
  cly61tphe027x07it9l4rcnlp?: InputMaybe<TeamSizeCreateManyInlineInput>;
  cly665oxl03rg07itb8n63248?: InputMaybe<GameModeCreateManyInlineInput>;
  cly667dr903v007itc4qf9e5h?: InputMaybe<GameModeCreateManyInlineInput>;
  cm3g6acee01a007iu8a49c53h?: InputMaybe<GameModeCalloutCreateManyInlineInput>;
  cm3g6assn01b007iu8m8t3zxk?: InputMaybe<GameModeCalloutCreateManyInlineInput>;
  cm3g6b02k01bl07iu9nc0flgw?: InputMaybe<GameModeCalloutCreateManyInlineInput>;
  cm3g6b9cs01c807iu25wbfgl5?: InputMaybe<GameModeCalloutCreateManyInlineInput>;
  cm3g6bn9z01cz07iu4r5yazs9?: InputMaybe<GameModeCalloutCreateManyInlineInput>;
  cm6pjggs000ya07k5gsfbfeaj?: InputMaybe<GameCreateManyInlineInput>;
  cmcnkpd0s09be06k4hwdkcg9o?: InputMaybe<GameSeriesCreateManyInlineInput>;
  /** content input for default locale (en) */
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PhraseCreateLocalizationsInput>;
  notes?: InputMaybe<Scalars['String']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PhraseCreateLocalizationDataInput = {
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PhraseCreateLocalizationInput = {
  /** Localization input */
  data: PhraseCreateLocalizationDataInput;
  locale: Locale;
};

export type PhraseCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PhraseCreateLocalizationInput>>;
};

export type PhraseCreateManyInlineInput = {
  /** Connect multiple existing Phrase documents */
  connect?: InputMaybe<Array<PhraseWhereUniqueInput>>;
  /** Create and connect multiple existing Phrase documents */
  create?: InputMaybe<Array<PhraseCreateInput>>;
};

export type PhraseCreateOneInlineInput = {
  /** Connect one existing Phrase document */
  connect?: InputMaybe<PhraseWhereUniqueInput>;
  /** Create and connect one Phrase document */
  create?: InputMaybe<PhraseCreateInput>;
};

/** An edge in a connection. */
export type PhraseEdge = {
  __typename?: 'PhraseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Phrase;
};

/** Identifies documents */
export type PhraseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PhraseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PhraseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PhraseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PhraseWhereStageInput>;
  documentInStages_none?: InputMaybe<PhraseWhereStageInput>;
  documentInStages_some?: InputMaybe<PhraseWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  notes_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  notes_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  notes_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  notes_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  notes_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  notes_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  notes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  notes_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  notes_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  reference?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  reference_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  reference_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  reference_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  reference_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  reference_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  reference_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  reference_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  reference_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  reference_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PhraseOrderByInput {
  CONTENT_ASC = 'content_ASC',
  CONTENT_DESC = 'content_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  NOTES_ASC = 'notes_ASC',
  NOTES_DESC = 'notes_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  REFERENCE_ASC = 'reference_ASC',
  REFERENCE_DESC = 'reference_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type PhraseUpdateInput = {
  cl7a710z72muy01ujczqt26ew?: InputMaybe<FeatureFlagUpdateManyInlineInput>;
  cl7a729zu2mx201ujep2z62ga?: InputMaybe<FeatureFlagUpdateManyInlineInput>;
  cl8end1p62zd601ulfiki6k8b?: InputMaybe<GameUpdateManyInlineInput>;
  cl8endmat300101ueevj60foc?: InputMaybe<GameUpdateManyInlineInput>;
  cl8iopid7014g01ul7tpdghx3?: InputMaybe<GameUpdateManyInlineInput>;
  cl8ioqcfy015z01ul1j8q1k49?: InputMaybe<GameUpdateManyInlineInput>;
  cl8iqdh2p00so01tcc102bqkv?: InputMaybe<PlatformUpdateManyInlineInput>;
  clasc34jh05kn01ur2vjvg4tl?: InputMaybe<PlatformUpdateManyInlineInput>;
  cld91svf10crj01t92w0m95wh?: InputMaybe<GameUpdateManyInlineInput>;
  cld91txgw0cm201uh217sfzys?: InputMaybe<GameUpdateManyInlineInput>;
  cldydm0m615n001ui2y9o72nz?: InputMaybe<ApexCharacterIssueUpdateManyInlineInput>;
  cldydmrv7163g01t2grzc2lfi?: InputMaybe<ApexCharacterIssueUpdateManyInlineInput>;
  clf9rgt2o1alx01up3ghlc0sx?: InputMaybe<BetCategoryUpdateManyInlineInput>;
  clfjogn7p021s01td0092gf4h?: InputMaybe<PlayBannerUpdateManyInlineInput>;
  clfjohs5p01su01ul6o1a9a5d?: InputMaybe<PlayBannerUpdateManyInlineInput>;
  clfjoje8c01um01ur0l42gu5a?: InputMaybe<PlayBannerUpdateManyInlineInput>;
  clfjojzr0021r01ug9vghd7cx?: InputMaybe<PlayBannerUpdateManyInlineInput>;
  clgxkwxkv0xlk01um6rfe5eus?: InputMaybe<PlatformUpdateManyInlineInput>;
  clh7y7sjg864701ta9zaoen93?: InputMaybe<MatchIssueUpdateManyInlineInput>;
  clh7y69dz887m01umg46v3puq?: InputMaybe<MatchIssueUpdateManyInlineInput>;
  clj5xejky0m4n01un9lab7rie?: InputMaybe<TwitchExplainerUpdateManyInlineInput>;
  clj5xft0h0mvq01ui3wc3cnad?: InputMaybe<TwitchExplainerUpdateManyInlineInput>;
  clp1mnij50yd301unfy9e9bts?: InputMaybe<GameUpdateManyInlineInput>;
  clp1mo0f40y0g01uk7de9cucj?: InputMaybe<GameUpdateManyInlineInput>;
  clp76gvyb1cz101ul2se6h0zo?: InputMaybe<OnboardingQuestionUpdateManyInlineInput>;
  clp76h9u01dk601t72sqg8n2g?: InputMaybe<OnboardingQuestionUpdateManyInlineInput>;
  clsa8ohnn154m01irggtbbeoa?: InputMaybe<GameModeUpdateManyInlineInput>;
  clw7xs7ol03io07k7ct591dvk?: InputMaybe<PlayBannerUpdateManyInlineInput>;
  clxngbiok00xw07iv6tav1acq?: InputMaybe<RegexPatternUpdateManyInlineInput>;
  cly61szba027007it1atu3se5?: InputMaybe<TeamSizeUpdateManyInlineInput>;
  cly61tphe027x07it9l4rcnlp?: InputMaybe<TeamSizeUpdateManyInlineInput>;
  cly665oxl03rg07itb8n63248?: InputMaybe<GameModeUpdateManyInlineInput>;
  cly667dr903v007itc4qf9e5h?: InputMaybe<GameModeUpdateManyInlineInput>;
  cm3g6acee01a007iu8a49c53h?: InputMaybe<GameModeCalloutUpdateManyInlineInput>;
  cm3g6assn01b007iu8m8t3zxk?: InputMaybe<GameModeCalloutUpdateManyInlineInput>;
  cm3g6b02k01bl07iu9nc0flgw?: InputMaybe<GameModeCalloutUpdateManyInlineInput>;
  cm3g6b9cs01c807iu25wbfgl5?: InputMaybe<GameModeCalloutUpdateManyInlineInput>;
  cm3g6bn9z01cz07iu4r5yazs9?: InputMaybe<GameModeCalloutUpdateManyInlineInput>;
  cm6pjggs000ya07k5gsfbfeaj?: InputMaybe<GameUpdateManyInlineInput>;
  cmcnkpd0s09be06k4hwdkcg9o?: InputMaybe<GameSeriesUpdateManyInlineInput>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['String']>;
  /** Manage document localizations */
  localizations?: InputMaybe<PhraseUpdateLocalizationsInput>;
  notes?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
};

export type PhraseUpdateLocalizationDataInput = {
  content?: InputMaybe<Scalars['String']>;
};

export type PhraseUpdateLocalizationInput = {
  data: PhraseUpdateLocalizationDataInput;
  locale: Locale;
};

export type PhraseUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PhraseCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<PhraseUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<PhraseUpsertLocalizationInput>>;
};

export type PhraseUpdateManyInlineInput = {
  /** Connect multiple existing Phrase documents */
  connect?: InputMaybe<Array<PhraseConnectInput>>;
  /** Create and connect multiple Phrase documents */
  create?: InputMaybe<Array<PhraseCreateInput>>;
  /** Delete multiple Phrase documents */
  delete?: InputMaybe<Array<PhraseWhereUniqueInput>>;
  /** Disconnect multiple Phrase documents */
  disconnect?: InputMaybe<Array<PhraseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Phrase documents */
  set?: InputMaybe<Array<PhraseWhereUniqueInput>>;
  /** Update multiple Phrase documents */
  update?: InputMaybe<Array<PhraseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Phrase documents */
  upsert?: InputMaybe<Array<PhraseUpsertWithNestedWhereUniqueInput>>;
};

export type PhraseUpdateManyInput = {
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['String']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<PhraseUpdateManyLocalizationsInput>;
  notes?: InputMaybe<Scalars['String']>;
};

export type PhraseUpdateManyLocalizationDataInput = {
  content?: InputMaybe<Scalars['String']>;
};

export type PhraseUpdateManyLocalizationInput = {
  data: PhraseUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type PhraseUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PhraseUpdateManyLocalizationInput>>;
};

export type PhraseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PhraseUpdateManyInput;
  /** Document search */
  where: PhraseWhereInput;
};

export type PhraseUpdateOneInlineInput = {
  /** Connect existing Phrase document */
  connect?: InputMaybe<PhraseWhereUniqueInput>;
  /** Create and connect one Phrase document */
  create?: InputMaybe<PhraseCreateInput>;
  /** Delete currently connected Phrase document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Phrase document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Phrase document */
  update?: InputMaybe<PhraseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Phrase document */
  upsert?: InputMaybe<PhraseUpsertWithNestedWhereUniqueInput>;
};

export type PhraseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PhraseUpdateInput;
  /** Unique document search */
  where: PhraseWhereUniqueInput;
};

export type PhraseUpsertInput = {
  /** Create document if it didn't exist */
  create: PhraseCreateInput;
  /** Update document if it exists */
  update: PhraseUpdateInput;
};

export type PhraseUpsertLocalizationInput = {
  create: PhraseCreateLocalizationDataInput;
  locale: Locale;
  update: PhraseUpdateLocalizationDataInput;
};

export type PhraseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PhraseUpsertInput;
  /** Unique document search */
  where: PhraseWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PhraseWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type PhraseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PhraseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PhraseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PhraseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PhraseWhereStageInput>;
  documentInStages_none?: InputMaybe<PhraseWhereStageInput>;
  documentInStages_some?: InputMaybe<PhraseWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  notes_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  notes_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  notes_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  notes_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  notes_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  notes_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  notes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  notes_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  notes_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  reference?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  reference_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  reference_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  reference_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  reference_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  reference_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  reference_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  reference_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  reference_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  reference_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PhraseWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PhraseWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PhraseWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PhraseWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PhraseWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Phrase record uniquely */
export type PhraseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  reference?: InputMaybe<Scalars['String']>;
};

export type Platform = Entity & Node & {
  __typename?: 'Platform';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Characters that are not allowed in this gamertag */
  disallowedCharacters?: Maybe<Scalars['String']>;
  displayName?: Maybe<Phrase>;
  /** Get the document in other stages */
  documentInStages: Array<Platform>;
  enabled: Scalars['Boolean'];
  /**
   * Name associated to the Gamertag, NOT platform (Xbox Live)
   *
   * e.g. Xbox Gamertag; PSN ID; Activision ID
   */
  gamertagName?: Maybe<Phrase>;
  /** Gamertag Visibility on account settings screen */
  gamertagVisible: Scalars['Boolean'];
  games: Array<Game>;
  /** List of Platform versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The maximum number of characters needed for a gamertag. */
  maxCharacters: Scalars['Int'];
  /** The minimum number of characters needed for a gamertag. */
  minCharacters: Scalars['Int'];
  /**
   * The name of the platform. e.g. PlayStation, Xbox, PC
   * Used in a context like "Are you at your PC"
   */
  platformName?: Maybe<Phrase>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  regexPatterns: Array<RegexPattern>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  systemId: Platforms;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /**
   * the relevant key to look up in the user object e.g.
   * loungeUsername
   * xblPlatformUsername
   */
  userLookup: Scalars['String'];
  visible: Scalars['Boolean'];
};


export type PlatformCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlatformDisplayNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlatformDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type PlatformGamertagNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlatformGamesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GameOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameWhereInput>;
};


export type PlatformHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type PlatformPlatformNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlatformPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlatformRegexPatternsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RegexPatternOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RegexPatternWhereInput>;
};


export type PlatformScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PlatformUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PlatformConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PlatformWhereUniqueInput;
};

/** A connection to a list of items. */
export type PlatformConnection = {
  __typename?: 'PlatformConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PlatformEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PlatformCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  disallowedCharacters?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<PhraseCreateOneInlineInput>;
  enabled: Scalars['Boolean'];
  gamertagName?: InputMaybe<PhraseCreateOneInlineInput>;
  gamertagVisible: Scalars['Boolean'];
  games?: InputMaybe<GameCreateManyInlineInput>;
  maxCharacters: Scalars['Int'];
  minCharacters: Scalars['Int'];
  platformName?: InputMaybe<PhraseCreateOneInlineInput>;
  regexPatterns?: InputMaybe<RegexPatternCreateManyInlineInput>;
  systemId: Platforms;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userLookup: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type PlatformCreateManyInlineInput = {
  /** Connect multiple existing Platform documents */
  connect?: InputMaybe<Array<PlatformWhereUniqueInput>>;
  /** Create and connect multiple existing Platform documents */
  create?: InputMaybe<Array<PlatformCreateInput>>;
};

export type PlatformCreateOneInlineInput = {
  /** Connect one existing Platform document */
  connect?: InputMaybe<PlatformWhereUniqueInput>;
  /** Create and connect one Platform document */
  create?: InputMaybe<PlatformCreateInput>;
};

/** An edge in a connection. */
export type PlatformEdge = {
  __typename?: 'PlatformEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Platform;
};

/** Identifies documents */
export type PlatformManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlatformWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlatformWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlatformWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  disallowedCharacters?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  disallowedCharacters_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  disallowedCharacters_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  disallowedCharacters_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  disallowedCharacters_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  disallowedCharacters_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  disallowedCharacters_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  disallowedCharacters_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  disallowedCharacters_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  disallowedCharacters_starts_with?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<PhraseWhereInput>;
  documentInStages_every?: InputMaybe<PlatformWhereStageInput>;
  documentInStages_none?: InputMaybe<PlatformWhereStageInput>;
  documentInStages_some?: InputMaybe<PlatformWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  gamertagName?: InputMaybe<PhraseWhereInput>;
  gamertagVisible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  gamertagVisible_not?: InputMaybe<Scalars['Boolean']>;
  games_every?: InputMaybe<GameWhereInput>;
  games_none?: InputMaybe<GameWhereInput>;
  games_some?: InputMaybe<GameWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  maxCharacters?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  maxCharacters_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  maxCharacters_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  maxCharacters_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  maxCharacters_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  maxCharacters_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  maxCharacters_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  maxCharacters_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  minCharacters?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  minCharacters_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  minCharacters_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  minCharacters_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  minCharacters_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  minCharacters_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  minCharacters_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  minCharacters_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  platformName?: InputMaybe<PhraseWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  regexPatterns_every?: InputMaybe<RegexPatternWhereInput>;
  regexPatterns_none?: InputMaybe<RegexPatternWhereInput>;
  regexPatterns_some?: InputMaybe<RegexPatternWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  systemId?: InputMaybe<Platforms>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Platforms>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Platforms>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Platforms>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  userLookup?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  userLookup_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  userLookup_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  userLookup_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  userLookup_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  userLookup_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  userLookup_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  userLookup_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  userLookup_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  userLookup_starts_with?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

export enum PlatformOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DISALLOWEDCHARACTERS_ASC = 'disallowedCharacters_ASC',
  DISALLOWEDCHARACTERS_DESC = 'disallowedCharacters_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  GAMERTAGVISIBLE_ASC = 'gamertagVisible_ASC',
  GAMERTAGVISIBLE_DESC = 'gamertagVisible_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  MAXCHARACTERS_ASC = 'maxCharacters_ASC',
  MAXCHARACTERS_DESC = 'maxCharacters_DESC',
  MINCHARACTERS_ASC = 'minCharacters_ASC',
  MINCHARACTERS_DESC = 'minCharacters_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  SYSTEMID_ASC = 'systemId_ASC',
  SYSTEMID_DESC = 'systemId_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  USERLOOKUP_ASC = 'userLookup_ASC',
  USERLOOKUP_DESC = 'userLookup_DESC',
  VISIBLE_ASC = 'visible_ASC',
  VISIBLE_DESC = 'visible_DESC'
}

export type PlatformUpdateInput = {
  disallowedCharacters?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<PhraseUpdateOneInlineInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  gamertagName?: InputMaybe<PhraseUpdateOneInlineInput>;
  gamertagVisible?: InputMaybe<Scalars['Boolean']>;
  games?: InputMaybe<GameUpdateManyInlineInput>;
  maxCharacters?: InputMaybe<Scalars['Int']>;
  minCharacters?: InputMaybe<Scalars['Int']>;
  platformName?: InputMaybe<PhraseUpdateOneInlineInput>;
  regexPatterns?: InputMaybe<RegexPatternUpdateManyInlineInput>;
  systemId?: InputMaybe<Platforms>;
  userLookup?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type PlatformUpdateManyInlineInput = {
  /** Connect multiple existing Platform documents */
  connect?: InputMaybe<Array<PlatformConnectInput>>;
  /** Create and connect multiple Platform documents */
  create?: InputMaybe<Array<PlatformCreateInput>>;
  /** Delete multiple Platform documents */
  delete?: InputMaybe<Array<PlatformWhereUniqueInput>>;
  /** Disconnect multiple Platform documents */
  disconnect?: InputMaybe<Array<PlatformWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Platform documents */
  set?: InputMaybe<Array<PlatformWhereUniqueInput>>;
  /** Update multiple Platform documents */
  update?: InputMaybe<Array<PlatformUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Platform documents */
  upsert?: InputMaybe<Array<PlatformUpsertWithNestedWhereUniqueInput>>;
};

export type PlatformUpdateManyInput = {
  disallowedCharacters?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  gamertagVisible?: InputMaybe<Scalars['Boolean']>;
  maxCharacters?: InputMaybe<Scalars['Int']>;
  minCharacters?: InputMaybe<Scalars['Int']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type PlatformUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PlatformUpdateManyInput;
  /** Document search */
  where: PlatformWhereInput;
};

export type PlatformUpdateOneInlineInput = {
  /** Connect existing Platform document */
  connect?: InputMaybe<PlatformWhereUniqueInput>;
  /** Create and connect one Platform document */
  create?: InputMaybe<PlatformCreateInput>;
  /** Delete currently connected Platform document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Platform document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Platform document */
  update?: InputMaybe<PlatformUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Platform document */
  upsert?: InputMaybe<PlatformUpsertWithNestedWhereUniqueInput>;
};

export type PlatformUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PlatformUpdateInput;
  /** Unique document search */
  where: PlatformWhereUniqueInput;
};

export type PlatformUpsertInput = {
  /** Create document if it didn't exist */
  create: PlatformCreateInput;
  /** Update document if it exists */
  update: PlatformUpdateInput;
};

export type PlatformUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PlatformUpsertInput;
  /** Unique document search */
  where: PlatformWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PlatformWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type PlatformWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlatformWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlatformWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlatformWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  disallowedCharacters?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  disallowedCharacters_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  disallowedCharacters_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  disallowedCharacters_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  disallowedCharacters_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  disallowedCharacters_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  disallowedCharacters_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  disallowedCharacters_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  disallowedCharacters_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  disallowedCharacters_starts_with?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<PhraseWhereInput>;
  documentInStages_every?: InputMaybe<PlatformWhereStageInput>;
  documentInStages_none?: InputMaybe<PlatformWhereStageInput>;
  documentInStages_some?: InputMaybe<PlatformWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  gamertagName?: InputMaybe<PhraseWhereInput>;
  gamertagVisible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  gamertagVisible_not?: InputMaybe<Scalars['Boolean']>;
  games_every?: InputMaybe<GameWhereInput>;
  games_none?: InputMaybe<GameWhereInput>;
  games_some?: InputMaybe<GameWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  maxCharacters?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  maxCharacters_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  maxCharacters_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  maxCharacters_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  maxCharacters_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  maxCharacters_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  maxCharacters_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  maxCharacters_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  minCharacters?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  minCharacters_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  minCharacters_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  minCharacters_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  minCharacters_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  minCharacters_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  minCharacters_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  minCharacters_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  platformName?: InputMaybe<PhraseWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  regexPatterns_every?: InputMaybe<RegexPatternWhereInput>;
  regexPatterns_none?: InputMaybe<RegexPatternWhereInput>;
  regexPatterns_some?: InputMaybe<RegexPatternWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  systemId?: InputMaybe<Platforms>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Platforms>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Platforms>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Platforms>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  userLookup?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  userLookup_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  userLookup_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  userLookup_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  userLookup_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  userLookup_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  userLookup_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  userLookup_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  userLookup_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  userLookup_starts_with?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PlatformWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlatformWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlatformWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlatformWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PlatformWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Platform record uniquely */
export type PlatformWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  systemId?: InputMaybe<Platforms>;
  userLookup?: InputMaybe<Scalars['String']>;
};

export enum Platforms {
  ACTIVISION = 'ACTIVISION',
  BATTLENET = 'BATTLENET',
  EPIC_GAMES = 'EPIC_GAMES',
  LEAGUE_OF_LEGENDS = 'LEAGUE_OF_LEGENDS',
  NETEASE_GAMES = 'NETEASE_GAMES',
  ORIGIN = 'ORIGIN',
  PLAYERS_LOUNGE = 'PLAYERS_LOUNGE',
  PLAYSTATION_NETWORK = 'PLAYSTATION_NETWORK',
  RIOT = 'RIOT',
  STEAM = 'STEAM',
  SUPERCELL = 'SUPERCELL',
  TWITCH = 'TWITCH',
  WB_GAMES = 'WB_GAMES',
  XBOX_LIVE = 'XBOX_LIVE'
}

export type PlayBanner = Entity & Node & {
  __typename?: 'PlayBanner';
  /** DEPRECATED. Used gradient colors now. */
  backgroundColor: Array<Color>;
  bannerBody?: Maybe<Phrase>;
  bannerHeader?: Maybe<Phrase>;
  bannerImage?: Maybe<Asset>;
  bannerImageId?: Maybe<PlayBannerImage>;
  bannerModalImageId?: Maybe<PlayBannerModalImage>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<PlayBanner>;
  enabled?: Maybe<Scalars['Boolean']>;
  gradientColors: Array<Color>;
  /** List of PlayBanner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  intercomButtonEnabled?: Maybe<Scalars['Boolean']>;
  modalBody?: Maybe<Phrase>;
  modalCtaBtnClickType?: Maybe<CtaButtonClickType>;
  /**
   * If click type is intercom, this field is not required. If click type is deeplink, this will be deposit, withdrawal, transactions, activity, faq, etc. If click type is webview, add URL.
   *
   * NOTE: When using deeplinks, do not include playersloungeconnect:// before the deeplink.
   */
  modalCtaBtnLink?: Maybe<Scalars['String']>;
  modalCtaBtnText?: Maybe<Phrase>;
  modalCtaBtnType?: Maybe<ButtonTypes>;
  modalHeader?: Maybe<Phrase>;
  modalImage?: Maybe<Asset>;
  /** Higher the number, the sooner it appears in the list. */
  priority: Scalars['Int'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  systemId?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PlayBannerBannerBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlayBannerBannerHeaderArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlayBannerBannerImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PlayBannerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlayBannerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type PlayBannerHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type PlayBannerModalBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlayBannerModalCtaBtnTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlayBannerModalHeaderArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlayBannerModalImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PlayBannerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlayBannerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PlayBannerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PlayBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PlayBannerWhereUniqueInput;
};

/** A connection to a list of items. */
export type PlayBannerConnection = {
  __typename?: 'PlayBannerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PlayBannerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PlayBannerCreateInput = {
  backgroundColor?: InputMaybe<Array<ColorInput>>;
  bannerBody?: InputMaybe<PhraseCreateOneInlineInput>;
  bannerHeader?: InputMaybe<PhraseCreateOneInlineInput>;
  bannerImage?: InputMaybe<AssetCreateOneInlineInput>;
  bannerImageId?: InputMaybe<PlayBannerImage>;
  bannerModalImageId?: InputMaybe<PlayBannerModalImage>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  gradientColors?: InputMaybe<Array<ColorInput>>;
  intercomButtonEnabled?: InputMaybe<Scalars['Boolean']>;
  modalBody?: InputMaybe<PhraseCreateOneInlineInput>;
  modalCtaBtnClickType?: InputMaybe<CtaButtonClickType>;
  modalCtaBtnLink?: InputMaybe<Scalars['String']>;
  modalCtaBtnText?: InputMaybe<PhraseCreateOneInlineInput>;
  modalCtaBtnType?: InputMaybe<ButtonTypes>;
  modalHeader?: InputMaybe<PhraseCreateOneInlineInput>;
  modalImage?: InputMaybe<AssetCreateOneInlineInput>;
  priority: Scalars['Int'];
  systemId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PlayBannerCreateManyInlineInput = {
  /** Connect multiple existing PlayBanner documents */
  connect?: InputMaybe<Array<PlayBannerWhereUniqueInput>>;
  /** Create and connect multiple existing PlayBanner documents */
  create?: InputMaybe<Array<PlayBannerCreateInput>>;
};

export type PlayBannerCreateOneInlineInput = {
  /** Connect one existing PlayBanner document */
  connect?: InputMaybe<PlayBannerWhereUniqueInput>;
  /** Create and connect one PlayBanner document */
  create?: InputMaybe<PlayBannerCreateInput>;
};

/** An edge in a connection. */
export type PlayBannerEdge = {
  __typename?: 'PlayBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PlayBanner;
};

export enum PlayBannerImage {
  BETCREDIT = 'betCredit',
  HANDSHAKE = 'handshake',
  LIVECOIN = 'liveCoin',
  MMPCHECKS = 'mmpChecks',
  MONEYBAG = 'moneyBag',
  MONEYSTACK = 'moneyStack',
  RISKFREE = 'riskFree',
  SWEEPSTAKESWHEEL = 'sweepstakesWheel',
  TROPHY = 'trophy'
}

/** Identifies documents */
export type PlayBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlayBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlayBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlayBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  bannerBody?: InputMaybe<PhraseWhereInput>;
  bannerHeader?: InputMaybe<PhraseWhereInput>;
  bannerImage?: InputMaybe<AssetWhereInput>;
  bannerImageId?: InputMaybe<PlayBannerImage>;
  /** All values that are contained in given list. */
  bannerImageId_in?: InputMaybe<Array<InputMaybe<PlayBannerImage>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerImageId_not?: InputMaybe<PlayBannerImage>;
  /** All values that are not contained in given list. */
  bannerImageId_not_in?: InputMaybe<Array<InputMaybe<PlayBannerImage>>>;
  bannerModalImageId?: InputMaybe<PlayBannerModalImage>;
  /** All values that are contained in given list. */
  bannerModalImageId_in?: InputMaybe<Array<InputMaybe<PlayBannerModalImage>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerModalImageId_not?: InputMaybe<PlayBannerModalImage>;
  /** All values that are not contained in given list. */
  bannerModalImageId_not_in?: InputMaybe<Array<InputMaybe<PlayBannerModalImage>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PlayBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<PlayBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<PlayBannerWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  intercomButtonEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  intercomButtonEnabled_not?: InputMaybe<Scalars['Boolean']>;
  modalBody?: InputMaybe<PhraseWhereInput>;
  modalCtaBtnClickType?: InputMaybe<CtaButtonClickType>;
  /** All values that are contained in given list. */
  modalCtaBtnClickType_in?: InputMaybe<Array<InputMaybe<CtaButtonClickType>>>;
  /** Any other value that exists and is not equal to the given value. */
  modalCtaBtnClickType_not?: InputMaybe<CtaButtonClickType>;
  /** All values that are not contained in given list. */
  modalCtaBtnClickType_not_in?: InputMaybe<Array<InputMaybe<CtaButtonClickType>>>;
  modalCtaBtnLink?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  modalCtaBtnLink_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  modalCtaBtnLink_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  modalCtaBtnLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  modalCtaBtnLink_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  modalCtaBtnLink_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  modalCtaBtnLink_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  modalCtaBtnLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  modalCtaBtnLink_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  modalCtaBtnLink_starts_with?: InputMaybe<Scalars['String']>;
  modalCtaBtnText?: InputMaybe<PhraseWhereInput>;
  modalCtaBtnType?: InputMaybe<ButtonTypes>;
  /** All values that are contained in given list. */
  modalCtaBtnType_in?: InputMaybe<Array<InputMaybe<ButtonTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  modalCtaBtnType_not?: InputMaybe<ButtonTypes>;
  /** All values that are not contained in given list. */
  modalCtaBtnType_not_in?: InputMaybe<Array<InputMaybe<ButtonTypes>>>;
  modalHeader?: InputMaybe<PhraseWhereInput>;
  modalImage?: InputMaybe<AssetWhereInput>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PlayBannerModalImage {
  LIVECOIN = 'liveCoin',
  MONEYBAG = 'moneyBag',
  MONEYSTACK = 'moneyStack',
  RISKFREE = 'riskFree',
  SWEEPSTAKESWHEEL = 'sweepstakesWheel',
  TROPHY = 'trophy'
}

export enum PlayBannerOrderByInput {
  BANNERIMAGEID_ASC = 'bannerImageId_ASC',
  BANNERIMAGEID_DESC = 'bannerImageId_DESC',
  BANNERMODALIMAGEID_ASC = 'bannerModalImageId_ASC',
  BANNERMODALIMAGEID_DESC = 'bannerModalImageId_DESC',
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  INTERCOMBUTTONENABLED_ASC = 'intercomButtonEnabled_ASC',
  INTERCOMBUTTONENABLED_DESC = 'intercomButtonEnabled_DESC',
  MODALCTABTNCLICKTYPE_ASC = 'modalCtaBtnClickType_ASC',
  MODALCTABTNCLICKTYPE_DESC = 'modalCtaBtnClickType_DESC',
  MODALCTABTNLINK_ASC = 'modalCtaBtnLink_ASC',
  MODALCTABTNLINK_DESC = 'modalCtaBtnLink_DESC',
  MODALCTABTNTYPE_ASC = 'modalCtaBtnType_ASC',
  MODALCTABTNTYPE_DESC = 'modalCtaBtnType_DESC',
  PRIORITY_ASC = 'priority_ASC',
  PRIORITY_DESC = 'priority_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  SYSTEMID_ASC = 'systemId_ASC',
  SYSTEMID_DESC = 'systemId_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type PlayBannerUpdateInput = {
  backgroundColor?: InputMaybe<Array<ColorInput>>;
  bannerBody?: InputMaybe<PhraseUpdateOneInlineInput>;
  bannerHeader?: InputMaybe<PhraseUpdateOneInlineInput>;
  bannerImage?: InputMaybe<AssetUpdateOneInlineInput>;
  bannerImageId?: InputMaybe<PlayBannerImage>;
  bannerModalImageId?: InputMaybe<PlayBannerModalImage>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  gradientColors?: InputMaybe<Array<ColorInput>>;
  intercomButtonEnabled?: InputMaybe<Scalars['Boolean']>;
  modalBody?: InputMaybe<PhraseUpdateOneInlineInput>;
  modalCtaBtnClickType?: InputMaybe<CtaButtonClickType>;
  modalCtaBtnLink?: InputMaybe<Scalars['String']>;
  modalCtaBtnText?: InputMaybe<PhraseUpdateOneInlineInput>;
  modalCtaBtnType?: InputMaybe<ButtonTypes>;
  modalHeader?: InputMaybe<PhraseUpdateOneInlineInput>;
  modalImage?: InputMaybe<AssetUpdateOneInlineInput>;
  priority?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type PlayBannerUpdateManyInlineInput = {
  /** Connect multiple existing PlayBanner documents */
  connect?: InputMaybe<Array<PlayBannerConnectInput>>;
  /** Create and connect multiple PlayBanner documents */
  create?: InputMaybe<Array<PlayBannerCreateInput>>;
  /** Delete multiple PlayBanner documents */
  delete?: InputMaybe<Array<PlayBannerWhereUniqueInput>>;
  /** Disconnect multiple PlayBanner documents */
  disconnect?: InputMaybe<Array<PlayBannerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PlayBanner documents */
  set?: InputMaybe<Array<PlayBannerWhereUniqueInput>>;
  /** Update multiple PlayBanner documents */
  update?: InputMaybe<Array<PlayBannerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PlayBanner documents */
  upsert?: InputMaybe<Array<PlayBannerUpsertWithNestedWhereUniqueInput>>;
};

export type PlayBannerUpdateManyInput = {
  backgroundColor?: InputMaybe<Array<ColorInput>>;
  bannerImageId?: InputMaybe<PlayBannerImage>;
  bannerModalImageId?: InputMaybe<PlayBannerModalImage>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  gradientColors?: InputMaybe<Array<ColorInput>>;
  intercomButtonEnabled?: InputMaybe<Scalars['Boolean']>;
  modalCtaBtnClickType?: InputMaybe<CtaButtonClickType>;
  modalCtaBtnLink?: InputMaybe<Scalars['String']>;
  modalCtaBtnType?: InputMaybe<ButtonTypes>;
};

export type PlayBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PlayBannerUpdateManyInput;
  /** Document search */
  where: PlayBannerWhereInput;
};

export type PlayBannerUpdateOneInlineInput = {
  /** Connect existing PlayBanner document */
  connect?: InputMaybe<PlayBannerWhereUniqueInput>;
  /** Create and connect one PlayBanner document */
  create?: InputMaybe<PlayBannerCreateInput>;
  /** Delete currently connected PlayBanner document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected PlayBanner document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single PlayBanner document */
  update?: InputMaybe<PlayBannerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PlayBanner document */
  upsert?: InputMaybe<PlayBannerUpsertWithNestedWhereUniqueInput>;
};

export type PlayBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PlayBannerUpdateInput;
  /** Unique document search */
  where: PlayBannerWhereUniqueInput;
};

export type PlayBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: PlayBannerCreateInput;
  /** Update document if it exists */
  update: PlayBannerUpdateInput;
};

export type PlayBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PlayBannerUpsertInput;
  /** Unique document search */
  where: PlayBannerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PlayBannerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type PlayBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlayBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlayBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlayBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  bannerBody?: InputMaybe<PhraseWhereInput>;
  bannerHeader?: InputMaybe<PhraseWhereInput>;
  bannerImage?: InputMaybe<AssetWhereInput>;
  bannerImageId?: InputMaybe<PlayBannerImage>;
  /** All values that are contained in given list. */
  bannerImageId_in?: InputMaybe<Array<InputMaybe<PlayBannerImage>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerImageId_not?: InputMaybe<PlayBannerImage>;
  /** All values that are not contained in given list. */
  bannerImageId_not_in?: InputMaybe<Array<InputMaybe<PlayBannerImage>>>;
  bannerModalImageId?: InputMaybe<PlayBannerModalImage>;
  /** All values that are contained in given list. */
  bannerModalImageId_in?: InputMaybe<Array<InputMaybe<PlayBannerModalImage>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerModalImageId_not?: InputMaybe<PlayBannerModalImage>;
  /** All values that are not contained in given list. */
  bannerModalImageId_not_in?: InputMaybe<Array<InputMaybe<PlayBannerModalImage>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PlayBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<PlayBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<PlayBannerWhereStageInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  intercomButtonEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  intercomButtonEnabled_not?: InputMaybe<Scalars['Boolean']>;
  modalBody?: InputMaybe<PhraseWhereInput>;
  modalCtaBtnClickType?: InputMaybe<CtaButtonClickType>;
  /** All values that are contained in given list. */
  modalCtaBtnClickType_in?: InputMaybe<Array<InputMaybe<CtaButtonClickType>>>;
  /** Any other value that exists and is not equal to the given value. */
  modalCtaBtnClickType_not?: InputMaybe<CtaButtonClickType>;
  /** All values that are not contained in given list. */
  modalCtaBtnClickType_not_in?: InputMaybe<Array<InputMaybe<CtaButtonClickType>>>;
  modalCtaBtnLink?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  modalCtaBtnLink_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  modalCtaBtnLink_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  modalCtaBtnLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  modalCtaBtnLink_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  modalCtaBtnLink_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  modalCtaBtnLink_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  modalCtaBtnLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  modalCtaBtnLink_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  modalCtaBtnLink_starts_with?: InputMaybe<Scalars['String']>;
  modalCtaBtnText?: InputMaybe<PhraseWhereInput>;
  modalCtaBtnType?: InputMaybe<ButtonTypes>;
  /** All values that are contained in given list. */
  modalCtaBtnType_in?: InputMaybe<Array<InputMaybe<ButtonTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  modalCtaBtnType_not?: InputMaybe<ButtonTypes>;
  /** All values that are not contained in given list. */
  modalCtaBtnType_not_in?: InputMaybe<Array<InputMaybe<ButtonTypes>>>;
  modalHeader?: InputMaybe<PhraseWhereInput>;
  modalImage?: InputMaybe<AssetWhereInput>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  systemId?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  systemId_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  systemId_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  systemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  systemId_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  systemId_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  systemId_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  systemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  systemId_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  systemId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PlayBannerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlayBannerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlayBannerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlayBannerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PlayBannerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PlayBanner record uniquely */
export type PlayBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['String']>;
};

/** Indicates whether this content relates to Head to Head or Connect */
export enum Product {
  CONNECT = 'CONNECT',
  H2H = 'H2H'
}

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single admin */
  admin?: Maybe<Admin>;
  /** Retrieve document version */
  adminVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple admins */
  admins: Array<Admin>;
  /** Retrieve multiple admins using the Relay connection interface */
  adminsConnection: AdminConnection;
  /** Retrieve a single apexCharacterIssue */
  apexCharacterIssue?: Maybe<ApexCharacterIssue>;
  /** Retrieve document version */
  apexCharacterIssueVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple apexCharacterIssues */
  apexCharacterIssues: Array<ApexCharacterIssue>;
  /** Retrieve multiple apexCharacterIssues using the Relay connection interface */
  apexCharacterIssuesConnection: ApexCharacterIssueConnection;
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /** Retrieve multiple betCategories */
  betCategories: Array<BetCategory>;
  /** Retrieve multiple betCategories using the Relay connection interface */
  betCategoriesConnection: BetCategoryConnection;
  /** Retrieve a single betCategory */
  betCategory?: Maybe<BetCategory>;
  /** Retrieve document version */
  betCategoryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single betDenominationRestriction */
  betDenominationRestriction?: Maybe<BetDenominationRestriction>;
  /** Retrieve document version */
  betDenominationRestrictionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple betDenominationRestrictions */
  betDenominationRestrictions: Array<BetDenominationRestriction>;
  /** Retrieve multiple betDenominationRestrictions using the Relay connection interface */
  betDenominationRestrictionsConnection: BetDenominationRestrictionConnection;
  /** Retrieve a single betLine */
  betLine?: Maybe<BetLine>;
  /** Retrieve a single betLineRule */
  betLineRule?: Maybe<BetLineRule>;
  /** Retrieve document version */
  betLineRuleVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple betLineRules */
  betLineRules: Array<BetLineRule>;
  /** Retrieve multiple betLineRules using the Relay connection interface */
  betLineRulesConnection: BetLineRuleConnection;
  /** Retrieve document version */
  betLineVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple betLines */
  betLines: Array<BetLine>;
  /** Retrieve multiple betLines using the Relay connection interface */
  betLinesConnection: BetLineConnection;
  /** Retrieve a single betRestriction */
  betRestriction?: Maybe<BetRestriction>;
  /** Retrieve document version */
  betRestrictionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple betRestrictions */
  betRestrictions: Array<BetRestriction>;
  /** Retrieve multiple betRestrictions using the Relay connection interface */
  betRestrictionsConnection: BetRestrictionConnection;
  /** Retrieve a single betValue */
  betValue?: Maybe<BetValue>;
  /** Retrieve document version */
  betValueVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple betValues */
  betValues: Array<BetValue>;
  /** Retrieve multiple betValues using the Relay connection interface */
  betValuesConnection: BetValueConnection;
  /** Retrieve a single commonContent */
  commonContent?: Maybe<CommonContent>;
  /** Retrieve document version */
  commonContentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple commonContents */
  commonContents: Array<CommonContent>;
  /** Retrieve multiple commonContents using the Relay connection interface */
  commonContentsConnection: CommonContentConnection;
  /** Retrieve a single defaultGameState */
  defaultGameState?: Maybe<DefaultGameState>;
  /** Retrieve document version */
  defaultGameStateVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple defaultGameStates */
  defaultGameStates: Array<DefaultGameState>;
  /** Retrieve multiple defaultGameStates using the Relay connection interface */
  defaultGameStatesConnection: DefaultGameStateConnection;
  /** Retrieve a single defaultPayoutBand */
  defaultPayoutBand?: Maybe<DefaultPayoutBand>;
  /** Retrieve document version */
  defaultPayoutBandVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple defaultPayoutBands */
  defaultPayoutBands: Array<DefaultPayoutBand>;
  /** Retrieve multiple defaultPayoutBands using the Relay connection interface */
  defaultPayoutBandsConnection: DefaultPayoutBandConnection;
  /** Retrieve a single demoModel */
  demoModel?: Maybe<DemoModel>;
  /** Retrieve document version */
  demoModelVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple demoModels */
  demoModels: Array<DemoModel>;
  /** Retrieve multiple demoModels using the Relay connection interface */
  demoModelsConnection: DemoModelConnection;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  /** Retrieve a single fAQ */
  fAQ?: Maybe<Faq>;
  /** Retrieve document version */
  fAQVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple fAQs */
  fAQs: Array<Faq>;
  /** Retrieve multiple fAQs using the Relay connection interface */
  fAQsConnection: FaqConnection;
  /** Retrieve multiple faqCategories */
  faqCategories: Array<FaqCategoryModel>;
  /** Retrieve multiple faqCategories using the Relay connection interface */
  faqCategoriesConnection: FaqCategoryModelConnection;
  /** Retrieve a single faqCategoryModel */
  faqCategoryModel?: Maybe<FaqCategoryModel>;
  /** Retrieve document version */
  faqCategoryModelVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single featureFlag */
  featureFlag?: Maybe<FeatureFlag>;
  /** Retrieve document version */
  featureFlagVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple featureFlags */
  featureFlags: Array<FeatureFlag>;
  /** Retrieve multiple featureFlags using the Relay connection interface */
  featureFlagsConnection: FeatureFlagConnection;
  /** Retrieve a single game */
  game?: Maybe<Game>;
  /** Retrieve a single gameMode */
  gameMode?: Maybe<GameMode>;
  /** Retrieve a single gameModeCallout */
  gameModeCallout?: Maybe<GameModeCallout>;
  /** Retrieve document version */
  gameModeCalloutVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple gameModeCallouts */
  gameModeCallouts: Array<GameModeCallout>;
  /** Retrieve multiple gameModeCallouts using the Relay connection interface */
  gameModeCalloutsConnection: GameModeCalloutConnection;
  /** Retrieve document version */
  gameModeVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple gameModes */
  gameModes: Array<GameMode>;
  /** Retrieve multiple gameModes using the Relay connection interface */
  gameModesConnection: GameModeConnection;
  /** Retrieve a single gameSeries */
  gameSeries?: Maybe<GameSeries>;
  /** Retrieve document version */
  gameSeriesVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple gameSerieses */
  gameSerieses: Array<GameSeries>;
  /** Retrieve multiple gameSerieses using the Relay connection interface */
  gameSeriesesConnection: GameSeriesConnection;
  /** Retrieve document version */
  gameVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple games */
  games: Array<Game>;
  /** Retrieve multiple games using the Relay connection interface */
  gamesConnection: GameConnection;
  /** Retrieve a single matchIssue */
  matchIssue?: Maybe<MatchIssue>;
  /** Retrieve document version */
  matchIssueVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple matchIssues */
  matchIssues: Array<MatchIssue>;
  /** Retrieve multiple matchIssues using the Relay connection interface */
  matchIssuesConnection: MatchIssueConnection;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Retrieve a single onboardingQuestion */
  onboardingQuestion?: Maybe<OnboardingQuestion>;
  /** Retrieve document version */
  onboardingQuestionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple onboardingQuestions */
  onboardingQuestions: Array<OnboardingQuestion>;
  /** Retrieve multiple onboardingQuestions using the Relay connection interface */
  onboardingQuestionsConnection: OnboardingQuestionConnection;
  /** Retrieve a single partnerAd */
  partnerAd?: Maybe<PartnerAd>;
  /** Retrieve document version */
  partnerAdVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple partnerAds */
  partnerAds: Array<PartnerAd>;
  /** Retrieve multiple partnerAds using the Relay connection interface */
  partnerAdsConnection: PartnerAdConnection;
  /** Retrieve a single phrase */
  phrase?: Maybe<Phrase>;
  /** Retrieve document version */
  phraseVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple phrases */
  phrases: Array<Phrase>;
  /** Retrieve multiple phrases using the Relay connection interface */
  phrasesConnection: PhraseConnection;
  /** Retrieve a single platform */
  platform?: Maybe<Platform>;
  /** Retrieve document version */
  platformVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple platforms */
  platforms: Array<Platform>;
  /** Retrieve multiple platforms using the Relay connection interface */
  platformsConnection: PlatformConnection;
  /** Retrieve a single playBanner */
  playBanner?: Maybe<PlayBanner>;
  /** Retrieve document version */
  playBannerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple playBanners */
  playBanners: Array<PlayBanner>;
  /** Retrieve multiple playBanners using the Relay connection interface */
  playBannersConnection: PlayBannerConnection;
  /** Retrieve a single regexPattern */
  regexPattern?: Maybe<RegexPattern>;
  /** Retrieve document version */
  regexPatternVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple regexPatterns */
  regexPatterns: Array<RegexPattern>;
  /** Retrieve multiple regexPatterns using the Relay connection interface */
  regexPatternsConnection: RegexPatternConnection;
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  /** Retrieve a single termsandPrivacy */
  termsandPrivacy?: Maybe<TermsandPrivacy>;
  /** Retrieve document version */
  termsandPrivacyVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple termsandPrivacys */
  termsandPrivacys: Array<TermsandPrivacy>;
  /** Retrieve multiple termsandPrivacys using the Relay connection interface */
  termsandPrivacysConnection: TermsandPrivacyConnection;
  /** Retrieve a single twitchExplainer */
  twitchExplainer?: Maybe<TwitchExplainer>;
  /** Retrieve document version */
  twitchExplainerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple twitchExplainers */
  twitchExplainers: Array<TwitchExplainer>;
  /** Retrieve multiple twitchExplainers using the Relay connection interface */
  twitchExplainersConnection: TwitchExplainerConnection;
  /** Retrieve a single user */
  user?: Maybe<User>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
};


export type QueryAdminArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AdminWhereUniqueInput;
};


export type QueryAdminVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAdminsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AdminOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AdminWhereInput>;
};


export type QueryAdminsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AdminOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AdminWhereInput>;
};


export type QueryApexCharacterIssueArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ApexCharacterIssueWhereUniqueInput;
};


export type QueryApexCharacterIssueVersionArgs = {
  where: VersionWhereInput;
};


export type QueryApexCharacterIssuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ApexCharacterIssueOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ApexCharacterIssueWhereInput>;
};


export type QueryApexCharacterIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ApexCharacterIssueOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ApexCharacterIssueWhereInput>;
};


export type QueryAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};


export type QueryAssetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryBetCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetCategoryWhereInput>;
};


export type QueryBetCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetCategoryWhereInput>;
};


export type QueryBetCategoryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BetCategoryWhereUniqueInput;
};


export type QueryBetCategoryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBetDenominationRestrictionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BetDenominationRestrictionWhereUniqueInput;
};


export type QueryBetDenominationRestrictionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBetDenominationRestrictionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetDenominationRestrictionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetDenominationRestrictionWhereInput>;
};


export type QueryBetDenominationRestrictionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetDenominationRestrictionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetDenominationRestrictionWhereInput>;
};


export type QueryBetLineArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BetLineWhereUniqueInput;
};


export type QueryBetLineRuleArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BetLineRuleWhereUniqueInput;
};


export type QueryBetLineRuleVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBetLineRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetLineRuleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetLineRuleWhereInput>;
};


export type QueryBetLineRulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetLineRuleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetLineRuleWhereInput>;
};


export type QueryBetLineVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBetLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetLineOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetLineWhereInput>;
};


export type QueryBetLinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetLineOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetLineWhereInput>;
};


export type QueryBetRestrictionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BetRestrictionWhereUniqueInput;
};


export type QueryBetRestrictionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBetRestrictionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetRestrictionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetRestrictionWhereInput>;
};


export type QueryBetRestrictionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetRestrictionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetRestrictionWhereInput>;
};


export type QueryBetValueArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BetValueWhereUniqueInput;
};


export type QueryBetValueVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBetValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetValueOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetValueWhereInput>;
};


export type QueryBetValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BetValueOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<BetValueWhereInput>;
};


export type QueryCommonContentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CommonContentWhereUniqueInput;
};


export type QueryCommonContentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCommonContentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CommonContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<CommonContentWhereInput>;
};


export type QueryCommonContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CommonContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<CommonContentWhereInput>;
};


export type QueryDefaultGameStateArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DefaultGameStateWhereUniqueInput;
};


export type QueryDefaultGameStateVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDefaultGameStatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DefaultGameStateOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<DefaultGameStateWhereInput>;
};


export type QueryDefaultGameStatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DefaultGameStateOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<DefaultGameStateWhereInput>;
};


export type QueryDefaultPayoutBandArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DefaultPayoutBandWhereUniqueInput;
};


export type QueryDefaultPayoutBandVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDefaultPayoutBandsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DefaultPayoutBandOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<DefaultPayoutBandWhereInput>;
};


export type QueryDefaultPayoutBandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DefaultPayoutBandOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<DefaultPayoutBandWhereInput>;
};


export type QueryDemoModelArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DemoModelWhereUniqueInput;
};


export type QueryDemoModelVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDemoModelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DemoModelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<DemoModelWhereInput>;
};


export type QueryDemoModelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DemoModelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<DemoModelWhereInput>;
};


export type QueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};


export type QueryFAqArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FaqWhereUniqueInput;
};


export type QueryFAqVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFaQsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FaqWhereInput>;
};


export type QueryFaQsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FaqWhereInput>;
};


export type QueryFaqCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqCategoryModelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FaqCategoryModelWhereInput>;
};


export type QueryFaqCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqCategoryModelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FaqCategoryModelWhereInput>;
};


export type QueryFaqCategoryModelArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FaqCategoryModelWhereUniqueInput;
};


export type QueryFaqCategoryModelVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFeatureFlagArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FeatureFlagWhereUniqueInput;
};


export type QueryFeatureFlagVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFeatureFlagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FeatureFlagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FeatureFlagWhereInput>;
};


export type QueryFeatureFlagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FeatureFlagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FeatureFlagWhereInput>;
};


export type QueryGameArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GameWhereUniqueInput;
};


export type QueryGameModeArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GameModeWhereUniqueInput;
};


export type QueryGameModeCalloutArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GameModeCalloutWhereUniqueInput;
};


export type QueryGameModeCalloutVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGameModeCalloutsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GameModeCalloutOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<GameModeCalloutWhereInput>;
};


export type QueryGameModeCalloutsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GameModeCalloutOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<GameModeCalloutWhereInput>;
};


export type QueryGameModeVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGameModesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GameModeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<GameModeWhereInput>;
};


export type QueryGameModesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GameModeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<GameModeWhereInput>;
};


export type QueryGameSeriesArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GameSeriesWhereUniqueInput;
};


export type QueryGameSeriesVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGameSeriesesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GameSeriesOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<GameSeriesWhereInput>;
};


export type QueryGameSeriesesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GameSeriesOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<GameSeriesWhereInput>;
};


export type QueryGameVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGamesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GameOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<GameWhereInput>;
};


export type QueryGamesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GameOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<GameWhereInput>;
};


export type QueryMatchIssueArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MatchIssueWhereUniqueInput;
};


export type QueryMatchIssueVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMatchIssuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MatchIssueOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<MatchIssueWhereInput>;
};


export type QueryMatchIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MatchIssueOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<MatchIssueWhereInput>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
  locales?: Array<Locale>;
  stage?: Stage;
};


export type QueryOnboardingQuestionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: OnboardingQuestionWhereUniqueInput;
};


export type QueryOnboardingQuestionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryOnboardingQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<OnboardingQuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<OnboardingQuestionWhereInput>;
};


export type QueryOnboardingQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<OnboardingQuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<OnboardingQuestionWhereInput>;
};


export type QueryPartnerAdArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PartnerAdWhereUniqueInput;
};


export type QueryPartnerAdVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPartnerAdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PartnerAdOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PartnerAdWhereInput>;
};


export type QueryPartnerAdsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PartnerAdOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PartnerAdWhereInput>;
};


export type QueryPhraseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PhraseWhereUniqueInput;
};


export type QueryPhraseVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPhrasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PhraseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PhraseWhereInput>;
};


export type QueryPhrasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PhraseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PhraseWhereInput>;
};


export type QueryPlatformArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PlatformWhereUniqueInput;
};


export type QueryPlatformVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPlatformsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PlatformOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PlatformWhereInput>;
};


export type QueryPlatformsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PlatformOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PlatformWhereInput>;
};


export type QueryPlayBannerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PlayBannerWhereUniqueInput;
};


export type QueryPlayBannerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPlayBannersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PlayBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PlayBannerWhereInput>;
};


export type QueryPlayBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PlayBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PlayBannerWhereInput>;
};


export type QueryRegexPatternArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RegexPatternWhereUniqueInput;
};


export type QueryRegexPatternVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRegexPatternsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RegexPatternOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<RegexPatternWhereInput>;
};


export type QueryRegexPatternsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RegexPatternOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<RegexPatternWhereInput>;
};


export type QueryScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};


export type QueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};


export type QueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryTermsandPrivacyArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TermsandPrivacyWhereUniqueInput;
};


export type QueryTermsandPrivacyVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTermsandPrivacysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TermsandPrivacyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<TermsandPrivacyWhereInput>;
};


export type QueryTermsandPrivacysConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TermsandPrivacyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<TermsandPrivacyWhereInput>;
};


export type QueryTwitchExplainerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TwitchExplainerWhereUniqueInput;
};


export type QueryTwitchExplainerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTwitchExplainersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TwitchExplainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<TwitchExplainerWhereInput>;
};


export type QueryTwitchExplainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TwitchExplainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<TwitchExplainerWhereInput>;
};


export type QueryUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA';
  a: Scalars['RGBATransparency'];
  b: Scalars['RGBAHue'];
  g: Scalars['RGBAHue'];
  r: Scalars['RGBAHue'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  a: Scalars['RGBATransparency'];
  b: Scalars['RGBAHue'];
  g: Scalars['RGBAHue'];
  r: Scalars['RGBAHue'];
};

export type RegexPattern = Entity & Node & {
  __typename?: 'RegexPattern';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<RegexPattern>;
  /** Error message to display when the validation is not met for this regex pattern */
  errorPhrase?: Maybe<Phrase>;
  /** List of RegexPattern versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  platforms: Array<Platform>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  regex: Scalars['String'];
  /** Describes the type of pattern this regex follows */
  regexType?: Maybe<RegexType>;
  /** Short name for the rule to describe what it does (e.g. "Min length 2 chars") */
  ruleName: Scalars['String'];
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type RegexPatternCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RegexPatternDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type RegexPatternErrorPhraseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RegexPatternHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type RegexPatternPlatformsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PlatformOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlatformWhereInput>;
};


export type RegexPatternPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RegexPatternScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RegexPatternUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RegexPatternConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RegexPatternWhereUniqueInput;
};

/** A connection to a list of items. */
export type RegexPatternConnection = {
  __typename?: 'RegexPatternConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RegexPatternEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RegexPatternCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  errorPhrase?: InputMaybe<PhraseCreateOneInlineInput>;
  platforms?: InputMaybe<PlatformCreateManyInlineInput>;
  regex: Scalars['String'];
  regexType?: InputMaybe<RegexType>;
  ruleName: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RegexPatternCreateManyInlineInput = {
  /** Connect multiple existing RegexPattern documents */
  connect?: InputMaybe<Array<RegexPatternWhereUniqueInput>>;
  /** Create and connect multiple existing RegexPattern documents */
  create?: InputMaybe<Array<RegexPatternCreateInput>>;
};

export type RegexPatternCreateOneInlineInput = {
  /** Connect one existing RegexPattern document */
  connect?: InputMaybe<RegexPatternWhereUniqueInput>;
  /** Create and connect one RegexPattern document */
  create?: InputMaybe<RegexPatternCreateInput>;
};

/** An edge in a connection. */
export type RegexPatternEdge = {
  __typename?: 'RegexPatternEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: RegexPattern;
};

/** Identifies documents */
export type RegexPatternManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RegexPatternWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RegexPatternWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RegexPatternWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RegexPatternWhereStageInput>;
  documentInStages_none?: InputMaybe<RegexPatternWhereStageInput>;
  documentInStages_some?: InputMaybe<RegexPatternWhereStageInput>;
  errorPhrase?: InputMaybe<PhraseWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  platforms_every?: InputMaybe<PlatformWhereInput>;
  platforms_none?: InputMaybe<PlatformWhereInput>;
  platforms_some?: InputMaybe<PlatformWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  regex?: InputMaybe<Scalars['String']>;
  regexType?: InputMaybe<RegexType>;
  /** All values that are contained in given list. */
  regexType_in?: InputMaybe<Array<InputMaybe<RegexType>>>;
  /** Any other value that exists and is not equal to the given value. */
  regexType_not?: InputMaybe<RegexType>;
  /** All values that are not contained in given list. */
  regexType_not_in?: InputMaybe<Array<InputMaybe<RegexType>>>;
  /** All values containing the given string. */
  regex_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  regex_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  regex_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  regex_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  regex_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  regex_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  regex_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  regex_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  regex_starts_with?: InputMaybe<Scalars['String']>;
  ruleName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  ruleName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  ruleName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  ruleName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ruleName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  ruleName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  ruleName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  ruleName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  ruleName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  ruleName_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RegexPatternOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  REGEXTYPE_ASC = 'regexType_ASC',
  REGEXTYPE_DESC = 'regexType_DESC',
  REGEX_ASC = 'regex_ASC',
  REGEX_DESC = 'regex_DESC',
  RULENAME_ASC = 'ruleName_ASC',
  RULENAME_DESC = 'ruleName_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type RegexPatternUpdateInput = {
  errorPhrase?: InputMaybe<PhraseUpdateOneInlineInput>;
  platforms?: InputMaybe<PlatformUpdateManyInlineInput>;
  regex?: InputMaybe<Scalars['String']>;
  regexType?: InputMaybe<RegexType>;
  ruleName?: InputMaybe<Scalars['String']>;
};

export type RegexPatternUpdateManyInlineInput = {
  /** Connect multiple existing RegexPattern documents */
  connect?: InputMaybe<Array<RegexPatternConnectInput>>;
  /** Create and connect multiple RegexPattern documents */
  create?: InputMaybe<Array<RegexPatternCreateInput>>;
  /** Delete multiple RegexPattern documents */
  delete?: InputMaybe<Array<RegexPatternWhereUniqueInput>>;
  /** Disconnect multiple RegexPattern documents */
  disconnect?: InputMaybe<Array<RegexPatternWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RegexPattern documents */
  set?: InputMaybe<Array<RegexPatternWhereUniqueInput>>;
  /** Update multiple RegexPattern documents */
  update?: InputMaybe<Array<RegexPatternUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RegexPattern documents */
  upsert?: InputMaybe<Array<RegexPatternUpsertWithNestedWhereUniqueInput>>;
};

export type RegexPatternUpdateManyInput = {
  regex?: InputMaybe<Scalars['String']>;
  regexType?: InputMaybe<RegexType>;
  ruleName?: InputMaybe<Scalars['String']>;
};

export type RegexPatternUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RegexPatternUpdateManyInput;
  /** Document search */
  where: RegexPatternWhereInput;
};

export type RegexPatternUpdateOneInlineInput = {
  /** Connect existing RegexPattern document */
  connect?: InputMaybe<RegexPatternWhereUniqueInput>;
  /** Create and connect one RegexPattern document */
  create?: InputMaybe<RegexPatternCreateInput>;
  /** Delete currently connected RegexPattern document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected RegexPattern document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single RegexPattern document */
  update?: InputMaybe<RegexPatternUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RegexPattern document */
  upsert?: InputMaybe<RegexPatternUpsertWithNestedWhereUniqueInput>;
};

export type RegexPatternUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RegexPatternUpdateInput;
  /** Unique document search */
  where: RegexPatternWhereUniqueInput;
};

export type RegexPatternUpsertInput = {
  /** Create document if it didn't exist */
  create: RegexPatternCreateInput;
  /** Update document if it exists */
  update: RegexPatternUpdateInput;
};

export type RegexPatternUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RegexPatternUpsertInput;
  /** Unique document search */
  where: RegexPatternWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RegexPatternWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type RegexPatternWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RegexPatternWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RegexPatternWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RegexPatternWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RegexPatternWhereStageInput>;
  documentInStages_none?: InputMaybe<RegexPatternWhereStageInput>;
  documentInStages_some?: InputMaybe<RegexPatternWhereStageInput>;
  errorPhrase?: InputMaybe<PhraseWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  platforms_every?: InputMaybe<PlatformWhereInput>;
  platforms_none?: InputMaybe<PlatformWhereInput>;
  platforms_some?: InputMaybe<PlatformWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  regex?: InputMaybe<Scalars['String']>;
  regexType?: InputMaybe<RegexType>;
  /** All values that are contained in given list. */
  regexType_in?: InputMaybe<Array<InputMaybe<RegexType>>>;
  /** Any other value that exists and is not equal to the given value. */
  regexType_not?: InputMaybe<RegexType>;
  /** All values that are not contained in given list. */
  regexType_not_in?: InputMaybe<Array<InputMaybe<RegexType>>>;
  /** All values containing the given string. */
  regex_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  regex_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  regex_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  regex_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  regex_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  regex_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  regex_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  regex_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  regex_starts_with?: InputMaybe<Scalars['String']>;
  ruleName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  ruleName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  ruleName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  ruleName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ruleName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  ruleName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  ruleName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  ruleName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  ruleName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  ruleName_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RegexPatternWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RegexPatternWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RegexPatternWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RegexPatternWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RegexPatternWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References RegexPattern record uniquely */
export type RegexPatternWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Used to describe the type of regex pattern */
export enum RegexType {
  CUSTOMRULE = 'customRule',
  DISALLOWED = 'disallowed',
  MAX = 'max',
  MIN = 'min'
}

export type Restriction = Entity & {
  __typename?: 'Restriction';
  /** The unique identifier */
  id: Scalars['ID'];
  /** What does the restriction need to check */
  requiredConditionType?: Maybe<Scalars['String']>;
  /** What is the value that must be met for the condition */
  requiredConditionValue?: Maybe<Scalars['String']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RestrictionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RestrictionWhereUniqueInput;
};

/** A connection to a list of items. */
export type RestrictionConnection = {
  __typename?: 'RestrictionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RestrictionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RestrictionCreateInput = {
  requiredConditionType?: InputMaybe<Scalars['String']>;
  requiredConditionValue?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RestrictionCreateManyInlineInput = {
  /** Create and connect multiple existing Restriction documents */
  create?: InputMaybe<Array<RestrictionCreateInput>>;
};

export type RestrictionCreateOneInlineInput = {
  /** Create and connect one Restriction document */
  create?: InputMaybe<RestrictionCreateInput>;
};

export type RestrictionCreateWithPositionInput = {
  /** Document to create */
  data: RestrictionCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type RestrictionEdge = {
  __typename?: 'RestrictionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Restriction;
};

/** Identifies documents */
export type RestrictionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RestrictionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RestrictionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RestrictionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  requiredConditionType?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  requiredConditionType_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  requiredConditionType_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  requiredConditionType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredConditionType_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  requiredConditionType_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  requiredConditionType_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  requiredConditionType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  requiredConditionType_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  requiredConditionType_starts_with?: InputMaybe<Scalars['String']>;
  requiredConditionValue?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  requiredConditionValue_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  requiredConditionValue_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  requiredConditionValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredConditionValue_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  requiredConditionValue_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  requiredConditionValue_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  requiredConditionValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  requiredConditionValue_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  requiredConditionValue_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export enum RestrictionOrderByInput {
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  REQUIREDCONDITIONTYPE_ASC = 'requiredConditionType_ASC',
  REQUIREDCONDITIONTYPE_DESC = 'requiredConditionType_DESC',
  REQUIREDCONDITIONVALUE_ASC = 'requiredConditionValue_ASC',
  REQUIREDCONDITIONVALUE_DESC = 'requiredConditionValue_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type RestrictionParent = BetRestriction;

export type RestrictionParentConnectInput = {
  BetRestriction?: InputMaybe<BetRestrictionConnectInput>;
};

export type RestrictionParentCreateInput = {
  BetRestriction?: InputMaybe<BetRestrictionCreateInput>;
};

export type RestrictionParentCreateManyInlineInput = {
  /** Connect multiple existing RestrictionParent documents */
  connect?: InputMaybe<Array<RestrictionParentWhereUniqueInput>>;
  /** Create and connect multiple existing RestrictionParent documents */
  create?: InputMaybe<Array<RestrictionParentCreateInput>>;
};

export type RestrictionParentCreateOneInlineInput = {
  /** Connect one existing RestrictionParent document */
  connect?: InputMaybe<RestrictionParentWhereUniqueInput>;
  /** Create and connect one RestrictionParent document */
  create?: InputMaybe<RestrictionParentCreateInput>;
};

export type RestrictionParentUpdateInput = {
  BetRestriction?: InputMaybe<BetRestrictionUpdateInput>;
};

export type RestrictionParentUpdateManyInlineInput = {
  /** Connect multiple existing RestrictionParent documents */
  connect?: InputMaybe<Array<RestrictionParentConnectInput>>;
  /** Create and connect multiple RestrictionParent documents */
  create?: InputMaybe<Array<RestrictionParentCreateInput>>;
  /** Delete multiple RestrictionParent documents */
  delete?: InputMaybe<Array<RestrictionParentWhereUniqueInput>>;
  /** Disconnect multiple RestrictionParent documents */
  disconnect?: InputMaybe<Array<RestrictionParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RestrictionParent documents */
  set?: InputMaybe<Array<RestrictionParentWhereUniqueInput>>;
  /** Update multiple RestrictionParent documents */
  update?: InputMaybe<Array<RestrictionParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RestrictionParent documents */
  upsert?: InputMaybe<Array<RestrictionParentUpsertWithNestedWhereUniqueInput>>;
};

export type RestrictionParentUpdateManyWithNestedWhereInput = {
  BetRestriction?: InputMaybe<BetRestrictionUpdateManyWithNestedWhereInput>;
};

export type RestrictionParentUpdateOneInlineInput = {
  /** Connect existing RestrictionParent document */
  connect?: InputMaybe<RestrictionParentWhereUniqueInput>;
  /** Create and connect one RestrictionParent document */
  create?: InputMaybe<RestrictionParentCreateInput>;
  /** Delete currently connected RestrictionParent document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected RestrictionParent document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single RestrictionParent document */
  update?: InputMaybe<RestrictionParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RestrictionParent document */
  upsert?: InputMaybe<RestrictionParentUpsertWithNestedWhereUniqueInput>;
};

export type RestrictionParentUpdateWithNestedWhereUniqueInput = {
  BetRestriction?: InputMaybe<BetRestrictionUpdateWithNestedWhereUniqueInput>;
};

export type RestrictionParentUpsertWithNestedWhereUniqueInput = {
  BetRestriction?: InputMaybe<BetRestrictionUpsertWithNestedWhereUniqueInput>;
};

export type RestrictionParentWhereInput = {
  BetRestriction?: InputMaybe<BetRestrictionWhereInput>;
};

export type RestrictionParentWhereUniqueInput = {
  BetRestriction?: InputMaybe<BetRestrictionWhereUniqueInput>;
};

export type RestrictionUpdateInput = {
  requiredConditionType?: InputMaybe<Scalars['String']>;
  requiredConditionValue?: InputMaybe<Scalars['String']>;
};

export type RestrictionUpdateManyInlineInput = {
  /** Create and connect multiple Restriction component instances */
  create?: InputMaybe<Array<RestrictionCreateWithPositionInput>>;
  /** Delete multiple Restriction documents */
  delete?: InputMaybe<Array<RestrictionWhereUniqueInput>>;
  /** Update multiple Restriction component instances */
  update?: InputMaybe<Array<RestrictionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Restriction component instances */
  upsert?: InputMaybe<Array<RestrictionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type RestrictionUpdateManyInput = {
  requiredConditionType?: InputMaybe<Scalars['String']>;
  requiredConditionValue?: InputMaybe<Scalars['String']>;
};

export type RestrictionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RestrictionUpdateManyInput;
  /** Document search */
  where: RestrictionWhereInput;
};

export type RestrictionUpdateOneInlineInput = {
  /** Create and connect one Restriction document */
  create?: InputMaybe<RestrictionCreateInput>;
  /** Delete currently connected Restriction document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Update single Restriction document */
  update?: InputMaybe<RestrictionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Restriction document */
  upsert?: InputMaybe<RestrictionUpsertWithNestedWhereUniqueInput>;
};

export type RestrictionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<RestrictionUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: RestrictionWhereUniqueInput;
};

export type RestrictionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RestrictionUpdateInput;
  /** Unique document search */
  where: RestrictionWhereUniqueInput;
};

export type RestrictionUpsertInput = {
  /** Create document if it didn't exist */
  create: RestrictionCreateInput;
  /** Update document if it exists */
  update: RestrictionUpdateInput;
};

export type RestrictionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<RestrictionUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: RestrictionWhereUniqueInput;
};

export type RestrictionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RestrictionUpsertInput;
  /** Unique document search */
  where: RestrictionWhereUniqueInput;
};

/** Identifies documents */
export type RestrictionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RestrictionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RestrictionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RestrictionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  requiredConditionType?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  requiredConditionType_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  requiredConditionType_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  requiredConditionType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredConditionType_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  requiredConditionType_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  requiredConditionType_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  requiredConditionType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  requiredConditionType_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  requiredConditionType_starts_with?: InputMaybe<Scalars['String']>;
  requiredConditionValue?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  requiredConditionValue_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  requiredConditionValue_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  requiredConditionValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredConditionValue_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  requiredConditionValue_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  requiredConditionValue_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  requiredConditionValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  requiredConditionValue_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  requiredConditionValue_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

/** References Restriction record uniquely */
export type RestrictionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity & Node & {
  __typename?: 'ScheduledOperation';
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Operation description */
  description?: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledOperation>;
  /** Operation error message */
  errorMessage?: Maybe<Scalars['String']>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json'];
  /** The release this operation is scheduled for */
  release?: Maybe<ScheduledRelease>;
  /** System stage field */
  stage: Stage;
  /** operation Status */
  status: ScheduledOperationStatus;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument = Admin | ApexCharacterIssue | Asset | BetCategory | BetDenominationRestriction | BetLine | BetLineRule | BetRestriction | BetValue | CommonContent | DefaultGameState | DefaultPayoutBand | DemoModel | Faq | FaqCategoryModel | FeatureFlag | Game | GameMode | GameModeCallout | GameSeries | MatchIssue | OnboardingQuestion | PartnerAd | Phrase | Platform | PlayBanner | RegexPattern | TermsandPrivacy | TwitchExplainer;

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DESCRIPTION_ASC = 'description_ASC',
  DESCRIPTION_DESC = 'description_DESC',
  ERRORMESSAGE_ASC = 'errorMessage_ASC',
  ERRORMESSAGE_DESC = 'errorMessage_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  STATUS_ASC = 'status_ASC',
  STATUS_DESC = 'status_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity & Node & {
  __typename?: 'ScheduledRelease';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Release description */
  description?: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledRelease>;
  /** Release error message */
  errorMessage?: Maybe<Scalars['String']>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean'];
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Release date and time */
  releaseAt?: Maybe<Scalars['DateTime']>;
  /** System stage field */
  stage: Stage;
  /** Release Status */
  status: ScheduledReleaseStatus;
  /** Release Title */
  title?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  isImplicit?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DESCRIPTION_ASC = 'description_ASC',
  DESCRIPTION_DESC = 'description_DESC',
  ERRORMESSAGE_ASC = 'errorMessage_ASC',
  ERRORMESSAGE_DESC = 'errorMessage_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  ISACTIVE_ASC = 'isActive_ASC',
  ISACTIVE_DESC = 'isActive_DESC',
  ISIMPLICIT_ASC = 'isImplicit_ASC',
  ISIMPLICIT_DESC = 'isImplicit_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  RELEASEAT_ASC = 'releaseAt_ASC',
  RELEASEAT_DESC = 'releaseAt_DESC',
  STATUS_ASC = 'status_ASC',
  STATUS_DESC = 'status_DESC',
  TITLE_ASC = 'title_ASC',
  TITLE_DESC = 'title_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput;
  /** Document search */
  where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput;
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  isImplicit?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export enum ScoreNoun {
  GOAL = 'goal',
  POINT = 'point'
}

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  DRAFT = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  PUBLISHED = 'PUBLISHED'
}

export enum SystemDateTimeFieldVariation {
  BASE = 'BASE',
  COMBINED = 'COMBINED',
  LOCALIZATION = 'LOCALIZATION'
}

export type TeamSize = Entity & {
  __typename?: 'TeamSize';
  /** A key for the phrases that provides a localised desicription */
  description: Scalars['String'];
  displayLockedReason?: Maybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  enabled: Scalars['Boolean'];
  /** The unique identifier */
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  lockedReasonBody?: Maybe<Phrase>;
  lockedReasonHead?: Maybe<Phrase>;
  /**
   * How many players can join a team for this game mode in-app?
   *
   * If no value is defined, this defaults to the game mode size. (E.g. 4 players for a Quads game mode in COD.)
   */
  maximumPlTeamSize?: Maybe<Scalars['Int']>;
  size: Scalars['Int'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
};


export type TeamSizeLockedReasonBodyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeamSizeLockedReasonHeadArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TeamSizeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TeamSizeWhereUniqueInput;
};

/** A connection to a list of items. */
export type TeamSizeConnection = {
  __typename?: 'TeamSizeConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TeamSizeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TeamSizeCreateInput = {
  description: Scalars['String'];
  displayLockedReason?: InputMaybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  enabled: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  lockedReasonBody?: InputMaybe<PhraseCreateOneInlineInput>;
  lockedReasonHead?: InputMaybe<PhraseCreateOneInlineInput>;
  maximumPlTeamSize?: InputMaybe<Scalars['Int']>;
  size: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
};

export type TeamSizeCreateManyInlineInput = {
  /** Create and connect multiple existing TeamSize documents */
  create?: InputMaybe<Array<TeamSizeCreateInput>>;
};

export type TeamSizeCreateOneInlineInput = {
  /** Create and connect one TeamSize document */
  create?: InputMaybe<TeamSizeCreateInput>;
};

export type TeamSizeCreateWithPositionInput = {
  /** Document to create */
  data: TeamSizeCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type TeamSizeEdge = {
  __typename?: 'TeamSizeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TeamSize;
};

/** Identifies documents */
export type TeamSizeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeamSizeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeamSizeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeamSizeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  displayLockedReason?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  displayLockedReason_not?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isDefault_not?: InputMaybe<Scalars['Boolean']>;
  lockedReasonBody?: InputMaybe<PhraseWhereInput>;
  lockedReasonHead?: InputMaybe<PhraseWhereInput>;
  maximumPlTeamSize?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  maximumPlTeamSize_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  maximumPlTeamSize_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  maximumPlTeamSize_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  maximumPlTeamSize_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  maximumPlTeamSize_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  maximumPlTeamSize_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  maximumPlTeamSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

export enum TeamSizeOrderByInput {
  DESCRIPTION_ASC = 'description_ASC',
  DESCRIPTION_DESC = 'description_DESC',
  DISPLAYLOCKEDREASON_ASC = 'displayLockedReason_ASC',
  DISPLAYLOCKEDREASON_DESC = 'displayLockedReason_DESC',
  DISPLAYNAME_ASC = 'displayName_ASC',
  DISPLAYNAME_DESC = 'displayName_DESC',
  ENABLED_ASC = 'enabled_ASC',
  ENABLED_DESC = 'enabled_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  ISDEFAULT_ASC = 'isDefault_ASC',
  ISDEFAULT_DESC = 'isDefault_DESC',
  MAXIMUMPLTEAMSIZE_ASC = 'maximumPlTeamSize_ASC',
  MAXIMUMPLTEAMSIZE_DESC = 'maximumPlTeamSize_DESC',
  SIZE_ASC = 'size_ASC',
  SIZE_DESC = 'size_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  VISIBLE_ASC = 'visible_ASC',
  VISIBLE_DESC = 'visible_DESC'
}

export type TeamSizeParent = GameMode;

export type TeamSizeParentConnectInput = {
  GameMode?: InputMaybe<GameModeConnectInput>;
};

export type TeamSizeParentCreateInput = {
  GameMode?: InputMaybe<GameModeCreateInput>;
};

export type TeamSizeParentCreateManyInlineInput = {
  /** Connect multiple existing TeamSizeParent documents */
  connect?: InputMaybe<Array<TeamSizeParentWhereUniqueInput>>;
  /** Create and connect multiple existing TeamSizeParent documents */
  create?: InputMaybe<Array<TeamSizeParentCreateInput>>;
};

export type TeamSizeParentCreateOneInlineInput = {
  /** Connect one existing TeamSizeParent document */
  connect?: InputMaybe<TeamSizeParentWhereUniqueInput>;
  /** Create and connect one TeamSizeParent document */
  create?: InputMaybe<TeamSizeParentCreateInput>;
};

export type TeamSizeParentUpdateInput = {
  GameMode?: InputMaybe<GameModeUpdateInput>;
};

export type TeamSizeParentUpdateManyInlineInput = {
  /** Connect multiple existing TeamSizeParent documents */
  connect?: InputMaybe<Array<TeamSizeParentConnectInput>>;
  /** Create and connect multiple TeamSizeParent documents */
  create?: InputMaybe<Array<TeamSizeParentCreateInput>>;
  /** Delete multiple TeamSizeParent documents */
  delete?: InputMaybe<Array<TeamSizeParentWhereUniqueInput>>;
  /** Disconnect multiple TeamSizeParent documents */
  disconnect?: InputMaybe<Array<TeamSizeParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TeamSizeParent documents */
  set?: InputMaybe<Array<TeamSizeParentWhereUniqueInput>>;
  /** Update multiple TeamSizeParent documents */
  update?: InputMaybe<Array<TeamSizeParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TeamSizeParent documents */
  upsert?: InputMaybe<Array<TeamSizeParentUpsertWithNestedWhereUniqueInput>>;
};

export type TeamSizeParentUpdateManyWithNestedWhereInput = {
  GameMode?: InputMaybe<GameModeUpdateManyWithNestedWhereInput>;
};

export type TeamSizeParentUpdateOneInlineInput = {
  /** Connect existing TeamSizeParent document */
  connect?: InputMaybe<TeamSizeParentWhereUniqueInput>;
  /** Create and connect one TeamSizeParent document */
  create?: InputMaybe<TeamSizeParentCreateInput>;
  /** Delete currently connected TeamSizeParent document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected TeamSizeParent document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single TeamSizeParent document */
  update?: InputMaybe<TeamSizeParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TeamSizeParent document */
  upsert?: InputMaybe<TeamSizeParentUpsertWithNestedWhereUniqueInput>;
};

export type TeamSizeParentUpdateWithNestedWhereUniqueInput = {
  GameMode?: InputMaybe<GameModeUpdateWithNestedWhereUniqueInput>;
};

export type TeamSizeParentUpsertWithNestedWhereUniqueInput = {
  GameMode?: InputMaybe<GameModeUpsertWithNestedWhereUniqueInput>;
};

export type TeamSizeParentWhereInput = {
  GameMode?: InputMaybe<GameModeWhereInput>;
};

export type TeamSizeParentWhereUniqueInput = {
  GameMode?: InputMaybe<GameModeWhereUniqueInput>;
};

export type TeamSizeUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  displayLockedReason?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lockedReasonBody?: InputMaybe<PhraseUpdateOneInlineInput>;
  lockedReasonHead?: InputMaybe<PhraseUpdateOneInlineInput>;
  maximumPlTeamSize?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type TeamSizeUpdateManyInlineInput = {
  /** Create and connect multiple TeamSize component instances */
  create?: InputMaybe<Array<TeamSizeCreateWithPositionInput>>;
  /** Delete multiple TeamSize documents */
  delete?: InputMaybe<Array<TeamSizeWhereUniqueInput>>;
  /** Update multiple TeamSize component instances */
  update?: InputMaybe<Array<TeamSizeUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple TeamSize component instances */
  upsert?: InputMaybe<Array<TeamSizeUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TeamSizeUpdateManyInput = {
  description?: InputMaybe<Scalars['String']>;
  displayLockedReason?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  maximumPlTeamSize?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type TeamSizeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TeamSizeUpdateManyInput;
  /** Document search */
  where: TeamSizeWhereInput;
};

export type TeamSizeUpdateOneInlineInput = {
  /** Create and connect one TeamSize document */
  create?: InputMaybe<TeamSizeCreateInput>;
  /** Delete currently connected TeamSize document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Update single TeamSize document */
  update?: InputMaybe<TeamSizeUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TeamSize document */
  upsert?: InputMaybe<TeamSizeUpsertWithNestedWhereUniqueInput>;
};

export type TeamSizeUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TeamSizeUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TeamSizeWhereUniqueInput;
};

export type TeamSizeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TeamSizeUpdateInput;
  /** Unique document search */
  where: TeamSizeWhereUniqueInput;
};

export type TeamSizeUpsertInput = {
  /** Create document if it didn't exist */
  create: TeamSizeCreateInput;
  /** Update document if it exists */
  update: TeamSizeUpdateInput;
};

export type TeamSizeUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TeamSizeUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TeamSizeWhereUniqueInput;
};

export type TeamSizeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TeamSizeUpsertInput;
  /** Unique document search */
  where: TeamSizeWhereUniqueInput;
};

/** Identifies documents */
export type TeamSizeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeamSizeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeamSizeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeamSizeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  displayLockedReason?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  displayLockedReason_not?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  enabled_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isDefault_not?: InputMaybe<Scalars['Boolean']>;
  lockedReasonBody?: InputMaybe<PhraseWhereInput>;
  lockedReasonHead?: InputMaybe<PhraseWhereInput>;
  maximumPlTeamSize?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  maximumPlTeamSize_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  maximumPlTeamSize_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  maximumPlTeamSize_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  maximumPlTeamSize_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  maximumPlTeamSize_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  maximumPlTeamSize_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  maximumPlTeamSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  visible_not?: InputMaybe<Scalars['Boolean']>;
};

/** References TeamSize record uniquely */
export type TeamSizeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacy = Entity & Node & {
  __typename?: 'TermsandPrivacy';
  /** Page content */
  content: TermsandPrivacyContentRichText;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** What we show to users on the frontend as the title for the long text, if it's different from the internal title. (E.g. Internal title = "Connect App Privacy Policy"; external title = "Players' Lounge Privacy Policy", since users of the app won't see both.) */
  displayTitle: Scalars['String'];
  /** Get the document in other stages */
  documentInStages: Array<TermsandPrivacy>;
  /** List of TermsandPrivacy versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Last time the content had a major update. Can be used to determine if we need to ask the user to renew their consent. */
  lastMajorUpdateTimestamp: Scalars['DateTime'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<TermsandPrivacy>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Internal reference / title for this text. */
  reference: Scalars['String'];
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Slug for URL */
  urlSlug: Scalars['String'];
};


/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacyCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacyCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacyDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacyHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacyLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacyPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacyPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacyScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacyUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Storing terms of service and privacy policy, which have a specific need for storing the time of their last major update. */
export type TermsandPrivacyUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TermsandPrivacyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TermsandPrivacyWhereUniqueInput;
};

/** A connection to a list of items. */
export type TermsandPrivacyConnection = {
  __typename?: 'TermsandPrivacyConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TermsandPrivacyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TermsandPrivacyContentRichText = {
  __typename?: 'TermsandPrivacyContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  json: Scalars['RichTextAST'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST'];
  references: Array<TermsandPrivacyContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};


export type TermsandPrivacyContentRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type TermsandPrivacyContentRichTextEmbeddedTypes = CommonContent | TermsandPrivacy;

export type TermsandPrivacyCreateInput = {
  /** content input for default locale (en) */
  content: Scalars['RichTextAST'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** displayTitle input for default locale (en) */
  displayTitle: Scalars['String'];
  lastMajorUpdateTimestamp: Scalars['DateTime'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TermsandPrivacyCreateLocalizationsInput>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  urlSlug: Scalars['String'];
};

export type TermsandPrivacyCreateLocalizationDataInput = {
  content: Scalars['RichTextAST'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  displayTitle: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TermsandPrivacyCreateLocalizationInput = {
  /** Localization input */
  data: TermsandPrivacyCreateLocalizationDataInput;
  locale: Locale;
};

export type TermsandPrivacyCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TermsandPrivacyCreateLocalizationInput>>;
};

export type TermsandPrivacyCreateManyInlineInput = {
  /** Connect multiple existing TermsandPrivacy documents */
  connect?: InputMaybe<Array<TermsandPrivacyWhereUniqueInput>>;
  /** Create and connect multiple existing TermsandPrivacy documents */
  create?: InputMaybe<Array<TermsandPrivacyCreateInput>>;
};

export type TermsandPrivacyCreateOneInlineInput = {
  /** Connect one existing TermsandPrivacy document */
  connect?: InputMaybe<TermsandPrivacyWhereUniqueInput>;
  /** Create and connect one TermsandPrivacy document */
  create?: InputMaybe<TermsandPrivacyCreateInput>;
};

/** An edge in a connection. */
export type TermsandPrivacyEdge = {
  __typename?: 'TermsandPrivacyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TermsandPrivacy;
};

/** Identifies documents */
export type TermsandPrivacyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TermsandPrivacyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TermsandPrivacyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TermsandPrivacyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TermsandPrivacyWhereStageInput>;
  documentInStages_none?: InputMaybe<TermsandPrivacyWhereStageInput>;
  documentInStages_some?: InputMaybe<TermsandPrivacyWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  lastMajorUpdateTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  lastMajorUpdateTimestamp_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  lastMajorUpdateTimestamp_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  lastMajorUpdateTimestamp_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  lastMajorUpdateTimestamp_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  lastMajorUpdateTimestamp_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  lastMajorUpdateTimestamp_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  lastMajorUpdateTimestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  reference?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  reference_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  reference_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  reference_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  reference_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  reference_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  reference_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  reference_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  reference_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  reference_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  urlSlug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  urlSlug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  urlSlug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  urlSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  urlSlug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  urlSlug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  urlSlug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  urlSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  urlSlug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  urlSlug_starts_with?: InputMaybe<Scalars['String']>;
};

export enum TermsandPrivacyOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DISPLAYTITLE_ASC = 'displayTitle_ASC',
  DISPLAYTITLE_DESC = 'displayTitle_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  LASTMAJORUPDATETIMESTAMP_ASC = 'lastMajorUpdateTimestamp_ASC',
  LASTMAJORUPDATETIMESTAMP_DESC = 'lastMajorUpdateTimestamp_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  REFERENCE_ASC = 'reference_ASC',
  REFERENCE_DESC = 'reference_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  URLSLUG_ASC = 'urlSlug_ASC',
  URLSLUG_DESC = 'urlSlug_DESC'
}

export type TermsandPrivacyUpdateInput = {
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']>;
  /** displayTitle input for default locale (en) */
  displayTitle?: InputMaybe<Scalars['String']>;
  lastMajorUpdateTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Manage document localizations */
  localizations?: InputMaybe<TermsandPrivacyUpdateLocalizationsInput>;
  reference?: InputMaybe<Scalars['String']>;
  urlSlug?: InputMaybe<Scalars['String']>;
};

export type TermsandPrivacyUpdateLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
  displayTitle?: InputMaybe<Scalars['String']>;
};

export type TermsandPrivacyUpdateLocalizationInput = {
  data: TermsandPrivacyUpdateLocalizationDataInput;
  locale: Locale;
};

export type TermsandPrivacyUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TermsandPrivacyCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<TermsandPrivacyUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<TermsandPrivacyUpsertLocalizationInput>>;
};

export type TermsandPrivacyUpdateManyInlineInput = {
  /** Connect multiple existing TermsandPrivacy documents */
  connect?: InputMaybe<Array<TermsandPrivacyConnectInput>>;
  /** Create and connect multiple TermsandPrivacy documents */
  create?: InputMaybe<Array<TermsandPrivacyCreateInput>>;
  /** Delete multiple TermsandPrivacy documents */
  delete?: InputMaybe<Array<TermsandPrivacyWhereUniqueInput>>;
  /** Disconnect multiple TermsandPrivacy documents */
  disconnect?: InputMaybe<Array<TermsandPrivacyWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TermsandPrivacy documents */
  set?: InputMaybe<Array<TermsandPrivacyWhereUniqueInput>>;
  /** Update multiple TermsandPrivacy documents */
  update?: InputMaybe<Array<TermsandPrivacyUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TermsandPrivacy documents */
  upsert?: InputMaybe<Array<TermsandPrivacyUpsertWithNestedWhereUniqueInput>>;
};

export type TermsandPrivacyUpdateManyInput = {
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']>;
  /** displayTitle input for default locale (en) */
  displayTitle?: InputMaybe<Scalars['String']>;
  lastMajorUpdateTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<TermsandPrivacyUpdateManyLocalizationsInput>;
  urlSlug?: InputMaybe<Scalars['String']>;
};

export type TermsandPrivacyUpdateManyLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
  displayTitle?: InputMaybe<Scalars['String']>;
};

export type TermsandPrivacyUpdateManyLocalizationInput = {
  data: TermsandPrivacyUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type TermsandPrivacyUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TermsandPrivacyUpdateManyLocalizationInput>>;
};

export type TermsandPrivacyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TermsandPrivacyUpdateManyInput;
  /** Document search */
  where: TermsandPrivacyWhereInput;
};

export type TermsandPrivacyUpdateOneInlineInput = {
  /** Connect existing TermsandPrivacy document */
  connect?: InputMaybe<TermsandPrivacyWhereUniqueInput>;
  /** Create and connect one TermsandPrivacy document */
  create?: InputMaybe<TermsandPrivacyCreateInput>;
  /** Delete currently connected TermsandPrivacy document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected TermsandPrivacy document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single TermsandPrivacy document */
  update?: InputMaybe<TermsandPrivacyUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TermsandPrivacy document */
  upsert?: InputMaybe<TermsandPrivacyUpsertWithNestedWhereUniqueInput>;
};

export type TermsandPrivacyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TermsandPrivacyUpdateInput;
  /** Unique document search */
  where: TermsandPrivacyWhereUniqueInput;
};

export type TermsandPrivacyUpsertInput = {
  /** Create document if it didn't exist */
  create: TermsandPrivacyCreateInput;
  /** Update document if it exists */
  update: TermsandPrivacyUpdateInput;
};

export type TermsandPrivacyUpsertLocalizationInput = {
  create: TermsandPrivacyCreateLocalizationDataInput;
  locale: Locale;
  update: TermsandPrivacyUpdateLocalizationDataInput;
};

export type TermsandPrivacyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TermsandPrivacyUpsertInput;
  /** Unique document search */
  where: TermsandPrivacyWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TermsandPrivacyWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type TermsandPrivacyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TermsandPrivacyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TermsandPrivacyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TermsandPrivacyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  displayTitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  displayTitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  displayTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  displayTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayTitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  displayTitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  displayTitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  displayTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  displayTitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  displayTitle_starts_with?: InputMaybe<Scalars['String']>;
  documentInStages_every?: InputMaybe<TermsandPrivacyWhereStageInput>;
  documentInStages_none?: InputMaybe<TermsandPrivacyWhereStageInput>;
  documentInStages_some?: InputMaybe<TermsandPrivacyWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  lastMajorUpdateTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  lastMajorUpdateTimestamp_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  lastMajorUpdateTimestamp_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  lastMajorUpdateTimestamp_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  lastMajorUpdateTimestamp_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  lastMajorUpdateTimestamp_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  lastMajorUpdateTimestamp_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  lastMajorUpdateTimestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  reference?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  reference_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  reference_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  reference_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  reference_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  reference_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  reference_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  reference_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  reference_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  reference_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  urlSlug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  urlSlug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  urlSlug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  urlSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  urlSlug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  urlSlug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  urlSlug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  urlSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  urlSlug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  urlSlug_starts_with?: InputMaybe<Scalars['String']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TermsandPrivacyWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TermsandPrivacyWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TermsandPrivacyWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TermsandPrivacyWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TermsandPrivacyWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TermsandPrivacy record uniquely */
export type TermsandPrivacyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  reference?: InputMaybe<Scalars['String']>;
};

/** How to stream to twitch explainer */
export type TwitchExplainer = Entity & Node & {
  __typename?: 'TwitchExplainer';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Device name */
  device?: Maybe<Phrase>;
  /** Get the document in other stages */
  documentInStages: Array<TwitchExplainer>;
  /** List of TwitchExplainer versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Priority to display console explainer */
  priority: Scalars['Int'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Text for explainer */
  text?: Maybe<Phrase>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** How to stream to twitch explainer */
export type TwitchExplainerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** How to stream to twitch explainer */
export type TwitchExplainerDeviceArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** How to stream to twitch explainer */
export type TwitchExplainerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** How to stream to twitch explainer */
export type TwitchExplainerHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** How to stream to twitch explainer */
export type TwitchExplainerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** How to stream to twitch explainer */
export type TwitchExplainerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** How to stream to twitch explainer */
export type TwitchExplainerTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** How to stream to twitch explainer */
export type TwitchExplainerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TwitchExplainerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TwitchExplainerWhereUniqueInput;
};

/** A connection to a list of items. */
export type TwitchExplainerConnection = {
  __typename?: 'TwitchExplainerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TwitchExplainerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TwitchExplainerCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  device?: InputMaybe<PhraseCreateOneInlineInput>;
  priority: Scalars['Int'];
  text?: InputMaybe<PhraseCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TwitchExplainerCreateManyInlineInput = {
  /** Connect multiple existing TwitchExplainer documents */
  connect?: InputMaybe<Array<TwitchExplainerWhereUniqueInput>>;
  /** Create and connect multiple existing TwitchExplainer documents */
  create?: InputMaybe<Array<TwitchExplainerCreateInput>>;
};

export type TwitchExplainerCreateOneInlineInput = {
  /** Connect one existing TwitchExplainer document */
  connect?: InputMaybe<TwitchExplainerWhereUniqueInput>;
  /** Create and connect one TwitchExplainer document */
  create?: InputMaybe<TwitchExplainerCreateInput>;
};

/** An edge in a connection. */
export type TwitchExplainerEdge = {
  __typename?: 'TwitchExplainerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TwitchExplainer;
};

/** Identifies documents */
export type TwitchExplainerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TwitchExplainerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TwitchExplainerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TwitchExplainerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  device?: InputMaybe<PhraseWhereInput>;
  documentInStages_every?: InputMaybe<TwitchExplainerWhereStageInput>;
  documentInStages_none?: InputMaybe<TwitchExplainerWhereStageInput>;
  documentInStages_some?: InputMaybe<TwitchExplainerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  text?: InputMaybe<PhraseWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TwitchExplainerOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PRIORITY_ASC = 'priority_ASC',
  PRIORITY_DESC = 'priority_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type TwitchExplainerUpdateInput = {
  device?: InputMaybe<PhraseUpdateOneInlineInput>;
  priority?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<PhraseUpdateOneInlineInput>;
};

export type TwitchExplainerUpdateManyInlineInput = {
  /** Connect multiple existing TwitchExplainer documents */
  connect?: InputMaybe<Array<TwitchExplainerConnectInput>>;
  /** Create and connect multiple TwitchExplainer documents */
  create?: InputMaybe<Array<TwitchExplainerCreateInput>>;
  /** Delete multiple TwitchExplainer documents */
  delete?: InputMaybe<Array<TwitchExplainerWhereUniqueInput>>;
  /** Disconnect multiple TwitchExplainer documents */
  disconnect?: InputMaybe<Array<TwitchExplainerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TwitchExplainer documents */
  set?: InputMaybe<Array<TwitchExplainerWhereUniqueInput>>;
  /** Update multiple TwitchExplainer documents */
  update?: InputMaybe<Array<TwitchExplainerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TwitchExplainer documents */
  upsert?: InputMaybe<Array<TwitchExplainerUpsertWithNestedWhereUniqueInput>>;
};

export type TwitchExplainerUpdateManyInput = {
  priority?: InputMaybe<Scalars['Int']>;
};

export type TwitchExplainerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TwitchExplainerUpdateManyInput;
  /** Document search */
  where: TwitchExplainerWhereInput;
};

export type TwitchExplainerUpdateOneInlineInput = {
  /** Connect existing TwitchExplainer document */
  connect?: InputMaybe<TwitchExplainerWhereUniqueInput>;
  /** Create and connect one TwitchExplainer document */
  create?: InputMaybe<TwitchExplainerCreateInput>;
  /** Delete currently connected TwitchExplainer document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected TwitchExplainer document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single TwitchExplainer document */
  update?: InputMaybe<TwitchExplainerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TwitchExplainer document */
  upsert?: InputMaybe<TwitchExplainerUpsertWithNestedWhereUniqueInput>;
};

export type TwitchExplainerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TwitchExplainerUpdateInput;
  /** Unique document search */
  where: TwitchExplainerWhereUniqueInput;
};

export type TwitchExplainerUpsertInput = {
  /** Create document if it didn't exist */
  create: TwitchExplainerCreateInput;
  /** Update document if it exists */
  update: TwitchExplainerUpdateInput;
};

export type TwitchExplainerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TwitchExplainerUpsertInput;
  /** Unique document search */
  where: TwitchExplainerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TwitchExplainerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type TwitchExplainerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TwitchExplainerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TwitchExplainerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TwitchExplainerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  device?: InputMaybe<PhraseWhereInput>;
  documentInStages_every?: InputMaybe<TwitchExplainerWhereStageInput>;
  documentInStages_none?: InputMaybe<TwitchExplainerWhereStageInput>;
  documentInStages_some?: InputMaybe<TwitchExplainerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  text?: InputMaybe<PhraseWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TwitchExplainerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TwitchExplainerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TwitchExplainerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TwitchExplainerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TwitchExplainerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TwitchExplainer record uniquely */
export type TwitchExplainerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

/** states of the US */
export enum UsStates {
  ALABAMA = 'Alabama',
  ALASKA = 'Alaska',
  ARIZONA = 'Arizona',
  ARKANSAS = 'Arkansas',
  CALIFORNIA = 'California',
  COLORADO = 'Colorado',
  CONNECTICUT = 'Connecticut',
  DELAWARE = 'Delaware',
  FLORIDA = 'Florida',
  GEORGIA = 'Georgia',
  HAWAII = 'Hawaii',
  IDAHO = 'Idaho',
  ILLINOIS = 'Illinois',
  INDIANA = 'Indiana',
  IOWA = 'Iowa',
  KANSAS = 'Kansas',
  KENTUCKY = 'Kentucky',
  LOUISIANA = 'Louisiana',
  MAINE = 'Maine',
  MARYLAND = 'Maryland',
  MASSACHUSETTS = 'Massachusetts',
  MICHIGAN = 'Michigan',
  MINNESOTA = 'Minnesota',
  MISSISSIPPI = 'Mississippi',
  MISSOURI = 'Missouri',
  MONTANA = 'Montana',
  NEBRASKA = 'Nebraska',
  NEVADA = 'Nevada',
  NEW_HAMPSHIRE = 'New_Hampshire',
  NEW_MEXICO = 'New_Mexico',
  NEW_YORK = 'New_York',
  NORTH_CAROLINA = 'North_Carolina',
  NORTH_DAKOTA = 'North_Dakota',
  OHIO = 'Ohio',
  OKLAHOMA = 'Oklahoma',
  OREGON = 'Oregon',
  PENNSYLVANIA = 'Pennsylvania',
  RHODE_ISLAND = 'Rhode_Island',
  SOUTH_CAROLINA = 'South_Carolina',
  SOUTH_DAKOTA = 'South_Dakota',
  TENNESSEE = 'Tennessee',
  TEXAS = 'Texas',
  UTAH = 'Utah',
  VERMONT = 'Vermont',
  VIRGINIA = 'Virginia',
  WASHINGTON = 'Washington',
  WEST_VIRGINIA = 'West_Virginia',
  WISCONSIN = 'Wisconsin',
  WYOMING = 'Wyoming'
}

/** User system model */
export type User = Entity & Node & {
  __typename?: 'User';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  /** The username */
  name: Scalars['String'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  MEMBER = 'MEMBER',
  PAT = 'PAT',
  PUBLIC = 'PUBLIC',
  WEBHOOK = 'WEBHOOK'
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export enum UserOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  ISACTIVE_ASC = 'isActive_ASC',
  ISACTIVE_DESC = 'isActive_DESC',
  KIND_ASC = 'kind_ASC',
  KIND_DESC = 'kind_DESC',
  NAME_ASC = 'name_ASC',
  NAME_DESC = 'name_DESC',
  PICTURE_ASC = 'picture_ASC',
  PICTURE_DESC = 'picture_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

export enum _FilterKind {
  AND = 'AND',
  NOT = 'NOT',
  OR = 'OR',
  CONTAINS = 'contains',
  CONTAINS_ALL = 'contains_all',
  CONTAINS_NONE = 'contains_none',
  CONTAINS_SOME = 'contains_some',
  DESCENDANTS_OF = 'descendants_of',
  ENDS_WITH = 'ends_with',
  EQ = 'eq',
  EQ_NOT = 'eq_not',
  GT = 'gt',
  GTE = 'gte',
  IN = 'in',
  JSON_PATH_EXISTS = 'json_path_exists',
  JSON_VALUE_RECURSIVE = 'json_value_recursive',
  LT = 'lt',
  LTE = 'lte',
  NOT_CONTAINS = 'not_contains',
  NOT_ENDS_WITH = 'not_ends_with',
  NOT_IN = 'not_in',
  NOT_STARTS_WITH = 'not_starts_with',
  RELATIONAL_EVERY = 'relational_every',
  RELATIONAL_NONE = 'relational_none',
  RELATIONAL_SINGLE = 'relational_single',
  RELATIONAL_SOME = 'relational_some',
  SEARCH = 'search',
  STARTS_WITH = 'starts_with',
  UNION_EMPTY = 'union_empty',
  UNION_EVERY = 'union_every',
  UNION_NONE = 'union_none',
  UNION_SINGLE = 'union_single',
  UNION_SOME = 'union_some'
}

export enum _MutationInputFieldKind {
  ENUM = 'enum',
  RELATION = 'relation',
  RICHTEXT = 'richText',
  RICHTEXTWITHEMBEDS = 'richTextWithEmbeds',
  SCALAR = 'scalar',
  UNION = 'union',
  VIRTUAL = 'virtual'
}

export enum _MutationKind {
  CREATE = 'create',
  DELETE = 'delete',
  DELETEMANY = 'deleteMany',
  PUBLISH = 'publish',
  PUBLISHMANY = 'publishMany',
  SCHEDULEPUBLISH = 'schedulePublish',
  SCHEDULEUNPUBLISH = 'scheduleUnpublish',
  UNPUBLISH = 'unpublish',
  UNPUBLISHMANY = 'unpublishMany',
  UPDATE = 'update',
  UPDATEMANY = 'updateMany',
  UPSERT = 'upsert'
}

export enum _OrderDirection {
  ASC = 'asc',
  DESC = 'desc'
}

export enum _RelationInputCardinality {
  MANY = 'many',
  ONE = 'one'
}

export enum _RelationInputKind {
  CREATE = 'create',
  UPDATE = 'update'
}

export enum _RelationKind {
  REGULAR = 'regular',
  UNION = 'union'
}

export enum _SystemDateTimeFieldVariation {
  BASE = 'base',
  COMBINED = 'combined',
  LOCALIZATION = 'localization'
}

export type GetFaQsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFaQsQuery = { __typename?: 'Query', faqCategoriesConnection: { __typename?: 'FaqCategoryModelConnection', edges: Array<{ __typename?: 'FaqCategoryModelEdge', node: { __typename?: 'FaqCategoryModel', faqCategory: FaqCategory, displayName: string } }> }, fAQs: Array<{ __typename?: 'FAQ', question?: string | null, id: string, answer?: string | null, faq_category: FaqCategory, priority: number }> };


export const GetFaQsDocument = gql`
    query GetFAQs {
  faqCategoriesConnection(orderBy: priority_ASC) {
    edges {
      node {
        faqCategory
        displayName
      }
    }
  }
  fAQs(where: {faq_product: CONNECT}) {
    question
    id
    answer
    faq_category
    priority
  }
}
    `;

/**
 * __useGetFaQsQuery__
 *
 * To run a query within a React component, call `useGetFaQsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFaQsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaQsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFaQsQuery(baseOptions?: Apollo.QueryHookOptions<GetFaQsQuery, GetFaQsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFaQsQuery, GetFaQsQueryVariables>(GetFaQsDocument, options);
      }
export function useGetFaQsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFaQsQuery, GetFaQsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFaQsQuery, GetFaQsQueryVariables>(GetFaQsDocument, options);
        }
export type GetFaQsQueryHookResult = ReturnType<typeof useGetFaQsQuery>;
export type GetFaQsLazyQueryHookResult = ReturnType<typeof useGetFaQsLazyQuery>;
export type GetFaQsQueryResult = Apollo.QueryResult<GetFaQsQuery, GetFaQsQueryVariables>;